{
    "ddd": 0,
    "h": 780,
    "w": 936,
    "meta": { "g": "LottieFiles Figma v41" },
    "layers": [
        {
            "ty": 4,
            "sr": 1,
            "st": 0,
            "op": 241,
            "ip": 0,
            "hasMask": false,
            "ao": 0,
            "ks": {
                "a": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [23.96, 15.7], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [23.96, 15.7], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [23.96, 15.7], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [23.96, 15.7], "t": 180 },
                        { "s": [23.96, 15.7], "t": 240 }
                    ]
                },
                "s": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100, 100], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100, 100], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100, 100], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100, 100], "t": 180 },
                        { "s": [100, 100], "t": 240 }
                    ]
                },
                "p": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [386.59, 519.53], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [386.03, 519.96], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [386.59, 519.53], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [386.03, 519.96], "t": 180 },
                        { "s": [386.59, 519.53], "t": 240 }
                    ]
                },
                "r": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [-3.07], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [-3.07], "t": 180 },
                        { "s": [0], "t": 240 }
                    ]
                },
                "o": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 180 },
                        { "s": [100], "t": 240 }
                    ]
                }
            },
            "shapes": [
                {
                    "ty": "sh",
                    "d": 1,
                    "ks": {
                        "a": 1,
                        "k": [
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": false,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [0, 19.85],
                                            [16.54, 36.39],
                                            [52.92, 0]
                                        ]
                                    }
                                ],
                                "t": 0
                            },
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": false,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [0, 19.85],
                                            [16.54, 36.39],
                                            [52.92, 0]
                                        ]
                                    }
                                ],
                                "t": 60
                            },
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": false,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [0, 19.85],
                                            [16.54, 36.39],
                                            [52.92, 0]
                                        ]
                                    }
                                ],
                                "t": 120
                            },
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": false,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [0, 19.85],
                                            [16.54, 36.39],
                                            [52.92, 0]
                                        ]
                                    }
                                ],
                                "t": 180
                            },
                            {
                                "s": [
                                    {
                                        "c": false,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [0, 19.85],
                                            [16.54, 36.39],
                                            [52.92, 0]
                                        ]
                                    }
                                ],
                                "t": 240
                            }
                        ]
                    }
                },
                {
                    "ty": "st",
                    "lc": 2,
                    "lj": 1,
                    "ml": 4,
                    "o": {
                        "a": 1,
                        "k": [
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 0 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 60 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 120 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 180 },
                            { "s": [100], "t": 240 }
                        ]
                    },
                    "w": {
                        "a": 1,
                        "k": [
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [10], "t": 0 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [10], "t": 60 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [10], "t": 120 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [10], "t": 180 },
                            { "s": [10], "t": 240 }
                        ]
                    },
                    "c": {
                        "a": 1,
                        "k": [
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [1, 1, 1], "t": 0 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [1, 1, 1], "t": 60 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [1, 1, 1], "t": 120 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [1, 1, 1], "t": 180 },
                            { "s": [1, 1, 1], "t": 240 }
                        ]
                    }
                }
            ],
            "ind": 1
        },
        {
            "ty": 4,
            "sr": 1,
            "st": 0,
            "op": 241,
            "ip": 0,
            "hasMask": false,
            "ao": 0,
            "ks": {
                "a": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [62.39, 62.41], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [62.39, 62.41], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [62.39, 62.41], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [62.39, 62.41], "t": 180 },
                        { "s": [62.39, 62.41], "t": 240 }
                    ]
                },
                "s": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100, 100], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100, 100], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100, 100], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100, 100], "t": 180 },
                        { "s": [100, 100], "t": 240 }
                    ]
                },
                "p": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [387.27, 519.85], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [386.84, 520.1], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [387.27, 519.85], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [386.84, 520.1], "t": 180 },
                        { "s": [387.27, 519.85], "t": 240 }
                    ]
                },
                "r": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [-3.07], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [-3.07], "t": 180 },
                        { "s": [0], "t": 240 }
                    ]
                },
                "o": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 180 },
                        { "s": [100], "t": 240 }
                    ]
                }
            },
            "shapes": [
                {
                    "ty": "sh",
                    "d": 1,
                    "ks": {
                        "a": 1,
                        "k": [
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [34.46, 0],
                                            [0, 34.47],
                                            [-34.46, 0],
                                            [0, -34.47]
                                        ],
                                        "o": [
                                            [0, 34.47],
                                            [-34.46, 0],
                                            [0, -34.47],
                                            [34.46, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [124.77, 62.41],
                                            [62.39, 124.81],
                                            [0, 62.41],
                                            [62.39, 0],
                                            [124.77, 62.41]
                                        ]
                                    }
                                ],
                                "t": 0
                            },
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [34.46, 0],
                                            [0, 34.47],
                                            [-34.46, 0],
                                            [0, -34.47]
                                        ],
                                        "o": [
                                            [0, 34.47],
                                            [-34.46, 0],
                                            [0, -34.47],
                                            [34.46, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [124.77, 62.41],
                                            [62.39, 124.81],
                                            [0, 62.41],
                                            [62.39, 0],
                                            [124.77, 62.41]
                                        ]
                                    }
                                ],
                                "t": 60
                            },
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [34.46, 0],
                                            [0, 34.47],
                                            [-34.46, 0],
                                            [0, -34.47]
                                        ],
                                        "o": [
                                            [0, 34.47],
                                            [-34.46, 0],
                                            [0, -34.47],
                                            [34.46, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [124.77, 62.41],
                                            [62.39, 124.81],
                                            [0, 62.41],
                                            [62.39, 0],
                                            [124.77, 62.41]
                                        ]
                                    }
                                ],
                                "t": 120
                            },
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [34.46, 0],
                                            [0, 34.47],
                                            [-34.46, 0],
                                            [0, -34.47]
                                        ],
                                        "o": [
                                            [0, 34.47],
                                            [-34.46, 0],
                                            [0, -34.47],
                                            [34.46, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [124.77, 62.41],
                                            [62.39, 124.81],
                                            [0, 62.41],
                                            [62.39, 0],
                                            [124.77, 62.41]
                                        ]
                                    }
                                ],
                                "t": 180
                            },
                            {
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [34.46, 0],
                                            [0, 34.47],
                                            [-34.46, 0],
                                            [0, -34.47]
                                        ],
                                        "o": [
                                            [0, 34.47],
                                            [-34.46, 0],
                                            [0, -34.47],
                                            [34.46, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [124.77, 62.41],
                                            [62.39, 124.81],
                                            [0, 62.41],
                                            [62.39, 0],
                                            [124.77, 62.41]
                                        ]
                                    }
                                ],
                                "t": 240
                            }
                        ]
                    }
                },
                {
                    "ty": "fl",
                    "c": {
                        "a": 1,
                        "k": [
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0.0902, 0.6784, 0.5255], "t": 0 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0.0902, 0.6784, 0.5255], "t": 60 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0.0902, 0.6784, 0.5255], "t": 120 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0.0902, 0.6784, 0.5255], "t": 180 },
                            { "s": [0.0902, 0.6784, 0.5255], "t": 240 }
                        ]
                    },
                    "r": 1,
                    "o": {
                        "a": 1,
                        "k": [
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 0 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 60 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 120 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 180 },
                            { "s": [100], "t": 240 }
                        ]
                    }
                }
            ],
            "ind": 2
        },
        {
            "ty": 4,
            "sr": 1,
            "st": 0,
            "op": 241,
            "ip": 0,
            "hasMask": false,
            "ao": 0,
            "ks": {
                "a": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [62.4, 62.4], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [62.4, 62.4], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [62.4, 62.4], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [62.4, 62.4], "t": 180 },
                        { "s": [62.4, 62.4], "t": 240 }
                    ]
                },
                "s": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [99.98, 100.02], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [99.98, 100.02], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [99.98, 100.02], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [99.98, 100.02], "t": 180 },
                        { "s": [99.98, 100.02], "t": 240 }
                    ]
                },
                "p": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [391.86, 527.83], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [391.86, 527.82], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [391.86, 527.83], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [391.86, 527.82], "t": 180 },
                        { "s": [391.86, 527.83], "t": 240 }
                    ]
                },
                "r": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [-45.01], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [-48.08], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [-45.01], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [-48.08], "t": 180 },
                        { "s": [-45.01], "t": 240 }
                    ]
                },
                "o": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [20], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [20], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [20], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [20], "t": 180 },
                        { "s": [20], "t": 240 }
                    ]
                }
            },
            "shapes": [
                {
                    "ty": "sh",
                    "d": 1,
                    "ks": {
                        "a": 1,
                        "k": [
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [34.46, 0],
                                            [0, 34.46],
                                            [-34.46, 0],
                                            [0, -34.46]
                                        ],
                                        "o": [
                                            [0, 34.46],
                                            [-34.46, 0],
                                            [0, -34.46],
                                            [34.46, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [124.79, 62.4],
                                            [62.4, 124.79],
                                            [0, 62.4],
                                            [62.4, 0],
                                            [124.79, 62.4]
                                        ]
                                    }
                                ],
                                "t": 0
                            },
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [34.46, 0],
                                            [0, 34.46],
                                            [-34.46, 0],
                                            [0, -34.46]
                                        ],
                                        "o": [
                                            [0, 34.46],
                                            [-34.46, 0],
                                            [0, -34.46],
                                            [34.46, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [124.79, 62.4],
                                            [62.4, 124.79],
                                            [0, 62.4],
                                            [62.4, 0],
                                            [124.79, 62.4]
                                        ]
                                    }
                                ],
                                "t": 60
                            },
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [34.46, 0],
                                            [0, 34.46],
                                            [-34.46, 0],
                                            [0, -34.46]
                                        ],
                                        "o": [
                                            [0, 34.46],
                                            [-34.46, 0],
                                            [0, -34.46],
                                            [34.46, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [124.79, 62.4],
                                            [62.4, 124.79],
                                            [0, 62.4],
                                            [62.4, 0],
                                            [124.79, 62.4]
                                        ]
                                    }
                                ],
                                "t": 120
                            },
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [34.46, 0],
                                            [0, 34.46],
                                            [-34.46, 0],
                                            [0, -34.46]
                                        ],
                                        "o": [
                                            [0, 34.46],
                                            [-34.46, 0],
                                            [0, -34.46],
                                            [34.46, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [124.79, 62.4],
                                            [62.4, 124.79],
                                            [0, 62.4],
                                            [62.4, 0],
                                            [124.79, 62.4]
                                        ]
                                    }
                                ],
                                "t": 180
                            },
                            {
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [34.46, 0],
                                            [0, 34.46],
                                            [-34.46, 0],
                                            [0, -34.46]
                                        ],
                                        "o": [
                                            [0, 34.46],
                                            [-34.46, 0],
                                            [0, -34.46],
                                            [34.46, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [124.79, 62.4],
                                            [62.4, 124.79],
                                            [0, 62.4],
                                            [62.4, 0],
                                            [124.79, 62.4]
                                        ]
                                    }
                                ],
                                "t": 240
                            }
                        ]
                    }
                },
                {
                    "ty": "fl",
                    "c": {
                        "a": 1,
                        "k": [
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0.2275, 0.4941, 0.7569], "t": 0 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0.2275, 0.4941, 0.7569], "t": 60 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0.2275, 0.4941, 0.7569], "t": 120 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0.2275, 0.4941, 0.7569], "t": 180 },
                            { "s": [0.2275, 0.4941, 0.7569], "t": 240 }
                        ]
                    },
                    "r": 1,
                    "o": {
                        "a": 1,
                        "k": [
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 0 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 60 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 120 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 180 },
                            { "s": [100], "t": 240 }
                        ]
                    }
                }
            ],
            "ind": 3
        },
        {
            "ty": 4,
            "sr": 1,
            "st": 0,
            "op": 241,
            "ip": 0,
            "hasMask": false,
            "ao": 0,
            "ks": {
                "a": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [16.89, 9.44], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [16.89, 9.44], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [16.89, 9.44], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [16.89, 9.44], "t": 180 },
                        { "s": [16.89, 9.44], "t": 240 }
                    ]
                },
                "s": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100, 100], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100, 100], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100, 100], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100, 100], "t": 180 },
                        { "s": [100, 100], "t": 240 }
                    ]
                },
                "p": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [585.54, 485.34], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [575.34, 490.82], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [585.54, 485.34], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [575.34, 490.82], "t": 180 },
                        { "s": [585.54, 485.34], "t": 240 }
                    ]
                },
                "r": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [5.41], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [5.41], "t": 180 },
                        { "s": [0], "t": 240 }
                    ]
                },
                "o": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 180 },
                        { "s": [100], "t": 240 }
                    ]
                }
            },
            "shapes": [
                {
                    "ty": "sh",
                    "d": 1,
                    "ks": {
                        "a": 1,
                        "k": [
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [1.3, -0.41],
                                            [0, 0],
                                            [0, 0],
                                            [2.23, -1.32],
                                            [2.09, -1.51],
                                            [1.1, -0.94],
                                            [0.68, 0.54],
                                            [0.99, 0.72],
                                            [1.18, 0.59],
                                            [0, 0],
                                            [0.08, -0.05],
                                            [-0.08, -0.11],
                                            [-2.72, -3.8],
                                            [-0.2, 0.15],
                                            [-4.13, 3.09],
                                            [0, 0],
                                            [-2.06, 1.55],
                                            [0.02, 0.09],
                                            [0.14, -0.02],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [-1.43, 0.23],
                                            [0, 0],
                                            [0, 0],
                                            [-2.46, 1],
                                            [-2.3, 1.23],
                                            [-1.17, 0.85],
                                            [-0.63, -0.58],
                                            [-0.9, -0.79],
                                            [-1.03, -0.69],
                                            [0, 0],
                                            [-0.08, -0.04],
                                            [-0.11, 0.08],
                                            [2.64, 3.86],
                                            [0.15, 0.2],
                                            [4.21, -2.98],
                                            [0, 0],
                                            [2.09, -1.52],
                                            [0.07, -0.05],
                                            [-0.02, -0.14],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [33.5, 0],
                                            [33.38, 0.02],
                                            [29.31, 1],
                                            [27.38, 1.63],
                                            [25.52, 2.37],
                                            [18.49, 5.85],
                                            [12, 10.08],
                                            [8.6, 12.78],
                                            [6.65, 11.09],
                                            [3.73, 8.88],
                                            [0.47, 6.91],
                                            [0.36, 6.86],
                                            [0.11, 6.88],
                                            [0.04, 7.22],
                                            [8.13, 18.69],
                                            [8.76, 18.79],
                                            [21.29, 9.71],
                                            [27.52, 5.11],
                                            [33.69, 0.45],
                                            [33.79, 0.21],
                                            [33.5, 0],
                                            [33.5, 0]
                                        ]
                                    }
                                ],
                                "t": 0
                            },
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [1.3, -0.41],
                                            [0, 0],
                                            [0, 0],
                                            [2.23, -1.32],
                                            [2.09, -1.51],
                                            [1.1, -0.94],
                                            [0.68, 0.54],
                                            [0.99, 0.72],
                                            [1.18, 0.59],
                                            [0, 0],
                                            [0.08, -0.05],
                                            [-0.08, -0.11],
                                            [-2.72, -3.8],
                                            [-0.2, 0.15],
                                            [-4.13, 3.09],
                                            [0, 0],
                                            [-2.06, 1.55],
                                            [0.02, 0.09],
                                            [0.14, -0.02],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [-1.43, 0.23],
                                            [0, 0],
                                            [0, 0],
                                            [-2.46, 1],
                                            [-2.3, 1.23],
                                            [-1.17, 0.85],
                                            [-0.63, -0.58],
                                            [-0.9, -0.79],
                                            [-1.03, -0.69],
                                            [0, 0],
                                            [-0.08, -0.04],
                                            [-0.11, 0.08],
                                            [2.64, 3.86],
                                            [0.15, 0.2],
                                            [4.21, -2.98],
                                            [0, 0],
                                            [2.09, -1.52],
                                            [0.07, -0.05],
                                            [-0.02, -0.14],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [33.5, 0],
                                            [33.38, 0.02],
                                            [29.31, 1],
                                            [27.38, 1.63],
                                            [25.52, 2.37],
                                            [18.49, 5.85],
                                            [12, 10.08],
                                            [8.6, 12.78],
                                            [6.65, 11.09],
                                            [3.73, 8.88],
                                            [0.47, 6.91],
                                            [0.36, 6.86],
                                            [0.11, 6.88],
                                            [0.04, 7.22],
                                            [8.13, 18.69],
                                            [8.76, 18.79],
                                            [21.29, 9.71],
                                            [27.52, 5.11],
                                            [33.69, 0.45],
                                            [33.79, 0.21],
                                            [33.5, 0],
                                            [33.5, 0]
                                        ]
                                    }
                                ],
                                "t": 60
                            },
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [1.3, -0.41],
                                            [0, 0],
                                            [0, 0],
                                            [2.23, -1.32],
                                            [2.09, -1.51],
                                            [1.1, -0.94],
                                            [0.68, 0.54],
                                            [0.99, 0.72],
                                            [1.18, 0.59],
                                            [0, 0],
                                            [0.08, -0.05],
                                            [-0.08, -0.11],
                                            [-2.72, -3.8],
                                            [-0.2, 0.15],
                                            [-4.13, 3.09],
                                            [0, 0],
                                            [-2.06, 1.55],
                                            [0.02, 0.09],
                                            [0.14, -0.02],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [-1.43, 0.23],
                                            [0, 0],
                                            [0, 0],
                                            [-2.46, 1],
                                            [-2.3, 1.23],
                                            [-1.17, 0.85],
                                            [-0.63, -0.58],
                                            [-0.9, -0.79],
                                            [-1.03, -0.69],
                                            [0, 0],
                                            [-0.08, -0.04],
                                            [-0.11, 0.08],
                                            [2.64, 3.86],
                                            [0.15, 0.2],
                                            [4.21, -2.98],
                                            [0, 0],
                                            [2.09, -1.52],
                                            [0.07, -0.05],
                                            [-0.02, -0.14],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [33.5, 0],
                                            [33.38, 0.02],
                                            [29.31, 1],
                                            [27.38, 1.63],
                                            [25.52, 2.37],
                                            [18.49, 5.85],
                                            [12, 10.08],
                                            [8.6, 12.78],
                                            [6.65, 11.09],
                                            [3.73, 8.88],
                                            [0.47, 6.91],
                                            [0.36, 6.86],
                                            [0.11, 6.88],
                                            [0.04, 7.22],
                                            [8.13, 18.69],
                                            [8.76, 18.79],
                                            [21.29, 9.71],
                                            [27.52, 5.11],
                                            [33.69, 0.45],
                                            [33.79, 0.21],
                                            [33.5, 0],
                                            [33.5, 0]
                                        ]
                                    }
                                ],
                                "t": 120
                            },
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [1.3, -0.41],
                                            [0, 0],
                                            [0, 0],
                                            [2.23, -1.32],
                                            [2.09, -1.51],
                                            [1.1, -0.94],
                                            [0.68, 0.54],
                                            [0.99, 0.72],
                                            [1.18, 0.59],
                                            [0, 0],
                                            [0.08, -0.05],
                                            [-0.08, -0.11],
                                            [-2.72, -3.8],
                                            [-0.2, 0.15],
                                            [-4.13, 3.09],
                                            [0, 0],
                                            [-2.06, 1.55],
                                            [0.02, 0.09],
                                            [0.14, -0.02],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [-1.43, 0.23],
                                            [0, 0],
                                            [0, 0],
                                            [-2.46, 1],
                                            [-2.3, 1.23],
                                            [-1.17, 0.85],
                                            [-0.63, -0.58],
                                            [-0.9, -0.79],
                                            [-1.03, -0.69],
                                            [0, 0],
                                            [-0.08, -0.04],
                                            [-0.11, 0.08],
                                            [2.64, 3.86],
                                            [0.15, 0.2],
                                            [4.21, -2.98],
                                            [0, 0],
                                            [2.09, -1.52],
                                            [0.07, -0.05],
                                            [-0.02, -0.14],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [33.5, 0],
                                            [33.38, 0.02],
                                            [29.31, 1],
                                            [27.38, 1.63],
                                            [25.52, 2.37],
                                            [18.49, 5.85],
                                            [12, 10.08],
                                            [8.6, 12.78],
                                            [6.65, 11.09],
                                            [3.73, 8.88],
                                            [0.47, 6.91],
                                            [0.36, 6.86],
                                            [0.11, 6.88],
                                            [0.04, 7.22],
                                            [8.13, 18.69],
                                            [8.76, 18.79],
                                            [21.29, 9.71],
                                            [27.52, 5.11],
                                            [33.69, 0.45],
                                            [33.79, 0.21],
                                            [33.5, 0],
                                            [33.5, 0]
                                        ]
                                    }
                                ],
                                "t": 180
                            },
                            {
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [1.3, -0.41],
                                            [0, 0],
                                            [0, 0],
                                            [2.23, -1.32],
                                            [2.09, -1.51],
                                            [1.1, -0.94],
                                            [0.68, 0.54],
                                            [0.99, 0.72],
                                            [1.18, 0.59],
                                            [0, 0],
                                            [0.08, -0.05],
                                            [-0.08, -0.11],
                                            [-2.72, -3.8],
                                            [-0.2, 0.15],
                                            [-4.13, 3.09],
                                            [0, 0],
                                            [-2.06, 1.55],
                                            [0.02, 0.09],
                                            [0.14, -0.02],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [-1.43, 0.23],
                                            [0, 0],
                                            [0, 0],
                                            [-2.46, 1],
                                            [-2.3, 1.23],
                                            [-1.17, 0.85],
                                            [-0.63, -0.58],
                                            [-0.9, -0.79],
                                            [-1.03, -0.69],
                                            [0, 0],
                                            [-0.08, -0.04],
                                            [-0.11, 0.08],
                                            [2.64, 3.86],
                                            [0.15, 0.2],
                                            [4.21, -2.98],
                                            [0, 0],
                                            [2.09, -1.52],
                                            [0.07, -0.05],
                                            [-0.02, -0.14],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [33.5, 0],
                                            [33.38, 0.02],
                                            [29.31, 1],
                                            [27.38, 1.63],
                                            [25.52, 2.37],
                                            [18.49, 5.85],
                                            [12, 10.08],
                                            [8.6, 12.78],
                                            [6.65, 11.09],
                                            [3.73, 8.88],
                                            [0.47, 6.91],
                                            [0.36, 6.86],
                                            [0.11, 6.88],
                                            [0.04, 7.22],
                                            [8.13, 18.69],
                                            [8.76, 18.79],
                                            [21.29, 9.71],
                                            [27.52, 5.11],
                                            [33.69, 0.45],
                                            [33.79, 0.21],
                                            [33.5, 0],
                                            [33.5, 0]
                                        ]
                                    }
                                ],
                                "t": 240
                            }
                        ]
                    }
                },
                {
                    "ty": "fl",
                    "c": {
                        "a": 1,
                        "k": [
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0.5412, 0.8353, 0.7608], "t": 0 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0.5412, 0.8353, 0.7608], "t": 60 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0.5412, 0.8353, 0.7608], "t": 120 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0.5412, 0.8353, 0.7608], "t": 180 },
                            { "s": [0.5412, 0.8353, 0.7608], "t": 240 }
                        ]
                    },
                    "r": 1,
                    "o": {
                        "a": 1,
                        "k": [
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 0 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 60 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 120 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 180 },
                            { "s": [100], "t": 240 }
                        ]
                    }
                }
            ],
            "ind": 4
        },
        {
            "ty": 4,
            "sr": 1,
            "st": 0,
            "op": 241,
            "ip": 0,
            "hasMask": false,
            "ao": 0,
            "ks": {
                "a": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [17.15, 17.16], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [17.15, 17.16], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [17.15, 17.16], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [17.15, 17.16], "t": 180 },
                        { "s": [17.15, 17.16], "t": 240 }
                    ]
                },
                "s": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100, 100], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100, 100], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100, 100], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100, 100], "t": 180 },
                        { "s": [100, 100], "t": 240 }
                    ]
                },
                "p": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [577.16, 487.99], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [566.75, 492.67], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [577.16, 487.99], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [566.75, 492.67], "t": 180 },
                        { "s": [577.16, 487.99], "t": 240 }
                    ]
                },
                "r": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [5.41], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [5.41], "t": 180 },
                        { "s": [0], "t": 240 }
                    ]
                },
                "o": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 180 },
                        { "s": [100], "t": 240 }
                    ]
                }
            },
            "shapes": [
                {
                    "ty": "sh",
                    "d": 1,
                    "ks": {
                        "a": 1,
                        "k": [
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [-1.48, 9.34],
                                            [-9.34, -1.48],
                                            [1.48, -9.34],
                                            [9.34, 1.48]
                                        ],
                                        "o": [
                                            [-9.34, -1.48],
                                            [1.48, -9.34],
                                            [9.34, 1.48],
                                            [-1.48, 9.34],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [14.47, 34.1],
                                            [0.21, 14.47],
                                            [19.84, 0.21],
                                            [34.09, 19.85],
                                            [14.47, 34.1]
                                        ]
                                    }
                                ],
                                "t": 0
                            },
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [-1.48, 9.34],
                                            [-9.34, -1.48],
                                            [1.48, -9.34],
                                            [9.34, 1.48]
                                        ],
                                        "o": [
                                            [-9.34, -1.48],
                                            [1.48, -9.34],
                                            [9.34, 1.48],
                                            [-1.48, 9.34],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [14.47, 34.1],
                                            [0.21, 14.47],
                                            [19.84, 0.21],
                                            [34.09, 19.85],
                                            [14.47, 34.1]
                                        ]
                                    }
                                ],
                                "t": 60
                            },
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [-1.48, 9.34],
                                            [-9.34, -1.48],
                                            [1.48, -9.34],
                                            [9.34, 1.48]
                                        ],
                                        "o": [
                                            [-9.34, -1.48],
                                            [1.48, -9.34],
                                            [9.34, 1.48],
                                            [-1.48, 9.34],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [14.47, 34.1],
                                            [0.21, 14.47],
                                            [19.84, 0.21],
                                            [34.09, 19.85],
                                            [14.47, 34.1]
                                        ]
                                    }
                                ],
                                "t": 120
                            },
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [-1.48, 9.34],
                                            [-9.34, -1.48],
                                            [1.48, -9.34],
                                            [9.34, 1.48]
                                        ],
                                        "o": [
                                            [-9.34, -1.48],
                                            [1.48, -9.34],
                                            [9.34, 1.48],
                                            [-1.48, 9.34],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [14.47, 34.1],
                                            [0.21, 14.47],
                                            [19.84, 0.21],
                                            [34.09, 19.85],
                                            [14.47, 34.1]
                                        ]
                                    }
                                ],
                                "t": 180
                            },
                            {
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [-1.48, 9.34],
                                            [-9.34, -1.48],
                                            [1.48, -9.34],
                                            [9.34, 1.48]
                                        ],
                                        "o": [
                                            [-9.34, -1.48],
                                            [1.48, -9.34],
                                            [9.34, 1.48],
                                            [-1.48, 9.34],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [14.47, 34.1],
                                            [0.21, 14.47],
                                            [19.84, 0.21],
                                            [34.09, 19.85],
                                            [14.47, 34.1]
                                        ]
                                    }
                                ],
                                "t": 240
                            }
                        ]
                    }
                },
                {
                    "ty": "sh",
                    "d": 1,
                    "ks": {
                        "a": 1,
                        "k": [
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [1.16, -7.32],
                                            [-7.32, -1.16],
                                            [-1.16, 7.32],
                                            [7.32, 1.16]
                                        ],
                                        "o": [
                                            [-7.32, -1.16],
                                            [-1.16, 7.32],
                                            [7.32, 1.16],
                                            [1.16, -7.32],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [19.26, 3.88],
                                            [3.88, 15.05],
                                            [15.05, 30.44],
                                            [30.43, 19.27],
                                            [19.26, 3.88]
                                        ]
                                    }
                                ],
                                "t": 0
                            },
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [1.16, -7.32],
                                            [-7.32, -1.16],
                                            [-1.16, 7.32],
                                            [7.32, 1.16]
                                        ],
                                        "o": [
                                            [-7.32, -1.16],
                                            [-1.16, 7.32],
                                            [7.32, 1.16],
                                            [1.16, -7.32],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [19.26, 3.88],
                                            [3.88, 15.05],
                                            [15.05, 30.44],
                                            [30.43, 19.27],
                                            [19.26, 3.88]
                                        ]
                                    }
                                ],
                                "t": 60
                            },
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [1.16, -7.32],
                                            [-7.32, -1.16],
                                            [-1.16, 7.32],
                                            [7.32, 1.16]
                                        ],
                                        "o": [
                                            [-7.32, -1.16],
                                            [-1.16, 7.32],
                                            [7.32, 1.16],
                                            [1.16, -7.32],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [19.26, 3.88],
                                            [3.88, 15.05],
                                            [15.05, 30.44],
                                            [30.43, 19.27],
                                            [19.26, 3.88]
                                        ]
                                    }
                                ],
                                "t": 120
                            },
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [1.16, -7.32],
                                            [-7.32, -1.16],
                                            [-1.16, 7.32],
                                            [7.32, 1.16]
                                        ],
                                        "o": [
                                            [-7.32, -1.16],
                                            [-1.16, 7.32],
                                            [7.32, 1.16],
                                            [1.16, -7.32],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [19.26, 3.88],
                                            [3.88, 15.05],
                                            [15.05, 30.44],
                                            [30.43, 19.27],
                                            [19.26, 3.88]
                                        ]
                                    }
                                ],
                                "t": 180
                            },
                            {
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [1.16, -7.32],
                                            [-7.32, -1.16],
                                            [-1.16, 7.32],
                                            [7.32, 1.16]
                                        ],
                                        "o": [
                                            [-7.32, -1.16],
                                            [-1.16, 7.32],
                                            [7.32, 1.16],
                                            [1.16, -7.32],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [19.26, 3.88],
                                            [3.88, 15.05],
                                            [15.05, 30.44],
                                            [30.43, 19.27],
                                            [19.26, 3.88]
                                        ]
                                    }
                                ],
                                "t": 240
                            }
                        ]
                    }
                },
                {
                    "ty": "fl",
                    "c": {
                        "a": 1,
                        "k": [
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0.8941, 0.9255, 0.9765], "t": 0 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0.8941, 0.9255, 0.9765], "t": 60 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0.8941, 0.9255, 0.9765], "t": 120 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0.8941, 0.9255, 0.9765], "t": 180 },
                            { "s": [0.8941, 0.9255, 0.9765], "t": 240 }
                        ]
                    },
                    "r": 1,
                    "o": {
                        "a": 1,
                        "k": [
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 0 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 60 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 120 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 180 },
                            { "s": [100], "t": 240 }
                        ]
                    }
                }
            ],
            "ind": 5
        },
        {
            "ty": 4,
            "sr": 1,
            "st": 0,
            "op": 241,
            "ip": 0,
            "hasMask": false,
            "ao": 0,
            "ks": {
                "a": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [16.68, 15.06], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [16.68, 15.06], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [16.68, 15.06], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [16.68, 15.06], "t": 180 },
                        { "s": [16.68, 15.06], "t": 240 }
                    ]
                },
                "s": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100, 100], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100, 100], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100, 100], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100, 100], "t": 180 },
                        { "s": [100, 100], "t": 240 }
                    ]
                },
                "p": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [524.92, 483.24], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [515.19, 483.01], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [524.92, 483.24], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [515.19, 483.01], "t": 180 },
                        { "s": [524.92, 483.24], "t": 240 }
                    ]
                },
                "r": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [5.41], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [5.41], "t": 180 },
                        { "s": [0], "t": 240 }
                    ]
                },
                "o": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 180 },
                        { "s": [100], "t": 240 }
                    ]
                }
            },
            "shapes": [
                {
                    "ty": "sh",
                    "d": 1,
                    "ks": {
                        "a": 1,
                        "k": [
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0.64, -0.52],
                                            [0.98, -0.49],
                                            [0.47, -0.19],
                                            [0.11, 1.28],
                                            [0.89, -0.73],
                                            [1.55, 0.19],
                                            [0.49, 0.23],
                                            [-0.28, 0.33],
                                            [0.1, 0.28],
                                            [0.31, 0.55],
                                            [-1.47, 4.66],
                                            [0.7, -0.51],
                                            [1.92, -3.6],
                                            [-0.24, -1.48],
                                            [-0.04, -0.15],
                                            [0.94, -0.67],
                                            [1.55, -0.48],
                                            [0.76, 1.08],
                                            [1.08, 2.48],
                                            [0.2, -3.14],
                                            [1.3, -0.32],
                                            [-1.12, 0.27],
                                            [-1.49, 0.65],
                                            [-2.26, 1.7],
                                            [-0.66, 0.59],
                                            [1.28, -0.87],
                                            [-0.76, -0.31],
                                            [-1.55, 0.18],
                                            [-0.45, 0.2],
                                            [-0.21, -0.14],
                                            [-2.37, 1.59],
                                            [2.14, -1.76],
                                            [3.97, 0.78],
                                            [-1.13, -0.22],
                                            [-3.82, 2.73],
                                            [0.22, 4.13],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [-0.04, -0.77],
                                            [-0.85, 0.69],
                                            [-0.47, 0.19],
                                            [-0.94, 0.5],
                                            [0.86, -0.78],
                                            [-1.1, 0.9],
                                            [-0.45, -0.06],
                                            [0.31, -0.25],
                                            [0.22, -0.26],
                                            [-0.29, -0.79],
                                            [3.7, -3.69],
                                            [0.29, -0.9],
                                            [-3.25, 2.41],
                                            [-0.68, 1.27],
                                            [0.02, 0.15],
                                            [-0.9, 0.84],
                                            [-1.31, 0.94],
                                            [-1.1, 0.34],
                                            [2.5, -1.4],
                                            [-1.62, -3.72],
                                            [-1.22, 0.57],
                                            [-1.12, 0.27],
                                            [0.9, -0.22],
                                            [2.12, 3.74],
                                            [0.67, -0.51],
                                            [0.51, 0.92],
                                            [-0.64, 0.43],
                                            [1.39, 0.58],
                                            [0.48, -0.06],
                                            [0.04, 0.24],
                                            [2.46, 1.61],
                                            [-0.41, 2.79],
                                            [-3.38, 2.78],
                                            [-1.12, -0.22],
                                            [4.33, 0.85],
                                            [3.34, -2.39],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [33.34, 17.23],
                                            [31.85, 16.52],
                                            [29.14, 18.38],
                                            [27.72, 18.95],
                                            [26.14, 17.77],
                                            [24.95, 16.44],
                                            [20.84, 18.35],
                                            [19.4, 17.87],
                                            [20.29, 17.03],
                                            [20.34, 16.13],
                                            [19.36, 14.27],
                                            [27.71, 1.15],
                                            [26.26, 0.2],
                                            [18.13, 9.25],
                                            [17.11, 13.38],
                                            [17.23, 13.82],
                                            [14.47, 16.12],
                                            [10.23, 18.32],
                                            [6.72, 18.13],
                                            [10.16, 12.26],
                                            [4.48, 17.29],
                                            [0.67, 18.59],
                                            [1.05, 20.34],
                                            [4.89, 19.03],
                                            [15.98, 17.24],
                                            [17.98, 15.59],
                                            [17.25, 17.22],
                                            [17.37, 18.87],
                                            [21.75, 20.16],
                                            [23.14, 19.75],
                                            [23.5, 20.36],
                                            [31.44, 19.04],
                                            [27.35, 26.34],
                                            [15.66, 27.66],
                                            [15.09, 29.36],
                                            [27.86, 28.19],
                                            [33.34, 17.23],
                                            [33.34, 17.23]
                                        ]
                                    }
                                ],
                                "t": 0
                            },
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0.64, -0.52],
                                            [0.98, -0.49],
                                            [0.47, -0.19],
                                            [0.11, 1.28],
                                            [0.89, -0.73],
                                            [1.55, 0.19],
                                            [0.49, 0.23],
                                            [-0.28, 0.33],
                                            [0.1, 0.28],
                                            [0.31, 0.55],
                                            [-1.47, 4.66],
                                            [0.7, -0.51],
                                            [1.92, -3.6],
                                            [-0.24, -1.48],
                                            [-0.04, -0.15],
                                            [0.94, -0.67],
                                            [1.55, -0.48],
                                            [0.76, 1.08],
                                            [1.08, 2.48],
                                            [0.2, -3.14],
                                            [1.3, -0.32],
                                            [-1.12, 0.27],
                                            [-1.49, 0.65],
                                            [-2.26, 1.7],
                                            [-0.66, 0.59],
                                            [1.28, -0.87],
                                            [-0.76, -0.31],
                                            [-1.55, 0.18],
                                            [-0.45, 0.2],
                                            [-0.21, -0.14],
                                            [-2.37, 1.59],
                                            [2.14, -1.76],
                                            [3.97, 0.78],
                                            [-1.13, -0.22],
                                            [-3.82, 2.73],
                                            [0.22, 4.13],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [-0.04, -0.77],
                                            [-0.85, 0.69],
                                            [-0.47, 0.19],
                                            [-0.94, 0.5],
                                            [0.86, -0.78],
                                            [-1.1, 0.9],
                                            [-0.45, -0.06],
                                            [0.31, -0.25],
                                            [0.22, -0.26],
                                            [-0.29, -0.79],
                                            [3.7, -3.69],
                                            [0.29, -0.9],
                                            [-3.25, 2.41],
                                            [-0.68, 1.27],
                                            [0.02, 0.15],
                                            [-0.9, 0.84],
                                            [-1.31, 0.94],
                                            [-1.1, 0.34],
                                            [2.5, -1.4],
                                            [-1.62, -3.72],
                                            [-1.22, 0.57],
                                            [-1.12, 0.27],
                                            [0.9, -0.22],
                                            [2.12, 3.74],
                                            [0.67, -0.51],
                                            [0.51, 0.92],
                                            [-0.64, 0.43],
                                            [1.39, 0.58],
                                            [0.48, -0.06],
                                            [0.04, 0.24],
                                            [2.46, 1.61],
                                            [-0.41, 2.79],
                                            [-3.38, 2.78],
                                            [-1.12, -0.22],
                                            [4.33, 0.85],
                                            [3.34, -2.39],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [33.34, 17.23],
                                            [31.85, 16.52],
                                            [29.14, 18.38],
                                            [27.72, 18.95],
                                            [26.14, 17.77],
                                            [24.95, 16.44],
                                            [20.84, 18.35],
                                            [19.4, 17.87],
                                            [20.29, 17.03],
                                            [20.34, 16.13],
                                            [19.36, 14.27],
                                            [27.71, 1.15],
                                            [26.26, 0.2],
                                            [18.13, 9.25],
                                            [17.11, 13.38],
                                            [17.23, 13.82],
                                            [14.47, 16.12],
                                            [10.23, 18.32],
                                            [6.72, 18.13],
                                            [10.16, 12.26],
                                            [4.48, 17.29],
                                            [0.67, 18.59],
                                            [1.05, 20.34],
                                            [4.89, 19.03],
                                            [15.98, 17.24],
                                            [17.98, 15.59],
                                            [17.25, 17.22],
                                            [17.37, 18.87],
                                            [21.75, 20.16],
                                            [23.14, 19.75],
                                            [23.5, 20.36],
                                            [31.44, 19.04],
                                            [27.35, 26.34],
                                            [15.66, 27.66],
                                            [15.09, 29.36],
                                            [27.86, 28.19],
                                            [33.34, 17.23],
                                            [33.34, 17.23]
                                        ]
                                    }
                                ],
                                "t": 60
                            },
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0.64, -0.52],
                                            [0.98, -0.49],
                                            [0.47, -0.19],
                                            [0.11, 1.28],
                                            [0.89, -0.73],
                                            [1.55, 0.19],
                                            [0.49, 0.23],
                                            [-0.28, 0.33],
                                            [0.1, 0.28],
                                            [0.31, 0.55],
                                            [-1.47, 4.66],
                                            [0.7, -0.51],
                                            [1.92, -3.6],
                                            [-0.24, -1.48],
                                            [-0.04, -0.15],
                                            [0.94, -0.67],
                                            [1.55, -0.48],
                                            [0.76, 1.08],
                                            [1.08, 2.48],
                                            [0.2, -3.14],
                                            [1.3, -0.32],
                                            [-1.12, 0.27],
                                            [-1.49, 0.65],
                                            [-2.26, 1.7],
                                            [-0.66, 0.59],
                                            [1.28, -0.87],
                                            [-0.76, -0.31],
                                            [-1.55, 0.18],
                                            [-0.45, 0.2],
                                            [-0.21, -0.14],
                                            [-2.37, 1.59],
                                            [2.14, -1.76],
                                            [3.97, 0.78],
                                            [-1.13, -0.22],
                                            [-3.82, 2.73],
                                            [0.22, 4.13],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [-0.04, -0.77],
                                            [-0.85, 0.69],
                                            [-0.47, 0.19],
                                            [-0.94, 0.5],
                                            [0.86, -0.78],
                                            [-1.1, 0.9],
                                            [-0.45, -0.06],
                                            [0.31, -0.25],
                                            [0.22, -0.26],
                                            [-0.29, -0.79],
                                            [3.7, -3.69],
                                            [0.29, -0.9],
                                            [-3.25, 2.41],
                                            [-0.68, 1.27],
                                            [0.02, 0.15],
                                            [-0.9, 0.84],
                                            [-1.31, 0.94],
                                            [-1.1, 0.34],
                                            [2.5, -1.4],
                                            [-1.62, -3.72],
                                            [-1.22, 0.57],
                                            [-1.12, 0.27],
                                            [0.9, -0.22],
                                            [2.12, 3.74],
                                            [0.67, -0.51],
                                            [0.51, 0.92],
                                            [-0.64, 0.43],
                                            [1.39, 0.58],
                                            [0.48, -0.06],
                                            [0.04, 0.24],
                                            [2.46, 1.61],
                                            [-0.41, 2.79],
                                            [-3.38, 2.78],
                                            [-1.12, -0.22],
                                            [4.33, 0.85],
                                            [3.34, -2.39],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [33.34, 17.23],
                                            [31.85, 16.52],
                                            [29.14, 18.38],
                                            [27.72, 18.95],
                                            [26.14, 17.77],
                                            [24.95, 16.44],
                                            [20.84, 18.35],
                                            [19.4, 17.87],
                                            [20.29, 17.03],
                                            [20.34, 16.13],
                                            [19.36, 14.27],
                                            [27.71, 1.15],
                                            [26.26, 0.2],
                                            [18.13, 9.25],
                                            [17.11, 13.38],
                                            [17.23, 13.82],
                                            [14.47, 16.12],
                                            [10.23, 18.32],
                                            [6.72, 18.13],
                                            [10.16, 12.26],
                                            [4.48, 17.29],
                                            [0.67, 18.59],
                                            [1.05, 20.34],
                                            [4.89, 19.03],
                                            [15.98, 17.24],
                                            [17.98, 15.59],
                                            [17.25, 17.22],
                                            [17.37, 18.87],
                                            [21.75, 20.16],
                                            [23.14, 19.75],
                                            [23.5, 20.36],
                                            [31.44, 19.04],
                                            [27.35, 26.34],
                                            [15.66, 27.66],
                                            [15.09, 29.36],
                                            [27.86, 28.19],
                                            [33.34, 17.23],
                                            [33.34, 17.23]
                                        ]
                                    }
                                ],
                                "t": 120
                            },
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0.64, -0.52],
                                            [0.98, -0.49],
                                            [0.47, -0.19],
                                            [0.11, 1.28],
                                            [0.89, -0.73],
                                            [1.55, 0.19],
                                            [0.49, 0.23],
                                            [-0.28, 0.33],
                                            [0.1, 0.28],
                                            [0.31, 0.55],
                                            [-1.47, 4.66],
                                            [0.7, -0.51],
                                            [1.92, -3.6],
                                            [-0.24, -1.48],
                                            [-0.04, -0.15],
                                            [0.94, -0.67],
                                            [1.55, -0.48],
                                            [0.76, 1.08],
                                            [1.08, 2.48],
                                            [0.2, -3.14],
                                            [1.3, -0.32],
                                            [-1.12, 0.27],
                                            [-1.49, 0.65],
                                            [-2.26, 1.7],
                                            [-0.66, 0.59],
                                            [1.28, -0.87],
                                            [-0.76, -0.31],
                                            [-1.55, 0.18],
                                            [-0.45, 0.2],
                                            [-0.21, -0.14],
                                            [-2.37, 1.59],
                                            [2.14, -1.76],
                                            [3.97, 0.78],
                                            [-1.13, -0.22],
                                            [-3.82, 2.73],
                                            [0.22, 4.13],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [-0.04, -0.77],
                                            [-0.85, 0.69],
                                            [-0.47, 0.19],
                                            [-0.94, 0.5],
                                            [0.86, -0.78],
                                            [-1.1, 0.9],
                                            [-0.45, -0.06],
                                            [0.31, -0.25],
                                            [0.22, -0.26],
                                            [-0.29, -0.79],
                                            [3.7, -3.69],
                                            [0.29, -0.9],
                                            [-3.25, 2.41],
                                            [-0.68, 1.27],
                                            [0.02, 0.15],
                                            [-0.9, 0.84],
                                            [-1.31, 0.94],
                                            [-1.1, 0.34],
                                            [2.5, -1.4],
                                            [-1.62, -3.72],
                                            [-1.22, 0.57],
                                            [-1.12, 0.27],
                                            [0.9, -0.22],
                                            [2.12, 3.74],
                                            [0.67, -0.51],
                                            [0.51, 0.92],
                                            [-0.64, 0.43],
                                            [1.39, 0.58],
                                            [0.48, -0.06],
                                            [0.04, 0.24],
                                            [2.46, 1.61],
                                            [-0.41, 2.79],
                                            [-3.38, 2.78],
                                            [-1.12, -0.22],
                                            [4.33, 0.85],
                                            [3.34, -2.39],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [33.34, 17.23],
                                            [31.85, 16.52],
                                            [29.14, 18.38],
                                            [27.72, 18.95],
                                            [26.14, 17.77],
                                            [24.95, 16.44],
                                            [20.84, 18.35],
                                            [19.4, 17.87],
                                            [20.29, 17.03],
                                            [20.34, 16.13],
                                            [19.36, 14.27],
                                            [27.71, 1.15],
                                            [26.26, 0.2],
                                            [18.13, 9.25],
                                            [17.11, 13.38],
                                            [17.23, 13.82],
                                            [14.47, 16.12],
                                            [10.23, 18.32],
                                            [6.72, 18.13],
                                            [10.16, 12.26],
                                            [4.48, 17.29],
                                            [0.67, 18.59],
                                            [1.05, 20.34],
                                            [4.89, 19.03],
                                            [15.98, 17.24],
                                            [17.98, 15.59],
                                            [17.25, 17.22],
                                            [17.37, 18.87],
                                            [21.75, 20.16],
                                            [23.14, 19.75],
                                            [23.5, 20.36],
                                            [31.44, 19.04],
                                            [27.35, 26.34],
                                            [15.66, 27.66],
                                            [15.09, 29.36],
                                            [27.86, 28.19],
                                            [33.34, 17.23],
                                            [33.34, 17.23]
                                        ]
                                    }
                                ],
                                "t": 180
                            },
                            {
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0.64, -0.52],
                                            [0.98, -0.49],
                                            [0.47, -0.19],
                                            [0.11, 1.28],
                                            [0.89, -0.73],
                                            [1.55, 0.19],
                                            [0.49, 0.23],
                                            [-0.28, 0.33],
                                            [0.1, 0.28],
                                            [0.31, 0.55],
                                            [-1.47, 4.66],
                                            [0.7, -0.51],
                                            [1.92, -3.6],
                                            [-0.24, -1.48],
                                            [-0.04, -0.15],
                                            [0.94, -0.67],
                                            [1.55, -0.48],
                                            [0.76, 1.08],
                                            [1.08, 2.48],
                                            [0.2, -3.14],
                                            [1.3, -0.32],
                                            [-1.12, 0.27],
                                            [-1.49, 0.65],
                                            [-2.26, 1.7],
                                            [-0.66, 0.59],
                                            [1.28, -0.87],
                                            [-0.76, -0.31],
                                            [-1.55, 0.18],
                                            [-0.45, 0.2],
                                            [-0.21, -0.14],
                                            [-2.37, 1.59],
                                            [2.14, -1.76],
                                            [3.97, 0.78],
                                            [-1.13, -0.22],
                                            [-3.82, 2.73],
                                            [0.22, 4.13],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [-0.04, -0.77],
                                            [-0.85, 0.69],
                                            [-0.47, 0.19],
                                            [-0.94, 0.5],
                                            [0.86, -0.78],
                                            [-1.1, 0.9],
                                            [-0.45, -0.06],
                                            [0.31, -0.25],
                                            [0.22, -0.26],
                                            [-0.29, -0.79],
                                            [3.7, -3.69],
                                            [0.29, -0.9],
                                            [-3.25, 2.41],
                                            [-0.68, 1.27],
                                            [0.02, 0.15],
                                            [-0.9, 0.84],
                                            [-1.31, 0.94],
                                            [-1.1, 0.34],
                                            [2.5, -1.4],
                                            [-1.62, -3.72],
                                            [-1.22, 0.57],
                                            [-1.12, 0.27],
                                            [0.9, -0.22],
                                            [2.12, 3.74],
                                            [0.67, -0.51],
                                            [0.51, 0.92],
                                            [-0.64, 0.43],
                                            [1.39, 0.58],
                                            [0.48, -0.06],
                                            [0.04, 0.24],
                                            [2.46, 1.61],
                                            [-0.41, 2.79],
                                            [-3.38, 2.78],
                                            [-1.12, -0.22],
                                            [4.33, 0.85],
                                            [3.34, -2.39],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [33.34, 17.23],
                                            [31.85, 16.52],
                                            [29.14, 18.38],
                                            [27.72, 18.95],
                                            [26.14, 17.77],
                                            [24.95, 16.44],
                                            [20.84, 18.35],
                                            [19.4, 17.87],
                                            [20.29, 17.03],
                                            [20.34, 16.13],
                                            [19.36, 14.27],
                                            [27.71, 1.15],
                                            [26.26, 0.2],
                                            [18.13, 9.25],
                                            [17.11, 13.38],
                                            [17.23, 13.82],
                                            [14.47, 16.12],
                                            [10.23, 18.32],
                                            [6.72, 18.13],
                                            [10.16, 12.26],
                                            [4.48, 17.29],
                                            [0.67, 18.59],
                                            [1.05, 20.34],
                                            [4.89, 19.03],
                                            [15.98, 17.24],
                                            [17.98, 15.59],
                                            [17.25, 17.22],
                                            [17.37, 18.87],
                                            [21.75, 20.16],
                                            [23.14, 19.75],
                                            [23.5, 20.36],
                                            [31.44, 19.04],
                                            [27.35, 26.34],
                                            [15.66, 27.66],
                                            [15.09, 29.36],
                                            [27.86, 28.19],
                                            [33.34, 17.23],
                                            [33.34, 17.23]
                                        ]
                                    }
                                ],
                                "t": 240
                            }
                        ]
                    }
                },
                {
                    "ty": "sh",
                    "d": 1,
                    "ks": {
                        "a": 1,
                        "k": [
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0.49, -0.5],
                                            [0.37, -0.25],
                                            [-0.39, 0.3],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [1.39, -1.07],
                                            [-0.3, 0.31],
                                            [0.04, -0.59],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [7.4, 13.98],
                                            [7.36, 15.44],
                                            [6.32, 16.26],
                                            [7.4, 13.98],
                                            [7.4, 13.98]
                                        ]
                                    }
                                ],
                                "t": 0
                            },
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0.49, -0.5],
                                            [0.37, -0.25],
                                            [-0.39, 0.3],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [1.39, -1.07],
                                            [-0.3, 0.31],
                                            [0.04, -0.59],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [7.4, 13.98],
                                            [7.36, 15.44],
                                            [6.32, 16.26],
                                            [7.4, 13.98],
                                            [7.4, 13.98]
                                        ]
                                    }
                                ],
                                "t": 60
                            },
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0.49, -0.5],
                                            [0.37, -0.25],
                                            [-0.39, 0.3],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [1.39, -1.07],
                                            [-0.3, 0.31],
                                            [0.04, -0.59],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [7.4, 13.98],
                                            [7.36, 15.44],
                                            [6.32, 16.26],
                                            [7.4, 13.98],
                                            [7.4, 13.98]
                                        ]
                                    }
                                ],
                                "t": 120
                            },
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0.49, -0.5],
                                            [0.37, -0.25],
                                            [-0.39, 0.3],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [1.39, -1.07],
                                            [-0.3, 0.31],
                                            [0.04, -0.59],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [7.4, 13.98],
                                            [7.36, 15.44],
                                            [6.32, 16.26],
                                            [7.4, 13.98],
                                            [7.4, 13.98]
                                        ]
                                    }
                                ],
                                "t": 180
                            },
                            {
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0.49, -0.5],
                                            [0.37, -0.25],
                                            [-0.39, 0.3],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [1.39, -1.07],
                                            [-0.3, 0.31],
                                            [0.04, -0.59],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [7.4, 13.98],
                                            [7.36, 15.44],
                                            [6.32, 16.26],
                                            [7.4, 13.98],
                                            [7.4, 13.98]
                                        ]
                                    }
                                ],
                                "t": 240
                            }
                        ]
                    }
                },
                {
                    "ty": "sh",
                    "d": 1,
                    "ks": {
                        "a": 1,
                        "k": [
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [-0.85, 1.15],
                                            [-1.16, 1.08],
                                            [2.28, -2.45],
                                            [-0.06, 0.24],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0.34, -1.39],
                                            [0.96, -1.29],
                                            [-1.42, 2.93],
                                            [0.03, -0.2],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [19.06, 11.46],
                                            [21.46, 7.38],
                                            [24.66, 3.86],
                                            [18.95, 12.1],
                                            [19.06, 11.46],
                                            [19.06, 11.46]
                                        ]
                                    }
                                ],
                                "t": 0
                            },
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [-0.85, 1.15],
                                            [-1.16, 1.08],
                                            [2.28, -2.45],
                                            [-0.06, 0.24],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0.34, -1.39],
                                            [0.96, -1.29],
                                            [-1.42, 2.93],
                                            [0.03, -0.2],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [19.06, 11.46],
                                            [21.46, 7.38],
                                            [24.66, 3.86],
                                            [18.95, 12.1],
                                            [19.06, 11.46],
                                            [19.06, 11.46]
                                        ]
                                    }
                                ],
                                "t": 60
                            },
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [-0.85, 1.15],
                                            [-1.16, 1.08],
                                            [2.28, -2.45],
                                            [-0.06, 0.24],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0.34, -1.39],
                                            [0.96, -1.29],
                                            [-1.42, 2.93],
                                            [0.03, -0.2],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [19.06, 11.46],
                                            [21.46, 7.38],
                                            [24.66, 3.86],
                                            [18.95, 12.1],
                                            [19.06, 11.46],
                                            [19.06, 11.46]
                                        ]
                                    }
                                ],
                                "t": 120
                            },
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [-0.85, 1.15],
                                            [-1.16, 1.08],
                                            [2.28, -2.45],
                                            [-0.06, 0.24],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0.34, -1.39],
                                            [0.96, -1.29],
                                            [-1.42, 2.93],
                                            [0.03, -0.2],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [19.06, 11.46],
                                            [21.46, 7.38],
                                            [24.66, 3.86],
                                            [18.95, 12.1],
                                            [19.06, 11.46],
                                            [19.06, 11.46]
                                        ]
                                    }
                                ],
                                "t": 180
                            },
                            {
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [-0.85, 1.15],
                                            [-1.16, 1.08],
                                            [2.28, -2.45],
                                            [-0.06, 0.24],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0.34, -1.39],
                                            [0.96, -1.29],
                                            [-1.42, 2.93],
                                            [0.03, -0.2],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [19.06, 11.46],
                                            [21.46, 7.38],
                                            [24.66, 3.86],
                                            [18.95, 12.1],
                                            [19.06, 11.46],
                                            [19.06, 11.46]
                                        ]
                                    }
                                ],
                                "t": 240
                            }
                        ]
                    }
                },
                {
                    "ty": "fl",
                    "c": {
                        "a": 1,
                        "k": [
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0.8941, 0.9255, 0.9765], "t": 0 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0.8941, 0.9255, 0.9765], "t": 60 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0.8941, 0.9255, 0.9765], "t": 120 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0.8941, 0.9255, 0.9765], "t": 180 },
                            { "s": [0.8941, 0.9255, 0.9765], "t": 240 }
                        ]
                    },
                    "r": 1,
                    "o": {
                        "a": 1,
                        "k": [
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 0 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 60 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 120 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 180 },
                            { "s": [100], "t": 240 }
                        ]
                    }
                }
            ],
            "ind": 6
        },
        {
            "ty": 4,
            "sr": 1,
            "st": 0,
            "op": 241,
            "ip": 0,
            "hasMask": false,
            "ao": 0,
            "ks": {
                "a": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [84.82, 4.75], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [84.82, 4.75], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [84.82, 4.75], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [84.82, 4.75], "t": 180 },
                        { "s": [84.82, 4.75], "t": 240 }
                    ]
                },
                "s": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100, 100], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100, 100], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100, 100], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100, 100], "t": 180 },
                        { "s": [100, 100], "t": 240 }
                    ]
                },
                "p": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [515.81, 445.2], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [509.71, 444.28], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [515.81, 445.2], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [509.71, 444.28], "t": 180 },
                        { "s": [515.81, 445.2], "t": 240 }
                    ]
                },
                "r": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [5.95], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [11.36], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [5.95], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [11.36], "t": 180 },
                        { "s": [5.95], "t": 240 }
                    ]
                },
                "o": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 180 },
                        { "s": [100], "t": 240 }
                    ]
                }
            },
            "shapes": [
                {
                    "ty": "sh",
                    "d": 1,
                    "ks": {
                        "a": 1,
                        "k": [
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, -2.62],
                                            [0, 0],
                                            [2.62, 0],
                                            [0, 0],
                                            [0, 2.62],
                                            [0, 0],
                                            [-2.62, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [2.62, 0],
                                            [0, 0],
                                            [0, 2.62],
                                            [0, 0],
                                            [-2.62, 0],
                                            [0, 0],
                                            [0, -2.62],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [4.75, 0],
                                            [164.89, 0],
                                            [169.64, 4.75],
                                            [169.64, 4.75],
                                            [164.89, 9.5],
                                            [4.75, 9.5],
                                            [0, 4.75],
                                            [0, 4.75],
                                            [4.75, 0]
                                        ]
                                    }
                                ],
                                "t": 0
                            },
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, -2.62],
                                            [0, 0],
                                            [2.62, 0],
                                            [0, 0],
                                            [0, 2.62],
                                            [0, 0],
                                            [-2.62, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [2.62, 0],
                                            [0, 0],
                                            [0, 2.62],
                                            [0, 0],
                                            [-2.62, 0],
                                            [0, 0],
                                            [0, -2.62],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [4.75, 0],
                                            [164.89, 0],
                                            [169.64, 4.75],
                                            [169.64, 4.75],
                                            [164.89, 9.5],
                                            [4.75, 9.5],
                                            [0, 4.75],
                                            [0, 4.75],
                                            [4.75, 0]
                                        ]
                                    }
                                ],
                                "t": 60
                            },
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, -2.62],
                                            [0, 0],
                                            [2.62, 0],
                                            [0, 0],
                                            [0, 2.62],
                                            [0, 0],
                                            [-2.62, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [2.62, 0],
                                            [0, 0],
                                            [0, 2.62],
                                            [0, 0],
                                            [-2.62, 0],
                                            [0, 0],
                                            [0, -2.62],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [4.75, 0],
                                            [164.89, 0],
                                            [169.64, 4.75],
                                            [169.64, 4.75],
                                            [164.89, 9.5],
                                            [4.75, 9.5],
                                            [0, 4.75],
                                            [0, 4.75],
                                            [4.75, 0]
                                        ]
                                    }
                                ],
                                "t": 120
                            },
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, -2.62],
                                            [0, 0],
                                            [2.62, 0],
                                            [0, 0],
                                            [0, 2.62],
                                            [0, 0],
                                            [-2.62, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [2.62, 0],
                                            [0, 0],
                                            [0, 2.62],
                                            [0, 0],
                                            [-2.62, 0],
                                            [0, 0],
                                            [0, -2.62],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [4.75, 0],
                                            [164.89, 0],
                                            [169.64, 4.75],
                                            [169.64, 4.75],
                                            [164.89, 9.5],
                                            [4.75, 9.5],
                                            [0, 4.75],
                                            [0, 4.75],
                                            [4.75, 0]
                                        ]
                                    }
                                ],
                                "t": 180
                            },
                            {
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, -2.62],
                                            [0, 0],
                                            [2.62, 0],
                                            [0, 0],
                                            [0, 2.62],
                                            [0, 0],
                                            [-2.62, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [2.62, 0],
                                            [0, 0],
                                            [0, 2.62],
                                            [0, 0],
                                            [-2.62, 0],
                                            [0, 0],
                                            [0, -2.62],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [4.75, 0],
                                            [164.89, 0],
                                            [169.64, 4.75],
                                            [169.64, 4.75],
                                            [164.89, 9.5],
                                            [4.75, 9.5],
                                            [0, 4.75],
                                            [0, 4.75],
                                            [4.75, 0]
                                        ]
                                    }
                                ],
                                "t": 240
                            }
                        ]
                    }
                },
                {
                    "ty": "fl",
                    "c": {
                        "a": 1,
                        "k": [
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0.8941, 0.9255, 0.9765], "t": 0 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0.8941, 0.9255, 0.9765], "t": 60 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0.8941, 0.9255, 0.9765], "t": 120 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0.8941, 0.9255, 0.9765], "t": 180 },
                            { "s": [0.8941, 0.9255, 0.9765], "t": 240 }
                        ]
                    },
                    "r": 1,
                    "o": {
                        "a": 1,
                        "k": [
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 0 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 60 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 120 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 180 },
                            { "s": [100], "t": 240 }
                        ]
                    }
                }
            ],
            "ind": 7
        },
        {
            "ty": 4,
            "sr": 1,
            "st": 0,
            "op": 241,
            "ip": 0,
            "hasMask": false,
            "ao": 0,
            "ks": {
                "a": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [84.82, 4.75], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [84.82, 4.75], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [84.82, 4.75], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [84.82, 4.75], "t": 180 },
                        { "s": [84.82, 4.75], "t": 240 }
                    ]
                },
                "s": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100, 100], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100, 100], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100, 100], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100, 100], "t": 180 },
                        { "s": [100, 100], "t": 240 }
                    ]
                },
                "p": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [518.32, 421.14], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [514.48, 420.57], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [518.32, 421.14], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [514.48, 420.57], "t": 180 },
                        { "s": [518.32, 421.14], "t": 240 }
                    ]
                },
                "r": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [5.95], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [11.36], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [5.95], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [11.36], "t": 180 },
                        { "s": [5.95], "t": 240 }
                    ]
                },
                "o": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 180 },
                        { "s": [100], "t": 240 }
                    ]
                }
            },
            "shapes": [
                {
                    "ty": "sh",
                    "d": 1,
                    "ks": {
                        "a": 1,
                        "k": [
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, -2.62],
                                            [0, 0],
                                            [2.62, 0],
                                            [0, 0],
                                            [0, 2.62],
                                            [0, 0],
                                            [-2.62, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [2.62, 0],
                                            [0, 0],
                                            [0, 2.62],
                                            [0, 0],
                                            [-2.62, 0],
                                            [0, 0],
                                            [0, -2.62],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [4.75, 0],
                                            [164.89, 0],
                                            [169.64, 4.75],
                                            [169.64, 4.75],
                                            [164.89, 9.5],
                                            [4.75, 9.5],
                                            [0, 4.75],
                                            [0, 4.75],
                                            [4.75, 0]
                                        ]
                                    }
                                ],
                                "t": 0
                            },
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, -2.62],
                                            [0, 0],
                                            [2.62, 0],
                                            [0, 0],
                                            [0, 2.62],
                                            [0, 0],
                                            [-2.62, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [2.62, 0],
                                            [0, 0],
                                            [0, 2.62],
                                            [0, 0],
                                            [-2.62, 0],
                                            [0, 0],
                                            [0, -2.62],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [4.75, 0],
                                            [164.89, 0],
                                            [169.64, 4.75],
                                            [169.64, 4.75],
                                            [164.89, 9.5],
                                            [4.75, 9.5],
                                            [0, 4.75],
                                            [0, 4.75],
                                            [4.75, 0]
                                        ]
                                    }
                                ],
                                "t": 60
                            },
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, -2.62],
                                            [0, 0],
                                            [2.62, 0],
                                            [0, 0],
                                            [0, 2.62],
                                            [0, 0],
                                            [-2.62, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [2.62, 0],
                                            [0, 0],
                                            [0, 2.62],
                                            [0, 0],
                                            [-2.62, 0],
                                            [0, 0],
                                            [0, -2.62],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [4.75, 0],
                                            [164.89, 0],
                                            [169.64, 4.75],
                                            [169.64, 4.75],
                                            [164.89, 9.5],
                                            [4.75, 9.5],
                                            [0, 4.75],
                                            [0, 4.75],
                                            [4.75, 0]
                                        ]
                                    }
                                ],
                                "t": 120
                            },
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, -2.62],
                                            [0, 0],
                                            [2.62, 0],
                                            [0, 0],
                                            [0, 2.62],
                                            [0, 0],
                                            [-2.62, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [2.62, 0],
                                            [0, 0],
                                            [0, 2.62],
                                            [0, 0],
                                            [-2.62, 0],
                                            [0, 0],
                                            [0, -2.62],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [4.75, 0],
                                            [164.89, 0],
                                            [169.64, 4.75],
                                            [169.64, 4.75],
                                            [164.89, 9.5],
                                            [4.75, 9.5],
                                            [0, 4.75],
                                            [0, 4.75],
                                            [4.75, 0]
                                        ]
                                    }
                                ],
                                "t": 180
                            },
                            {
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, -2.62],
                                            [0, 0],
                                            [2.62, 0],
                                            [0, 0],
                                            [0, 2.62],
                                            [0, 0],
                                            [-2.62, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [2.62, 0],
                                            [0, 0],
                                            [0, 2.62],
                                            [0, 0],
                                            [-2.62, 0],
                                            [0, 0],
                                            [0, -2.62],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [4.75, 0],
                                            [164.89, 0],
                                            [169.64, 4.75],
                                            [169.64, 4.75],
                                            [164.89, 9.5],
                                            [4.75, 9.5],
                                            [0, 4.75],
                                            [0, 4.75],
                                            [4.75, 0]
                                        ]
                                    }
                                ],
                                "t": 240
                            }
                        ]
                    }
                },
                {
                    "ty": "fl",
                    "c": {
                        "a": 1,
                        "k": [
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0.8941, 0.9255, 0.9765], "t": 0 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0.8941, 0.9255, 0.9765], "t": 60 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0.8941, 0.9255, 0.9765], "t": 120 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0.8941, 0.9255, 0.9765], "t": 180 },
                            { "s": [0.8941, 0.9255, 0.9765], "t": 240 }
                        ]
                    },
                    "r": 1,
                    "o": {
                        "a": 1,
                        "k": [
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 0 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 60 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 120 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 180 },
                            { "s": [100], "t": 240 }
                        ]
                    }
                }
            ],
            "ind": 8
        },
        {
            "ty": 4,
            "sr": 1,
            "st": 0,
            "op": 241,
            "ip": 0,
            "hasMask": false,
            "ao": 0,
            "ks": {
                "a": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [84.82, 4.75], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [84.82, 4.75], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [84.82, 4.75], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [84.82, 4.75], "t": 180 },
                        { "s": [84.82, 4.75], "t": 240 }
                    ]
                },
                "s": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100, 100], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100, 100], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100, 100], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100, 100], "t": 180 },
                        { "s": [100, 100], "t": 240 }
                    ]
                },
                "p": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [520.82, 397.09], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [519.24, 396.87], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [520.82, 397.09], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [519.24, 396.87], "t": 180 },
                        { "s": [520.82, 397.09], "t": 240 }
                    ]
                },
                "r": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [5.95], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [11.36], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [5.95], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [11.36], "t": 180 },
                        { "s": [5.95], "t": 240 }
                    ]
                },
                "o": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 180 },
                        { "s": [100], "t": 240 }
                    ]
                }
            },
            "shapes": [
                {
                    "ty": "sh",
                    "d": 1,
                    "ks": {
                        "a": 1,
                        "k": [
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, -2.62],
                                            [0, 0],
                                            [2.62, 0],
                                            [0, 0],
                                            [0, 2.62],
                                            [0, 0],
                                            [-2.62, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [2.62, 0],
                                            [0, 0],
                                            [0, 2.62],
                                            [0, 0],
                                            [-2.62, 0],
                                            [0, 0],
                                            [0, -2.62],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [4.75, 0],
                                            [164.89, 0],
                                            [169.64, 4.75],
                                            [169.64, 4.75],
                                            [164.89, 9.5],
                                            [4.75, 9.5],
                                            [0, 4.75],
                                            [0, 4.75],
                                            [4.75, 0]
                                        ]
                                    }
                                ],
                                "t": 0
                            },
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, -2.62],
                                            [0, 0],
                                            [2.62, 0],
                                            [0, 0],
                                            [0, 2.62],
                                            [0, 0],
                                            [-2.62, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [2.62, 0],
                                            [0, 0],
                                            [0, 2.62],
                                            [0, 0],
                                            [-2.62, 0],
                                            [0, 0],
                                            [0, -2.62],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [4.75, 0],
                                            [164.89, 0],
                                            [169.64, 4.75],
                                            [169.64, 4.75],
                                            [164.89, 9.5],
                                            [4.75, 9.5],
                                            [0, 4.75],
                                            [0, 4.75],
                                            [4.75, 0]
                                        ]
                                    }
                                ],
                                "t": 60
                            },
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, -2.62],
                                            [0, 0],
                                            [2.62, 0],
                                            [0, 0],
                                            [0, 2.62],
                                            [0, 0],
                                            [-2.62, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [2.62, 0],
                                            [0, 0],
                                            [0, 2.62],
                                            [0, 0],
                                            [-2.62, 0],
                                            [0, 0],
                                            [0, -2.62],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [4.75, 0],
                                            [164.89, 0],
                                            [169.64, 4.75],
                                            [169.64, 4.75],
                                            [164.89, 9.5],
                                            [4.75, 9.5],
                                            [0, 4.75],
                                            [0, 4.75],
                                            [4.75, 0]
                                        ]
                                    }
                                ],
                                "t": 120
                            },
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, -2.62],
                                            [0, 0],
                                            [2.62, 0],
                                            [0, 0],
                                            [0, 2.62],
                                            [0, 0],
                                            [-2.62, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [2.62, 0],
                                            [0, 0],
                                            [0, 2.62],
                                            [0, 0],
                                            [-2.62, 0],
                                            [0, 0],
                                            [0, -2.62],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [4.75, 0],
                                            [164.89, 0],
                                            [169.64, 4.75],
                                            [169.64, 4.75],
                                            [164.89, 9.5],
                                            [4.75, 9.5],
                                            [0, 4.75],
                                            [0, 4.75],
                                            [4.75, 0]
                                        ]
                                    }
                                ],
                                "t": 180
                            },
                            {
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, -2.62],
                                            [0, 0],
                                            [2.62, 0],
                                            [0, 0],
                                            [0, 2.62],
                                            [0, 0],
                                            [-2.62, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [2.62, 0],
                                            [0, 0],
                                            [0, 2.62],
                                            [0, 0],
                                            [-2.62, 0],
                                            [0, 0],
                                            [0, -2.62],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [4.75, 0],
                                            [164.89, 0],
                                            [169.64, 4.75],
                                            [169.64, 4.75],
                                            [164.89, 9.5],
                                            [4.75, 9.5],
                                            [0, 4.75],
                                            [0, 4.75],
                                            [4.75, 0]
                                        ]
                                    }
                                ],
                                "t": 240
                            }
                        ]
                    }
                },
                {
                    "ty": "fl",
                    "c": {
                        "a": 1,
                        "k": [
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0.8941, 0.9255, 0.9765], "t": 0 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0.8941, 0.9255, 0.9765], "t": 60 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0.8941, 0.9255, 0.9765], "t": 120 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0.8941, 0.9255, 0.9765], "t": 180 },
                            { "s": [0.8941, 0.9255, 0.9765], "t": 240 }
                        ]
                    },
                    "r": 1,
                    "o": {
                        "a": 1,
                        "k": [
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 0 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 60 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 120 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 180 },
                            { "s": [100], "t": 240 }
                        ]
                    }
                }
            ],
            "ind": 9
        },
        {
            "ty": 4,
            "sr": 1,
            "st": 0,
            "op": 241,
            "ip": 0,
            "hasMask": false,
            "ao": 0,
            "ks": {
                "a": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [84.82, 4.75], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [84.82, 4.75], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [84.82, 4.75], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [84.82, 4.75], "t": 180 },
                        { "s": [84.82, 4.75], "t": 240 }
                    ]
                },
                "s": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100, 100], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100, 100], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100, 100], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100, 100], "t": 180 },
                        { "s": [100, 100], "t": 240 }
                    ]
                },
                "p": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [523.33, 373.04], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [524.01, 373.16], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [523.33, 373.04], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [524.01, 373.16], "t": 180 },
                        { "s": [523.33, 373.04], "t": 240 }
                    ]
                },
                "r": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [5.95], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [11.36], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [5.95], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [11.36], "t": 180 },
                        { "s": [5.95], "t": 240 }
                    ]
                },
                "o": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 180 },
                        { "s": [100], "t": 240 }
                    ]
                }
            },
            "shapes": [
                {
                    "ty": "sh",
                    "d": 1,
                    "ks": {
                        "a": 1,
                        "k": [
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, -2.62],
                                            [0, 0],
                                            [2.62, 0],
                                            [0, 0],
                                            [0, 2.62],
                                            [0, 0],
                                            [-2.62, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [2.62, 0],
                                            [0, 0],
                                            [0, 2.62],
                                            [0, 0],
                                            [-2.62, 0],
                                            [0, 0],
                                            [0, -2.62],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [4.75, 0],
                                            [164.89, 0],
                                            [169.64, 4.75],
                                            [169.64, 4.75],
                                            [164.89, 9.5],
                                            [4.75, 9.5],
                                            [0, 4.75],
                                            [0, 4.75],
                                            [4.75, 0]
                                        ]
                                    }
                                ],
                                "t": 0
                            },
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, -2.62],
                                            [0, 0],
                                            [2.62, 0],
                                            [0, 0],
                                            [0, 2.62],
                                            [0, 0],
                                            [-2.62, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [2.62, 0],
                                            [0, 0],
                                            [0, 2.62],
                                            [0, 0],
                                            [-2.62, 0],
                                            [0, 0],
                                            [0, -2.62],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [4.75, 0],
                                            [164.89, 0],
                                            [169.64, 4.75],
                                            [169.64, 4.75],
                                            [164.89, 9.5],
                                            [4.75, 9.5],
                                            [0, 4.75],
                                            [0, 4.75],
                                            [4.75, 0]
                                        ]
                                    }
                                ],
                                "t": 60
                            },
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, -2.62],
                                            [0, 0],
                                            [2.62, 0],
                                            [0, 0],
                                            [0, 2.62],
                                            [0, 0],
                                            [-2.62, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [2.62, 0],
                                            [0, 0],
                                            [0, 2.62],
                                            [0, 0],
                                            [-2.62, 0],
                                            [0, 0],
                                            [0, -2.62],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [4.75, 0],
                                            [164.89, 0],
                                            [169.64, 4.75],
                                            [169.64, 4.75],
                                            [164.89, 9.5],
                                            [4.75, 9.5],
                                            [0, 4.75],
                                            [0, 4.75],
                                            [4.75, 0]
                                        ]
                                    }
                                ],
                                "t": 120
                            },
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, -2.62],
                                            [0, 0],
                                            [2.62, 0],
                                            [0, 0],
                                            [0, 2.62],
                                            [0, 0],
                                            [-2.62, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [2.62, 0],
                                            [0, 0],
                                            [0, 2.62],
                                            [0, 0],
                                            [-2.62, 0],
                                            [0, 0],
                                            [0, -2.62],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [4.75, 0],
                                            [164.89, 0],
                                            [169.64, 4.75],
                                            [169.64, 4.75],
                                            [164.89, 9.5],
                                            [4.75, 9.5],
                                            [0, 4.75],
                                            [0, 4.75],
                                            [4.75, 0]
                                        ]
                                    }
                                ],
                                "t": 180
                            },
                            {
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, -2.62],
                                            [0, 0],
                                            [2.62, 0],
                                            [0, 0],
                                            [0, 2.62],
                                            [0, 0],
                                            [-2.62, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [2.62, 0],
                                            [0, 0],
                                            [0, 2.62],
                                            [0, 0],
                                            [-2.62, 0],
                                            [0, 0],
                                            [0, -2.62],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [4.75, 0],
                                            [164.89, 0],
                                            [169.64, 4.75],
                                            [169.64, 4.75],
                                            [164.89, 9.5],
                                            [4.75, 9.5],
                                            [0, 4.75],
                                            [0, 4.75],
                                            [4.75, 0]
                                        ]
                                    }
                                ],
                                "t": 240
                            }
                        ]
                    }
                },
                {
                    "ty": "fl",
                    "c": {
                        "a": 1,
                        "k": [
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0.8941, 0.9255, 0.9765], "t": 0 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0.8941, 0.9255, 0.9765], "t": 60 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0.8941, 0.9255, 0.9765], "t": 120 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0.8941, 0.9255, 0.9765], "t": 180 },
                            { "s": [0.8941, 0.9255, 0.9765], "t": 240 }
                        ]
                    },
                    "r": 1,
                    "o": {
                        "a": 1,
                        "k": [
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 0 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 60 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 120 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 180 },
                            { "s": [100], "t": 240 }
                        ]
                    }
                }
            ],
            "ind": 10
        },
        {
            "ty": 4,
            "sr": 1,
            "st": 0,
            "op": 241,
            "ip": 0,
            "hasMask": false,
            "ao": 0,
            "ks": {
                "a": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [84.82, 4.75], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [84.82, 4.75], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [84.82, 4.75], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [84.82, 4.75], "t": 180 },
                        { "s": [84.82, 4.75], "t": 240 }
                    ]
                },
                "s": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100, 100], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100, 100], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100, 100], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100, 100], "t": 180 },
                        { "s": [100, 100], "t": 240 }
                    ]
                },
                "p": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [525.83, 348.99], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [528.77, 349.45], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [525.83, 348.99], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [528.77, 349.45], "t": 180 },
                        { "s": [525.83, 348.99], "t": 240 }
                    ]
                },
                "r": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [5.95], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [11.36], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [5.95], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [11.36], "t": 180 },
                        { "s": [5.95], "t": 240 }
                    ]
                },
                "o": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 180 },
                        { "s": [100], "t": 240 }
                    ]
                }
            },
            "shapes": [
                {
                    "ty": "sh",
                    "d": 1,
                    "ks": {
                        "a": 1,
                        "k": [
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, -2.62],
                                            [0, 0],
                                            [2.62, 0],
                                            [0, 0],
                                            [0, 2.62],
                                            [0, 0],
                                            [-2.62, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [2.62, 0],
                                            [0, 0],
                                            [0, 2.62],
                                            [0, 0],
                                            [-2.62, 0],
                                            [0, 0],
                                            [0, -2.62],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [4.75, 0],
                                            [164.89, 0],
                                            [169.64, 4.75],
                                            [169.64, 4.75],
                                            [164.89, 9.5],
                                            [4.75, 9.5],
                                            [0, 4.75],
                                            [0, 4.75],
                                            [4.75, 0]
                                        ]
                                    }
                                ],
                                "t": 0
                            },
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, -2.62],
                                            [0, 0],
                                            [2.62, 0],
                                            [0, 0],
                                            [0, 2.62],
                                            [0, 0],
                                            [-2.62, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [2.62, 0],
                                            [0, 0],
                                            [0, 2.62],
                                            [0, 0],
                                            [-2.62, 0],
                                            [0, 0],
                                            [0, -2.62],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [4.75, 0],
                                            [164.89, 0],
                                            [169.64, 4.75],
                                            [169.64, 4.75],
                                            [164.89, 9.5],
                                            [4.75, 9.5],
                                            [0, 4.75],
                                            [0, 4.75],
                                            [4.75, 0]
                                        ]
                                    }
                                ],
                                "t": 60
                            },
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, -2.62],
                                            [0, 0],
                                            [2.62, 0],
                                            [0, 0],
                                            [0, 2.62],
                                            [0, 0],
                                            [-2.62, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [2.62, 0],
                                            [0, 0],
                                            [0, 2.62],
                                            [0, 0],
                                            [-2.62, 0],
                                            [0, 0],
                                            [0, -2.62],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [4.75, 0],
                                            [164.89, 0],
                                            [169.64, 4.75],
                                            [169.64, 4.75],
                                            [164.89, 9.5],
                                            [4.75, 9.5],
                                            [0, 4.75],
                                            [0, 4.75],
                                            [4.75, 0]
                                        ]
                                    }
                                ],
                                "t": 120
                            },
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, -2.62],
                                            [0, 0],
                                            [2.62, 0],
                                            [0, 0],
                                            [0, 2.62],
                                            [0, 0],
                                            [-2.62, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [2.62, 0],
                                            [0, 0],
                                            [0, 2.62],
                                            [0, 0],
                                            [-2.62, 0],
                                            [0, 0],
                                            [0, -2.62],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [4.75, 0],
                                            [164.89, 0],
                                            [169.64, 4.75],
                                            [169.64, 4.75],
                                            [164.89, 9.5],
                                            [4.75, 9.5],
                                            [0, 4.75],
                                            [0, 4.75],
                                            [4.75, 0]
                                        ]
                                    }
                                ],
                                "t": 180
                            },
                            {
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, -2.62],
                                            [0, 0],
                                            [2.62, 0],
                                            [0, 0],
                                            [0, 2.62],
                                            [0, 0],
                                            [-2.62, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [2.62, 0],
                                            [0, 0],
                                            [0, 2.62],
                                            [0, 0],
                                            [-2.62, 0],
                                            [0, 0],
                                            [0, -2.62],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [4.75, 0],
                                            [164.89, 0],
                                            [169.64, 4.75],
                                            [169.64, 4.75],
                                            [164.89, 9.5],
                                            [4.75, 9.5],
                                            [0, 4.75],
                                            [0, 4.75],
                                            [4.75, 0]
                                        ]
                                    }
                                ],
                                "t": 240
                            }
                        ]
                    }
                },
                {
                    "ty": "fl",
                    "c": {
                        "a": 1,
                        "k": [
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0.8941, 0.9255, 0.9765], "t": 0 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0.8941, 0.9255, 0.9765], "t": 60 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0.8941, 0.9255, 0.9765], "t": 120 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0.8941, 0.9255, 0.9765], "t": 180 },
                            { "s": [0.8941, 0.9255, 0.9765], "t": 240 }
                        ]
                    },
                    "r": 1,
                    "o": {
                        "a": 1,
                        "k": [
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 0 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 60 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 120 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 180 },
                            { "s": [100], "t": 240 }
                        ]
                    }
                }
            ],
            "ind": 11
        },
        {
            "ty": 4,
            "sr": 1,
            "st": 0,
            "op": 241,
            "ip": 0,
            "hasMask": false,
            "ao": 0,
            "ks": {
                "a": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [84.82, 4.75], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [84.82, 4.75], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [84.82, 4.75], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [84.82, 4.75], "t": 180 },
                        { "s": [84.82, 4.75], "t": 240 }
                    ]
                },
                "s": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100, 100], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100, 100], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100, 100], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100, 100], "t": 180 },
                        { "s": [100, 100], "t": 240 }
                    ]
                },
                "p": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [528.34, 324.94], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [533.53, 325.74], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [528.34, 324.94], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [533.53, 325.74], "t": 180 },
                        { "s": [528.34, 324.94], "t": 240 }
                    ]
                },
                "r": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [5.95], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [11.36], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [5.95], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [11.36], "t": 180 },
                        { "s": [5.95], "t": 240 }
                    ]
                },
                "o": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 180 },
                        { "s": [100], "t": 240 }
                    ]
                }
            },
            "shapes": [
                {
                    "ty": "sh",
                    "d": 1,
                    "ks": {
                        "a": 1,
                        "k": [
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, -2.62],
                                            [0, 0],
                                            [2.62, 0],
                                            [0, 0],
                                            [0, 2.62],
                                            [0, 0],
                                            [-2.62, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [2.62, 0],
                                            [0, 0],
                                            [0, 2.62],
                                            [0, 0],
                                            [-2.62, 0],
                                            [0, 0],
                                            [0, -2.62],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [4.75, 0],
                                            [164.89, 0],
                                            [169.64, 4.75],
                                            [169.64, 4.75],
                                            [164.89, 9.5],
                                            [4.75, 9.5],
                                            [0, 4.75],
                                            [0, 4.75],
                                            [4.75, 0]
                                        ]
                                    }
                                ],
                                "t": 0
                            },
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, -2.62],
                                            [0, 0],
                                            [2.62, 0],
                                            [0, 0],
                                            [0, 2.62],
                                            [0, 0],
                                            [-2.62, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [2.62, 0],
                                            [0, 0],
                                            [0, 2.62],
                                            [0, 0],
                                            [-2.62, 0],
                                            [0, 0],
                                            [0, -2.62],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [4.75, 0],
                                            [164.89, 0],
                                            [169.64, 4.75],
                                            [169.64, 4.75],
                                            [164.89, 9.5],
                                            [4.75, 9.5],
                                            [0, 4.75],
                                            [0, 4.75],
                                            [4.75, 0]
                                        ]
                                    }
                                ],
                                "t": 60
                            },
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, -2.62],
                                            [0, 0],
                                            [2.62, 0],
                                            [0, 0],
                                            [0, 2.62],
                                            [0, 0],
                                            [-2.62, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [2.62, 0],
                                            [0, 0],
                                            [0, 2.62],
                                            [0, 0],
                                            [-2.62, 0],
                                            [0, 0],
                                            [0, -2.62],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [4.75, 0],
                                            [164.89, 0],
                                            [169.64, 4.75],
                                            [169.64, 4.75],
                                            [164.89, 9.5],
                                            [4.75, 9.5],
                                            [0, 4.75],
                                            [0, 4.75],
                                            [4.75, 0]
                                        ]
                                    }
                                ],
                                "t": 120
                            },
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, -2.62],
                                            [0, 0],
                                            [2.62, 0],
                                            [0, 0],
                                            [0, 2.62],
                                            [0, 0],
                                            [-2.62, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [2.62, 0],
                                            [0, 0],
                                            [0, 2.62],
                                            [0, 0],
                                            [-2.62, 0],
                                            [0, 0],
                                            [0, -2.62],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [4.75, 0],
                                            [164.89, 0],
                                            [169.64, 4.75],
                                            [169.64, 4.75],
                                            [164.89, 9.5],
                                            [4.75, 9.5],
                                            [0, 4.75],
                                            [0, 4.75],
                                            [4.75, 0]
                                        ]
                                    }
                                ],
                                "t": 180
                            },
                            {
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, -2.62],
                                            [0, 0],
                                            [2.62, 0],
                                            [0, 0],
                                            [0, 2.62],
                                            [0, 0],
                                            [-2.62, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [2.62, 0],
                                            [0, 0],
                                            [0, 2.62],
                                            [0, 0],
                                            [-2.62, 0],
                                            [0, 0],
                                            [0, -2.62],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [4.75, 0],
                                            [164.89, 0],
                                            [169.64, 4.75],
                                            [169.64, 4.75],
                                            [164.89, 9.5],
                                            [4.75, 9.5],
                                            [0, 4.75],
                                            [0, 4.75],
                                            [4.75, 0]
                                        ]
                                    }
                                ],
                                "t": 240
                            }
                        ]
                    }
                },
                {
                    "ty": "fl",
                    "c": {
                        "a": 1,
                        "k": [
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0.8941, 0.9255, 0.9765], "t": 0 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0.8941, 0.9255, 0.9765], "t": 60 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0.8941, 0.9255, 0.9765], "t": 120 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0.8941, 0.9255, 0.9765], "t": 180 },
                            { "s": [0.8941, 0.9255, 0.9765], "t": 240 }
                        ]
                    },
                    "r": 1,
                    "o": {
                        "a": 1,
                        "k": [
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 0 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 60 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 120 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 180 },
                            { "s": [100], "t": 240 }
                        ]
                    }
                }
            ],
            "ind": 12
        },
        {
            "ty": 4,
            "sr": 1,
            "st": 0,
            "op": 241,
            "ip": 0,
            "hasMask": false,
            "ao": 0,
            "ks": {
                "a": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [53.18, 4.75], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [53.18, 4.75], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [53.18, 4.75], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [53.18, 4.75], "t": 180 },
                        { "s": [53.18, 4.75], "t": 240 }
                    ]
                },
                "s": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100, 100], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100, 100], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100, 100], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100, 100], "t": 180 },
                        { "s": [100, 100], "t": 240 }
                    ]
                },
                "p": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [531.68, 292.87], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [539.88, 294.13], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [531.68, 292.87], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [539.88, 294.13], "t": 180 },
                        { "s": [531.68, 292.87], "t": 240 }
                    ]
                },
                "r": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [5.95], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [11.36], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [5.95], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [11.36], "t": 180 },
                        { "s": [5.95], "t": 240 }
                    ]
                },
                "o": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 180 },
                        { "s": [100], "t": 240 }
                    ]
                }
            },
            "shapes": [
                {
                    "ty": "sh",
                    "d": 1,
                    "ks": {
                        "a": 1,
                        "k": [
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, -2.62],
                                            [0, 0],
                                            [2.62, 0],
                                            [0, 0],
                                            [0, 2.62],
                                            [0, 0],
                                            [-2.62, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [2.62, 0],
                                            [0, 0],
                                            [0, 2.62],
                                            [0, 0],
                                            [-2.62, 0],
                                            [0, 0],
                                            [0, -2.62],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [4.75, 0],
                                            [101.62, 0],
                                            [106.37, 4.75],
                                            [106.37, 4.75],
                                            [101.62, 9.5],
                                            [4.75, 9.5],
                                            [0, 4.75],
                                            [0, 4.75],
                                            [4.75, 0]
                                        ]
                                    }
                                ],
                                "t": 0
                            },
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, -2.62],
                                            [0, 0],
                                            [2.62, 0],
                                            [0, 0],
                                            [0, 2.62],
                                            [0, 0],
                                            [-2.62, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [2.62, 0],
                                            [0, 0],
                                            [0, 2.62],
                                            [0, 0],
                                            [-2.62, 0],
                                            [0, 0],
                                            [0, -2.62],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [4.75, 0],
                                            [101.62, 0],
                                            [106.37, 4.75],
                                            [106.37, 4.75],
                                            [101.62, 9.5],
                                            [4.75, 9.5],
                                            [0, 4.75],
                                            [0, 4.75],
                                            [4.75, 0]
                                        ]
                                    }
                                ],
                                "t": 60
                            },
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, -2.62],
                                            [0, 0],
                                            [2.62, 0],
                                            [0, 0],
                                            [0, 2.62],
                                            [0, 0],
                                            [-2.62, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [2.62, 0],
                                            [0, 0],
                                            [0, 2.62],
                                            [0, 0],
                                            [-2.62, 0],
                                            [0, 0],
                                            [0, -2.62],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [4.75, 0],
                                            [101.62, 0],
                                            [106.37, 4.75],
                                            [106.37, 4.75],
                                            [101.62, 9.5],
                                            [4.75, 9.5],
                                            [0, 4.75],
                                            [0, 4.75],
                                            [4.75, 0]
                                        ]
                                    }
                                ],
                                "t": 120
                            },
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, -2.62],
                                            [0, 0],
                                            [2.62, 0],
                                            [0, 0],
                                            [0, 2.62],
                                            [0, 0],
                                            [-2.62, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [2.62, 0],
                                            [0, 0],
                                            [0, 2.62],
                                            [0, 0],
                                            [-2.62, 0],
                                            [0, 0],
                                            [0, -2.62],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [4.75, 0],
                                            [101.62, 0],
                                            [106.37, 4.75],
                                            [106.37, 4.75],
                                            [101.62, 9.5],
                                            [4.75, 9.5],
                                            [0, 4.75],
                                            [0, 4.75],
                                            [4.75, 0]
                                        ]
                                    }
                                ],
                                "t": 180
                            },
                            {
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, -2.62],
                                            [0, 0],
                                            [2.62, 0],
                                            [0, 0],
                                            [0, 2.62],
                                            [0, 0],
                                            [-2.62, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [2.62, 0],
                                            [0, 0],
                                            [0, 2.62],
                                            [0, 0],
                                            [-2.62, 0],
                                            [0, 0],
                                            [0, -2.62],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [4.75, 0],
                                            [101.62, 0],
                                            [106.37, 4.75],
                                            [106.37, 4.75],
                                            [101.62, 9.5],
                                            [4.75, 9.5],
                                            [0, 4.75],
                                            [0, 4.75],
                                            [4.75, 0]
                                        ]
                                    }
                                ],
                                "t": 240
                            }
                        ]
                    }
                },
                {
                    "ty": "fl",
                    "c": {
                        "a": 1,
                        "k": [
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0.5412, 0.8353, 0.7608], "t": 0 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0.5412, 0.8353, 0.7608], "t": 60 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0.5412, 0.8353, 0.7608], "t": 120 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0.5412, 0.8353, 0.7608], "t": 180 },
                            { "s": [0.5412, 0.8353, 0.7608], "t": 240 }
                        ]
                    },
                    "r": 1,
                    "o": {
                        "a": 1,
                        "k": [
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 0 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 60 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 120 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 180 },
                            { "s": [100], "t": 240 }
                        ]
                    }
                }
            ],
            "ind": 13
        },
        {
            "ty": 4,
            "sr": 1,
            "st": 0,
            "op": 241,
            "ip": 0,
            "hasMask": false,
            "ao": 0,
            "ks": {
                "a": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [17.9, 4.8], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [17.9, 4.8], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [17.9, 4.8], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [17.9, 4.8], "t": 180 },
                        { "s": [17.9, 4.8], "t": 240 }
                    ]
                },
                "s": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100, 100], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100, 100], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100, 100], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100, 100], "t": 180 },
                        { "s": [100, 100], "t": 240 }
                    ]
                },
                "p": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [621.23, 300.37], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [628.32, 310.04], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [621.23, 300.37], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [628.32, 310.04], "t": 180 },
                        { "s": [621.23, 300.37], "t": 240 }
                    ]
                },
                "r": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [5.41], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [5.41], "t": 180 },
                        { "s": [0], "t": 240 }
                    ]
                },
                "o": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 180 },
                        { "s": [100], "t": 240 }
                    ]
                }
            },
            "shapes": [
                {
                    "ty": "sh",
                    "d": 1,
                    "ks": {
                        "a": 1,
                        "k": [
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [0, 0],
                                            [35.19, 9.6],
                                            [35.79, 3.87],
                                            [0, 0]
                                        ]
                                    }
                                ],
                                "t": 0
                            },
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [0, 0],
                                            [35.19, 9.6],
                                            [35.79, 3.87],
                                            [0, 0]
                                        ]
                                    }
                                ],
                                "t": 60
                            },
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [0, 0],
                                            [35.19, 9.6],
                                            [35.79, 3.87],
                                            [0, 0]
                                        ]
                                    }
                                ],
                                "t": 120
                            },
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [0, 0],
                                            [35.19, 9.6],
                                            [35.79, 3.87],
                                            [0, 0]
                                        ]
                                    }
                                ],
                                "t": 180
                            },
                            {
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [0, 0],
                                            [35.19, 9.6],
                                            [35.79, 3.87],
                                            [0, 0]
                                        ]
                                    }
                                ],
                                "t": 240
                            }
                        ]
                    }
                },
                {
                    "ty": "fl",
                    "c": {
                        "a": 1,
                        "k": [
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0.8078, 0.8078, 0.8078], "t": 0 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0.8078, 0.8078, 0.8078], "t": 60 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0.8078, 0.8078, 0.8078], "t": 120 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0.8078, 0.8078, 0.8078], "t": 180 },
                            { "s": [0.8078, 0.8078, 0.8078], "t": 240 }
                        ]
                    },
                    "r": 1,
                    "o": {
                        "a": 1,
                        "k": [
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 0 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 60 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 120 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 180 },
                            { "s": [100], "t": 240 }
                        ]
                    }
                }
            ],
            "ind": 14
        },
        {
            "ty": 4,
            "sr": 1,
            "st": 0,
            "op": 241,
            "ip": 0,
            "hasMask": false,
            "ao": 0,
            "ks": {
                "a": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [22.05, 24.97], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [22.05, 24.97], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [22.05, 24.97], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [22.05, 24.97], "t": 180 },
                        { "s": [22.05, 24.97], "t": 240 }
                    ]
                },
                "s": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100, 100], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100, 100], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100, 100], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100, 100], "t": 180 },
                        { "s": [100, 100], "t": 240 }
                    ]
                },
                "p": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [617.07, 274.47], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [626.62, 283.87], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [617.07, 274.47], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [626.62, 283.87], "t": 180 },
                        { "s": [617.07, 274.47], "t": 240 }
                    ]
                },
                "r": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [5.41], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [5.41], "t": 180 },
                        { "s": [0], "t": 240 }
                    ]
                },
                "o": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 180 },
                        { "s": [100], "t": 240 }
                    ]
                }
            },
            "shapes": [
                {
                    "ty": "sh",
                    "d": 1,
                    "ks": {
                        "a": 1,
                        "k": [
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [-6.17, -0.64],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [-0.64, 6.17],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [0.06, 34.04],
                                            [10.07, 46.38],
                                            [44.1, 49.93],
                                            [3.61, 0],
                                            [0.06, 34.04],
                                            [0.06, 34.04]
                                        ]
                                    }
                                ],
                                "t": 0
                            },
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [-6.17, -0.64],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [-0.64, 6.17],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [0.06, 34.04],
                                            [10.07, 46.38],
                                            [44.1, 49.93],
                                            [3.61, 0],
                                            [0.06, 34.04],
                                            [0.06, 34.04]
                                        ]
                                    }
                                ],
                                "t": 60
                            },
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [-6.17, -0.64],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [-0.64, 6.17],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [0.06, 34.04],
                                            [10.07, 46.38],
                                            [44.1, 49.93],
                                            [3.61, 0],
                                            [0.06, 34.04],
                                            [0.06, 34.04]
                                        ]
                                    }
                                ],
                                "t": 120
                            },
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [-6.17, -0.64],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [-0.64, 6.17],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [0.06, 34.04],
                                            [10.07, 46.38],
                                            [44.1, 49.93],
                                            [3.61, 0],
                                            [0.06, 34.04],
                                            [0.06, 34.04]
                                        ]
                                    }
                                ],
                                "t": 180
                            },
                            {
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [-6.17, -0.64],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [-0.64, 6.17],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [0.06, 34.04],
                                            [10.07, 46.38],
                                            [44.1, 49.93],
                                            [3.61, 0],
                                            [0.06, 34.04],
                                            [0.06, 34.04]
                                        ]
                                    }
                                ],
                                "t": 240
                            }
                        ]
                    }
                },
                {
                    "ty": "fl",
                    "c": {
                        "a": 1,
                        "k": [
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0.9294, 0.9294, 0.9294], "t": 0 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0.9294, 0.9294, 0.9294], "t": 60 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0.9294, 0.9294, 0.9294], "t": 120 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0.9294, 0.9294, 0.9294], "t": 180 },
                            { "s": [0.9294, 0.9294, 0.9294], "t": 240 }
                        ]
                    },
                    "r": 1,
                    "o": {
                        "a": 1,
                        "k": [
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 0 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 60 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 120 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 180 },
                            { "s": [100], "t": 240 }
                        ]
                    }
                }
            ],
            "ind": 15
        },
        {
            "ty": 4,
            "sr": 1,
            "st": 0,
            "op": 241,
            "ip": 0,
            "hasMask": false,
            "ao": 0,
            "ks": {
                "a": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [118.09, 144.77], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [118.09, 144.77], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [118.09, 144.77], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [118.09, 144.77], "t": 180 },
                        { "s": [118.09, 144.77], "t": 240 }
                    ]
                },
                "s": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100, 100], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100, 100], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100, 100], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100, 100], "t": 180 },
                        { "s": [100, 100], "t": 240 }
                    ]
                },
                "p": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [521.03, 377.79], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [521.27, 377.67], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [521.03, 377.79], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [521.27, 377.67], "t": 180 },
                        { "s": [521.03, 377.79], "t": 240 }
                    ]
                },
                "r": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [5.41], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [5.41], "t": 180 },
                        { "s": [0], "t": 240 }
                    ]
                },
                "o": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 180 },
                        { "s": [100], "t": 240 }
                    ]
                }
            },
            "shapes": [
                {
                    "ty": "sh",
                    "d": 1,
                    "ks": {
                        "a": 1,
                        "k": [
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0.64, -6.17],
                                            [0, 0],
                                            [-6.17, -0.64],
                                            [0, 0],
                                            [-0.64, 6.17],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [-6.17, -0.64],
                                            [0, 0],
                                            [-0.64, 6.17],
                                            [0, 0],
                                            [6.17, 0.64],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [195.69, 16.49],
                                            [38.15, 0.06],
                                            [25.81, 10.07],
                                            [0.06, 257.16],
                                            [10.07, 269.51],
                                            [201.65, 289.48],
                                            [213.99, 279.47],
                                            [236.19, 66.42],
                                            [195.69, 16.49]
                                        ]
                                    }
                                ],
                                "t": 0
                            },
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0.64, -6.17],
                                            [0, 0],
                                            [-6.17, -0.64],
                                            [0, 0],
                                            [-0.64, 6.17],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [-6.17, -0.64],
                                            [0, 0],
                                            [-0.64, 6.17],
                                            [0, 0],
                                            [6.17, 0.64],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [195.69, 16.49],
                                            [38.15, 0.06],
                                            [25.81, 10.07],
                                            [0.06, 257.16],
                                            [10.07, 269.51],
                                            [201.65, 289.48],
                                            [213.99, 279.47],
                                            [236.19, 66.42],
                                            [195.69, 16.49]
                                        ]
                                    }
                                ],
                                "t": 60
                            },
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0.64, -6.17],
                                            [0, 0],
                                            [-6.17, -0.64],
                                            [0, 0],
                                            [-0.64, 6.17],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [-6.17, -0.64],
                                            [0, 0],
                                            [-0.64, 6.17],
                                            [0, 0],
                                            [6.17, 0.64],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [195.69, 16.49],
                                            [38.15, 0.06],
                                            [25.81, 10.07],
                                            [0.06, 257.16],
                                            [10.07, 269.51],
                                            [201.65, 289.48],
                                            [213.99, 279.47],
                                            [236.19, 66.42],
                                            [195.69, 16.49]
                                        ]
                                    }
                                ],
                                "t": 120
                            },
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0.64, -6.17],
                                            [0, 0],
                                            [-6.17, -0.64],
                                            [0, 0],
                                            [-0.64, 6.17],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [-6.17, -0.64],
                                            [0, 0],
                                            [-0.64, 6.17],
                                            [0, 0],
                                            [6.17, 0.64],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [195.69, 16.49],
                                            [38.15, 0.06],
                                            [25.81, 10.07],
                                            [0.06, 257.16],
                                            [10.07, 269.51],
                                            [201.65, 289.48],
                                            [213.99, 279.47],
                                            [236.19, 66.42],
                                            [195.69, 16.49]
                                        ]
                                    }
                                ],
                                "t": 180
                            },
                            {
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0.64, -6.17],
                                            [0, 0],
                                            [-6.17, -0.64],
                                            [0, 0],
                                            [-0.64, 6.17],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [-6.17, -0.64],
                                            [0, 0],
                                            [-0.64, 6.17],
                                            [0, 0],
                                            [6.17, 0.64],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [195.69, 16.49],
                                            [38.15, 0.06],
                                            [25.81, 10.07],
                                            [0.06, 257.16],
                                            [10.07, 269.51],
                                            [201.65, 289.48],
                                            [213.99, 279.47],
                                            [236.19, 66.42],
                                            [195.69, 16.49]
                                        ]
                                    }
                                ],
                                "t": 240
                            }
                        ]
                    }
                },
                {
                    "ty": "fl",
                    "c": {
                        "a": 1,
                        "k": [
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [1, 1, 1], "t": 0 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [1, 1, 1], "t": 60 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [1, 1, 1], "t": 120 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [1, 1, 1], "t": 180 },
                            { "s": [1, 1, 1], "t": 240 }
                        ]
                    },
                    "r": 1,
                    "o": {
                        "a": 1,
                        "k": [
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 0 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 60 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 120 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 180 },
                            { "s": [100], "t": 240 }
                        ]
                    }
                }
            ],
            "ind": 16
        },
        {
            "ty": 4,
            "sr": 1,
            "st": 0,
            "op": 241,
            "ip": 0,
            "hasMask": false,
            "ao": 0,
            "ks": {
                "a": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [118.09, 144.77], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [118.09, 144.77], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [118.09, 144.77], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [118.09, 144.77], "t": 180 },
                        { "s": [118.09, 144.77], "t": 240 }
                    ]
                },
                "s": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100, 100], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100, 100], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100, 100], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100, 100], "t": 180 },
                        { "s": [100, 100], "t": 240 }
                    ]
                },
                "p": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [523.84, 382.71], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [523.6, 382.83], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [523.84, 382.71], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [523.6, 382.83], "t": 180 },
                        { "s": [523.84, 382.71], "t": 240 }
                    ]
                },
                "r": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [5.41], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [5.41], "t": 180 },
                        { "s": [0], "t": 240 }
                    ]
                },
                "o": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [25], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [25], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [25], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [25], "t": 180 },
                        { "s": [25], "t": 240 }
                    ]
                }
            },
            "shapes": [
                {
                    "ty": "sh",
                    "d": 1,
                    "ks": {
                        "a": 1,
                        "k": [
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0.64, -6.17],
                                            [0, 0],
                                            [-6.17, -0.64],
                                            [0, 0],
                                            [-0.64, 6.17],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [-6.17, -0.64],
                                            [0, 0],
                                            [-0.64, 6.17],
                                            [0, 0],
                                            [6.17, 0.64],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [195.69, 16.49],
                                            [38.14, 0.06],
                                            [25.81, 10.07],
                                            [0.06, 257.16],
                                            [10.07, 269.51],
                                            [201.65, 289.48],
                                            [213.99, 279.47],
                                            [236.19, 66.42],
                                            [195.69, 16.49],
                                            [195.69, 16.49]
                                        ]
                                    }
                                ],
                                "t": 0
                            },
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0.64, -6.17],
                                            [0, 0],
                                            [-6.17, -0.64],
                                            [0, 0],
                                            [-0.64, 6.17],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [-6.17, -0.64],
                                            [0, 0],
                                            [-0.64, 6.17],
                                            [0, 0],
                                            [6.17, 0.64],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [195.69, 16.49],
                                            [38.14, 0.06],
                                            [25.81, 10.07],
                                            [0.06, 257.16],
                                            [10.07, 269.51],
                                            [201.65, 289.48],
                                            [213.99, 279.47],
                                            [236.19, 66.42],
                                            [195.69, 16.49],
                                            [195.69, 16.49]
                                        ]
                                    }
                                ],
                                "t": 60
                            },
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0.64, -6.17],
                                            [0, 0],
                                            [-6.17, -0.64],
                                            [0, 0],
                                            [-0.64, 6.17],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [-6.17, -0.64],
                                            [0, 0],
                                            [-0.64, 6.17],
                                            [0, 0],
                                            [6.17, 0.64],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [195.69, 16.49],
                                            [38.14, 0.06],
                                            [25.81, 10.07],
                                            [0.06, 257.16],
                                            [10.07, 269.51],
                                            [201.65, 289.48],
                                            [213.99, 279.47],
                                            [236.19, 66.42],
                                            [195.69, 16.49],
                                            [195.69, 16.49]
                                        ]
                                    }
                                ],
                                "t": 120
                            },
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0.64, -6.17],
                                            [0, 0],
                                            [-6.17, -0.64],
                                            [0, 0],
                                            [-0.64, 6.17],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [-6.17, -0.64],
                                            [0, 0],
                                            [-0.64, 6.17],
                                            [0, 0],
                                            [6.17, 0.64],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [195.69, 16.49],
                                            [38.14, 0.06],
                                            [25.81, 10.07],
                                            [0.06, 257.16],
                                            [10.07, 269.51],
                                            [201.65, 289.48],
                                            [213.99, 279.47],
                                            [236.19, 66.42],
                                            [195.69, 16.49],
                                            [195.69, 16.49]
                                        ]
                                    }
                                ],
                                "t": 180
                            },
                            {
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0.64, -6.17],
                                            [0, 0],
                                            [-6.17, -0.64],
                                            [0, 0],
                                            [-0.64, 6.17],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [-6.17, -0.64],
                                            [0, 0],
                                            [-0.64, 6.17],
                                            [0, 0],
                                            [6.17, 0.64],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [195.69, 16.49],
                                            [38.14, 0.06],
                                            [25.81, 10.07],
                                            [0.06, 257.16],
                                            [10.07, 269.51],
                                            [201.65, 289.48],
                                            [213.99, 279.47],
                                            [236.19, 66.42],
                                            [195.69, 16.49],
                                            [195.69, 16.49]
                                        ]
                                    }
                                ],
                                "t": 240
                            }
                        ]
                    }
                },
                {
                    "ty": "fl",
                    "c": {
                        "a": 1,
                        "k": [
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0.2275, 0.4941, 0.7569], "t": 0 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0.2275, 0.4941, 0.7569], "t": 60 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0.2275, 0.4941, 0.7569], "t": 120 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0.2275, 0.4941, 0.7569], "t": 180 },
                            { "s": [0.2275, 0.4941, 0.7569], "t": 240 }
                        ]
                    },
                    "r": 1,
                    "o": {
                        "a": 1,
                        "k": [
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 0 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 60 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 120 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 180 },
                            { "s": [100], "t": 240 }
                        ]
                    }
                }
            ],
            "ind": 17
        },
        {
            "ty": 4,
            "sr": 1,
            "st": 0,
            "op": 241,
            "ip": 0,
            "hasMask": false,
            "ao": 0,
            "ks": {
                "a": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [11.25, 11.26], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [11.25, 11.26], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [11.25, 11.26], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [11.25, 11.26], "t": 180 },
                        { "s": [11.25, 11.26], "t": 240 }
                    ]
                },
                "s": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100, 100], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100, 100], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100, 100], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100, 100], "t": 180 },
                        { "s": [100, 100], "t": 240 }
                    ]
                },
                "p": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [333.12, 260.05], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [330.67, 261.16], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [333.12, 260.05], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [330.67, 261.16], "t": 180 },
                        { "s": [333.12, 260.05], "t": 240 }
                    ]
                },
                "r": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [-8.2], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [-11.5], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [-8.2], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [-11.5], "t": 180 },
                        { "s": [-8.2], "t": 240 }
                    ]
                },
                "o": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 180 },
                        { "s": [100], "t": 240 }
                    ]
                }
            },
            "shapes": [
                {
                    "ty": "sh",
                    "d": 1,
                    "ks": {
                        "a": 1,
                        "k": [
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [6.22, 0],
                                            [0, 6.22],
                                            [-6.22, 0],
                                            [0, -6.22]
                                        ],
                                        "o": [
                                            [0, 6.22],
                                            [-6.22, 0],
                                            [0, -6.22],
                                            [6.22, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [22.51, 11.26],
                                            [11.25, 22.51],
                                            [0, 11.26],
                                            [11.25, 0],
                                            [22.51, 11.26]
                                        ]
                                    }
                                ],
                                "t": 0
                            },
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [6.22, 0],
                                            [0, 6.22],
                                            [-6.22, 0],
                                            [0, -6.22]
                                        ],
                                        "o": [
                                            [0, 6.22],
                                            [-6.22, 0],
                                            [0, -6.22],
                                            [6.22, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [22.51, 11.26],
                                            [11.25, 22.51],
                                            [0, 11.26],
                                            [11.25, 0],
                                            [22.51, 11.26]
                                        ]
                                    }
                                ],
                                "t": 60
                            },
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [6.22, 0],
                                            [0, 6.22],
                                            [-6.22, 0],
                                            [0, -6.22]
                                        ],
                                        "o": [
                                            [0, 6.22],
                                            [-6.22, 0],
                                            [0, -6.22],
                                            [6.22, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [22.51, 11.26],
                                            [11.25, 22.51],
                                            [0, 11.26],
                                            [11.25, 0],
                                            [22.51, 11.26]
                                        ]
                                    }
                                ],
                                "t": 120
                            },
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [6.22, 0],
                                            [0, 6.22],
                                            [-6.22, 0],
                                            [0, -6.22]
                                        ],
                                        "o": [
                                            [0, 6.22],
                                            [-6.22, 0],
                                            [0, -6.22],
                                            [6.22, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [22.51, 11.26],
                                            [11.25, 22.51],
                                            [0, 11.26],
                                            [11.25, 0],
                                            [22.51, 11.26]
                                        ]
                                    }
                                ],
                                "t": 180
                            },
                            {
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [6.22, 0],
                                            [0, 6.22],
                                            [-6.22, 0],
                                            [0, -6.22]
                                        ],
                                        "o": [
                                            [0, 6.22],
                                            [-6.22, 0],
                                            [0, -6.22],
                                            [6.22, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [22.51, 11.26],
                                            [11.25, 22.51],
                                            [0, 11.26],
                                            [11.25, 0],
                                            [22.51, 11.26]
                                        ]
                                    }
                                ],
                                "t": 240
                            }
                        ]
                    }
                },
                {
                    "ty": "fl",
                    "c": {
                        "a": 1,
                        "k": [
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [1, 1, 1], "t": 0 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [1, 1, 1], "t": 60 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [1, 1, 1], "t": 120 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [1, 1, 1], "t": 180 },
                            { "s": [1, 1, 1], "t": 240 }
                        ]
                    },
                    "r": 1,
                    "o": {
                        "a": 1,
                        "k": [
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 0 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 60 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 120 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 180 },
                            { "s": [100], "t": 240 }
                        ]
                    }
                }
            ],
            "ind": 18
        },
        {
            "ty": 4,
            "sr": 1,
            "st": 0,
            "op": 241,
            "ip": 0,
            "hasMask": false,
            "ao": 0,
            "ks": {
                "a": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [11.25, 11.26], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [11.25, 11.26], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [11.25, 11.26], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [11.25, 11.26], "t": 180 },
                        { "s": [11.25, 11.26], "t": 240 }
                    ]
                },
                "s": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100, 100], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100, 100], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100, 100], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100, 100], "t": 180 },
                        { "s": [100, 100], "t": 240 }
                    ]
                },
                "p": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [307.65, 199.14], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [301.75, 201.82], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [307.65, 199.14], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [301.75, 201.82], "t": 180 },
                        { "s": [307.65, 199.14], "t": 240 }
                    ]
                },
                "r": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [-8.2], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [-11.5], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [-8.2], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [-11.5], "t": 180 },
                        { "s": [-8.2], "t": 240 }
                    ]
                },
                "o": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 180 },
                        { "s": [100], "t": 240 }
                    ]
                }
            },
            "shapes": [
                {
                    "ty": "sh",
                    "d": 1,
                    "ks": {
                        "a": 1,
                        "k": [
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [6.22, 0],
                                            [0, 6.22],
                                            [-6.22, 0],
                                            [0, -6.22]
                                        ],
                                        "o": [
                                            [0, 6.22],
                                            [-6.22, 0],
                                            [0, -6.22],
                                            [6.22, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [22.51, 11.26],
                                            [11.25, 22.51],
                                            [0, 11.26],
                                            [11.25, 0],
                                            [22.51, 11.26]
                                        ]
                                    }
                                ],
                                "t": 0
                            },
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [6.22, 0],
                                            [0, 6.22],
                                            [-6.22, 0],
                                            [0, -6.22]
                                        ],
                                        "o": [
                                            [0, 6.22],
                                            [-6.22, 0],
                                            [0, -6.22],
                                            [6.22, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [22.51, 11.26],
                                            [11.25, 22.51],
                                            [0, 11.26],
                                            [11.25, 0],
                                            [22.51, 11.26]
                                        ]
                                    }
                                ],
                                "t": 60
                            },
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [6.22, 0],
                                            [0, 6.22],
                                            [-6.22, 0],
                                            [0, -6.22]
                                        ],
                                        "o": [
                                            [0, 6.22],
                                            [-6.22, 0],
                                            [0, -6.22],
                                            [6.22, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [22.51, 11.26],
                                            [11.25, 22.51],
                                            [0, 11.26],
                                            [11.25, 0],
                                            [22.51, 11.26]
                                        ]
                                    }
                                ],
                                "t": 120
                            },
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [6.22, 0],
                                            [0, 6.22],
                                            [-6.22, 0],
                                            [0, -6.22]
                                        ],
                                        "o": [
                                            [0, 6.22],
                                            [-6.22, 0],
                                            [0, -6.22],
                                            [6.22, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [22.51, 11.26],
                                            [11.25, 22.51],
                                            [0, 11.26],
                                            [11.25, 0],
                                            [22.51, 11.26]
                                        ]
                                    }
                                ],
                                "t": 180
                            },
                            {
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [6.22, 0],
                                            [0, 6.22],
                                            [-6.22, 0],
                                            [0, -6.22]
                                        ],
                                        "o": [
                                            [0, 6.22],
                                            [-6.22, 0],
                                            [0, -6.22],
                                            [6.22, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [22.51, 11.26],
                                            [11.25, 22.51],
                                            [0, 11.26],
                                            [11.25, 0],
                                            [22.51, 11.26]
                                        ]
                                    }
                                ],
                                "t": 240
                            }
                        ]
                    }
                },
                {
                    "ty": "fl",
                    "c": {
                        "a": 1,
                        "k": [
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [1, 1, 1], "t": 0 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [1, 1, 1], "t": 60 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [1, 1, 1], "t": 120 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [1, 1, 1], "t": 180 },
                            { "s": [1, 1, 1], "t": 240 }
                        ]
                    },
                    "r": 1,
                    "o": {
                        "a": 1,
                        "k": [
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 0 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 60 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 120 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 180 },
                            { "s": [100], "t": 240 }
                        ]
                    }
                }
            ],
            "ind": 19
        },
        {
            "ty": 4,
            "sr": 1,
            "st": 0,
            "op": 241,
            "ip": 0,
            "hasMask": false,
            "ao": 0,
            "ks": {
                "a": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [18.48, 41.3], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [18.48, 41.3], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [18.48, 41.3], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [18.48, 41.3], "t": 180 },
                        { "s": [18.48, 41.3], "t": 240 }
                    ]
                },
                "s": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100, 100], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100, 100], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100, 100], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100, 100], "t": 180 },
                        { "s": [100, 100], "t": 240 }
                    ]
                },
                "p": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [320.06, 228.8], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [315.84, 230.71], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [320.06, 228.8], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [315.84, 230.71], "t": 180 },
                        { "s": [320.06, 228.8], "t": 240 }
                    ]
                },
                "r": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [-8.2], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [-11.5], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [-8.2], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [-11.5], "t": 180 },
                        { "s": [-8.2], "t": 240 }
                    ]
                },
                "o": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 180 },
                        { "s": [100], "t": 240 }
                    ]
                }
            },
            "shapes": [
                {
                    "ty": "sh",
                    "d": 1,
                    "ks": {
                        "a": 1,
                        "k": [
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0.94, 3.63],
                                            [0, 0],
                                            [-1.1, 1.86],
                                            [-2.08, 0.54],
                                            [0, 0],
                                            [-1.11, -4.3],
                                            [0, 0],
                                            [1.1, -1.86],
                                            [2.08, -0.54],
                                            [0, 0],
                                            [0.67, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [-3.58, 0],
                                            [0, 0],
                                            [-0.54, -2.08],
                                            [1.1, -1.86],
                                            [0, 0],
                                            [4.3, -1.11],
                                            [0, 0],
                                            [0.54, 2.08],
                                            [-1.1, 1.86],
                                            [0, 0],
                                            [-0.67, 0.17],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [24.99, 82.59],
                                            [17.18, 76.55],
                                            [0.26, 11.09],
                                            [1.12, 4.99],
                                            [6.04, 1.27],
                                            [9.96, 0.26],
                                            [19.78, 6.04],
                                            [36.71, 71.5],
                                            [35.84, 77.6],
                                            [30.92, 81.32],
                                            [27, 82.33],
                                            [24.99, 82.59],
                                            [24.99, 82.59]
                                        ]
                                    }
                                ],
                                "t": 0
                            },
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0.94, 3.63],
                                            [0, 0],
                                            [-1.1, 1.86],
                                            [-2.08, 0.54],
                                            [0, 0],
                                            [-1.11, -4.3],
                                            [0, 0],
                                            [1.1, -1.86],
                                            [2.08, -0.54],
                                            [0, 0],
                                            [0.67, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [-3.58, 0],
                                            [0, 0],
                                            [-0.54, -2.08],
                                            [1.1, -1.86],
                                            [0, 0],
                                            [4.3, -1.11],
                                            [0, 0],
                                            [0.54, 2.08],
                                            [-1.1, 1.86],
                                            [0, 0],
                                            [-0.67, 0.17],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [24.99, 82.59],
                                            [17.18, 76.55],
                                            [0.26, 11.09],
                                            [1.12, 4.99],
                                            [6.04, 1.27],
                                            [9.96, 0.26],
                                            [19.78, 6.04],
                                            [36.71, 71.5],
                                            [35.84, 77.6],
                                            [30.92, 81.32],
                                            [27, 82.33],
                                            [24.99, 82.59],
                                            [24.99, 82.59]
                                        ]
                                    }
                                ],
                                "t": 60
                            },
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0.94, 3.63],
                                            [0, 0],
                                            [-1.1, 1.86],
                                            [-2.08, 0.54],
                                            [0, 0],
                                            [-1.11, -4.3],
                                            [0, 0],
                                            [1.1, -1.86],
                                            [2.08, -0.54],
                                            [0, 0],
                                            [0.67, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [-3.58, 0],
                                            [0, 0],
                                            [-0.54, -2.08],
                                            [1.1, -1.86],
                                            [0, 0],
                                            [4.3, -1.11],
                                            [0, 0],
                                            [0.54, 2.08],
                                            [-1.1, 1.86],
                                            [0, 0],
                                            [-0.67, 0.17],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [24.99, 82.59],
                                            [17.18, 76.55],
                                            [0.26, 11.09],
                                            [1.12, 4.99],
                                            [6.04, 1.27],
                                            [9.96, 0.26],
                                            [19.78, 6.04],
                                            [36.71, 71.5],
                                            [35.84, 77.6],
                                            [30.92, 81.32],
                                            [27, 82.33],
                                            [24.99, 82.59],
                                            [24.99, 82.59]
                                        ]
                                    }
                                ],
                                "t": 120
                            },
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0.94, 3.63],
                                            [0, 0],
                                            [-1.1, 1.86],
                                            [-2.08, 0.54],
                                            [0, 0],
                                            [-1.11, -4.3],
                                            [0, 0],
                                            [1.1, -1.86],
                                            [2.08, -0.54],
                                            [0, 0],
                                            [0.67, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [-3.58, 0],
                                            [0, 0],
                                            [-0.54, -2.08],
                                            [1.1, -1.86],
                                            [0, 0],
                                            [4.3, -1.11],
                                            [0, 0],
                                            [0.54, 2.08],
                                            [-1.1, 1.86],
                                            [0, 0],
                                            [-0.67, 0.17],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [24.99, 82.59],
                                            [17.18, 76.55],
                                            [0.26, 11.09],
                                            [1.12, 4.99],
                                            [6.04, 1.27],
                                            [9.96, 0.26],
                                            [19.78, 6.04],
                                            [36.71, 71.5],
                                            [35.84, 77.6],
                                            [30.92, 81.32],
                                            [27, 82.33],
                                            [24.99, 82.59],
                                            [24.99, 82.59]
                                        ]
                                    }
                                ],
                                "t": 180
                            },
                            {
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0.94, 3.63],
                                            [0, 0],
                                            [-1.1, 1.86],
                                            [-2.08, 0.54],
                                            [0, 0],
                                            [-1.11, -4.3],
                                            [0, 0],
                                            [1.1, -1.86],
                                            [2.08, -0.54],
                                            [0, 0],
                                            [0.67, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [-3.58, 0],
                                            [0, 0],
                                            [-0.54, -2.08],
                                            [1.1, -1.86],
                                            [0, 0],
                                            [4.3, -1.11],
                                            [0, 0],
                                            [0.54, 2.08],
                                            [-1.1, 1.86],
                                            [0, 0],
                                            [-0.67, 0.17],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [24.99, 82.59],
                                            [17.18, 76.55],
                                            [0.26, 11.09],
                                            [1.12, 4.99],
                                            [6.04, 1.27],
                                            [9.96, 0.26],
                                            [19.78, 6.04],
                                            [36.71, 71.5],
                                            [35.84, 77.6],
                                            [30.92, 81.32],
                                            [27, 82.33],
                                            [24.99, 82.59],
                                            [24.99, 82.59]
                                        ]
                                    }
                                ],
                                "t": 240
                            }
                        ]
                    }
                },
                {
                    "ty": "sh",
                    "d": 1,
                    "ks": {
                        "a": 1,
                        "k": [
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0.48, -0.12],
                                            [0, 0],
                                            [0.78, -1.33],
                                            [-0.38, -1.48],
                                            [0, 0],
                                            [-3.07, 0.79],
                                            [0, 0],
                                            [-0.78, 1.33],
                                            [0.38, 1.48],
                                            [0, 0],
                                            [2.56, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [-0.48, 0],
                                            [0, 0],
                                            [-1.48, 0.38],
                                            [-0.78, 1.33],
                                            [0, 0],
                                            [0.8, 3.07],
                                            [0, 0],
                                            [1.48, -0.38],
                                            [0.78, -1.33],
                                            [0, 0],
                                            [-0.67, -2.59],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [11.98, 2.3],
                                            [10.53, 2.49],
                                            [6.62, 3.5],
                                            [3.11, 6.15],
                                            [2.49, 10.51],
                                            [19.41, 75.97],
                                            [26.43, 80.1],
                                            [30.34, 79.09],
                                            [33.85, 76.43],
                                            [34.47, 72.08],
                                            [17.55, 6.62],
                                            [11.97, 2.3],
                                            [11.98, 2.3]
                                        ]
                                    }
                                ],
                                "t": 0
                            },
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0.48, -0.12],
                                            [0, 0],
                                            [0.78, -1.33],
                                            [-0.38, -1.48],
                                            [0, 0],
                                            [-3.07, 0.79],
                                            [0, 0],
                                            [-0.78, 1.33],
                                            [0.38, 1.48],
                                            [0, 0],
                                            [2.56, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [-0.48, 0],
                                            [0, 0],
                                            [-1.48, 0.38],
                                            [-0.78, 1.33],
                                            [0, 0],
                                            [0.8, 3.07],
                                            [0, 0],
                                            [1.48, -0.38],
                                            [0.78, -1.33],
                                            [0, 0],
                                            [-0.67, -2.59],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [11.98, 2.3],
                                            [10.53, 2.49],
                                            [6.62, 3.5],
                                            [3.11, 6.15],
                                            [2.49, 10.51],
                                            [19.41, 75.97],
                                            [26.43, 80.1],
                                            [30.34, 79.09],
                                            [33.85, 76.43],
                                            [34.47, 72.08],
                                            [17.55, 6.62],
                                            [11.97, 2.3],
                                            [11.98, 2.3]
                                        ]
                                    }
                                ],
                                "t": 60
                            },
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0.48, -0.12],
                                            [0, 0],
                                            [0.78, -1.33],
                                            [-0.38, -1.48],
                                            [0, 0],
                                            [-3.07, 0.79],
                                            [0, 0],
                                            [-0.78, 1.33],
                                            [0.38, 1.48],
                                            [0, 0],
                                            [2.56, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [-0.48, 0],
                                            [0, 0],
                                            [-1.48, 0.38],
                                            [-0.78, 1.33],
                                            [0, 0],
                                            [0.8, 3.07],
                                            [0, 0],
                                            [1.48, -0.38],
                                            [0.78, -1.33],
                                            [0, 0],
                                            [-0.67, -2.59],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [11.98, 2.3],
                                            [10.53, 2.49],
                                            [6.62, 3.5],
                                            [3.11, 6.15],
                                            [2.49, 10.51],
                                            [19.41, 75.97],
                                            [26.43, 80.1],
                                            [30.34, 79.09],
                                            [33.85, 76.43],
                                            [34.47, 72.08],
                                            [17.55, 6.62],
                                            [11.97, 2.3],
                                            [11.98, 2.3]
                                        ]
                                    }
                                ],
                                "t": 120
                            },
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0.48, -0.12],
                                            [0, 0],
                                            [0.78, -1.33],
                                            [-0.38, -1.48],
                                            [0, 0],
                                            [-3.07, 0.79],
                                            [0, 0],
                                            [-0.78, 1.33],
                                            [0.38, 1.48],
                                            [0, 0],
                                            [2.56, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [-0.48, 0],
                                            [0, 0],
                                            [-1.48, 0.38],
                                            [-0.78, 1.33],
                                            [0, 0],
                                            [0.8, 3.07],
                                            [0, 0],
                                            [1.48, -0.38],
                                            [0.78, -1.33],
                                            [0, 0],
                                            [-0.67, -2.59],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [11.98, 2.3],
                                            [10.53, 2.49],
                                            [6.62, 3.5],
                                            [3.11, 6.15],
                                            [2.49, 10.51],
                                            [19.41, 75.97],
                                            [26.43, 80.1],
                                            [30.34, 79.09],
                                            [33.85, 76.43],
                                            [34.47, 72.08],
                                            [17.55, 6.62],
                                            [11.97, 2.3],
                                            [11.98, 2.3]
                                        ]
                                    }
                                ],
                                "t": 180
                            },
                            {
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0.48, -0.12],
                                            [0, 0],
                                            [0.78, -1.33],
                                            [-0.38, -1.48],
                                            [0, 0],
                                            [-3.07, 0.79],
                                            [0, 0],
                                            [-0.78, 1.33],
                                            [0.38, 1.48],
                                            [0, 0],
                                            [2.56, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [-0.48, 0],
                                            [0, 0],
                                            [-1.48, 0.38],
                                            [-0.78, 1.33],
                                            [0, 0],
                                            [0.8, 3.07],
                                            [0, 0],
                                            [1.48, -0.38],
                                            [0.78, -1.33],
                                            [0, 0],
                                            [-0.67, -2.59],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [11.98, 2.3],
                                            [10.53, 2.49],
                                            [6.62, 3.5],
                                            [3.11, 6.15],
                                            [2.49, 10.51],
                                            [19.41, 75.97],
                                            [26.43, 80.1],
                                            [30.34, 79.09],
                                            [33.85, 76.43],
                                            [34.47, 72.08],
                                            [17.55, 6.62],
                                            [11.97, 2.3],
                                            [11.98, 2.3]
                                        ]
                                    }
                                ],
                                "t": 240
                            }
                        ]
                    }
                },
                {
                    "ty": "fl",
                    "c": {
                        "a": 1,
                        "k": [
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0.2667, 0.2667, 0.2667], "t": 0 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0.2667, 0.2667, 0.2667], "t": 60 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0.2667, 0.2667, 0.2667], "t": 120 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0.2667, 0.2667, 0.2667], "t": 180 },
                            { "s": [0.2667, 0.2667, 0.2667], "t": 240 }
                        ]
                    },
                    "r": 1,
                    "o": {
                        "a": 1,
                        "k": [
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 0 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 60 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 120 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 180 },
                            { "s": [100], "t": 240 }
                        ]
                    }
                }
            ],
            "ind": 20
        },
        {
            "ty": 4,
            "sr": 1,
            "st": 0,
            "op": 241,
            "ip": 0,
            "hasMask": false,
            "ao": 0,
            "ks": {
                "a": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [102.23, 42.56], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [102.23, 42.56], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [102.23, 42.56], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [102.23, 42.56], "t": 180 },
                        { "s": [102.23, 42.56], "t": 240 }
                    ]
                },
                "s": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100, 100], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100, 100], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100, 100], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100, 100], "t": 180 },
                        { "s": [100, 100], "t": 240 }
                    ]
                },
                "p": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [302.17, 195.43], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [296.06, 198.42], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [302.17, 195.43], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [296.06, 198.42], "t": 180 },
                        { "s": [302.17, 195.43], "t": 240 }
                    ]
                },
                "r": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [-8.2], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [-11.5], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [-8.2], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [-11.5], "t": 180 },
                        { "s": [-8.2], "t": 240 }
                    ]
                },
                "o": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 180 },
                        { "s": [100], "t": 240 }
                    ]
                }
            },
            "shapes": [
                {
                    "ty": "sh",
                    "d": 1,
                    "ks": {
                        "a": 1,
                        "k": [
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [1.01, -0.26],
                                            [0, 0],
                                            [0.64, 0.84],
                                            [0, 0],
                                            [-2.55, 0.66],
                                            [0, 0],
                                            [-1.97, -1.43],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [-0.15, 1.04],
                                            [0, 0],
                                            [-1.02, 0.26],
                                            [0, 0],
                                            [1.04, -2.21],
                                            [0, 0],
                                            [2.55, -0.66],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [204.45, 1.61],
                                            [199.15, 38.38],
                                            [197.23, 40.53],
                                            [25.19, 85.03],
                                            [22.46, 84.09],
                                            [0, 54.5],
                                            [5.56, 49.88],
                                            [197.35, 0.27],
                                            [204.45, 1.61],
                                            [204.45, 1.61]
                                        ]
                                    }
                                ],
                                "t": 0
                            },
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [1.01, -0.26],
                                            [0, 0],
                                            [0.64, 0.84],
                                            [0, 0],
                                            [-2.55, 0.66],
                                            [0, 0],
                                            [-1.97, -1.43],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [-0.15, 1.04],
                                            [0, 0],
                                            [-1.02, 0.26],
                                            [0, 0],
                                            [1.04, -2.21],
                                            [0, 0],
                                            [2.55, -0.66],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [204.45, 1.61],
                                            [199.15, 38.38],
                                            [197.23, 40.53],
                                            [25.19, 85.03],
                                            [22.46, 84.09],
                                            [0, 54.5],
                                            [5.56, 49.88],
                                            [197.35, 0.27],
                                            [204.45, 1.61],
                                            [204.45, 1.61]
                                        ]
                                    }
                                ],
                                "t": 60
                            },
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [1.01, -0.26],
                                            [0, 0],
                                            [0.64, 0.84],
                                            [0, 0],
                                            [-2.55, 0.66],
                                            [0, 0],
                                            [-1.97, -1.43],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [-0.15, 1.04],
                                            [0, 0],
                                            [-1.02, 0.26],
                                            [0, 0],
                                            [1.04, -2.21],
                                            [0, 0],
                                            [2.55, -0.66],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [204.45, 1.61],
                                            [199.15, 38.38],
                                            [197.23, 40.53],
                                            [25.19, 85.03],
                                            [22.46, 84.09],
                                            [0, 54.5],
                                            [5.56, 49.88],
                                            [197.35, 0.27],
                                            [204.45, 1.61],
                                            [204.45, 1.61]
                                        ]
                                    }
                                ],
                                "t": 120
                            },
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [1.01, -0.26],
                                            [0, 0],
                                            [0.64, 0.84],
                                            [0, 0],
                                            [-2.55, 0.66],
                                            [0, 0],
                                            [-1.97, -1.43],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [-0.15, 1.04],
                                            [0, 0],
                                            [-1.02, 0.26],
                                            [0, 0],
                                            [1.04, -2.21],
                                            [0, 0],
                                            [2.55, -0.66],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [204.45, 1.61],
                                            [199.15, 38.38],
                                            [197.23, 40.53],
                                            [25.19, 85.03],
                                            [22.46, 84.09],
                                            [0, 54.5],
                                            [5.56, 49.88],
                                            [197.35, 0.27],
                                            [204.45, 1.61],
                                            [204.45, 1.61]
                                        ]
                                    }
                                ],
                                "t": 180
                            },
                            {
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [1.01, -0.26],
                                            [0, 0],
                                            [0.64, 0.84],
                                            [0, 0],
                                            [-2.55, 0.66],
                                            [0, 0],
                                            [-1.97, -1.43],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [-0.15, 1.04],
                                            [0, 0],
                                            [-1.02, 0.26],
                                            [0, 0],
                                            [1.04, -2.21],
                                            [0, 0],
                                            [2.55, -0.66],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [204.45, 1.61],
                                            [199.15, 38.38],
                                            [197.23, 40.53],
                                            [25.19, 85.03],
                                            [22.46, 84.09],
                                            [0, 54.5],
                                            [5.56, 49.88],
                                            [197.35, 0.27],
                                            [204.45, 1.61],
                                            [204.45, 1.61]
                                        ]
                                    }
                                ],
                                "t": 240
                            }
                        ]
                    }
                },
                {
                    "ty": "fl",
                    "c": {
                        "a": 1,
                        "k": [
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0.8078, 0.8157, 0.8784], "t": 0 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0.8078, 0.8157, 0.8784], "t": 60 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0.8078, 0.8157, 0.8784], "t": 120 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0.8078, 0.8157, 0.8784], "t": 180 },
                            { "s": [0.8078, 0.8157, 0.8784], "t": 240 }
                        ]
                    },
                    "r": 1,
                    "o": {
                        "a": 1,
                        "k": [
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 0 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 60 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 120 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 180 },
                            { "s": [100], "t": 240 }
                        ]
                    }
                }
            ],
            "ind": 21
        },
        {
            "ty": 4,
            "sr": 1,
            "st": 0,
            "op": 241,
            "ip": 0,
            "hasMask": false,
            "ao": 0,
            "ks": {
                "a": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [102.67, 38.32], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [102.67, 38.32], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [102.67, 38.32], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [102.67, 38.32], "t": 180 },
                        { "s": [102.67, 38.32], "t": 240 }
                    ]
                },
                "s": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100, 100], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100, 100], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100, 100], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100, 100], "t": 180 },
                        { "s": [100, 100], "t": 240 }
                    ]
                },
                "p": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [400.62, 415.17], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [406.98, 412.14], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [400.62, 415.17], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [406.98, 412.14], "t": 180 },
                        { "s": [400.62, 415.17], "t": 240 }
                    ]
                },
                "r": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [-8.2], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [-11.5], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [-8.2], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [-11.5], "t": 180 },
                        { "s": [-8.2], "t": 240 }
                    ]
                },
                "o": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 180 },
                        { "s": [100], "t": 240 }
                    ]
                }
            },
            "shapes": [
                {
                    "ty": "sh",
                    "d": 1,
                    "ks": {
                        "a": 1,
                        "k": [
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [2.81, -0.73],
                                            [0, 0],
                                            [2.04, 1.77],
                                            [0, 0],
                                            [-1.66, 0.43],
                                            [0, 0],
                                            [-1.06, -1.34],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [-0.93, 2.53],
                                            [0, 0],
                                            [-2.81, 0.73],
                                            [0, 0],
                                            [0.27, -1.69],
                                            [0, 0],
                                            [1.66, -0.43],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [205.33, 21.45],
                                            [199.48, 26.77],
                                            [7.69, 76.38],
                                            [0, 74.57],
                                            [4, 49.7],
                                            [7.18, 46.21],
                                            [185.31, 0.14],
                                            [189.77, 1.64],
                                            [205.33, 21.45],
                                            [205.33, 21.45]
                                        ]
                                    }
                                ],
                                "t": 0
                            },
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [2.81, -0.73],
                                            [0, 0],
                                            [2.04, 1.77],
                                            [0, 0],
                                            [-1.66, 0.43],
                                            [0, 0],
                                            [-1.06, -1.34],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [-0.93, 2.53],
                                            [0, 0],
                                            [-2.81, 0.73],
                                            [0, 0],
                                            [0.27, -1.69],
                                            [0, 0],
                                            [1.66, -0.43],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [205.33, 21.45],
                                            [199.48, 26.77],
                                            [7.69, 76.38],
                                            [0, 74.57],
                                            [4, 49.7],
                                            [7.18, 46.21],
                                            [185.31, 0.14],
                                            [189.77, 1.64],
                                            [205.33, 21.45],
                                            [205.33, 21.45]
                                        ]
                                    }
                                ],
                                "t": 60
                            },
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [2.81, -0.73],
                                            [0, 0],
                                            [2.04, 1.77],
                                            [0, 0],
                                            [-1.66, 0.43],
                                            [0, 0],
                                            [-1.06, -1.34],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [-0.93, 2.53],
                                            [0, 0],
                                            [-2.81, 0.73],
                                            [0, 0],
                                            [0.27, -1.69],
                                            [0, 0],
                                            [1.66, -0.43],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [205.33, 21.45],
                                            [199.48, 26.77],
                                            [7.69, 76.38],
                                            [0, 74.57],
                                            [4, 49.7],
                                            [7.18, 46.21],
                                            [185.31, 0.14],
                                            [189.77, 1.64],
                                            [205.33, 21.45],
                                            [205.33, 21.45]
                                        ]
                                    }
                                ],
                                "t": 120
                            },
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [2.81, -0.73],
                                            [0, 0],
                                            [2.04, 1.77],
                                            [0, 0],
                                            [-1.66, 0.43],
                                            [0, 0],
                                            [-1.06, -1.34],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [-0.93, 2.53],
                                            [0, 0],
                                            [-2.81, 0.73],
                                            [0, 0],
                                            [0.27, -1.69],
                                            [0, 0],
                                            [1.66, -0.43],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [205.33, 21.45],
                                            [199.48, 26.77],
                                            [7.69, 76.38],
                                            [0, 74.57],
                                            [4, 49.7],
                                            [7.18, 46.21],
                                            [185.31, 0.14],
                                            [189.77, 1.64],
                                            [205.33, 21.45],
                                            [205.33, 21.45]
                                        ]
                                    }
                                ],
                                "t": 180
                            },
                            {
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [2.81, -0.73],
                                            [0, 0],
                                            [2.04, 1.77],
                                            [0, 0],
                                            [-1.66, 0.43],
                                            [0, 0],
                                            [-1.06, -1.34],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [-0.93, 2.53],
                                            [0, 0],
                                            [-2.81, 0.73],
                                            [0, 0],
                                            [0.27, -1.69],
                                            [0, 0],
                                            [1.66, -0.43],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [205.33, 21.45],
                                            [199.48, 26.77],
                                            [7.69, 76.38],
                                            [0, 74.57],
                                            [4, 49.7],
                                            [7.18, 46.21],
                                            [185.31, 0.14],
                                            [189.77, 1.64],
                                            [205.33, 21.45],
                                            [205.33, 21.45]
                                        ]
                                    }
                                ],
                                "t": 240
                            }
                        ]
                    }
                },
                {
                    "ty": "fl",
                    "c": {
                        "a": 1,
                        "k": [
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0.8078, 0.8157, 0.8784], "t": 0 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0.8078, 0.8157, 0.8784], "t": 60 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0.8078, 0.8157, 0.8784], "t": 120 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0.8078, 0.8157, 0.8784], "t": 180 },
                            { "s": [0.8078, 0.8157, 0.8784], "t": 240 }
                        ]
                    },
                    "r": 1,
                    "o": {
                        "a": 1,
                        "k": [
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 0 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 60 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 120 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 180 },
                            { "s": [100], "t": 240 }
                        ]
                    }
                }
            ],
            "ind": 22
        },
        {
            "ty": 4,
            "sr": 1,
            "st": 0,
            "op": 241,
            "ip": 0,
            "hasMask": false,
            "ao": 0,
            "ks": {
                "a": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [104.44, 38.33], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [104.44, 38.33], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [104.44, 38.33], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [104.44, 38.33], "t": 180 },
                        { "s": [104.44, 38.33], "t": 240 }
                    ]
                },
                "s": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100, 100], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100, 100], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100, 100], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100, 100], "t": 180 },
                        { "s": [100, 100], "t": 240 }
                    ]
                },
                "p": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [399.38, 415.34], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [405.75, 412.39], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [399.38, 415.34], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [405.75, 412.39], "t": 180 },
                        { "s": [399.38, 415.34], "t": 240 }
                    ]
                },
                "r": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [-8.2], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [-11.5], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [-8.2], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [-11.5], "t": 180 },
                        { "s": [-8.2], "t": 240 }
                    ]
                },
                "o": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 180 },
                        { "s": [100], "t": 240 }
                    ]
                }
            },
            "shapes": [
                {
                    "ty": "sh",
                    "d": 1,
                    "ks": {
                        "a": 1,
                        "k": [
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [4.54, -1.17],
                                            [0, 0],
                                            [1.18, 4.54],
                                            [0, 0],
                                            [0, 0],
                                            [-1.66, 0.42],
                                            [0, 0],
                                            [-1.26, -1.14],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [1.17, 4.54],
                                            [0, 0],
                                            [-4.54, 1.17],
                                            [0, 0],
                                            [0, 0],
                                            [0.55, -1.61],
                                            [0, 0],
                                            [1.66, -0.43],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [208.24, 15.01],
                                            [208.61, 16.43],
                                            [202.51, 26.78],
                                            [10.72, 76.39],
                                            [0.37, 70.29],
                                            [0, 68.87],
                                            [6.58, 49.59],
                                            [10.21, 46.24],
                                            [188.33, 0.16],
                                            [193.14, 1.33],
                                            [208.24, 15.01],
                                            [208.24, 15.01]
                                        ]
                                    }
                                ],
                                "t": 0
                            },
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [4.54, -1.17],
                                            [0, 0],
                                            [1.18, 4.54],
                                            [0, 0],
                                            [0, 0],
                                            [-1.66, 0.42],
                                            [0, 0],
                                            [-1.26, -1.14],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [1.17, 4.54],
                                            [0, 0],
                                            [-4.54, 1.17],
                                            [0, 0],
                                            [0, 0],
                                            [0.55, -1.61],
                                            [0, 0],
                                            [1.66, -0.43],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [208.24, 15.01],
                                            [208.61, 16.43],
                                            [202.51, 26.78],
                                            [10.72, 76.39],
                                            [0.37, 70.29],
                                            [0, 68.87],
                                            [6.58, 49.59],
                                            [10.21, 46.24],
                                            [188.33, 0.16],
                                            [193.14, 1.33],
                                            [208.24, 15.01],
                                            [208.24, 15.01]
                                        ]
                                    }
                                ],
                                "t": 60
                            },
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [4.54, -1.17],
                                            [0, 0],
                                            [1.18, 4.54],
                                            [0, 0],
                                            [0, 0],
                                            [-1.66, 0.42],
                                            [0, 0],
                                            [-1.26, -1.14],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [1.17, 4.54],
                                            [0, 0],
                                            [-4.54, 1.17],
                                            [0, 0],
                                            [0, 0],
                                            [0.55, -1.61],
                                            [0, 0],
                                            [1.66, -0.43],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [208.24, 15.01],
                                            [208.61, 16.43],
                                            [202.51, 26.78],
                                            [10.72, 76.39],
                                            [0.37, 70.29],
                                            [0, 68.87],
                                            [6.58, 49.59],
                                            [10.21, 46.24],
                                            [188.33, 0.16],
                                            [193.14, 1.33],
                                            [208.24, 15.01],
                                            [208.24, 15.01]
                                        ]
                                    }
                                ],
                                "t": 120
                            },
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [4.54, -1.17],
                                            [0, 0],
                                            [1.18, 4.54],
                                            [0, 0],
                                            [0, 0],
                                            [-1.66, 0.42],
                                            [0, 0],
                                            [-1.26, -1.14],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [1.17, 4.54],
                                            [0, 0],
                                            [-4.54, 1.17],
                                            [0, 0],
                                            [0, 0],
                                            [0.55, -1.61],
                                            [0, 0],
                                            [1.66, -0.43],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [208.24, 15.01],
                                            [208.61, 16.43],
                                            [202.51, 26.78],
                                            [10.72, 76.39],
                                            [0.37, 70.29],
                                            [0, 68.87],
                                            [6.58, 49.59],
                                            [10.21, 46.24],
                                            [188.33, 0.16],
                                            [193.14, 1.33],
                                            [208.24, 15.01],
                                            [208.24, 15.01]
                                        ]
                                    }
                                ],
                                "t": 180
                            },
                            {
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [4.54, -1.17],
                                            [0, 0],
                                            [1.18, 4.54],
                                            [0, 0],
                                            [0, 0],
                                            [-1.66, 0.42],
                                            [0, 0],
                                            [-1.26, -1.14],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [1.17, 4.54],
                                            [0, 0],
                                            [-4.54, 1.17],
                                            [0, 0],
                                            [0, 0],
                                            [0.55, -1.61],
                                            [0, 0],
                                            [1.66, -0.43],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [208.24, 15.01],
                                            [208.61, 16.43],
                                            [202.51, 26.78],
                                            [10.72, 76.39],
                                            [0.37, 70.29],
                                            [0, 68.87],
                                            [6.58, 49.59],
                                            [10.21, 46.24],
                                            [188.33, 0.16],
                                            [193.14, 1.33],
                                            [208.24, 15.01],
                                            [208.24, 15.01]
                                        ]
                                    }
                                ],
                                "t": 240
                            }
                        ]
                    }
                },
                {
                    "ty": "fl",
                    "c": {
                        "a": 1,
                        "k": [
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0.3843, 0.4235, 0.6275], "t": 0 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0.3843, 0.4235, 0.6275], "t": 60 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0.3843, 0.4235, 0.6275], "t": 120 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0.3843, 0.4235, 0.6275], "t": 180 },
                            { "s": [0.3843, 0.4235, 0.6275], "t": 240 }
                        ]
                    },
                    "r": 1,
                    "o": {
                        "a": 1,
                        "k": [
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 0 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 60 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 120 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 180 },
                            { "s": [100], "t": 240 }
                        ]
                    }
                }
            ],
            "ind": 23
        },
        {
            "ty": 4,
            "sr": 1,
            "st": 0,
            "op": 241,
            "ip": 0,
            "hasMask": false,
            "ao": 0,
            "ks": {
                "a": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [104.65, 42.24], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [104.65, 42.24], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [104.65, 42.24], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [104.65, 42.24], "t": 180 },
                        { "s": [104.65, 42.24], "t": 240 }
                    ]
                },
                "s": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100, 100], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100, 100], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100, 100], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100, 100], "t": 180 },
                        { "s": [100, 100], "t": 240 }
                    ]
                },
                "p": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [303.73, 194.88], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [297.58, 197.79], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [303.73, 194.88], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [297.58, 197.79], "t": 180 },
                        { "s": [303.73, 194.88], "t": 240 }
                    ]
                },
                "r": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [-8.2], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [-11.5], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [-8.2], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [-11.5], "t": 180 },
                        { "s": [-8.2], "t": 240 }
                    ]
                },
                "o": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 180 },
                        { "s": [100], "t": 240 }
                    ]
                }
            },
            "shapes": [
                {
                    "ty": "sh",
                    "d": 1,
                    "ks": {
                        "a": 1,
                        "k": [
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [-4.54, 1.17],
                                            [0, 0],
                                            [-1.18, -4.55]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [-1.18, -4.55],
                                            [0, 0],
                                            [4.54, -1.17],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [208.51, 6.37],
                                            [209.3, 9.41],
                                            [199.83, 38.9],
                                            [112.02, 62.78],
                                            [23.63, 84.48],
                                            [1.06, 63.28],
                                            [0.27, 60.24],
                                            [6.37, 49.88],
                                            [198.16, 0.27],
                                            [208.51, 6.37]
                                        ]
                                    }
                                ],
                                "t": 0
                            },
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [-4.54, 1.17],
                                            [0, 0],
                                            [-1.18, -4.55]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [-1.18, -4.55],
                                            [0, 0],
                                            [4.54, -1.17],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [208.51, 6.37],
                                            [209.3, 9.41],
                                            [199.83, 38.9],
                                            [112.02, 62.78],
                                            [23.63, 84.48],
                                            [1.06, 63.28],
                                            [0.27, 60.24],
                                            [6.37, 49.88],
                                            [198.16, 0.27],
                                            [208.51, 6.37]
                                        ]
                                    }
                                ],
                                "t": 60
                            },
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [-4.54, 1.17],
                                            [0, 0],
                                            [-1.18, -4.55]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [-1.18, -4.55],
                                            [0, 0],
                                            [4.54, -1.17],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [208.51, 6.37],
                                            [209.3, 9.41],
                                            [199.83, 38.9],
                                            [112.02, 62.78],
                                            [23.63, 84.48],
                                            [1.06, 63.28],
                                            [0.27, 60.24],
                                            [6.37, 49.88],
                                            [198.16, 0.27],
                                            [208.51, 6.37]
                                        ]
                                    }
                                ],
                                "t": 120
                            },
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [-4.54, 1.17],
                                            [0, 0],
                                            [-1.18, -4.55]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [-1.18, -4.55],
                                            [0, 0],
                                            [4.54, -1.17],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [208.51, 6.37],
                                            [209.3, 9.41],
                                            [199.83, 38.9],
                                            [112.02, 62.78],
                                            [23.63, 84.48],
                                            [1.06, 63.28],
                                            [0.27, 60.24],
                                            [6.37, 49.88],
                                            [198.16, 0.27],
                                            [208.51, 6.37]
                                        ]
                                    }
                                ],
                                "t": 180
                            },
                            {
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [-4.54, 1.17],
                                            [0, 0],
                                            [-1.18, -4.55]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [-1.18, -4.55],
                                            [0, 0],
                                            [4.54, -1.17],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [208.51, 6.37],
                                            [209.3, 9.41],
                                            [199.83, 38.9],
                                            [112.02, 62.78],
                                            [23.63, 84.48],
                                            [1.06, 63.28],
                                            [0.27, 60.24],
                                            [6.37, 49.88],
                                            [198.16, 0.27],
                                            [208.51, 6.37]
                                        ]
                                    }
                                ],
                                "t": 240
                            }
                        ]
                    }
                },
                {
                    "ty": "fl",
                    "c": {
                        "a": 1,
                        "k": [
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0.3852, 0.422, 0.627], "t": 0 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0.3852, 0.422, 0.627], "t": 60 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0.3852, 0.422, 0.627], "t": 120 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0.3852, 0.422, 0.627], "t": 180 },
                            { "s": [0.3852, 0.422, 0.627], "t": 240 }
                        ]
                    },
                    "r": 1,
                    "o": {
                        "a": 1,
                        "k": [
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 0 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 60 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 120 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 180 },
                            { "s": [100], "t": 240 }
                        ]
                    }
                }
            ],
            "ind": 24
        },
        {
            "ty": 4,
            "sr": 1,
            "st": 0,
            "op": 241,
            "ip": 0,
            "hasMask": false,
            "ao": 0,
            "ks": {
                "a": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [136.17, 156.21], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [136.17, 156.21], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [136.17, 156.21], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [136.17, 156.21], "t": 180 },
                        { "s": [136.17, 156.21], "t": 240 }
                    ]
                },
                "s": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100, 100], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100, 100], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100, 100], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100, 100], "t": 180 },
                        { "s": [100, 100], "t": 240 }
                    ]
                },
                "p": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [351.19, 303.19], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [351.19, 303.19], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [351.19, 303.19], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [351.19, 303.19], "t": 180 },
                        { "s": [351.19, 303.19], "t": 240 }
                    ]
                },
                "r": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [-8.2], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [-11.5], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [-8.2], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [-11.5], "t": 180 },
                        { "s": [-8.2], "t": 240 }
                    ]
                },
                "o": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 180 },
                        { "s": [100], "t": 240 }
                    ]
                }
            },
            "shapes": [
                {
                    "ty": "sh",
                    "d": 1,
                    "ks": {
                        "a": 1,
                        "k": [
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0.58, -1.56],
                                            [2.81, -0.73],
                                            [0, 0],
                                            [2.04, 1.77],
                                            [0.45, 1.73],
                                            [0, 0],
                                            [-0.81, 1.73],
                                            [-2.55, 0.66],
                                            [0, 0],
                                            [-1.97, -1.43],
                                            [-0.51, -1.99]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [0.45, 1.73],
                                            [-0.93, 2.53],
                                            [0, 0],
                                            [-2.81, 0.73],
                                            [-1.26, -1.09],
                                            [0, 0],
                                            [-0.52, -1.99],
                                            [1.04, -2.21],
                                            [0, 0],
                                            [2.55, -0.66],
                                            [1.56, 1.11],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [208.52, 6.37],
                                            [272.07, 252.18],
                                            [271.83, 257.22],
                                            [265.98, 262.53],
                                            [74.18, 312.15],
                                            [66.49, 310.34],
                                            [63.83, 306.05],
                                            [0.27, 60.24],
                                            [0.81, 54.51],
                                            [6.37, 49.88],
                                            [198.17, 0.27],
                                            [205.27, 1.61],
                                            [208.52, 6.37]
                                        ]
                                    }
                                ],
                                "t": 0
                            },
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0.58, -1.56],
                                            [2.81, -0.73],
                                            [0, 0],
                                            [2.04, 1.77],
                                            [0.45, 1.73],
                                            [0, 0],
                                            [-0.81, 1.73],
                                            [-2.55, 0.66],
                                            [0, 0],
                                            [-1.97, -1.43],
                                            [-0.51, -1.99]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [0.45, 1.73],
                                            [-0.93, 2.53],
                                            [0, 0],
                                            [-2.81, 0.73],
                                            [-1.26, -1.09],
                                            [0, 0],
                                            [-0.52, -1.99],
                                            [1.04, -2.21],
                                            [0, 0],
                                            [2.55, -0.66],
                                            [1.56, 1.11],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [208.52, 6.37],
                                            [272.07, 252.18],
                                            [271.83, 257.22],
                                            [265.98, 262.53],
                                            [74.18, 312.15],
                                            [66.49, 310.34],
                                            [63.83, 306.05],
                                            [0.27, 60.24],
                                            [0.81, 54.51],
                                            [6.37, 49.88],
                                            [198.17, 0.27],
                                            [205.27, 1.61],
                                            [208.52, 6.37]
                                        ]
                                    }
                                ],
                                "t": 60
                            },
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0.58, -1.56],
                                            [2.81, -0.73],
                                            [0, 0],
                                            [2.04, 1.77],
                                            [0.45, 1.73],
                                            [0, 0],
                                            [-0.81, 1.73],
                                            [-2.55, 0.66],
                                            [0, 0],
                                            [-1.97, -1.43],
                                            [-0.51, -1.99]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [0.45, 1.73],
                                            [-0.93, 2.53],
                                            [0, 0],
                                            [-2.81, 0.73],
                                            [-1.26, -1.09],
                                            [0, 0],
                                            [-0.52, -1.99],
                                            [1.04, -2.21],
                                            [0, 0],
                                            [2.55, -0.66],
                                            [1.56, 1.11],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [208.52, 6.37],
                                            [272.07, 252.18],
                                            [271.83, 257.22],
                                            [265.98, 262.53],
                                            [74.18, 312.15],
                                            [66.49, 310.34],
                                            [63.83, 306.05],
                                            [0.27, 60.24],
                                            [0.81, 54.51],
                                            [6.37, 49.88],
                                            [198.17, 0.27],
                                            [205.27, 1.61],
                                            [208.52, 6.37]
                                        ]
                                    }
                                ],
                                "t": 120
                            },
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0.58, -1.56],
                                            [2.81, -0.73],
                                            [0, 0],
                                            [2.04, 1.77],
                                            [0.45, 1.73],
                                            [0, 0],
                                            [-0.81, 1.73],
                                            [-2.55, 0.66],
                                            [0, 0],
                                            [-1.97, -1.43],
                                            [-0.51, -1.99]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [0.45, 1.73],
                                            [-0.93, 2.53],
                                            [0, 0],
                                            [-2.81, 0.73],
                                            [-1.26, -1.09],
                                            [0, 0],
                                            [-0.52, -1.99],
                                            [1.04, -2.21],
                                            [0, 0],
                                            [2.55, -0.66],
                                            [1.56, 1.11],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [208.52, 6.37],
                                            [272.07, 252.18],
                                            [271.83, 257.22],
                                            [265.98, 262.53],
                                            [74.18, 312.15],
                                            [66.49, 310.34],
                                            [63.83, 306.05],
                                            [0.27, 60.24],
                                            [0.81, 54.51],
                                            [6.37, 49.88],
                                            [198.17, 0.27],
                                            [205.27, 1.61],
                                            [208.52, 6.37]
                                        ]
                                    }
                                ],
                                "t": 180
                            },
                            {
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0.58, -1.56],
                                            [2.81, -0.73],
                                            [0, 0],
                                            [2.04, 1.77],
                                            [0.45, 1.73],
                                            [0, 0],
                                            [-0.81, 1.73],
                                            [-2.55, 0.66],
                                            [0, 0],
                                            [-1.97, -1.43],
                                            [-0.51, -1.99]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [0.45, 1.73],
                                            [-0.93, 2.53],
                                            [0, 0],
                                            [-2.81, 0.73],
                                            [-1.26, -1.09],
                                            [0, 0],
                                            [-0.52, -1.99],
                                            [1.04, -2.21],
                                            [0, 0],
                                            [2.55, -0.66],
                                            [1.56, 1.11],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [208.52, 6.37],
                                            [272.07, 252.18],
                                            [271.83, 257.22],
                                            [265.98, 262.53],
                                            [74.18, 312.15],
                                            [66.49, 310.34],
                                            [63.83, 306.05],
                                            [0.27, 60.24],
                                            [0.81, 54.51],
                                            [6.37, 49.88],
                                            [198.17, 0.27],
                                            [205.27, 1.61],
                                            [208.52, 6.37]
                                        ]
                                    }
                                ],
                                "t": 240
                            }
                        ]
                    }
                },
                {
                    "ty": "fl",
                    "c": {
                        "a": 1,
                        "k": [
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0.5176, 0.5451, 0.698], "t": 0 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0.5176, 0.5451, 0.698], "t": 60 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0.5176, 0.5451, 0.698], "t": 120 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0.5176, 0.5451, 0.698], "t": 180 },
                            { "s": [0.5176, 0.5451, 0.698], "t": 240 }
                        ]
                    },
                    "r": 1,
                    "o": {
                        "a": 1,
                        "k": [
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 0 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 60 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 120 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 180 },
                            { "s": [100], "t": 240 }
                        ]
                    }
                }
            ],
            "ind": 25
        },
        {
            "ty": 4,
            "sr": 1,
            "st": 0,
            "op": 241,
            "ip": 0,
            "hasMask": false,
            "ao": 0,
            "ks": {
                "a": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [136.16, 156.21], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [136.16, 156.21], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [136.16, 156.21], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [136.16, 156.21], "t": 180 },
                        { "s": [136.16, 156.21], "t": 240 }
                    ]
                },
                "s": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100, 100], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100, 100], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100, 100], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100, 100], "t": 180 },
                        { "s": [100, 100], "t": 240 }
                    ]
                },
                "p": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [351.13, 310.41], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [351.54, 310.4], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [351.13, 310.41], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [351.54, 310.4], "t": 180 },
                        { "s": [351.13, 310.41], "t": 240 }
                    ]
                },
                "r": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [-8.2], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [-11.5], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [-8.2], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [-11.5], "t": 180 },
                        { "s": [-8.2], "t": 240 }
                    ]
                },
                "o": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [20], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [20], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [20], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [20], "t": 180 },
                        { "s": [20], "t": 240 }
                    ]
                }
            },
            "shapes": [
                {
                    "ty": "sh",
                    "d": 1,
                    "ks": {
                        "a": 1,
                        "k": [
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [-0.04, 0.07],
                                            [-0.11, 0.22],
                                            [-0.03, 0.06],
                                            [-0.13, 0.41],
                                            [-0.03, 0.13],
                                            [-0.02, 0.11],
                                            [-0.03, 0.15],
                                            [-0.01, 0.09],
                                            [-0.01, 0.25],
                                            [0, 0.04],
                                            [0.01, 0.22],
                                            [0, 0.08],
                                            [0.02, 0.19],
                                            [0.01, 0.08],
                                            [0.07, 0.26],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0.09, 0.25],
                                            [0.03, 0.08],
                                            [0.08, 0.17],
                                            [0.04, 0.09],
                                            [0.09, 0.14],
                                            [0.05, 0.08],
                                            [0.1, 0.14],
                                            [0.06, 0.08],
                                            [0.11, 0.12],
                                            [0.07, 0.07],
                                            [0.12, 0.11],
                                            [0.07, 0.06],
                                            [0.12, 0.09],
                                            [0.35, 0.2],
                                            [0.06, 0.03],
                                            [0.2, 0.09],
                                            [0.09, 0.04],
                                            [0.18, 0.06],
                                            [0.1, 0.03],
                                            [0.18, 0.04],
                                            [0.11, 0.02],
                                            [0.18, 0.02],
                                            [0.11, 0.01],
                                            [0.19, 0],
                                            [0.11, 0],
                                            [0.21, -0.02],
                                            [0.1, -0.01],
                                            [0.3, -0.08],
                                            [0, 0],
                                            [0.29, -0.11],
                                            [0.09, -0.04],
                                            [0.18, -0.09],
                                            [0.1, -0.05],
                                            [0.16, -0.1],
                                            [0.09, -0.06],
                                            [0.14, -0.12],
                                            [0.08, -0.07],
                                            [0.14, -0.14],
                                            [0.07, -0.07],
                                            [0.13, -0.16],
                                            [0.05, -0.07],
                                            [0.12, -0.2],
                                            [0.03, -0.05],
                                            [0.16, -0.36],
                                            [0.05, -0.15],
                                            [0.03, -0.1],
                                            [0.04, -0.15],
                                            [0.02, -0.1],
                                            [0.03, -0.16],
                                            [0.01, -0.1],
                                            [0.01, -0.16],
                                            [0, -0.1],
                                            [0, -0.17],
                                            [-0.01, -0.1],
                                            [-0.02, -0.18],
                                            [-0.01, -0.09],
                                            [-0.07, -0.27],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [-0.09, -0.25],
                                            [-0.03, -0.07],
                                            [-0.08, -0.17],
                                            [-0.04, -0.07],
                                            [-0.11, -0.18],
                                            [-0.02, -0.03],
                                            [-0.15, -0.19],
                                            [-0.05, -0.07],
                                            [-0.1, -0.12],
                                            [-0.08, -0.08],
                                            [-0.1, -0.09],
                                            [-0.09, -0.08],
                                            [-0.16, -0.12],
                                            [-0.08, -0.06],
                                            [-0.16, -0.1],
                                            [-0.08, -0.04],
                                            [-0.16, -0.08],
                                            [-0.07, -0.03],
                                            [-0.2, -0.07],
                                            [-0.06, -0.02],
                                            [-0.19, -0.05],
                                            [-0.04, -0.01],
                                            [-0.23, -0.04],
                                            [-0.06, -0.01],
                                            [-0.24, -0.01],
                                            [-0.04, 0],
                                            [-0.22, 0.01],
                                            [-0.05, 0],
                                            [-0.25, 0.04],
                                            [-0.05, 0.01],
                                            [-0.25, 0.07],
                                            [0, 0],
                                            [-0.3, 0.12],
                                            [-0.09, 0.04],
                                            [-0.2, 0.1],
                                            [-0.1, 0.06],
                                            [-0.18, 0.12],
                                            [-0.08, 0.06],
                                            [-0.21, 0.19],
                                            [-0.02, 0.02],
                                            [-0.21, 0.24],
                                            [-0.04, 0.05],
                                            [-0.14, 0.21],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0.05, -0.07],
                                            [0.13, -0.21],
                                            [0.03, -0.06],
                                            [0.19, -0.38],
                                            [0.04, -0.12],
                                            [0.03, -0.1],
                                            [0.04, -0.15],
                                            [0.02, -0.09],
                                            [0.03, -0.24],
                                            [0, -0.04],
                                            [0.01, -0.21],
                                            [0, -0.08],
                                            [-0.01, -0.19],
                                            [-0.01, -0.08],
                                            [-0.04, -0.26],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [-0.07, -0.27],
                                            [-0.03, -0.08],
                                            [-0.07, -0.17],
                                            [-0.04, -0.09],
                                            [-0.08, -0.15],
                                            [-0.05, -0.08],
                                            [-0.09, -0.14],
                                            [-0.06, -0.08],
                                            [-0.1, -0.13],
                                            [-0.06, -0.07],
                                            [-0.11, -0.12],
                                            [-0.07, -0.07],
                                            [-0.11, -0.1],
                                            [-0.32, -0.25],
                                            [-0.06, -0.03],
                                            [-0.19, -0.11],
                                            [-0.09, -0.04],
                                            [-0.18, -0.07],
                                            [-0.1, -0.03],
                                            [-0.18, -0.05],
                                            [-0.11, -0.02],
                                            [-0.18, -0.03],
                                            [-0.11, -0.01],
                                            [-0.19, -0.01],
                                            [-0.11, 0],
                                            [-0.2, 0.01],
                                            [-0.1, 0.01],
                                            [-0.3, 0.04],
                                            [0, 0],
                                            [-0.3, 0.08],
                                            [-0.09, 0.03],
                                            [-0.19, 0.08],
                                            [-0.1, 0.05],
                                            [-0.17, 0.09],
                                            [-0.09, 0.06],
                                            [-0.15, 0.11],
                                            [-0.08, 0.07],
                                            [-0.14, 0.13],
                                            [-0.07, 0.07],
                                            [-0.14, 0.15],
                                            [-0.05, 0.07],
                                            [-0.14, 0.19],
                                            [-0.03, 0.05],
                                            [-0.2, 0.34],
                                            [-0.06, 0.14],
                                            [-0.04, 0.1],
                                            [-0.05, 0.15],
                                            [-0.03, 0.1],
                                            [-0.04, 0.16],
                                            [-0.02, 0.1],
                                            [-0.02, 0.16],
                                            [-0.01, 0.1],
                                            [-0.01, 0.17],
                                            [0, 0.1],
                                            [0.01, 0.18],
                                            [0.01, 0.09],
                                            [0.04, 0.27],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0.07, 0.26],
                                            [0.03, 0.07],
                                            [0.07, 0.18],
                                            [0.03, 0.07],
                                            [0.1, 0.19],
                                            [0.02, 0.04],
                                            [0.13, 0.21],
                                            [0.05, 0.07],
                                            [0.1, 0.12],
                                            [0.07, 0.08],
                                            [0.09, 0.1],
                                            [0.09, 0.08],
                                            [0.15, 0.13],
                                            [0.08, 0.06],
                                            [0.15, 0.11],
                                            [0.08, 0.05],
                                            [0.15, 0.08],
                                            [0.07, 0.03],
                                            [0.2, 0.09],
                                            [0.06, 0.02],
                                            [0.19, 0.06],
                                            [0.04, 0.01],
                                            [0.22, 0.06],
                                            [0.06, 0.01],
                                            [0.23, 0.03],
                                            [0.04, 0],
                                            [0.22, 0.01],
                                            [0.05, 0],
                                            [0.24, -0.01],
                                            [0.05, -0.01],
                                            [0.25, -0.04],
                                            [0, 0],
                                            [0.32, -0.08],
                                            [0.1, -0.04],
                                            [0.21, -0.09],
                                            [0.1, -0.05],
                                            [0.19, -0.11],
                                            [0.08, -0.06],
                                            [0.23, -0.17],
                                            [0.02, -0.02],
                                            [0.23, -0.22],
                                            [0.04, -0.05],
                                            [0.16, -0.19],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [270.83, 259.11],
                                            [270.97, 258.9],
                                            [271.34, 258.26],
                                            [271.44, 258.08],
                                            [271.92, 256.88],
                                            [272.04, 256.51],
                                            [272.11, 256.19],
                                            [272.2, 255.73],
                                            [272.25, 255.47],
                                            [272.32, 254.74],
                                            [272.32, 254.62],
                                            [272.32, 253.98],
                                            [272.31, 253.74],
                                            [272.25, 253.18],
                                            [272.22, 252.95],
                                            [272.06, 252.18],
                                            [271.69, 250.76],
                                            [209.29, 9.4],
                                            [208.51, 6.36],
                                            [208.26, 5.58],
                                            [208.16, 5.34],
                                            [207.95, 4.83],
                                            [207.81, 4.57],
                                            [207.56, 4.12],
                                            [207.41, 3.87],
                                            [207.12, 3.46],
                                            [206.94, 3.23],
                                            [206.62, 2.84],
                                            [206.43, 2.63],
                                            [206.07, 2.28],
                                            [205.86, 2.09],
                                            [205.51, 1.81],
                                            [204.51, 1.13],
                                            [204.33, 1.04],
                                            [203.74, 0.74],
                                            [203.47, 0.63],
                                            [202.93, 0.43],
                                            [202.62, 0.33],
                                            [202.08, 0.2],
                                            [201.75, 0.13],
                                            [201.21, 0.05],
                                            [200.87, 0.02],
                                            [200.3, 0],
                                            [199.97, 0],
                                            [199.35, 0.05],
                                            [199.06, 0.08],
                                            [198.15, 0.26],
                                            [6.36, 49.88],
                                            [5.48, 50.16],
                                            [5.22, 50.27],
                                            [4.65, 50.53],
                                            [4.36, 50.69],
                                            [3.87, 50.98],
                                            [3.59, 51.17],
                                            [3.14, 51.51],
                                            [2.9, 51.72],
                                            [2.48, 52.11],
                                            [2.27, 52.33],
                                            [1.87, 52.8],
                                            [1.71, 53],
                                            [1.31, 53.58],
                                            [1.22, 53.72],
                                            [0.68, 54.78],
                                            [0.51, 55.21],
                                            [0.41, 55.5],
                                            [0.27, 55.96],
                                            [0.21, 56.25],
                                            [0.11, 56.72],
                                            [0.07, 57.03],
                                            [0.02, 57.51],
                                            [0, 57.82],
                                            [0, 58.32],
                                            [0.01, 58.62],
                                            [0.07, 59.17],
                                            [0.1, 59.43],
                                            [0.26, 60.24],
                                            [1.05, 63.28],
                                            [63.45, 304.63],
                                            [63.82, 306.05],
                                            [64.06, 306.8],
                                            [64.14, 307.02],
                                            [64.36, 307.53],
                                            [64.46, 307.75],
                                            [64.77, 308.31],
                                            [64.83, 308.42],
                                            [65.25, 309.02],
                                            [65.41, 309.23],
                                            [65.72, 309.58],
                                            [65.94, 309.82],
                                            [66.22, 310.1],
                                            [66.48, 310.34],
                                            [66.94, 310.71],
                                            [67.18, 310.88],
                                            [67.64, 311.18],
                                            [67.87, 311.32],
                                            [68.33, 311.56],
                                            [68.54, 311.66],
                                            [69.14, 311.9],
                                            [69.33, 311.97],
                                            [69.9, 312.14],
                                            [70.02, 312.18],
                                            [70.71, 312.31],
                                            [70.89, 312.34],
                                            [71.6, 312.41],
                                            [71.71, 312.41],
                                            [72.38, 312.41],
                                            [72.52, 312.41],
                                            [73.25, 312.33],
                                            [73.41, 312.31],
                                            [74.17, 312.15],
                                            [265.95, 262.53],
                                            [266.89, 262.23],
                                            [267.17, 262.11],
                                            [267.78, 261.82],
                                            [268.07, 261.66],
                                            [268.63, 261.31],
                                            [268.87, 261.14],
                                            [269.53, 260.6],
                                            [269.59, 260.55],
                                            [270.25, 259.86],
                                            [270.38, 259.71],
                                            [270.83, 259.11],
                                            [270.83, 259.11]
                                        ]
                                    }
                                ],
                                "t": 0
                            },
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [-0.04, 0.07],
                                            [-0.11, 0.22],
                                            [-0.03, 0.06],
                                            [-0.13, 0.41],
                                            [-0.03, 0.13],
                                            [-0.02, 0.11],
                                            [-0.03, 0.15],
                                            [-0.01, 0.09],
                                            [-0.01, 0.25],
                                            [0, 0.04],
                                            [0.01, 0.22],
                                            [0, 0.08],
                                            [0.02, 0.19],
                                            [0.01, 0.08],
                                            [0.07, 0.26],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0.09, 0.25],
                                            [0.03, 0.08],
                                            [0.08, 0.17],
                                            [0.04, 0.09],
                                            [0.09, 0.14],
                                            [0.05, 0.08],
                                            [0.1, 0.14],
                                            [0.06, 0.08],
                                            [0.11, 0.12],
                                            [0.07, 0.07],
                                            [0.12, 0.11],
                                            [0.07, 0.06],
                                            [0.12, 0.09],
                                            [0.35, 0.2],
                                            [0.06, 0.03],
                                            [0.2, 0.09],
                                            [0.09, 0.04],
                                            [0.18, 0.06],
                                            [0.1, 0.03],
                                            [0.18, 0.04],
                                            [0.11, 0.02],
                                            [0.18, 0.02],
                                            [0.11, 0.01],
                                            [0.19, 0],
                                            [0.11, 0],
                                            [0.21, -0.02],
                                            [0.1, -0.01],
                                            [0.3, -0.08],
                                            [0, 0],
                                            [0.29, -0.11],
                                            [0.09, -0.04],
                                            [0.18, -0.09],
                                            [0.1, -0.05],
                                            [0.16, -0.1],
                                            [0.09, -0.06],
                                            [0.14, -0.12],
                                            [0.08, -0.07],
                                            [0.14, -0.14],
                                            [0.07, -0.07],
                                            [0.13, -0.16],
                                            [0.05, -0.07],
                                            [0.12, -0.2],
                                            [0.03, -0.05],
                                            [0.16, -0.36],
                                            [0.05, -0.15],
                                            [0.03, -0.1],
                                            [0.04, -0.15],
                                            [0.02, -0.1],
                                            [0.03, -0.16],
                                            [0.01, -0.1],
                                            [0.01, -0.16],
                                            [0, -0.1],
                                            [0, -0.17],
                                            [-0.01, -0.1],
                                            [-0.02, -0.18],
                                            [-0.01, -0.09],
                                            [-0.07, -0.27],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [-0.09, -0.25],
                                            [-0.03, -0.07],
                                            [-0.08, -0.17],
                                            [-0.04, -0.07],
                                            [-0.11, -0.18],
                                            [-0.02, -0.03],
                                            [-0.15, -0.19],
                                            [-0.05, -0.07],
                                            [-0.1, -0.12],
                                            [-0.08, -0.08],
                                            [-0.1, -0.09],
                                            [-0.09, -0.08],
                                            [-0.16, -0.12],
                                            [-0.08, -0.06],
                                            [-0.16, -0.1],
                                            [-0.08, -0.04],
                                            [-0.16, -0.08],
                                            [-0.07, -0.03],
                                            [-0.2, -0.07],
                                            [-0.06, -0.02],
                                            [-0.19, -0.05],
                                            [-0.04, -0.01],
                                            [-0.23, -0.04],
                                            [-0.06, -0.01],
                                            [-0.24, -0.01],
                                            [-0.04, 0],
                                            [-0.22, 0.01],
                                            [-0.05, 0],
                                            [-0.25, 0.04],
                                            [-0.05, 0.01],
                                            [-0.25, 0.07],
                                            [0, 0],
                                            [-0.3, 0.12],
                                            [-0.09, 0.04],
                                            [-0.2, 0.1],
                                            [-0.1, 0.06],
                                            [-0.18, 0.12],
                                            [-0.08, 0.06],
                                            [-0.21, 0.19],
                                            [-0.02, 0.02],
                                            [-0.21, 0.24],
                                            [-0.04, 0.05],
                                            [-0.14, 0.21],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0.05, -0.07],
                                            [0.13, -0.21],
                                            [0.03, -0.06],
                                            [0.19, -0.38],
                                            [0.04, -0.12],
                                            [0.03, -0.1],
                                            [0.04, -0.15],
                                            [0.02, -0.09],
                                            [0.03, -0.24],
                                            [0, -0.04],
                                            [0.01, -0.21],
                                            [0, -0.08],
                                            [-0.01, -0.19],
                                            [-0.01, -0.08],
                                            [-0.04, -0.26],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [-0.07, -0.27],
                                            [-0.03, -0.08],
                                            [-0.07, -0.17],
                                            [-0.04, -0.09],
                                            [-0.08, -0.15],
                                            [-0.05, -0.08],
                                            [-0.09, -0.14],
                                            [-0.06, -0.08],
                                            [-0.1, -0.13],
                                            [-0.06, -0.07],
                                            [-0.11, -0.12],
                                            [-0.07, -0.07],
                                            [-0.11, -0.1],
                                            [-0.32, -0.25],
                                            [-0.06, -0.03],
                                            [-0.19, -0.11],
                                            [-0.09, -0.04],
                                            [-0.18, -0.07],
                                            [-0.1, -0.03],
                                            [-0.18, -0.05],
                                            [-0.11, -0.02],
                                            [-0.18, -0.03],
                                            [-0.11, -0.01],
                                            [-0.19, -0.01],
                                            [-0.11, 0],
                                            [-0.2, 0.01],
                                            [-0.1, 0.01],
                                            [-0.3, 0.04],
                                            [0, 0],
                                            [-0.3, 0.08],
                                            [-0.09, 0.03],
                                            [-0.19, 0.08],
                                            [-0.1, 0.05],
                                            [-0.17, 0.09],
                                            [-0.09, 0.06],
                                            [-0.15, 0.11],
                                            [-0.08, 0.07],
                                            [-0.14, 0.13],
                                            [-0.07, 0.07],
                                            [-0.14, 0.15],
                                            [-0.05, 0.07],
                                            [-0.14, 0.19],
                                            [-0.03, 0.05],
                                            [-0.2, 0.34],
                                            [-0.06, 0.14],
                                            [-0.04, 0.1],
                                            [-0.05, 0.15],
                                            [-0.03, 0.1],
                                            [-0.04, 0.16],
                                            [-0.02, 0.1],
                                            [-0.02, 0.16],
                                            [-0.01, 0.1],
                                            [-0.01, 0.17],
                                            [0, 0.1],
                                            [0.01, 0.18],
                                            [0.01, 0.09],
                                            [0.04, 0.27],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0.07, 0.26],
                                            [0.03, 0.07],
                                            [0.07, 0.18],
                                            [0.03, 0.07],
                                            [0.1, 0.19],
                                            [0.02, 0.04],
                                            [0.13, 0.21],
                                            [0.05, 0.07],
                                            [0.1, 0.12],
                                            [0.07, 0.08],
                                            [0.09, 0.1],
                                            [0.09, 0.08],
                                            [0.15, 0.13],
                                            [0.08, 0.06],
                                            [0.15, 0.11],
                                            [0.08, 0.05],
                                            [0.15, 0.08],
                                            [0.07, 0.03],
                                            [0.2, 0.09],
                                            [0.06, 0.02],
                                            [0.19, 0.06],
                                            [0.04, 0.01],
                                            [0.22, 0.06],
                                            [0.06, 0.01],
                                            [0.23, 0.03],
                                            [0.04, 0],
                                            [0.22, 0.01],
                                            [0.05, 0],
                                            [0.24, -0.01],
                                            [0.05, -0.01],
                                            [0.25, -0.04],
                                            [0, 0],
                                            [0.32, -0.08],
                                            [0.1, -0.04],
                                            [0.21, -0.09],
                                            [0.1, -0.05],
                                            [0.19, -0.11],
                                            [0.08, -0.06],
                                            [0.23, -0.17],
                                            [0.02, -0.02],
                                            [0.23, -0.22],
                                            [0.04, -0.05],
                                            [0.16, -0.19],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [270.83, 259.11],
                                            [270.97, 258.9],
                                            [271.34, 258.26],
                                            [271.44, 258.08],
                                            [271.92, 256.88],
                                            [272.04, 256.51],
                                            [272.11, 256.19],
                                            [272.2, 255.73],
                                            [272.25, 255.47],
                                            [272.32, 254.74],
                                            [272.32, 254.62],
                                            [272.32, 253.98],
                                            [272.31, 253.74],
                                            [272.25, 253.18],
                                            [272.22, 252.95],
                                            [272.06, 252.18],
                                            [271.69, 250.76],
                                            [209.29, 9.4],
                                            [208.51, 6.36],
                                            [208.26, 5.58],
                                            [208.16, 5.34],
                                            [207.95, 4.83],
                                            [207.81, 4.57],
                                            [207.56, 4.12],
                                            [207.41, 3.87],
                                            [207.12, 3.46],
                                            [206.94, 3.23],
                                            [206.62, 2.84],
                                            [206.43, 2.63],
                                            [206.07, 2.28],
                                            [205.86, 2.09],
                                            [205.51, 1.81],
                                            [204.51, 1.13],
                                            [204.33, 1.04],
                                            [203.74, 0.74],
                                            [203.47, 0.63],
                                            [202.93, 0.43],
                                            [202.62, 0.33],
                                            [202.08, 0.2],
                                            [201.75, 0.13],
                                            [201.21, 0.05],
                                            [200.87, 0.02],
                                            [200.3, 0],
                                            [199.97, 0],
                                            [199.35, 0.05],
                                            [199.06, 0.08],
                                            [198.15, 0.26],
                                            [6.36, 49.88],
                                            [5.48, 50.16],
                                            [5.22, 50.27],
                                            [4.65, 50.53],
                                            [4.36, 50.69],
                                            [3.87, 50.98],
                                            [3.59, 51.17],
                                            [3.14, 51.51],
                                            [2.9, 51.72],
                                            [2.48, 52.11],
                                            [2.27, 52.33],
                                            [1.87, 52.8],
                                            [1.71, 53],
                                            [1.31, 53.58],
                                            [1.22, 53.72],
                                            [0.68, 54.78],
                                            [0.51, 55.21],
                                            [0.41, 55.5],
                                            [0.27, 55.96],
                                            [0.21, 56.25],
                                            [0.11, 56.72],
                                            [0.07, 57.03],
                                            [0.02, 57.51],
                                            [0, 57.82],
                                            [0, 58.32],
                                            [0.01, 58.62],
                                            [0.07, 59.17],
                                            [0.1, 59.43],
                                            [0.26, 60.24],
                                            [1.05, 63.28],
                                            [63.45, 304.63],
                                            [63.82, 306.05],
                                            [64.06, 306.8],
                                            [64.14, 307.02],
                                            [64.36, 307.53],
                                            [64.46, 307.75],
                                            [64.77, 308.31],
                                            [64.83, 308.42],
                                            [65.25, 309.02],
                                            [65.41, 309.23],
                                            [65.72, 309.58],
                                            [65.94, 309.82],
                                            [66.22, 310.1],
                                            [66.48, 310.34],
                                            [66.94, 310.71],
                                            [67.18, 310.88],
                                            [67.64, 311.18],
                                            [67.87, 311.32],
                                            [68.33, 311.56],
                                            [68.54, 311.66],
                                            [69.14, 311.9],
                                            [69.33, 311.97],
                                            [69.9, 312.14],
                                            [70.02, 312.18],
                                            [70.71, 312.31],
                                            [70.89, 312.34],
                                            [71.6, 312.41],
                                            [71.71, 312.41],
                                            [72.38, 312.41],
                                            [72.52, 312.41],
                                            [73.25, 312.33],
                                            [73.41, 312.31],
                                            [74.17, 312.15],
                                            [265.95, 262.53],
                                            [266.89, 262.23],
                                            [267.17, 262.11],
                                            [267.78, 261.82],
                                            [268.07, 261.66],
                                            [268.63, 261.31],
                                            [268.87, 261.14],
                                            [269.53, 260.6],
                                            [269.59, 260.55],
                                            [270.25, 259.86],
                                            [270.38, 259.71],
                                            [270.83, 259.11],
                                            [270.83, 259.11]
                                        ]
                                    }
                                ],
                                "t": 60
                            },
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [-0.04, 0.07],
                                            [-0.11, 0.22],
                                            [-0.03, 0.06],
                                            [-0.13, 0.41],
                                            [-0.03, 0.13],
                                            [-0.02, 0.11],
                                            [-0.03, 0.15],
                                            [-0.01, 0.09],
                                            [-0.01, 0.25],
                                            [0, 0.04],
                                            [0.01, 0.22],
                                            [0, 0.08],
                                            [0.02, 0.19],
                                            [0.01, 0.08],
                                            [0.07, 0.26],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0.09, 0.25],
                                            [0.03, 0.08],
                                            [0.08, 0.17],
                                            [0.04, 0.09],
                                            [0.09, 0.14],
                                            [0.05, 0.08],
                                            [0.1, 0.14],
                                            [0.06, 0.08],
                                            [0.11, 0.12],
                                            [0.07, 0.07],
                                            [0.12, 0.11],
                                            [0.07, 0.06],
                                            [0.12, 0.09],
                                            [0.35, 0.2],
                                            [0.06, 0.03],
                                            [0.2, 0.09],
                                            [0.09, 0.04],
                                            [0.18, 0.06],
                                            [0.1, 0.03],
                                            [0.18, 0.04],
                                            [0.11, 0.02],
                                            [0.18, 0.02],
                                            [0.11, 0.01],
                                            [0.19, 0],
                                            [0.11, 0],
                                            [0.21, -0.02],
                                            [0.1, -0.01],
                                            [0.3, -0.08],
                                            [0, 0],
                                            [0.29, -0.11],
                                            [0.09, -0.04],
                                            [0.18, -0.09],
                                            [0.1, -0.05],
                                            [0.16, -0.1],
                                            [0.09, -0.06],
                                            [0.14, -0.12],
                                            [0.08, -0.07],
                                            [0.14, -0.14],
                                            [0.07, -0.07],
                                            [0.13, -0.16],
                                            [0.05, -0.07],
                                            [0.12, -0.2],
                                            [0.03, -0.05],
                                            [0.16, -0.36],
                                            [0.05, -0.15],
                                            [0.03, -0.1],
                                            [0.04, -0.15],
                                            [0.02, -0.1],
                                            [0.03, -0.16],
                                            [0.01, -0.1],
                                            [0.01, -0.16],
                                            [0, -0.1],
                                            [0, -0.17],
                                            [-0.01, -0.1],
                                            [-0.02, -0.18],
                                            [-0.01, -0.09],
                                            [-0.07, -0.27],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [-0.09, -0.25],
                                            [-0.03, -0.07],
                                            [-0.08, -0.17],
                                            [-0.04, -0.07],
                                            [-0.11, -0.18],
                                            [-0.02, -0.03],
                                            [-0.15, -0.19],
                                            [-0.05, -0.07],
                                            [-0.1, -0.12],
                                            [-0.08, -0.08],
                                            [-0.1, -0.09],
                                            [-0.09, -0.08],
                                            [-0.16, -0.12],
                                            [-0.08, -0.06],
                                            [-0.16, -0.1],
                                            [-0.08, -0.04],
                                            [-0.16, -0.08],
                                            [-0.07, -0.03],
                                            [-0.2, -0.07],
                                            [-0.06, -0.02],
                                            [-0.19, -0.05],
                                            [-0.04, -0.01],
                                            [-0.23, -0.04],
                                            [-0.06, -0.01],
                                            [-0.24, -0.01],
                                            [-0.04, 0],
                                            [-0.22, 0.01],
                                            [-0.05, 0],
                                            [-0.25, 0.04],
                                            [-0.05, 0.01],
                                            [-0.25, 0.07],
                                            [0, 0],
                                            [-0.3, 0.12],
                                            [-0.09, 0.04],
                                            [-0.2, 0.1],
                                            [-0.1, 0.06],
                                            [-0.18, 0.12],
                                            [-0.08, 0.06],
                                            [-0.21, 0.19],
                                            [-0.02, 0.02],
                                            [-0.21, 0.24],
                                            [-0.04, 0.05],
                                            [-0.14, 0.21],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0.05, -0.07],
                                            [0.13, -0.21],
                                            [0.03, -0.06],
                                            [0.19, -0.38],
                                            [0.04, -0.12],
                                            [0.03, -0.1],
                                            [0.04, -0.15],
                                            [0.02, -0.09],
                                            [0.03, -0.24],
                                            [0, -0.04],
                                            [0.01, -0.21],
                                            [0, -0.08],
                                            [-0.01, -0.19],
                                            [-0.01, -0.08],
                                            [-0.04, -0.26],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [-0.07, -0.27],
                                            [-0.03, -0.08],
                                            [-0.07, -0.17],
                                            [-0.04, -0.09],
                                            [-0.08, -0.15],
                                            [-0.05, -0.08],
                                            [-0.09, -0.14],
                                            [-0.06, -0.08],
                                            [-0.1, -0.13],
                                            [-0.06, -0.07],
                                            [-0.11, -0.12],
                                            [-0.07, -0.07],
                                            [-0.11, -0.1],
                                            [-0.32, -0.25],
                                            [-0.06, -0.03],
                                            [-0.19, -0.11],
                                            [-0.09, -0.04],
                                            [-0.18, -0.07],
                                            [-0.1, -0.03],
                                            [-0.18, -0.05],
                                            [-0.11, -0.02],
                                            [-0.18, -0.03],
                                            [-0.11, -0.01],
                                            [-0.19, -0.01],
                                            [-0.11, 0],
                                            [-0.2, 0.01],
                                            [-0.1, 0.01],
                                            [-0.3, 0.04],
                                            [0, 0],
                                            [-0.3, 0.08],
                                            [-0.09, 0.03],
                                            [-0.19, 0.08],
                                            [-0.1, 0.05],
                                            [-0.17, 0.09],
                                            [-0.09, 0.06],
                                            [-0.15, 0.11],
                                            [-0.08, 0.07],
                                            [-0.14, 0.13],
                                            [-0.07, 0.07],
                                            [-0.14, 0.15],
                                            [-0.05, 0.07],
                                            [-0.14, 0.19],
                                            [-0.03, 0.05],
                                            [-0.2, 0.34],
                                            [-0.06, 0.14],
                                            [-0.04, 0.1],
                                            [-0.05, 0.15],
                                            [-0.03, 0.1],
                                            [-0.04, 0.16],
                                            [-0.02, 0.1],
                                            [-0.02, 0.16],
                                            [-0.01, 0.1],
                                            [-0.01, 0.17],
                                            [0, 0.1],
                                            [0.01, 0.18],
                                            [0.01, 0.09],
                                            [0.04, 0.27],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0.07, 0.26],
                                            [0.03, 0.07],
                                            [0.07, 0.18],
                                            [0.03, 0.07],
                                            [0.1, 0.19],
                                            [0.02, 0.04],
                                            [0.13, 0.21],
                                            [0.05, 0.07],
                                            [0.1, 0.12],
                                            [0.07, 0.08],
                                            [0.09, 0.1],
                                            [0.09, 0.08],
                                            [0.15, 0.13],
                                            [0.08, 0.06],
                                            [0.15, 0.11],
                                            [0.08, 0.05],
                                            [0.15, 0.08],
                                            [0.07, 0.03],
                                            [0.2, 0.09],
                                            [0.06, 0.02],
                                            [0.19, 0.06],
                                            [0.04, 0.01],
                                            [0.22, 0.06],
                                            [0.06, 0.01],
                                            [0.23, 0.03],
                                            [0.04, 0],
                                            [0.22, 0.01],
                                            [0.05, 0],
                                            [0.24, -0.01],
                                            [0.05, -0.01],
                                            [0.25, -0.04],
                                            [0, 0],
                                            [0.32, -0.08],
                                            [0.1, -0.04],
                                            [0.21, -0.09],
                                            [0.1, -0.05],
                                            [0.19, -0.11],
                                            [0.08, -0.06],
                                            [0.23, -0.17],
                                            [0.02, -0.02],
                                            [0.23, -0.22],
                                            [0.04, -0.05],
                                            [0.16, -0.19],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [270.83, 259.11],
                                            [270.97, 258.9],
                                            [271.34, 258.26],
                                            [271.44, 258.08],
                                            [271.92, 256.88],
                                            [272.04, 256.51],
                                            [272.11, 256.19],
                                            [272.2, 255.73],
                                            [272.25, 255.47],
                                            [272.32, 254.74],
                                            [272.32, 254.62],
                                            [272.32, 253.98],
                                            [272.31, 253.74],
                                            [272.25, 253.18],
                                            [272.22, 252.95],
                                            [272.06, 252.18],
                                            [271.69, 250.76],
                                            [209.29, 9.4],
                                            [208.51, 6.36],
                                            [208.26, 5.58],
                                            [208.16, 5.34],
                                            [207.95, 4.83],
                                            [207.81, 4.57],
                                            [207.56, 4.12],
                                            [207.41, 3.87],
                                            [207.12, 3.46],
                                            [206.94, 3.23],
                                            [206.62, 2.84],
                                            [206.43, 2.63],
                                            [206.07, 2.28],
                                            [205.86, 2.09],
                                            [205.51, 1.81],
                                            [204.51, 1.13],
                                            [204.33, 1.04],
                                            [203.74, 0.74],
                                            [203.47, 0.63],
                                            [202.93, 0.43],
                                            [202.62, 0.33],
                                            [202.08, 0.2],
                                            [201.75, 0.13],
                                            [201.21, 0.05],
                                            [200.87, 0.02],
                                            [200.3, 0],
                                            [199.97, 0],
                                            [199.35, 0.05],
                                            [199.06, 0.08],
                                            [198.15, 0.26],
                                            [6.36, 49.88],
                                            [5.48, 50.16],
                                            [5.22, 50.27],
                                            [4.65, 50.53],
                                            [4.36, 50.69],
                                            [3.87, 50.98],
                                            [3.59, 51.17],
                                            [3.14, 51.51],
                                            [2.9, 51.72],
                                            [2.48, 52.11],
                                            [2.27, 52.33],
                                            [1.87, 52.8],
                                            [1.71, 53],
                                            [1.31, 53.58],
                                            [1.22, 53.72],
                                            [0.68, 54.78],
                                            [0.51, 55.21],
                                            [0.41, 55.5],
                                            [0.27, 55.96],
                                            [0.21, 56.25],
                                            [0.11, 56.72],
                                            [0.07, 57.03],
                                            [0.02, 57.51],
                                            [0, 57.82],
                                            [0, 58.32],
                                            [0.01, 58.62],
                                            [0.07, 59.17],
                                            [0.1, 59.43],
                                            [0.26, 60.24],
                                            [1.05, 63.28],
                                            [63.45, 304.63],
                                            [63.82, 306.05],
                                            [64.06, 306.8],
                                            [64.14, 307.02],
                                            [64.36, 307.53],
                                            [64.46, 307.75],
                                            [64.77, 308.31],
                                            [64.83, 308.42],
                                            [65.25, 309.02],
                                            [65.41, 309.23],
                                            [65.72, 309.58],
                                            [65.94, 309.82],
                                            [66.22, 310.1],
                                            [66.48, 310.34],
                                            [66.94, 310.71],
                                            [67.18, 310.88],
                                            [67.64, 311.18],
                                            [67.87, 311.32],
                                            [68.33, 311.56],
                                            [68.54, 311.66],
                                            [69.14, 311.9],
                                            [69.33, 311.97],
                                            [69.9, 312.14],
                                            [70.02, 312.18],
                                            [70.71, 312.31],
                                            [70.89, 312.34],
                                            [71.6, 312.41],
                                            [71.71, 312.41],
                                            [72.38, 312.41],
                                            [72.52, 312.41],
                                            [73.25, 312.33],
                                            [73.41, 312.31],
                                            [74.17, 312.15],
                                            [265.95, 262.53],
                                            [266.89, 262.23],
                                            [267.17, 262.11],
                                            [267.78, 261.82],
                                            [268.07, 261.66],
                                            [268.63, 261.31],
                                            [268.87, 261.14],
                                            [269.53, 260.6],
                                            [269.59, 260.55],
                                            [270.25, 259.86],
                                            [270.38, 259.71],
                                            [270.83, 259.11],
                                            [270.83, 259.11]
                                        ]
                                    }
                                ],
                                "t": 120
                            },
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [-0.04, 0.07],
                                            [-0.11, 0.22],
                                            [-0.03, 0.06],
                                            [-0.13, 0.41],
                                            [-0.03, 0.13],
                                            [-0.02, 0.11],
                                            [-0.03, 0.15],
                                            [-0.01, 0.09],
                                            [-0.01, 0.25],
                                            [0, 0.04],
                                            [0.01, 0.22],
                                            [0, 0.08],
                                            [0.02, 0.19],
                                            [0.01, 0.08],
                                            [0.07, 0.26],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0.09, 0.25],
                                            [0.03, 0.08],
                                            [0.08, 0.17],
                                            [0.04, 0.09],
                                            [0.09, 0.14],
                                            [0.05, 0.08],
                                            [0.1, 0.14],
                                            [0.06, 0.08],
                                            [0.11, 0.12],
                                            [0.07, 0.07],
                                            [0.12, 0.11],
                                            [0.07, 0.06],
                                            [0.12, 0.09],
                                            [0.35, 0.2],
                                            [0.06, 0.03],
                                            [0.2, 0.09],
                                            [0.09, 0.04],
                                            [0.18, 0.06],
                                            [0.1, 0.03],
                                            [0.18, 0.04],
                                            [0.11, 0.02],
                                            [0.18, 0.02],
                                            [0.11, 0.01],
                                            [0.19, 0],
                                            [0.11, 0],
                                            [0.21, -0.02],
                                            [0.1, -0.01],
                                            [0.3, -0.08],
                                            [0, 0],
                                            [0.29, -0.11],
                                            [0.09, -0.04],
                                            [0.18, -0.09],
                                            [0.1, -0.05],
                                            [0.16, -0.1],
                                            [0.09, -0.06],
                                            [0.14, -0.12],
                                            [0.08, -0.07],
                                            [0.14, -0.14],
                                            [0.07, -0.07],
                                            [0.13, -0.16],
                                            [0.05, -0.07],
                                            [0.12, -0.2],
                                            [0.03, -0.05],
                                            [0.16, -0.36],
                                            [0.05, -0.15],
                                            [0.03, -0.1],
                                            [0.04, -0.15],
                                            [0.02, -0.1],
                                            [0.03, -0.16],
                                            [0.01, -0.1],
                                            [0.01, -0.16],
                                            [0, -0.1],
                                            [0, -0.17],
                                            [-0.01, -0.1],
                                            [-0.02, -0.18],
                                            [-0.01, -0.09],
                                            [-0.07, -0.27],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [-0.09, -0.25],
                                            [-0.03, -0.07],
                                            [-0.08, -0.17],
                                            [-0.04, -0.07],
                                            [-0.11, -0.18],
                                            [-0.02, -0.03],
                                            [-0.15, -0.19],
                                            [-0.05, -0.07],
                                            [-0.1, -0.12],
                                            [-0.08, -0.08],
                                            [-0.1, -0.09],
                                            [-0.09, -0.08],
                                            [-0.16, -0.12],
                                            [-0.08, -0.06],
                                            [-0.16, -0.1],
                                            [-0.08, -0.04],
                                            [-0.16, -0.08],
                                            [-0.07, -0.03],
                                            [-0.2, -0.07],
                                            [-0.06, -0.02],
                                            [-0.19, -0.05],
                                            [-0.04, -0.01],
                                            [-0.23, -0.04],
                                            [-0.06, -0.01],
                                            [-0.24, -0.01],
                                            [-0.04, 0],
                                            [-0.22, 0.01],
                                            [-0.05, 0],
                                            [-0.25, 0.04],
                                            [-0.05, 0.01],
                                            [-0.25, 0.07],
                                            [0, 0],
                                            [-0.3, 0.12],
                                            [-0.09, 0.04],
                                            [-0.2, 0.1],
                                            [-0.1, 0.06],
                                            [-0.18, 0.12],
                                            [-0.08, 0.06],
                                            [-0.21, 0.19],
                                            [-0.02, 0.02],
                                            [-0.21, 0.24],
                                            [-0.04, 0.05],
                                            [-0.14, 0.21],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0.05, -0.07],
                                            [0.13, -0.21],
                                            [0.03, -0.06],
                                            [0.19, -0.38],
                                            [0.04, -0.12],
                                            [0.03, -0.1],
                                            [0.04, -0.15],
                                            [0.02, -0.09],
                                            [0.03, -0.24],
                                            [0, -0.04],
                                            [0.01, -0.21],
                                            [0, -0.08],
                                            [-0.01, -0.19],
                                            [-0.01, -0.08],
                                            [-0.04, -0.26],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [-0.07, -0.27],
                                            [-0.03, -0.08],
                                            [-0.07, -0.17],
                                            [-0.04, -0.09],
                                            [-0.08, -0.15],
                                            [-0.05, -0.08],
                                            [-0.09, -0.14],
                                            [-0.06, -0.08],
                                            [-0.1, -0.13],
                                            [-0.06, -0.07],
                                            [-0.11, -0.12],
                                            [-0.07, -0.07],
                                            [-0.11, -0.1],
                                            [-0.32, -0.25],
                                            [-0.06, -0.03],
                                            [-0.19, -0.11],
                                            [-0.09, -0.04],
                                            [-0.18, -0.07],
                                            [-0.1, -0.03],
                                            [-0.18, -0.05],
                                            [-0.11, -0.02],
                                            [-0.18, -0.03],
                                            [-0.11, -0.01],
                                            [-0.19, -0.01],
                                            [-0.11, 0],
                                            [-0.2, 0.01],
                                            [-0.1, 0.01],
                                            [-0.3, 0.04],
                                            [0, 0],
                                            [-0.3, 0.08],
                                            [-0.09, 0.03],
                                            [-0.19, 0.08],
                                            [-0.1, 0.05],
                                            [-0.17, 0.09],
                                            [-0.09, 0.06],
                                            [-0.15, 0.11],
                                            [-0.08, 0.07],
                                            [-0.14, 0.13],
                                            [-0.07, 0.07],
                                            [-0.14, 0.15],
                                            [-0.05, 0.07],
                                            [-0.14, 0.19],
                                            [-0.03, 0.05],
                                            [-0.2, 0.34],
                                            [-0.06, 0.14],
                                            [-0.04, 0.1],
                                            [-0.05, 0.15],
                                            [-0.03, 0.1],
                                            [-0.04, 0.16],
                                            [-0.02, 0.1],
                                            [-0.02, 0.16],
                                            [-0.01, 0.1],
                                            [-0.01, 0.17],
                                            [0, 0.1],
                                            [0.01, 0.18],
                                            [0.01, 0.09],
                                            [0.04, 0.27],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0.07, 0.26],
                                            [0.03, 0.07],
                                            [0.07, 0.18],
                                            [0.03, 0.07],
                                            [0.1, 0.19],
                                            [0.02, 0.04],
                                            [0.13, 0.21],
                                            [0.05, 0.07],
                                            [0.1, 0.12],
                                            [0.07, 0.08],
                                            [0.09, 0.1],
                                            [0.09, 0.08],
                                            [0.15, 0.13],
                                            [0.08, 0.06],
                                            [0.15, 0.11],
                                            [0.08, 0.05],
                                            [0.15, 0.08],
                                            [0.07, 0.03],
                                            [0.2, 0.09],
                                            [0.06, 0.02],
                                            [0.19, 0.06],
                                            [0.04, 0.01],
                                            [0.22, 0.06],
                                            [0.06, 0.01],
                                            [0.23, 0.03],
                                            [0.04, 0],
                                            [0.22, 0.01],
                                            [0.05, 0],
                                            [0.24, -0.01],
                                            [0.05, -0.01],
                                            [0.25, -0.04],
                                            [0, 0],
                                            [0.32, -0.08],
                                            [0.1, -0.04],
                                            [0.21, -0.09],
                                            [0.1, -0.05],
                                            [0.19, -0.11],
                                            [0.08, -0.06],
                                            [0.23, -0.17],
                                            [0.02, -0.02],
                                            [0.23, -0.22],
                                            [0.04, -0.05],
                                            [0.16, -0.19],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [270.83, 259.11],
                                            [270.97, 258.9],
                                            [271.34, 258.26],
                                            [271.44, 258.08],
                                            [271.92, 256.88],
                                            [272.04, 256.51],
                                            [272.11, 256.19],
                                            [272.2, 255.73],
                                            [272.25, 255.47],
                                            [272.32, 254.74],
                                            [272.32, 254.62],
                                            [272.32, 253.98],
                                            [272.31, 253.74],
                                            [272.25, 253.18],
                                            [272.22, 252.95],
                                            [272.06, 252.18],
                                            [271.69, 250.76],
                                            [209.29, 9.4],
                                            [208.51, 6.36],
                                            [208.26, 5.58],
                                            [208.16, 5.34],
                                            [207.95, 4.83],
                                            [207.81, 4.57],
                                            [207.56, 4.12],
                                            [207.41, 3.87],
                                            [207.12, 3.46],
                                            [206.94, 3.23],
                                            [206.62, 2.84],
                                            [206.43, 2.63],
                                            [206.07, 2.28],
                                            [205.86, 2.09],
                                            [205.51, 1.81],
                                            [204.51, 1.13],
                                            [204.33, 1.04],
                                            [203.74, 0.74],
                                            [203.47, 0.63],
                                            [202.93, 0.43],
                                            [202.62, 0.33],
                                            [202.08, 0.2],
                                            [201.75, 0.13],
                                            [201.21, 0.05],
                                            [200.87, 0.02],
                                            [200.3, 0],
                                            [199.97, 0],
                                            [199.35, 0.05],
                                            [199.06, 0.08],
                                            [198.15, 0.26],
                                            [6.36, 49.88],
                                            [5.48, 50.16],
                                            [5.22, 50.27],
                                            [4.65, 50.53],
                                            [4.36, 50.69],
                                            [3.87, 50.98],
                                            [3.59, 51.17],
                                            [3.14, 51.51],
                                            [2.9, 51.72],
                                            [2.48, 52.11],
                                            [2.27, 52.33],
                                            [1.87, 52.8],
                                            [1.71, 53],
                                            [1.31, 53.58],
                                            [1.22, 53.72],
                                            [0.68, 54.78],
                                            [0.51, 55.21],
                                            [0.41, 55.5],
                                            [0.27, 55.96],
                                            [0.21, 56.25],
                                            [0.11, 56.72],
                                            [0.07, 57.03],
                                            [0.02, 57.51],
                                            [0, 57.82],
                                            [0, 58.32],
                                            [0.01, 58.62],
                                            [0.07, 59.17],
                                            [0.1, 59.43],
                                            [0.26, 60.24],
                                            [1.05, 63.28],
                                            [63.45, 304.63],
                                            [63.82, 306.05],
                                            [64.06, 306.8],
                                            [64.14, 307.02],
                                            [64.36, 307.53],
                                            [64.46, 307.75],
                                            [64.77, 308.31],
                                            [64.83, 308.42],
                                            [65.25, 309.02],
                                            [65.41, 309.23],
                                            [65.72, 309.58],
                                            [65.94, 309.82],
                                            [66.22, 310.1],
                                            [66.48, 310.34],
                                            [66.94, 310.71],
                                            [67.18, 310.88],
                                            [67.64, 311.18],
                                            [67.87, 311.32],
                                            [68.33, 311.56],
                                            [68.54, 311.66],
                                            [69.14, 311.9],
                                            [69.33, 311.97],
                                            [69.9, 312.14],
                                            [70.02, 312.18],
                                            [70.71, 312.31],
                                            [70.89, 312.34],
                                            [71.6, 312.41],
                                            [71.71, 312.41],
                                            [72.38, 312.41],
                                            [72.52, 312.41],
                                            [73.25, 312.33],
                                            [73.41, 312.31],
                                            [74.17, 312.15],
                                            [265.95, 262.53],
                                            [266.89, 262.23],
                                            [267.17, 262.11],
                                            [267.78, 261.82],
                                            [268.07, 261.66],
                                            [268.63, 261.31],
                                            [268.87, 261.14],
                                            [269.53, 260.6],
                                            [269.59, 260.55],
                                            [270.25, 259.86],
                                            [270.38, 259.71],
                                            [270.83, 259.11],
                                            [270.83, 259.11]
                                        ]
                                    }
                                ],
                                "t": 180
                            },
                            {
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [-0.04, 0.07],
                                            [-0.11, 0.22],
                                            [-0.03, 0.06],
                                            [-0.13, 0.41],
                                            [-0.03, 0.13],
                                            [-0.02, 0.11],
                                            [-0.03, 0.15],
                                            [-0.01, 0.09],
                                            [-0.01, 0.25],
                                            [0, 0.04],
                                            [0.01, 0.22],
                                            [0, 0.08],
                                            [0.02, 0.19],
                                            [0.01, 0.08],
                                            [0.07, 0.26],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0.09, 0.25],
                                            [0.03, 0.08],
                                            [0.08, 0.17],
                                            [0.04, 0.09],
                                            [0.09, 0.14],
                                            [0.05, 0.08],
                                            [0.1, 0.14],
                                            [0.06, 0.08],
                                            [0.11, 0.12],
                                            [0.07, 0.07],
                                            [0.12, 0.11],
                                            [0.07, 0.06],
                                            [0.12, 0.09],
                                            [0.35, 0.2],
                                            [0.06, 0.03],
                                            [0.2, 0.09],
                                            [0.09, 0.04],
                                            [0.18, 0.06],
                                            [0.1, 0.03],
                                            [0.18, 0.04],
                                            [0.11, 0.02],
                                            [0.18, 0.02],
                                            [0.11, 0.01],
                                            [0.19, 0],
                                            [0.11, 0],
                                            [0.21, -0.02],
                                            [0.1, -0.01],
                                            [0.3, -0.08],
                                            [0, 0],
                                            [0.29, -0.11],
                                            [0.09, -0.04],
                                            [0.18, -0.09],
                                            [0.1, -0.05],
                                            [0.16, -0.1],
                                            [0.09, -0.06],
                                            [0.14, -0.12],
                                            [0.08, -0.07],
                                            [0.14, -0.14],
                                            [0.07, -0.07],
                                            [0.13, -0.16],
                                            [0.05, -0.07],
                                            [0.12, -0.2],
                                            [0.03, -0.05],
                                            [0.16, -0.36],
                                            [0.05, -0.15],
                                            [0.03, -0.1],
                                            [0.04, -0.15],
                                            [0.02, -0.1],
                                            [0.03, -0.16],
                                            [0.01, -0.1],
                                            [0.01, -0.16],
                                            [0, -0.1],
                                            [0, -0.17],
                                            [-0.01, -0.1],
                                            [-0.02, -0.18],
                                            [-0.01, -0.09],
                                            [-0.07, -0.27],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [-0.09, -0.25],
                                            [-0.03, -0.07],
                                            [-0.08, -0.17],
                                            [-0.04, -0.07],
                                            [-0.11, -0.18],
                                            [-0.02, -0.03],
                                            [-0.15, -0.19],
                                            [-0.05, -0.07],
                                            [-0.1, -0.12],
                                            [-0.08, -0.08],
                                            [-0.1, -0.09],
                                            [-0.09, -0.08],
                                            [-0.16, -0.12],
                                            [-0.08, -0.06],
                                            [-0.16, -0.1],
                                            [-0.08, -0.04],
                                            [-0.16, -0.08],
                                            [-0.07, -0.03],
                                            [-0.2, -0.07],
                                            [-0.06, -0.02],
                                            [-0.19, -0.05],
                                            [-0.04, -0.01],
                                            [-0.23, -0.04],
                                            [-0.06, -0.01],
                                            [-0.24, -0.01],
                                            [-0.04, 0],
                                            [-0.22, 0.01],
                                            [-0.05, 0],
                                            [-0.25, 0.04],
                                            [-0.05, 0.01],
                                            [-0.25, 0.07],
                                            [0, 0],
                                            [-0.3, 0.12],
                                            [-0.09, 0.04],
                                            [-0.2, 0.1],
                                            [-0.1, 0.06],
                                            [-0.18, 0.12],
                                            [-0.08, 0.06],
                                            [-0.21, 0.19],
                                            [-0.02, 0.02],
                                            [-0.21, 0.24],
                                            [-0.04, 0.05],
                                            [-0.14, 0.21],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0.05, -0.07],
                                            [0.13, -0.21],
                                            [0.03, -0.06],
                                            [0.19, -0.38],
                                            [0.04, -0.12],
                                            [0.03, -0.1],
                                            [0.04, -0.15],
                                            [0.02, -0.09],
                                            [0.03, -0.24],
                                            [0, -0.04],
                                            [0.01, -0.21],
                                            [0, -0.08],
                                            [-0.01, -0.19],
                                            [-0.01, -0.08],
                                            [-0.04, -0.26],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [-0.07, -0.27],
                                            [-0.03, -0.08],
                                            [-0.07, -0.17],
                                            [-0.04, -0.09],
                                            [-0.08, -0.15],
                                            [-0.05, -0.08],
                                            [-0.09, -0.14],
                                            [-0.06, -0.08],
                                            [-0.1, -0.13],
                                            [-0.06, -0.07],
                                            [-0.11, -0.12],
                                            [-0.07, -0.07],
                                            [-0.11, -0.1],
                                            [-0.32, -0.25],
                                            [-0.06, -0.03],
                                            [-0.19, -0.11],
                                            [-0.09, -0.04],
                                            [-0.18, -0.07],
                                            [-0.1, -0.03],
                                            [-0.18, -0.05],
                                            [-0.11, -0.02],
                                            [-0.18, -0.03],
                                            [-0.11, -0.01],
                                            [-0.19, -0.01],
                                            [-0.11, 0],
                                            [-0.2, 0.01],
                                            [-0.1, 0.01],
                                            [-0.3, 0.04],
                                            [0, 0],
                                            [-0.3, 0.08],
                                            [-0.09, 0.03],
                                            [-0.19, 0.08],
                                            [-0.1, 0.05],
                                            [-0.17, 0.09],
                                            [-0.09, 0.06],
                                            [-0.15, 0.11],
                                            [-0.08, 0.07],
                                            [-0.14, 0.13],
                                            [-0.07, 0.07],
                                            [-0.14, 0.15],
                                            [-0.05, 0.07],
                                            [-0.14, 0.19],
                                            [-0.03, 0.05],
                                            [-0.2, 0.34],
                                            [-0.06, 0.14],
                                            [-0.04, 0.1],
                                            [-0.05, 0.15],
                                            [-0.03, 0.1],
                                            [-0.04, 0.16],
                                            [-0.02, 0.1],
                                            [-0.02, 0.16],
                                            [-0.01, 0.1],
                                            [-0.01, 0.17],
                                            [0, 0.1],
                                            [0.01, 0.18],
                                            [0.01, 0.09],
                                            [0.04, 0.27],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0.07, 0.26],
                                            [0.03, 0.07],
                                            [0.07, 0.18],
                                            [0.03, 0.07],
                                            [0.1, 0.19],
                                            [0.02, 0.04],
                                            [0.13, 0.21],
                                            [0.05, 0.07],
                                            [0.1, 0.12],
                                            [0.07, 0.08],
                                            [0.09, 0.1],
                                            [0.09, 0.08],
                                            [0.15, 0.13],
                                            [0.08, 0.06],
                                            [0.15, 0.11],
                                            [0.08, 0.05],
                                            [0.15, 0.08],
                                            [0.07, 0.03],
                                            [0.2, 0.09],
                                            [0.06, 0.02],
                                            [0.19, 0.06],
                                            [0.04, 0.01],
                                            [0.22, 0.06],
                                            [0.06, 0.01],
                                            [0.23, 0.03],
                                            [0.04, 0],
                                            [0.22, 0.01],
                                            [0.05, 0],
                                            [0.24, -0.01],
                                            [0.05, -0.01],
                                            [0.25, -0.04],
                                            [0, 0],
                                            [0.32, -0.08],
                                            [0.1, -0.04],
                                            [0.21, -0.09],
                                            [0.1, -0.05],
                                            [0.19, -0.11],
                                            [0.08, -0.06],
                                            [0.23, -0.17],
                                            [0.02, -0.02],
                                            [0.23, -0.22],
                                            [0.04, -0.05],
                                            [0.16, -0.19],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [270.83, 259.11],
                                            [270.97, 258.9],
                                            [271.34, 258.26],
                                            [271.44, 258.08],
                                            [271.92, 256.88],
                                            [272.04, 256.51],
                                            [272.11, 256.19],
                                            [272.2, 255.73],
                                            [272.25, 255.47],
                                            [272.32, 254.74],
                                            [272.32, 254.62],
                                            [272.32, 253.98],
                                            [272.31, 253.74],
                                            [272.25, 253.18],
                                            [272.22, 252.95],
                                            [272.06, 252.18],
                                            [271.69, 250.76],
                                            [209.29, 9.4],
                                            [208.51, 6.36],
                                            [208.26, 5.58],
                                            [208.16, 5.34],
                                            [207.95, 4.83],
                                            [207.81, 4.57],
                                            [207.56, 4.12],
                                            [207.41, 3.87],
                                            [207.12, 3.46],
                                            [206.94, 3.23],
                                            [206.62, 2.84],
                                            [206.43, 2.63],
                                            [206.07, 2.28],
                                            [205.86, 2.09],
                                            [205.51, 1.81],
                                            [204.51, 1.13],
                                            [204.33, 1.04],
                                            [203.74, 0.74],
                                            [203.47, 0.63],
                                            [202.93, 0.43],
                                            [202.62, 0.33],
                                            [202.08, 0.2],
                                            [201.75, 0.13],
                                            [201.21, 0.05],
                                            [200.87, 0.02],
                                            [200.3, 0],
                                            [199.97, 0],
                                            [199.35, 0.05],
                                            [199.06, 0.08],
                                            [198.15, 0.26],
                                            [6.36, 49.88],
                                            [5.48, 50.16],
                                            [5.22, 50.27],
                                            [4.65, 50.53],
                                            [4.36, 50.69],
                                            [3.87, 50.98],
                                            [3.59, 51.17],
                                            [3.14, 51.51],
                                            [2.9, 51.72],
                                            [2.48, 52.11],
                                            [2.27, 52.33],
                                            [1.87, 52.8],
                                            [1.71, 53],
                                            [1.31, 53.58],
                                            [1.22, 53.72],
                                            [0.68, 54.78],
                                            [0.51, 55.21],
                                            [0.41, 55.5],
                                            [0.27, 55.96],
                                            [0.21, 56.25],
                                            [0.11, 56.72],
                                            [0.07, 57.03],
                                            [0.02, 57.51],
                                            [0, 57.82],
                                            [0, 58.32],
                                            [0.01, 58.62],
                                            [0.07, 59.17],
                                            [0.1, 59.43],
                                            [0.26, 60.24],
                                            [1.05, 63.28],
                                            [63.45, 304.63],
                                            [63.82, 306.05],
                                            [64.06, 306.8],
                                            [64.14, 307.02],
                                            [64.36, 307.53],
                                            [64.46, 307.75],
                                            [64.77, 308.31],
                                            [64.83, 308.42],
                                            [65.25, 309.02],
                                            [65.41, 309.23],
                                            [65.72, 309.58],
                                            [65.94, 309.82],
                                            [66.22, 310.1],
                                            [66.48, 310.34],
                                            [66.94, 310.71],
                                            [67.18, 310.88],
                                            [67.64, 311.18],
                                            [67.87, 311.32],
                                            [68.33, 311.56],
                                            [68.54, 311.66],
                                            [69.14, 311.9],
                                            [69.33, 311.97],
                                            [69.9, 312.14],
                                            [70.02, 312.18],
                                            [70.71, 312.31],
                                            [70.89, 312.34],
                                            [71.6, 312.41],
                                            [71.71, 312.41],
                                            [72.38, 312.41],
                                            [72.52, 312.41],
                                            [73.25, 312.33],
                                            [73.41, 312.31],
                                            [74.17, 312.15],
                                            [265.95, 262.53],
                                            [266.89, 262.23],
                                            [267.17, 262.11],
                                            [267.78, 261.82],
                                            [268.07, 261.66],
                                            [268.63, 261.31],
                                            [268.87, 261.14],
                                            [269.53, 260.6],
                                            [269.59, 260.55],
                                            [270.25, 259.86],
                                            [270.38, 259.71],
                                            [270.83, 259.11],
                                            [270.83, 259.11]
                                        ]
                                    }
                                ],
                                "t": 240
                            }
                        ]
                    }
                },
                {
                    "ty": "fl",
                    "c": {
                        "a": 1,
                        "k": [
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0.2275, 0.4941, 0.7569], "t": 0 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0.2275, 0.4941, 0.7569], "t": 60 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0.2275, 0.4941, 0.7569], "t": 120 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0.2275, 0.4941, 0.7569], "t": 180 },
                            { "s": [0.2275, 0.4941, 0.7569], "t": 240 }
                        ]
                    },
                    "r": 1,
                    "o": {
                        "a": 1,
                        "k": [
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 0 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 60 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 120 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 180 },
                            { "s": [100], "t": 240 }
                        ]
                    }
                }
            ],
            "ind": 26
        },
        {
            "ty": 4,
            "sr": 1,
            "st": 0,
            "op": 241,
            "ip": 0,
            "hasMask": false,
            "ao": 0,
            "ks": {
                "a": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [150.9, 165.38], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [150.9, 165.38], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [150.9, 165.38], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [150.9, 165.38], "t": 180 },
                        { "s": [150.9, 165.38], "t": 240 }
                    ]
                },
                "s": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100, 100], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100, 100], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100, 100], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100, 100], "t": 180 },
                        { "s": [100, 100], "t": 240 }
                    ]
                },
                "p": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [351.18, 303.19], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [351.18, 303.19], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [351.18, 303.19], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [351.18, 303.19], "t": 180 },
                        { "s": [351.18, 303.19], "t": 240 }
                    ]
                },
                "r": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [-8.2], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [-11.5], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [-8.2], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [-11.5], "t": 180 },
                        { "s": [-8.2], "t": 240 }
                    ]
                },
                "o": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 180 },
                        { "s": [100], "t": 240 }
                    ]
                }
            },
            "shapes": [
                {
                    "ty": "sh",
                    "d": 1,
                    "ks": {
                        "a": 1,
                        "k": [
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0.24, 0.02],
                                            [0.04, 0],
                                            [0, 0],
                                            [0.22, 0.04],
                                            [0, 0],
                                            [0.06, 0.01],
                                            [0.23, 0.06],
                                            [0.07, 0.02],
                                            [0, 0],
                                            [0.18, 0.07],
                                            [0, 0],
                                            [0.08, 0.03],
                                            [0.2, 0.1],
                                            [0.09, 0.05],
                                            [0.17, 0.11],
                                            [0.08, 0.06],
                                            [0, 0],
                                            [0.12, 0.09],
                                            [0.09, 0.08],
                                            [0.14, 0.13],
                                            [0, 0],
                                            [0.05, 0.05],
                                            [0.17, 0.2],
                                            [0.02, 0.03],
                                            [0, 0],
                                            [0.14, 0.19],
                                            [0.05, 0.07],
                                            [0, 0],
                                            [0.11, 0.18],
                                            [0, 0],
                                            [0.03, 0.06],
                                            [0.11, 0.25],
                                            [0, 0],
                                            [0, 0],
                                            [0.1, 0.31],
                                            [0.02, 0.07],
                                            [0.01, 0.03],
                                            [0.05, 0.21],
                                            [0.02, 0.08],
                                            [0, 0],
                                            [0.02, 0.16],
                                            [0.01, 0.11],
                                            [0.01, 0.17],
                                            [0, 0.11],
                                            [-0.01, 0.2],
                                            [0, 0],
                                            [-0.01, 0.09],
                                            [-0.02, 0.16],
                                            [0, 0],
                                            [-0.02, 0.08],
                                            [-0.04, 0.15],
                                            [0, 0],
                                            [-0.16, 0.39],
                                            [-0.02, 0.04],
                                            [-0.01, 0.01],
                                            [-0.11, 0.21],
                                            [-0.03, 0.06],
                                            [0, 0],
                                            [-0.12, 0.17],
                                            [-0.06, 0.08],
                                            [0, 0],
                                            [-0.13, 0.16],
                                            [-0.08, 0.09],
                                            [-0.16, 0.16],
                                            [0, 0],
                                            [-0.08, 0.08],
                                            [-0.14, 0.11],
                                            [0, 0],
                                            [-0.08, 0.05],
                                            [-0.18, 0.11],
                                            [-0.03, 0.02],
                                            [-0.07, 0.04],
                                            [-0.31, 0.13],
                                            [0, 0],
                                            [-0.35, 0.11],
                                            [-0.07, 0.02],
                                            [-0.03, 0.01],
                                            [-0.24, 0.05],
                                            [-0.09, 0.01],
                                            [0, 0],
                                            [-0.22, 0.02],
                                            [-0.11, 0],
                                            [0, 0],
                                            [-0.19, 0],
                                            [-0.12, -0.01],
                                            [-0.22, -0.03],
                                            [0, 0],
                                            [-0.11, -0.02],
                                            [-0.24, -0.06],
                                            [0, 0],
                                            [-0.08, -0.02],
                                            [-0.27, -0.09],
                                            [-0.02, -0.01],
                                            [-0.05, -0.02],
                                            [-0.42, -0.23],
                                            [0, 0],
                                            [-0.13, -0.08],
                                            [-0.06, -0.04],
                                            [0, 0],
                                            [-0.16, -0.12],
                                            [-0.07, -0.06],
                                            [0, 0],
                                            [-0.12, -0.12],
                                            [-0.08, -0.08],
                                            [-0.12, -0.14],
                                            [-0.07, -0.08],
                                            [-0.13, -0.17],
                                            [0, 0],
                                            [-0.05, -0.07],
                                            [-0.1, -0.17],
                                            [-0.01, -0.02],
                                            [-0.03, -0.06],
                                            [-0.11, -0.27],
                                            [0, 0],
                                            [-0.1, -0.31],
                                            [-0.02, -0.06],
                                            [0, 0],
                                            [-0.05, -0.2],
                                            [0, 0],
                                            [-0.02, -0.07],
                                            [-0.03, -0.23],
                                            [0, 0],
                                            [0, -0.04],
                                            [0, -0.29],
                                            [0, -0.07],
                                            [0, 0],
                                            [0.01, -0.16],
                                            [0.01, -0.12],
                                            [0.02, -0.14],
                                            [0.14, -0.45],
                                            [0.02, -0.05],
                                            [0, 0],
                                            [0.11, -0.25],
                                            [0.04, -0.08],
                                            [0.15, -0.25],
                                            [0, 0],
                                            [0.03, -0.04],
                                            [0.21, -0.27],
                                            [0.02, -0.02],
                                            [0.22, -0.23],
                                            [0.06, -0.06],
                                            [0, 0],
                                            [0.18, -0.15],
                                            [0.1, -0.07],
                                            [0.23, -0.14],
                                            [0, 0],
                                            [0.07, -0.04],
                                            [0.31, -0.14],
                                            [0, 0],
                                            [0.3, -0.1],
                                            [0, 0],
                                            [0.05, -0.02],
                                            [0.26, -0.06],
                                            [0.04, -0.01],
                                            [0, 0],
                                            [0.24, -0.03],
                                            [0, 0],
                                            [0.03, 0],
                                            [0.28, -0.01],
                                            [0.06, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [-0.29, 0],
                                            [-0.04, 0],
                                            [0, 0],
                                            [-0.21, -0.02],
                                            [0, 0],
                                            [-0.06, -0.01],
                                            [-0.24, -0.05],
                                            [-0.07, -0.02],
                                            [0, 0],
                                            [-0.19, -0.06],
                                            [0, 0],
                                            [-0.08, -0.03],
                                            [-0.19, -0.08],
                                            [-0.09, -0.05],
                                            [-0.22, -0.12],
                                            [-0.08, -0.05],
                                            [0, 0],
                                            [-0.12, -0.08],
                                            [-0.1, -0.07],
                                            [-0.13, -0.1],
                                            [0, 0],
                                            [-0.05, -0.05],
                                            [-0.2, -0.2],
                                            [-0.03, -0.03],
                                            [0, 0],
                                            [-0.15, -0.18],
                                            [-0.05, -0.07],
                                            [0, 0],
                                            [-0.11, -0.17],
                                            [0, 0],
                                            [-0.03, -0.06],
                                            [-0.15, -0.28],
                                            [0, 0],
                                            [0, 0],
                                            [-0.12, -0.27],
                                            [-0.02, -0.06],
                                            [-0.01, -0.03],
                                            [-0.05, -0.17],
                                            [-0.02, -0.08],
                                            [0, 0],
                                            [-0.04, -0.21],
                                            [-0.01, -0.11],
                                            [-0.02, -0.18],
                                            [0, -0.11],
                                            [0, -0.16],
                                            [0, 0],
                                            [0.01, -0.09],
                                            [0.02, -0.19],
                                            [0, 0],
                                            [0.01, -0.08],
                                            [0.03, -0.17],
                                            [0, 0],
                                            [0.11, -0.45],
                                            [0.02, -0.04],
                                            [0.01, -0.01],
                                            [0.11, -0.26],
                                            [0.03, -0.06],
                                            [0, 0],
                                            [0.13, -0.22],
                                            [0.06, -0.08],
                                            [0, 0],
                                            [0.13, -0.18],
                                            [0.08, -0.09],
                                            [0.13, -0.15],
                                            [0, 0],
                                            [0.08, -0.08],
                                            [0.18, -0.16],
                                            [0, 0],
                                            [0.07, -0.06],
                                            [0.2, -0.14],
                                            [0.02, -0.01],
                                            [0.06, -0.04],
                                            [0.31, -0.18],
                                            [0, 0],
                                            [0.3, -0.13],
                                            [0.07, -0.02],
                                            [0.03, -0.01],
                                            [0.2, -0.05],
                                            [0.09, -0.02],
                                            [0, 0],
                                            [0.19, -0.03],
                                            [0.11, -0.01],
                                            [0, 0],
                                            [0.22, -0.01],
                                            [0.12, 0],
                                            [0.2, 0.01],
                                            [0, 0],
                                            [0.11, 0.01],
                                            [0.19, 0.03],
                                            [0, 0],
                                            [0.08, 0.02],
                                            [0.21, 0.06],
                                            [0.02, 0.01],
                                            [0.05, 0.02],
                                            [0.4, 0.15],
                                            [0, 0],
                                            [0.12, 0.07],
                                            [0.07, 0.04],
                                            [0, 0],
                                            [0.14, 0.09],
                                            [0.07, 0.06],
                                            [0, 0],
                                            [0.16, 0.13],
                                            [0.08, 0.07],
                                            [0.13, 0.13],
                                            [0.07, 0.08],
                                            [0.11, 0.13],
                                            [0, 0],
                                            [0.05, 0.07],
                                            [0.12, 0.17],
                                            [0.01, 0.02],
                                            [0.04, 0.06],
                                            [0.16, 0.29],
                                            [0, 0],
                                            [0.11, 0.25],
                                            [0.02, 0.06],
                                            [0, 0],
                                            [0.06, 0.2],
                                            [0, 0],
                                            [0.02, 0.07],
                                            [0.05, 0.23],
                                            [0, 0],
                                            [0.01, 0.04],
                                            [0.03, 0.27],
                                            [0, 0.07],
                                            [0, 0],
                                            [0, 0.19],
                                            [-0.01, 0.12],
                                            [-0.02, 0.14],
                                            [-0.07, 0.48],
                                            [-0.02, 0.05],
                                            [0, 0],
                                            [-0.09, 0.26],
                                            [-0.04, 0.08],
                                            [-0.12, 0.24],
                                            [0, 0],
                                            [-0.03, 0.05],
                                            [-0.2, 0.32],
                                            [-0.02, 0.03],
                                            [-0.19, 0.24],
                                            [-0.06, 0.06],
                                            [0, 0],
                                            [-0.18, 0.17],
                                            [-0.1, 0.08],
                                            [-0.19, 0.14],
                                            [0, 0],
                                            [-0.07, 0.04],
                                            [-0.35, 0.2],
                                            [0, 0],
                                            [-0.24, 0.1],
                                            [0, 0],
                                            [-0.05, 0.02],
                                            [-0.27, 0.08],
                                            [-0.03, 0.01],
                                            [0, 0],
                                            [-0.25, 0.05],
                                            [0, 0],
                                            [-0.03, 0],
                                            [-0.25, 0.03],
                                            [-0.06, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [110.74, 330.76],
                                            [110.71, 330.76],
                                            [109.94, 330.73],
                                            [109.83, 330.72],
                                            [109.8, 330.71],
                                            [109.14, 330.62],
                                            [109.09, 330.62],
                                            [108.91, 330.58],
                                            [108.21, 330.42],
                                            [108.01, 330.36],
                                            [107.97, 330.35],
                                            [107.42, 330.16],
                                            [107.4, 330.15],
                                            [107.15, 330.06],
                                            [106.58, 329.8],
                                            [106.3, 329.66],
                                            [105.73, 329.33],
                                            [105.48, 329.16],
                                            [105.41, 329.11],
                                            [105.04, 328.86],
                                            [104.76, 328.63],
                                            [104.36, 328.29],
                                            [104.31, 328.24],
                                            [104.15, 328.1],
                                            [103.59, 327.5],
                                            [103.51, 327.42],
                                            [103.5, 327.4],
                                            [103.06, 326.84],
                                            [102.92, 326.63],
                                            [102.91, 326.62],
                                            [102.58, 326.09],
                                            [102.55, 326.04],
                                            [102.45, 325.86],
                                            [102.06, 325.08],
                                            [101.48, 323.74],
                                            [0.78, 92.27],
                                            [0.46, 91.41],
                                            [0.4, 91.22],
                                            [0.38, 91.14],
                                            [0.22, 90.55],
                                            [0.17, 90.29],
                                            [0.16, 90.22],
                                            [0.07, 89.67],
                                            [0.04, 89.33],
                                            [0.01, 88.79],
                                            [0, 88.45],
                                            [0.02, 87.91],
                                            [0.02, 87.85],
                                            [0.04, 87.57],
                                            [0.11, 87.04],
                                            [0.13, 86.96],
                                            [0.17, 86.71],
                                            [0.28, 86.24],
                                            [0.29, 86.2],
                                            [0.69, 84.95],
                                            [0.75, 84.82],
                                            [0.77, 84.78],
                                            [1.1, 84.08],
                                            [1.2, 83.89],
                                            [1.24, 83.82],
                                            [1.6, 83.24],
                                            [1.77, 82.99],
                                            [1.79, 82.97],
                                            [2.18, 82.46],
                                            [2.42, 82.19],
                                            [2.85, 81.74],
                                            [2.87, 81.72],
                                            [3.12, 81.49],
                                            [3.61, 81.08],
                                            [3.68, 81.02],
                                            [3.9, 80.86],
                                            [4.48, 80.47],
                                            [4.55, 80.43],
                                            [4.75, 80.31],
                                            [5.67, 79.84],
                                            [187.31, 0.78],
                                            [188.28, 0.42],
                                            [188.5, 0.36],
                                            [188.59, 0.34],
                                            [189.25, 0.17],
                                            [189.54, 0.13],
                                            [189.62, 0.11],
                                            [190.25, 0.03],
                                            [190.58, 0.01],
                                            [190.62, 0.01],
                                            [191.24, 0],
                                            [191.61, 0.01],
                                            [192.23, 0.07],
                                            [192.25, 0.07],
                                            [192.58, 0.12],
                                            [193.22, 0.25],
                                            [193.3, 0.27],
                                            [193.53, 0.32],
                                            [194.23, 0.55],
                                            [194.29, 0.56],
                                            [194.45, 0.62],
                                            [195.65, 1.19],
                                            [195.71, 1.21],
                                            [196.08, 1.43],
                                            [196.28, 1.56],
                                            [196.35, 1.61],
                                            [196.8, 1.93],
                                            [197.02, 2.1],
                                            [197.05, 2.13],
                                            [197.47, 2.49],
                                            [197.71, 2.72],
                                            [198.09, 3.12],
                                            [198.31, 3.37],
                                            [198.66, 3.82],
                                            [198.7, 3.88],
                                            [198.85, 4.08],
                                            [199.18, 4.6],
                                            [199.22, 4.67],
                                            [199.33, 4.85],
                                            [199.73, 5.67],
                                            [301.01, 238.48],
                                            [301.32, 239.3],
                                            [301.38, 239.48],
                                            [301.4, 239.54],
                                            [301.56, 240.15],
                                            [301.57, 240.19],
                                            [301.62, 240.41],
                                            [301.73, 241.11],
                                            [301.73, 241.14],
                                            [301.75, 241.25],
                                            [301.8, 242.06],
                                            [301.8, 242.28],
                                            [301.8, 242.36],
                                            [301.77, 242.88],
                                            [301.74, 243.24],
                                            [301.69, 243.67],
                                            [301.36, 245.06],
                                            [301.31, 245.22],
                                            [301.29, 245.28],
                                            [300.99, 246.05],
                                            [300.88, 246.3],
                                            [300.49, 247.04],
                                            [300.46, 247.09],
                                            [300.38, 247.22],
                                            [299.77, 248.1],
                                            [299.71, 248.17],
                                            [299.08, 248.87],
                                            [298.91, 249.04],
                                            [298.85, 249.1],
                                            [298.29, 249.59],
                                            [298, 249.81],
                                            [297.38, 250.23],
                                            [297.31, 250.28],
                                            [297.1, 250.41],
                                            [296.12, 250.91],
                                            [114.48, 329.98],
                                            [113.67, 330.28],
                                            [113.65, 330.29],
                                            [113.5, 330.34],
                                            [112.71, 330.55],
                                            [112.6, 330.57],
                                            [112.56, 330.58],
                                            [111.83, 330.69],
                                            [111.8, 330.7],
                                            [111.7, 330.71],
                                            [110.91, 330.76],
                                            [110.73, 330.76],
                                            [110.74, 330.76]
                                        ]
                                    }
                                ],
                                "t": 0
                            },
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0.24, 0.02],
                                            [0.04, 0],
                                            [0, 0],
                                            [0.22, 0.04],
                                            [0, 0],
                                            [0.06, 0.01],
                                            [0.23, 0.06],
                                            [0.07, 0.02],
                                            [0, 0],
                                            [0.18, 0.07],
                                            [0, 0],
                                            [0.08, 0.03],
                                            [0.2, 0.1],
                                            [0.09, 0.05],
                                            [0.17, 0.11],
                                            [0.08, 0.06],
                                            [0, 0],
                                            [0.12, 0.09],
                                            [0.09, 0.08],
                                            [0.14, 0.13],
                                            [0, 0],
                                            [0.05, 0.05],
                                            [0.17, 0.2],
                                            [0.02, 0.03],
                                            [0, 0],
                                            [0.14, 0.19],
                                            [0.05, 0.07],
                                            [0, 0],
                                            [0.11, 0.18],
                                            [0, 0],
                                            [0.03, 0.06],
                                            [0.11, 0.25],
                                            [0, 0],
                                            [0, 0],
                                            [0.1, 0.31],
                                            [0.02, 0.07],
                                            [0.01, 0.03],
                                            [0.05, 0.21],
                                            [0.02, 0.08],
                                            [0, 0],
                                            [0.02, 0.16],
                                            [0.01, 0.11],
                                            [0.01, 0.17],
                                            [0, 0.11],
                                            [-0.01, 0.2],
                                            [0, 0],
                                            [-0.01, 0.09],
                                            [-0.02, 0.16],
                                            [0, 0],
                                            [-0.02, 0.08],
                                            [-0.04, 0.15],
                                            [0, 0],
                                            [-0.16, 0.39],
                                            [-0.02, 0.04],
                                            [-0.01, 0.01],
                                            [-0.11, 0.21],
                                            [-0.03, 0.06],
                                            [0, 0],
                                            [-0.12, 0.17],
                                            [-0.06, 0.08],
                                            [0, 0],
                                            [-0.13, 0.16],
                                            [-0.08, 0.09],
                                            [-0.16, 0.16],
                                            [0, 0],
                                            [-0.08, 0.08],
                                            [-0.14, 0.11],
                                            [0, 0],
                                            [-0.08, 0.05],
                                            [-0.18, 0.11],
                                            [-0.03, 0.02],
                                            [-0.07, 0.04],
                                            [-0.31, 0.13],
                                            [0, 0],
                                            [-0.35, 0.11],
                                            [-0.07, 0.02],
                                            [-0.03, 0.01],
                                            [-0.24, 0.05],
                                            [-0.09, 0.01],
                                            [0, 0],
                                            [-0.22, 0.02],
                                            [-0.11, 0],
                                            [0, 0],
                                            [-0.19, 0],
                                            [-0.12, -0.01],
                                            [-0.22, -0.03],
                                            [0, 0],
                                            [-0.11, -0.02],
                                            [-0.24, -0.06],
                                            [0, 0],
                                            [-0.08, -0.02],
                                            [-0.27, -0.09],
                                            [-0.02, -0.01],
                                            [-0.05, -0.02],
                                            [-0.42, -0.23],
                                            [0, 0],
                                            [-0.13, -0.08],
                                            [-0.06, -0.04],
                                            [0, 0],
                                            [-0.16, -0.12],
                                            [-0.07, -0.06],
                                            [0, 0],
                                            [-0.12, -0.12],
                                            [-0.08, -0.08],
                                            [-0.12, -0.14],
                                            [-0.07, -0.08],
                                            [-0.13, -0.17],
                                            [0, 0],
                                            [-0.05, -0.07],
                                            [-0.1, -0.17],
                                            [-0.01, -0.02],
                                            [-0.03, -0.06],
                                            [-0.11, -0.27],
                                            [0, 0],
                                            [-0.1, -0.31],
                                            [-0.02, -0.06],
                                            [0, 0],
                                            [-0.05, -0.2],
                                            [0, 0],
                                            [-0.02, -0.07],
                                            [-0.03, -0.23],
                                            [0, 0],
                                            [0, -0.04],
                                            [0, -0.29],
                                            [0, -0.07],
                                            [0, 0],
                                            [0.01, -0.16],
                                            [0.01, -0.12],
                                            [0.02, -0.14],
                                            [0.14, -0.45],
                                            [0.02, -0.05],
                                            [0, 0],
                                            [0.11, -0.25],
                                            [0.04, -0.08],
                                            [0.15, -0.25],
                                            [0, 0],
                                            [0.03, -0.04],
                                            [0.21, -0.27],
                                            [0.02, -0.02],
                                            [0.22, -0.23],
                                            [0.06, -0.06],
                                            [0, 0],
                                            [0.18, -0.15],
                                            [0.1, -0.07],
                                            [0.23, -0.14],
                                            [0, 0],
                                            [0.07, -0.04],
                                            [0.31, -0.14],
                                            [0, 0],
                                            [0.3, -0.1],
                                            [0, 0],
                                            [0.05, -0.02],
                                            [0.26, -0.06],
                                            [0.04, -0.01],
                                            [0, 0],
                                            [0.24, -0.03],
                                            [0, 0],
                                            [0.03, 0],
                                            [0.28, -0.01],
                                            [0.06, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [-0.29, 0],
                                            [-0.04, 0],
                                            [0, 0],
                                            [-0.21, -0.02],
                                            [0, 0],
                                            [-0.06, -0.01],
                                            [-0.24, -0.05],
                                            [-0.07, -0.02],
                                            [0, 0],
                                            [-0.19, -0.06],
                                            [0, 0],
                                            [-0.08, -0.03],
                                            [-0.19, -0.08],
                                            [-0.09, -0.05],
                                            [-0.22, -0.12],
                                            [-0.08, -0.05],
                                            [0, 0],
                                            [-0.12, -0.08],
                                            [-0.1, -0.07],
                                            [-0.13, -0.1],
                                            [0, 0],
                                            [-0.05, -0.05],
                                            [-0.2, -0.2],
                                            [-0.03, -0.03],
                                            [0, 0],
                                            [-0.15, -0.18],
                                            [-0.05, -0.07],
                                            [0, 0],
                                            [-0.11, -0.17],
                                            [0, 0],
                                            [-0.03, -0.06],
                                            [-0.15, -0.28],
                                            [0, 0],
                                            [0, 0],
                                            [-0.12, -0.27],
                                            [-0.02, -0.06],
                                            [-0.01, -0.03],
                                            [-0.05, -0.17],
                                            [-0.02, -0.08],
                                            [0, 0],
                                            [-0.04, -0.21],
                                            [-0.01, -0.11],
                                            [-0.02, -0.18],
                                            [0, -0.11],
                                            [0, -0.16],
                                            [0, 0],
                                            [0.01, -0.09],
                                            [0.02, -0.19],
                                            [0, 0],
                                            [0.01, -0.08],
                                            [0.03, -0.17],
                                            [0, 0],
                                            [0.11, -0.45],
                                            [0.02, -0.04],
                                            [0.01, -0.01],
                                            [0.11, -0.26],
                                            [0.03, -0.06],
                                            [0, 0],
                                            [0.13, -0.22],
                                            [0.06, -0.08],
                                            [0, 0],
                                            [0.13, -0.18],
                                            [0.08, -0.09],
                                            [0.13, -0.15],
                                            [0, 0],
                                            [0.08, -0.08],
                                            [0.18, -0.16],
                                            [0, 0],
                                            [0.07, -0.06],
                                            [0.2, -0.14],
                                            [0.02, -0.01],
                                            [0.06, -0.04],
                                            [0.31, -0.18],
                                            [0, 0],
                                            [0.3, -0.13],
                                            [0.07, -0.02],
                                            [0.03, -0.01],
                                            [0.2, -0.05],
                                            [0.09, -0.02],
                                            [0, 0],
                                            [0.19, -0.03],
                                            [0.11, -0.01],
                                            [0, 0],
                                            [0.22, -0.01],
                                            [0.12, 0],
                                            [0.2, 0.01],
                                            [0, 0],
                                            [0.11, 0.01],
                                            [0.19, 0.03],
                                            [0, 0],
                                            [0.08, 0.02],
                                            [0.21, 0.06],
                                            [0.02, 0.01],
                                            [0.05, 0.02],
                                            [0.4, 0.15],
                                            [0, 0],
                                            [0.12, 0.07],
                                            [0.07, 0.04],
                                            [0, 0],
                                            [0.14, 0.09],
                                            [0.07, 0.06],
                                            [0, 0],
                                            [0.16, 0.13],
                                            [0.08, 0.07],
                                            [0.13, 0.13],
                                            [0.07, 0.08],
                                            [0.11, 0.13],
                                            [0, 0],
                                            [0.05, 0.07],
                                            [0.12, 0.17],
                                            [0.01, 0.02],
                                            [0.04, 0.06],
                                            [0.16, 0.29],
                                            [0, 0],
                                            [0.11, 0.25],
                                            [0.02, 0.06],
                                            [0, 0],
                                            [0.06, 0.2],
                                            [0, 0],
                                            [0.02, 0.07],
                                            [0.05, 0.23],
                                            [0, 0],
                                            [0.01, 0.04],
                                            [0.03, 0.27],
                                            [0, 0.07],
                                            [0, 0],
                                            [0, 0.19],
                                            [-0.01, 0.12],
                                            [-0.02, 0.14],
                                            [-0.07, 0.48],
                                            [-0.02, 0.05],
                                            [0, 0],
                                            [-0.09, 0.26],
                                            [-0.04, 0.08],
                                            [-0.12, 0.24],
                                            [0, 0],
                                            [-0.03, 0.05],
                                            [-0.2, 0.32],
                                            [-0.02, 0.03],
                                            [-0.19, 0.24],
                                            [-0.06, 0.06],
                                            [0, 0],
                                            [-0.18, 0.17],
                                            [-0.1, 0.08],
                                            [-0.19, 0.14],
                                            [0, 0],
                                            [-0.07, 0.04],
                                            [-0.35, 0.2],
                                            [0, 0],
                                            [-0.24, 0.1],
                                            [0, 0],
                                            [-0.05, 0.02],
                                            [-0.27, 0.08],
                                            [-0.03, 0.01],
                                            [0, 0],
                                            [-0.25, 0.05],
                                            [0, 0],
                                            [-0.03, 0],
                                            [-0.25, 0.03],
                                            [-0.06, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [110.74, 330.76],
                                            [110.71, 330.76],
                                            [109.94, 330.73],
                                            [109.83, 330.72],
                                            [109.8, 330.71],
                                            [109.14, 330.62],
                                            [109.09, 330.62],
                                            [108.91, 330.58],
                                            [108.21, 330.42],
                                            [108.01, 330.36],
                                            [107.97, 330.35],
                                            [107.42, 330.16],
                                            [107.4, 330.15],
                                            [107.15, 330.06],
                                            [106.58, 329.8],
                                            [106.3, 329.66],
                                            [105.73, 329.33],
                                            [105.48, 329.16],
                                            [105.41, 329.11],
                                            [105.04, 328.86],
                                            [104.76, 328.63],
                                            [104.36, 328.29],
                                            [104.31, 328.24],
                                            [104.15, 328.1],
                                            [103.59, 327.5],
                                            [103.51, 327.42],
                                            [103.5, 327.4],
                                            [103.06, 326.84],
                                            [102.92, 326.63],
                                            [102.91, 326.62],
                                            [102.58, 326.09],
                                            [102.55, 326.04],
                                            [102.45, 325.86],
                                            [102.06, 325.08],
                                            [101.48, 323.74],
                                            [0.78, 92.27],
                                            [0.46, 91.41],
                                            [0.4, 91.22],
                                            [0.38, 91.14],
                                            [0.22, 90.55],
                                            [0.17, 90.29],
                                            [0.16, 90.22],
                                            [0.07, 89.67],
                                            [0.04, 89.33],
                                            [0.01, 88.79],
                                            [0, 88.45],
                                            [0.02, 87.91],
                                            [0.02, 87.85],
                                            [0.04, 87.57],
                                            [0.11, 87.04],
                                            [0.13, 86.96],
                                            [0.17, 86.71],
                                            [0.28, 86.24],
                                            [0.29, 86.2],
                                            [0.69, 84.95],
                                            [0.75, 84.82],
                                            [0.77, 84.78],
                                            [1.1, 84.08],
                                            [1.2, 83.89],
                                            [1.24, 83.82],
                                            [1.6, 83.24],
                                            [1.77, 82.99],
                                            [1.79, 82.97],
                                            [2.18, 82.46],
                                            [2.42, 82.19],
                                            [2.85, 81.74],
                                            [2.87, 81.72],
                                            [3.12, 81.49],
                                            [3.61, 81.08],
                                            [3.68, 81.02],
                                            [3.9, 80.86],
                                            [4.48, 80.47],
                                            [4.55, 80.43],
                                            [4.75, 80.31],
                                            [5.67, 79.84],
                                            [187.31, 0.78],
                                            [188.28, 0.42],
                                            [188.5, 0.36],
                                            [188.59, 0.34],
                                            [189.25, 0.17],
                                            [189.54, 0.13],
                                            [189.62, 0.11],
                                            [190.25, 0.03],
                                            [190.58, 0.01],
                                            [190.62, 0.01],
                                            [191.24, 0],
                                            [191.61, 0.01],
                                            [192.23, 0.07],
                                            [192.25, 0.07],
                                            [192.58, 0.12],
                                            [193.22, 0.25],
                                            [193.3, 0.27],
                                            [193.53, 0.32],
                                            [194.23, 0.55],
                                            [194.29, 0.56],
                                            [194.45, 0.62],
                                            [195.65, 1.19],
                                            [195.71, 1.21],
                                            [196.08, 1.43],
                                            [196.28, 1.56],
                                            [196.35, 1.61],
                                            [196.8, 1.93],
                                            [197.02, 2.1],
                                            [197.05, 2.13],
                                            [197.47, 2.49],
                                            [197.71, 2.72],
                                            [198.09, 3.12],
                                            [198.31, 3.37],
                                            [198.66, 3.82],
                                            [198.7, 3.88],
                                            [198.85, 4.08],
                                            [199.18, 4.6],
                                            [199.22, 4.67],
                                            [199.33, 4.85],
                                            [199.73, 5.67],
                                            [301.01, 238.48],
                                            [301.32, 239.3],
                                            [301.38, 239.48],
                                            [301.4, 239.54],
                                            [301.56, 240.15],
                                            [301.57, 240.19],
                                            [301.62, 240.41],
                                            [301.73, 241.11],
                                            [301.73, 241.14],
                                            [301.75, 241.25],
                                            [301.8, 242.06],
                                            [301.8, 242.28],
                                            [301.8, 242.36],
                                            [301.77, 242.88],
                                            [301.74, 243.24],
                                            [301.69, 243.67],
                                            [301.36, 245.06],
                                            [301.31, 245.22],
                                            [301.29, 245.28],
                                            [300.99, 246.05],
                                            [300.88, 246.3],
                                            [300.49, 247.04],
                                            [300.46, 247.09],
                                            [300.38, 247.22],
                                            [299.77, 248.1],
                                            [299.71, 248.17],
                                            [299.08, 248.87],
                                            [298.91, 249.04],
                                            [298.85, 249.1],
                                            [298.29, 249.59],
                                            [298, 249.81],
                                            [297.38, 250.23],
                                            [297.31, 250.28],
                                            [297.1, 250.41],
                                            [296.12, 250.91],
                                            [114.48, 329.98],
                                            [113.67, 330.28],
                                            [113.65, 330.29],
                                            [113.5, 330.34],
                                            [112.71, 330.55],
                                            [112.6, 330.57],
                                            [112.56, 330.58],
                                            [111.83, 330.69],
                                            [111.8, 330.7],
                                            [111.7, 330.71],
                                            [110.91, 330.76],
                                            [110.73, 330.76],
                                            [110.74, 330.76]
                                        ]
                                    }
                                ],
                                "t": 60
                            },
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0.24, 0.02],
                                            [0.04, 0],
                                            [0, 0],
                                            [0.22, 0.04],
                                            [0, 0],
                                            [0.06, 0.01],
                                            [0.23, 0.06],
                                            [0.07, 0.02],
                                            [0, 0],
                                            [0.18, 0.07],
                                            [0, 0],
                                            [0.08, 0.03],
                                            [0.2, 0.1],
                                            [0.09, 0.05],
                                            [0.17, 0.11],
                                            [0.08, 0.06],
                                            [0, 0],
                                            [0.12, 0.09],
                                            [0.09, 0.08],
                                            [0.14, 0.13],
                                            [0, 0],
                                            [0.05, 0.05],
                                            [0.17, 0.2],
                                            [0.02, 0.03],
                                            [0, 0],
                                            [0.14, 0.19],
                                            [0.05, 0.07],
                                            [0, 0],
                                            [0.11, 0.18],
                                            [0, 0],
                                            [0.03, 0.06],
                                            [0.11, 0.25],
                                            [0, 0],
                                            [0, 0],
                                            [0.1, 0.31],
                                            [0.02, 0.07],
                                            [0.01, 0.03],
                                            [0.05, 0.21],
                                            [0.02, 0.08],
                                            [0, 0],
                                            [0.02, 0.16],
                                            [0.01, 0.11],
                                            [0.01, 0.17],
                                            [0, 0.11],
                                            [-0.01, 0.2],
                                            [0, 0],
                                            [-0.01, 0.09],
                                            [-0.02, 0.16],
                                            [0, 0],
                                            [-0.02, 0.08],
                                            [-0.04, 0.15],
                                            [0, 0],
                                            [-0.16, 0.39],
                                            [-0.02, 0.04],
                                            [-0.01, 0.01],
                                            [-0.11, 0.21],
                                            [-0.03, 0.06],
                                            [0, 0],
                                            [-0.12, 0.17],
                                            [-0.06, 0.08],
                                            [0, 0],
                                            [-0.13, 0.16],
                                            [-0.08, 0.09],
                                            [-0.16, 0.16],
                                            [0, 0],
                                            [-0.08, 0.08],
                                            [-0.14, 0.11],
                                            [0, 0],
                                            [-0.08, 0.05],
                                            [-0.18, 0.11],
                                            [-0.03, 0.02],
                                            [-0.07, 0.04],
                                            [-0.31, 0.13],
                                            [0, 0],
                                            [-0.35, 0.11],
                                            [-0.07, 0.02],
                                            [-0.03, 0.01],
                                            [-0.24, 0.05],
                                            [-0.09, 0.01],
                                            [0, 0],
                                            [-0.22, 0.02],
                                            [-0.11, 0],
                                            [0, 0],
                                            [-0.19, 0],
                                            [-0.12, -0.01],
                                            [-0.22, -0.03],
                                            [0, 0],
                                            [-0.11, -0.02],
                                            [-0.24, -0.06],
                                            [0, 0],
                                            [-0.08, -0.02],
                                            [-0.27, -0.09],
                                            [-0.02, -0.01],
                                            [-0.05, -0.02],
                                            [-0.42, -0.23],
                                            [0, 0],
                                            [-0.13, -0.08],
                                            [-0.06, -0.04],
                                            [0, 0],
                                            [-0.16, -0.12],
                                            [-0.07, -0.06],
                                            [0, 0],
                                            [-0.12, -0.12],
                                            [-0.08, -0.08],
                                            [-0.12, -0.14],
                                            [-0.07, -0.08],
                                            [-0.13, -0.17],
                                            [0, 0],
                                            [-0.05, -0.07],
                                            [-0.1, -0.17],
                                            [-0.01, -0.02],
                                            [-0.03, -0.06],
                                            [-0.11, -0.27],
                                            [0, 0],
                                            [-0.1, -0.31],
                                            [-0.02, -0.06],
                                            [0, 0],
                                            [-0.05, -0.2],
                                            [0, 0],
                                            [-0.02, -0.07],
                                            [-0.03, -0.23],
                                            [0, 0],
                                            [0, -0.04],
                                            [0, -0.29],
                                            [0, -0.07],
                                            [0, 0],
                                            [0.01, -0.16],
                                            [0.01, -0.12],
                                            [0.02, -0.14],
                                            [0.14, -0.45],
                                            [0.02, -0.05],
                                            [0, 0],
                                            [0.11, -0.25],
                                            [0.04, -0.08],
                                            [0.15, -0.25],
                                            [0, 0],
                                            [0.03, -0.04],
                                            [0.21, -0.27],
                                            [0.02, -0.02],
                                            [0.22, -0.23],
                                            [0.06, -0.06],
                                            [0, 0],
                                            [0.18, -0.15],
                                            [0.1, -0.07],
                                            [0.23, -0.14],
                                            [0, 0],
                                            [0.07, -0.04],
                                            [0.31, -0.14],
                                            [0, 0],
                                            [0.3, -0.1],
                                            [0, 0],
                                            [0.05, -0.02],
                                            [0.26, -0.06],
                                            [0.04, -0.01],
                                            [0, 0],
                                            [0.24, -0.03],
                                            [0, 0],
                                            [0.03, 0],
                                            [0.28, -0.01],
                                            [0.06, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [-0.29, 0],
                                            [-0.04, 0],
                                            [0, 0],
                                            [-0.21, -0.02],
                                            [0, 0],
                                            [-0.06, -0.01],
                                            [-0.24, -0.05],
                                            [-0.07, -0.02],
                                            [0, 0],
                                            [-0.19, -0.06],
                                            [0, 0],
                                            [-0.08, -0.03],
                                            [-0.19, -0.08],
                                            [-0.09, -0.05],
                                            [-0.22, -0.12],
                                            [-0.08, -0.05],
                                            [0, 0],
                                            [-0.12, -0.08],
                                            [-0.1, -0.07],
                                            [-0.13, -0.1],
                                            [0, 0],
                                            [-0.05, -0.05],
                                            [-0.2, -0.2],
                                            [-0.03, -0.03],
                                            [0, 0],
                                            [-0.15, -0.18],
                                            [-0.05, -0.07],
                                            [0, 0],
                                            [-0.11, -0.17],
                                            [0, 0],
                                            [-0.03, -0.06],
                                            [-0.15, -0.28],
                                            [0, 0],
                                            [0, 0],
                                            [-0.12, -0.27],
                                            [-0.02, -0.06],
                                            [-0.01, -0.03],
                                            [-0.05, -0.17],
                                            [-0.02, -0.08],
                                            [0, 0],
                                            [-0.04, -0.21],
                                            [-0.01, -0.11],
                                            [-0.02, -0.18],
                                            [0, -0.11],
                                            [0, -0.16],
                                            [0, 0],
                                            [0.01, -0.09],
                                            [0.02, -0.19],
                                            [0, 0],
                                            [0.01, -0.08],
                                            [0.03, -0.17],
                                            [0, 0],
                                            [0.11, -0.45],
                                            [0.02, -0.04],
                                            [0.01, -0.01],
                                            [0.11, -0.26],
                                            [0.03, -0.06],
                                            [0, 0],
                                            [0.13, -0.22],
                                            [0.06, -0.08],
                                            [0, 0],
                                            [0.13, -0.18],
                                            [0.08, -0.09],
                                            [0.13, -0.15],
                                            [0, 0],
                                            [0.08, -0.08],
                                            [0.18, -0.16],
                                            [0, 0],
                                            [0.07, -0.06],
                                            [0.2, -0.14],
                                            [0.02, -0.01],
                                            [0.06, -0.04],
                                            [0.31, -0.18],
                                            [0, 0],
                                            [0.3, -0.13],
                                            [0.07, -0.02],
                                            [0.03, -0.01],
                                            [0.2, -0.05],
                                            [0.09, -0.02],
                                            [0, 0],
                                            [0.19, -0.03],
                                            [0.11, -0.01],
                                            [0, 0],
                                            [0.22, -0.01],
                                            [0.12, 0],
                                            [0.2, 0.01],
                                            [0, 0],
                                            [0.11, 0.01],
                                            [0.19, 0.03],
                                            [0, 0],
                                            [0.08, 0.02],
                                            [0.21, 0.06],
                                            [0.02, 0.01],
                                            [0.05, 0.02],
                                            [0.4, 0.15],
                                            [0, 0],
                                            [0.12, 0.07],
                                            [0.07, 0.04],
                                            [0, 0],
                                            [0.14, 0.09],
                                            [0.07, 0.06],
                                            [0, 0],
                                            [0.16, 0.13],
                                            [0.08, 0.07],
                                            [0.13, 0.13],
                                            [0.07, 0.08],
                                            [0.11, 0.13],
                                            [0, 0],
                                            [0.05, 0.07],
                                            [0.12, 0.17],
                                            [0.01, 0.02],
                                            [0.04, 0.06],
                                            [0.16, 0.29],
                                            [0, 0],
                                            [0.11, 0.25],
                                            [0.02, 0.06],
                                            [0, 0],
                                            [0.06, 0.2],
                                            [0, 0],
                                            [0.02, 0.07],
                                            [0.05, 0.23],
                                            [0, 0],
                                            [0.01, 0.04],
                                            [0.03, 0.27],
                                            [0, 0.07],
                                            [0, 0],
                                            [0, 0.19],
                                            [-0.01, 0.12],
                                            [-0.02, 0.14],
                                            [-0.07, 0.48],
                                            [-0.02, 0.05],
                                            [0, 0],
                                            [-0.09, 0.26],
                                            [-0.04, 0.08],
                                            [-0.12, 0.24],
                                            [0, 0],
                                            [-0.03, 0.05],
                                            [-0.2, 0.32],
                                            [-0.02, 0.03],
                                            [-0.19, 0.24],
                                            [-0.06, 0.06],
                                            [0, 0],
                                            [-0.18, 0.17],
                                            [-0.1, 0.08],
                                            [-0.19, 0.14],
                                            [0, 0],
                                            [-0.07, 0.04],
                                            [-0.35, 0.2],
                                            [0, 0],
                                            [-0.24, 0.1],
                                            [0, 0],
                                            [-0.05, 0.02],
                                            [-0.27, 0.08],
                                            [-0.03, 0.01],
                                            [0, 0],
                                            [-0.25, 0.05],
                                            [0, 0],
                                            [-0.03, 0],
                                            [-0.25, 0.03],
                                            [-0.06, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [110.74, 330.76],
                                            [110.71, 330.76],
                                            [109.94, 330.73],
                                            [109.83, 330.72],
                                            [109.8, 330.71],
                                            [109.14, 330.62],
                                            [109.09, 330.62],
                                            [108.91, 330.58],
                                            [108.21, 330.42],
                                            [108.01, 330.36],
                                            [107.97, 330.35],
                                            [107.42, 330.16],
                                            [107.4, 330.15],
                                            [107.15, 330.06],
                                            [106.58, 329.8],
                                            [106.3, 329.66],
                                            [105.73, 329.33],
                                            [105.48, 329.16],
                                            [105.41, 329.11],
                                            [105.04, 328.86],
                                            [104.76, 328.63],
                                            [104.36, 328.29],
                                            [104.31, 328.24],
                                            [104.15, 328.1],
                                            [103.59, 327.5],
                                            [103.51, 327.42],
                                            [103.5, 327.4],
                                            [103.06, 326.84],
                                            [102.92, 326.63],
                                            [102.91, 326.62],
                                            [102.58, 326.09],
                                            [102.55, 326.04],
                                            [102.45, 325.86],
                                            [102.06, 325.08],
                                            [101.48, 323.74],
                                            [0.78, 92.27],
                                            [0.46, 91.41],
                                            [0.4, 91.22],
                                            [0.38, 91.14],
                                            [0.22, 90.55],
                                            [0.17, 90.29],
                                            [0.16, 90.22],
                                            [0.07, 89.67],
                                            [0.04, 89.33],
                                            [0.01, 88.79],
                                            [0, 88.45],
                                            [0.02, 87.91],
                                            [0.02, 87.85],
                                            [0.04, 87.57],
                                            [0.11, 87.04],
                                            [0.13, 86.96],
                                            [0.17, 86.71],
                                            [0.28, 86.24],
                                            [0.29, 86.2],
                                            [0.69, 84.95],
                                            [0.75, 84.82],
                                            [0.77, 84.78],
                                            [1.1, 84.08],
                                            [1.2, 83.89],
                                            [1.24, 83.82],
                                            [1.6, 83.24],
                                            [1.77, 82.99],
                                            [1.79, 82.97],
                                            [2.18, 82.46],
                                            [2.42, 82.19],
                                            [2.85, 81.74],
                                            [2.87, 81.72],
                                            [3.12, 81.49],
                                            [3.61, 81.08],
                                            [3.68, 81.02],
                                            [3.9, 80.86],
                                            [4.48, 80.47],
                                            [4.55, 80.43],
                                            [4.75, 80.31],
                                            [5.67, 79.84],
                                            [187.31, 0.78],
                                            [188.28, 0.42],
                                            [188.5, 0.36],
                                            [188.59, 0.34],
                                            [189.25, 0.17],
                                            [189.54, 0.13],
                                            [189.62, 0.11],
                                            [190.25, 0.03],
                                            [190.58, 0.01],
                                            [190.62, 0.01],
                                            [191.24, 0],
                                            [191.61, 0.01],
                                            [192.23, 0.07],
                                            [192.25, 0.07],
                                            [192.58, 0.12],
                                            [193.22, 0.25],
                                            [193.3, 0.27],
                                            [193.53, 0.32],
                                            [194.23, 0.55],
                                            [194.29, 0.56],
                                            [194.45, 0.62],
                                            [195.65, 1.19],
                                            [195.71, 1.21],
                                            [196.08, 1.43],
                                            [196.28, 1.56],
                                            [196.35, 1.61],
                                            [196.8, 1.93],
                                            [197.02, 2.1],
                                            [197.05, 2.13],
                                            [197.47, 2.49],
                                            [197.71, 2.72],
                                            [198.09, 3.12],
                                            [198.31, 3.37],
                                            [198.66, 3.82],
                                            [198.7, 3.88],
                                            [198.85, 4.08],
                                            [199.18, 4.6],
                                            [199.22, 4.67],
                                            [199.33, 4.85],
                                            [199.73, 5.67],
                                            [301.01, 238.48],
                                            [301.32, 239.3],
                                            [301.38, 239.48],
                                            [301.4, 239.54],
                                            [301.56, 240.15],
                                            [301.57, 240.19],
                                            [301.62, 240.41],
                                            [301.73, 241.11],
                                            [301.73, 241.14],
                                            [301.75, 241.25],
                                            [301.8, 242.06],
                                            [301.8, 242.28],
                                            [301.8, 242.36],
                                            [301.77, 242.88],
                                            [301.74, 243.24],
                                            [301.69, 243.67],
                                            [301.36, 245.06],
                                            [301.31, 245.22],
                                            [301.29, 245.28],
                                            [300.99, 246.05],
                                            [300.88, 246.3],
                                            [300.49, 247.04],
                                            [300.46, 247.09],
                                            [300.38, 247.22],
                                            [299.77, 248.1],
                                            [299.71, 248.17],
                                            [299.08, 248.87],
                                            [298.91, 249.04],
                                            [298.85, 249.1],
                                            [298.29, 249.59],
                                            [298, 249.81],
                                            [297.38, 250.23],
                                            [297.31, 250.28],
                                            [297.1, 250.41],
                                            [296.12, 250.91],
                                            [114.48, 329.98],
                                            [113.67, 330.28],
                                            [113.65, 330.29],
                                            [113.5, 330.34],
                                            [112.71, 330.55],
                                            [112.6, 330.57],
                                            [112.56, 330.58],
                                            [111.83, 330.69],
                                            [111.8, 330.7],
                                            [111.7, 330.71],
                                            [110.91, 330.76],
                                            [110.73, 330.76],
                                            [110.74, 330.76]
                                        ]
                                    }
                                ],
                                "t": 120
                            },
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0.24, 0.02],
                                            [0.04, 0],
                                            [0, 0],
                                            [0.22, 0.04],
                                            [0, 0],
                                            [0.06, 0.01],
                                            [0.23, 0.06],
                                            [0.07, 0.02],
                                            [0, 0],
                                            [0.18, 0.07],
                                            [0, 0],
                                            [0.08, 0.03],
                                            [0.2, 0.1],
                                            [0.09, 0.05],
                                            [0.17, 0.11],
                                            [0.08, 0.06],
                                            [0, 0],
                                            [0.12, 0.09],
                                            [0.09, 0.08],
                                            [0.14, 0.13],
                                            [0, 0],
                                            [0.05, 0.05],
                                            [0.17, 0.2],
                                            [0.02, 0.03],
                                            [0, 0],
                                            [0.14, 0.19],
                                            [0.05, 0.07],
                                            [0, 0],
                                            [0.11, 0.18],
                                            [0, 0],
                                            [0.03, 0.06],
                                            [0.11, 0.25],
                                            [0, 0],
                                            [0, 0],
                                            [0.1, 0.31],
                                            [0.02, 0.07],
                                            [0.01, 0.03],
                                            [0.05, 0.21],
                                            [0.02, 0.08],
                                            [0, 0],
                                            [0.02, 0.16],
                                            [0.01, 0.11],
                                            [0.01, 0.17],
                                            [0, 0.11],
                                            [-0.01, 0.2],
                                            [0, 0],
                                            [-0.01, 0.09],
                                            [-0.02, 0.16],
                                            [0, 0],
                                            [-0.02, 0.08],
                                            [-0.04, 0.15],
                                            [0, 0],
                                            [-0.16, 0.39],
                                            [-0.02, 0.04],
                                            [-0.01, 0.01],
                                            [-0.11, 0.21],
                                            [-0.03, 0.06],
                                            [0, 0],
                                            [-0.12, 0.17],
                                            [-0.06, 0.08],
                                            [0, 0],
                                            [-0.13, 0.16],
                                            [-0.08, 0.09],
                                            [-0.16, 0.16],
                                            [0, 0],
                                            [-0.08, 0.08],
                                            [-0.14, 0.11],
                                            [0, 0],
                                            [-0.08, 0.05],
                                            [-0.18, 0.11],
                                            [-0.03, 0.02],
                                            [-0.07, 0.04],
                                            [-0.31, 0.13],
                                            [0, 0],
                                            [-0.35, 0.11],
                                            [-0.07, 0.02],
                                            [-0.03, 0.01],
                                            [-0.24, 0.05],
                                            [-0.09, 0.01],
                                            [0, 0],
                                            [-0.22, 0.02],
                                            [-0.11, 0],
                                            [0, 0],
                                            [-0.19, 0],
                                            [-0.12, -0.01],
                                            [-0.22, -0.03],
                                            [0, 0],
                                            [-0.11, -0.02],
                                            [-0.24, -0.06],
                                            [0, 0],
                                            [-0.08, -0.02],
                                            [-0.27, -0.09],
                                            [-0.02, -0.01],
                                            [-0.05, -0.02],
                                            [-0.42, -0.23],
                                            [0, 0],
                                            [-0.13, -0.08],
                                            [-0.06, -0.04],
                                            [0, 0],
                                            [-0.16, -0.12],
                                            [-0.07, -0.06],
                                            [0, 0],
                                            [-0.12, -0.12],
                                            [-0.08, -0.08],
                                            [-0.12, -0.14],
                                            [-0.07, -0.08],
                                            [-0.13, -0.17],
                                            [0, 0],
                                            [-0.05, -0.07],
                                            [-0.1, -0.17],
                                            [-0.01, -0.02],
                                            [-0.03, -0.06],
                                            [-0.11, -0.27],
                                            [0, 0],
                                            [-0.1, -0.31],
                                            [-0.02, -0.06],
                                            [0, 0],
                                            [-0.05, -0.2],
                                            [0, 0],
                                            [-0.02, -0.07],
                                            [-0.03, -0.23],
                                            [0, 0],
                                            [0, -0.04],
                                            [0, -0.29],
                                            [0, -0.07],
                                            [0, 0],
                                            [0.01, -0.16],
                                            [0.01, -0.12],
                                            [0.02, -0.14],
                                            [0.14, -0.45],
                                            [0.02, -0.05],
                                            [0, 0],
                                            [0.11, -0.25],
                                            [0.04, -0.08],
                                            [0.15, -0.25],
                                            [0, 0],
                                            [0.03, -0.04],
                                            [0.21, -0.27],
                                            [0.02, -0.02],
                                            [0.22, -0.23],
                                            [0.06, -0.06],
                                            [0, 0],
                                            [0.18, -0.15],
                                            [0.1, -0.07],
                                            [0.23, -0.14],
                                            [0, 0],
                                            [0.07, -0.04],
                                            [0.31, -0.14],
                                            [0, 0],
                                            [0.3, -0.1],
                                            [0, 0],
                                            [0.05, -0.02],
                                            [0.26, -0.06],
                                            [0.04, -0.01],
                                            [0, 0],
                                            [0.24, -0.03],
                                            [0, 0],
                                            [0.03, 0],
                                            [0.28, -0.01],
                                            [0.06, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [-0.29, 0],
                                            [-0.04, 0],
                                            [0, 0],
                                            [-0.21, -0.02],
                                            [0, 0],
                                            [-0.06, -0.01],
                                            [-0.24, -0.05],
                                            [-0.07, -0.02],
                                            [0, 0],
                                            [-0.19, -0.06],
                                            [0, 0],
                                            [-0.08, -0.03],
                                            [-0.19, -0.08],
                                            [-0.09, -0.05],
                                            [-0.22, -0.12],
                                            [-0.08, -0.05],
                                            [0, 0],
                                            [-0.12, -0.08],
                                            [-0.1, -0.07],
                                            [-0.13, -0.1],
                                            [0, 0],
                                            [-0.05, -0.05],
                                            [-0.2, -0.2],
                                            [-0.03, -0.03],
                                            [0, 0],
                                            [-0.15, -0.18],
                                            [-0.05, -0.07],
                                            [0, 0],
                                            [-0.11, -0.17],
                                            [0, 0],
                                            [-0.03, -0.06],
                                            [-0.15, -0.28],
                                            [0, 0],
                                            [0, 0],
                                            [-0.12, -0.27],
                                            [-0.02, -0.06],
                                            [-0.01, -0.03],
                                            [-0.05, -0.17],
                                            [-0.02, -0.08],
                                            [0, 0],
                                            [-0.04, -0.21],
                                            [-0.01, -0.11],
                                            [-0.02, -0.18],
                                            [0, -0.11],
                                            [0, -0.16],
                                            [0, 0],
                                            [0.01, -0.09],
                                            [0.02, -0.19],
                                            [0, 0],
                                            [0.01, -0.08],
                                            [0.03, -0.17],
                                            [0, 0],
                                            [0.11, -0.45],
                                            [0.02, -0.04],
                                            [0.01, -0.01],
                                            [0.11, -0.26],
                                            [0.03, -0.06],
                                            [0, 0],
                                            [0.13, -0.22],
                                            [0.06, -0.08],
                                            [0, 0],
                                            [0.13, -0.18],
                                            [0.08, -0.09],
                                            [0.13, -0.15],
                                            [0, 0],
                                            [0.08, -0.08],
                                            [0.18, -0.16],
                                            [0, 0],
                                            [0.07, -0.06],
                                            [0.2, -0.14],
                                            [0.02, -0.01],
                                            [0.06, -0.04],
                                            [0.31, -0.18],
                                            [0, 0],
                                            [0.3, -0.13],
                                            [0.07, -0.02],
                                            [0.03, -0.01],
                                            [0.2, -0.05],
                                            [0.09, -0.02],
                                            [0, 0],
                                            [0.19, -0.03],
                                            [0.11, -0.01],
                                            [0, 0],
                                            [0.22, -0.01],
                                            [0.12, 0],
                                            [0.2, 0.01],
                                            [0, 0],
                                            [0.11, 0.01],
                                            [0.19, 0.03],
                                            [0, 0],
                                            [0.08, 0.02],
                                            [0.21, 0.06],
                                            [0.02, 0.01],
                                            [0.05, 0.02],
                                            [0.4, 0.15],
                                            [0, 0],
                                            [0.12, 0.07],
                                            [0.07, 0.04],
                                            [0, 0],
                                            [0.14, 0.09],
                                            [0.07, 0.06],
                                            [0, 0],
                                            [0.16, 0.13],
                                            [0.08, 0.07],
                                            [0.13, 0.13],
                                            [0.07, 0.08],
                                            [0.11, 0.13],
                                            [0, 0],
                                            [0.05, 0.07],
                                            [0.12, 0.17],
                                            [0.01, 0.02],
                                            [0.04, 0.06],
                                            [0.16, 0.29],
                                            [0, 0],
                                            [0.11, 0.25],
                                            [0.02, 0.06],
                                            [0, 0],
                                            [0.06, 0.2],
                                            [0, 0],
                                            [0.02, 0.07],
                                            [0.05, 0.23],
                                            [0, 0],
                                            [0.01, 0.04],
                                            [0.03, 0.27],
                                            [0, 0.07],
                                            [0, 0],
                                            [0, 0.19],
                                            [-0.01, 0.12],
                                            [-0.02, 0.14],
                                            [-0.07, 0.48],
                                            [-0.02, 0.05],
                                            [0, 0],
                                            [-0.09, 0.26],
                                            [-0.04, 0.08],
                                            [-0.12, 0.24],
                                            [0, 0],
                                            [-0.03, 0.05],
                                            [-0.2, 0.32],
                                            [-0.02, 0.03],
                                            [-0.19, 0.24],
                                            [-0.06, 0.06],
                                            [0, 0],
                                            [-0.18, 0.17],
                                            [-0.1, 0.08],
                                            [-0.19, 0.14],
                                            [0, 0],
                                            [-0.07, 0.04],
                                            [-0.35, 0.2],
                                            [0, 0],
                                            [-0.24, 0.1],
                                            [0, 0],
                                            [-0.05, 0.02],
                                            [-0.27, 0.08],
                                            [-0.03, 0.01],
                                            [0, 0],
                                            [-0.25, 0.05],
                                            [0, 0],
                                            [-0.03, 0],
                                            [-0.25, 0.03],
                                            [-0.06, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [110.74, 330.76],
                                            [110.71, 330.76],
                                            [109.94, 330.73],
                                            [109.83, 330.72],
                                            [109.8, 330.71],
                                            [109.14, 330.62],
                                            [109.09, 330.62],
                                            [108.91, 330.58],
                                            [108.21, 330.42],
                                            [108.01, 330.36],
                                            [107.97, 330.35],
                                            [107.42, 330.16],
                                            [107.4, 330.15],
                                            [107.15, 330.06],
                                            [106.58, 329.8],
                                            [106.3, 329.66],
                                            [105.73, 329.33],
                                            [105.48, 329.16],
                                            [105.41, 329.11],
                                            [105.04, 328.86],
                                            [104.76, 328.63],
                                            [104.36, 328.29],
                                            [104.31, 328.24],
                                            [104.15, 328.1],
                                            [103.59, 327.5],
                                            [103.51, 327.42],
                                            [103.5, 327.4],
                                            [103.06, 326.84],
                                            [102.92, 326.63],
                                            [102.91, 326.62],
                                            [102.58, 326.09],
                                            [102.55, 326.04],
                                            [102.45, 325.86],
                                            [102.06, 325.08],
                                            [101.48, 323.74],
                                            [0.78, 92.27],
                                            [0.46, 91.41],
                                            [0.4, 91.22],
                                            [0.38, 91.14],
                                            [0.22, 90.55],
                                            [0.17, 90.29],
                                            [0.16, 90.22],
                                            [0.07, 89.67],
                                            [0.04, 89.33],
                                            [0.01, 88.79],
                                            [0, 88.45],
                                            [0.02, 87.91],
                                            [0.02, 87.85],
                                            [0.04, 87.57],
                                            [0.11, 87.04],
                                            [0.13, 86.96],
                                            [0.17, 86.71],
                                            [0.28, 86.24],
                                            [0.29, 86.2],
                                            [0.69, 84.95],
                                            [0.75, 84.82],
                                            [0.77, 84.78],
                                            [1.1, 84.08],
                                            [1.2, 83.89],
                                            [1.24, 83.82],
                                            [1.6, 83.24],
                                            [1.77, 82.99],
                                            [1.79, 82.97],
                                            [2.18, 82.46],
                                            [2.42, 82.19],
                                            [2.85, 81.74],
                                            [2.87, 81.72],
                                            [3.12, 81.49],
                                            [3.61, 81.08],
                                            [3.68, 81.02],
                                            [3.9, 80.86],
                                            [4.48, 80.47],
                                            [4.55, 80.43],
                                            [4.75, 80.31],
                                            [5.67, 79.84],
                                            [187.31, 0.78],
                                            [188.28, 0.42],
                                            [188.5, 0.36],
                                            [188.59, 0.34],
                                            [189.25, 0.17],
                                            [189.54, 0.13],
                                            [189.62, 0.11],
                                            [190.25, 0.03],
                                            [190.58, 0.01],
                                            [190.62, 0.01],
                                            [191.24, 0],
                                            [191.61, 0.01],
                                            [192.23, 0.07],
                                            [192.25, 0.07],
                                            [192.58, 0.12],
                                            [193.22, 0.25],
                                            [193.3, 0.27],
                                            [193.53, 0.32],
                                            [194.23, 0.55],
                                            [194.29, 0.56],
                                            [194.45, 0.62],
                                            [195.65, 1.19],
                                            [195.71, 1.21],
                                            [196.08, 1.43],
                                            [196.28, 1.56],
                                            [196.35, 1.61],
                                            [196.8, 1.93],
                                            [197.02, 2.1],
                                            [197.05, 2.13],
                                            [197.47, 2.49],
                                            [197.71, 2.72],
                                            [198.09, 3.12],
                                            [198.31, 3.37],
                                            [198.66, 3.82],
                                            [198.7, 3.88],
                                            [198.85, 4.08],
                                            [199.18, 4.6],
                                            [199.22, 4.67],
                                            [199.33, 4.85],
                                            [199.73, 5.67],
                                            [301.01, 238.48],
                                            [301.32, 239.3],
                                            [301.38, 239.48],
                                            [301.4, 239.54],
                                            [301.56, 240.15],
                                            [301.57, 240.19],
                                            [301.62, 240.41],
                                            [301.73, 241.11],
                                            [301.73, 241.14],
                                            [301.75, 241.25],
                                            [301.8, 242.06],
                                            [301.8, 242.28],
                                            [301.8, 242.36],
                                            [301.77, 242.88],
                                            [301.74, 243.24],
                                            [301.69, 243.67],
                                            [301.36, 245.06],
                                            [301.31, 245.22],
                                            [301.29, 245.28],
                                            [300.99, 246.05],
                                            [300.88, 246.3],
                                            [300.49, 247.04],
                                            [300.46, 247.09],
                                            [300.38, 247.22],
                                            [299.77, 248.1],
                                            [299.71, 248.17],
                                            [299.08, 248.87],
                                            [298.91, 249.04],
                                            [298.85, 249.1],
                                            [298.29, 249.59],
                                            [298, 249.81],
                                            [297.38, 250.23],
                                            [297.31, 250.28],
                                            [297.1, 250.41],
                                            [296.12, 250.91],
                                            [114.48, 329.98],
                                            [113.67, 330.28],
                                            [113.65, 330.29],
                                            [113.5, 330.34],
                                            [112.71, 330.55],
                                            [112.6, 330.57],
                                            [112.56, 330.58],
                                            [111.83, 330.69],
                                            [111.8, 330.7],
                                            [111.7, 330.71],
                                            [110.91, 330.76],
                                            [110.73, 330.76],
                                            [110.74, 330.76]
                                        ]
                                    }
                                ],
                                "t": 180
                            },
                            {
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0.24, 0.02],
                                            [0.04, 0],
                                            [0, 0],
                                            [0.22, 0.04],
                                            [0, 0],
                                            [0.06, 0.01],
                                            [0.23, 0.06],
                                            [0.07, 0.02],
                                            [0, 0],
                                            [0.18, 0.07],
                                            [0, 0],
                                            [0.08, 0.03],
                                            [0.2, 0.1],
                                            [0.09, 0.05],
                                            [0.17, 0.11],
                                            [0.08, 0.06],
                                            [0, 0],
                                            [0.12, 0.09],
                                            [0.09, 0.08],
                                            [0.14, 0.13],
                                            [0, 0],
                                            [0.05, 0.05],
                                            [0.17, 0.2],
                                            [0.02, 0.03],
                                            [0, 0],
                                            [0.14, 0.19],
                                            [0.05, 0.07],
                                            [0, 0],
                                            [0.11, 0.18],
                                            [0, 0],
                                            [0.03, 0.06],
                                            [0.11, 0.25],
                                            [0, 0],
                                            [0, 0],
                                            [0.1, 0.31],
                                            [0.02, 0.07],
                                            [0.01, 0.03],
                                            [0.05, 0.21],
                                            [0.02, 0.08],
                                            [0, 0],
                                            [0.02, 0.16],
                                            [0.01, 0.11],
                                            [0.01, 0.17],
                                            [0, 0.11],
                                            [-0.01, 0.2],
                                            [0, 0],
                                            [-0.01, 0.09],
                                            [-0.02, 0.16],
                                            [0, 0],
                                            [-0.02, 0.08],
                                            [-0.04, 0.15],
                                            [0, 0],
                                            [-0.16, 0.39],
                                            [-0.02, 0.04],
                                            [-0.01, 0.01],
                                            [-0.11, 0.21],
                                            [-0.03, 0.06],
                                            [0, 0],
                                            [-0.12, 0.17],
                                            [-0.06, 0.08],
                                            [0, 0],
                                            [-0.13, 0.16],
                                            [-0.08, 0.09],
                                            [-0.16, 0.16],
                                            [0, 0],
                                            [-0.08, 0.08],
                                            [-0.14, 0.11],
                                            [0, 0],
                                            [-0.08, 0.05],
                                            [-0.18, 0.11],
                                            [-0.03, 0.02],
                                            [-0.07, 0.04],
                                            [-0.31, 0.13],
                                            [0, 0],
                                            [-0.35, 0.11],
                                            [-0.07, 0.02],
                                            [-0.03, 0.01],
                                            [-0.24, 0.05],
                                            [-0.09, 0.01],
                                            [0, 0],
                                            [-0.22, 0.02],
                                            [-0.11, 0],
                                            [0, 0],
                                            [-0.19, 0],
                                            [-0.12, -0.01],
                                            [-0.22, -0.03],
                                            [0, 0],
                                            [-0.11, -0.02],
                                            [-0.24, -0.06],
                                            [0, 0],
                                            [-0.08, -0.02],
                                            [-0.27, -0.09],
                                            [-0.02, -0.01],
                                            [-0.05, -0.02],
                                            [-0.42, -0.23],
                                            [0, 0],
                                            [-0.13, -0.08],
                                            [-0.06, -0.04],
                                            [0, 0],
                                            [-0.16, -0.12],
                                            [-0.07, -0.06],
                                            [0, 0],
                                            [-0.12, -0.12],
                                            [-0.08, -0.08],
                                            [-0.12, -0.14],
                                            [-0.07, -0.08],
                                            [-0.13, -0.17],
                                            [0, 0],
                                            [-0.05, -0.07],
                                            [-0.1, -0.17],
                                            [-0.01, -0.02],
                                            [-0.03, -0.06],
                                            [-0.11, -0.27],
                                            [0, 0],
                                            [-0.1, -0.31],
                                            [-0.02, -0.06],
                                            [0, 0],
                                            [-0.05, -0.2],
                                            [0, 0],
                                            [-0.02, -0.07],
                                            [-0.03, -0.23],
                                            [0, 0],
                                            [0, -0.04],
                                            [0, -0.29],
                                            [0, -0.07],
                                            [0, 0],
                                            [0.01, -0.16],
                                            [0.01, -0.12],
                                            [0.02, -0.14],
                                            [0.14, -0.45],
                                            [0.02, -0.05],
                                            [0, 0],
                                            [0.11, -0.25],
                                            [0.04, -0.08],
                                            [0.15, -0.25],
                                            [0, 0],
                                            [0.03, -0.04],
                                            [0.21, -0.27],
                                            [0.02, -0.02],
                                            [0.22, -0.23],
                                            [0.06, -0.06],
                                            [0, 0],
                                            [0.18, -0.15],
                                            [0.1, -0.07],
                                            [0.23, -0.14],
                                            [0, 0],
                                            [0.07, -0.04],
                                            [0.31, -0.14],
                                            [0, 0],
                                            [0.3, -0.1],
                                            [0, 0],
                                            [0.05, -0.02],
                                            [0.26, -0.06],
                                            [0.04, -0.01],
                                            [0, 0],
                                            [0.24, -0.03],
                                            [0, 0],
                                            [0.03, 0],
                                            [0.28, -0.01],
                                            [0.06, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [-0.29, 0],
                                            [-0.04, 0],
                                            [0, 0],
                                            [-0.21, -0.02],
                                            [0, 0],
                                            [-0.06, -0.01],
                                            [-0.24, -0.05],
                                            [-0.07, -0.02],
                                            [0, 0],
                                            [-0.19, -0.06],
                                            [0, 0],
                                            [-0.08, -0.03],
                                            [-0.19, -0.08],
                                            [-0.09, -0.05],
                                            [-0.22, -0.12],
                                            [-0.08, -0.05],
                                            [0, 0],
                                            [-0.12, -0.08],
                                            [-0.1, -0.07],
                                            [-0.13, -0.1],
                                            [0, 0],
                                            [-0.05, -0.05],
                                            [-0.2, -0.2],
                                            [-0.03, -0.03],
                                            [0, 0],
                                            [-0.15, -0.18],
                                            [-0.05, -0.07],
                                            [0, 0],
                                            [-0.11, -0.17],
                                            [0, 0],
                                            [-0.03, -0.06],
                                            [-0.15, -0.28],
                                            [0, 0],
                                            [0, 0],
                                            [-0.12, -0.27],
                                            [-0.02, -0.06],
                                            [-0.01, -0.03],
                                            [-0.05, -0.17],
                                            [-0.02, -0.08],
                                            [0, 0],
                                            [-0.04, -0.21],
                                            [-0.01, -0.11],
                                            [-0.02, -0.18],
                                            [0, -0.11],
                                            [0, -0.16],
                                            [0, 0],
                                            [0.01, -0.09],
                                            [0.02, -0.19],
                                            [0, 0],
                                            [0.01, -0.08],
                                            [0.03, -0.17],
                                            [0, 0],
                                            [0.11, -0.45],
                                            [0.02, -0.04],
                                            [0.01, -0.01],
                                            [0.11, -0.26],
                                            [0.03, -0.06],
                                            [0, 0],
                                            [0.13, -0.22],
                                            [0.06, -0.08],
                                            [0, 0],
                                            [0.13, -0.18],
                                            [0.08, -0.09],
                                            [0.13, -0.15],
                                            [0, 0],
                                            [0.08, -0.08],
                                            [0.18, -0.16],
                                            [0, 0],
                                            [0.07, -0.06],
                                            [0.2, -0.14],
                                            [0.02, -0.01],
                                            [0.06, -0.04],
                                            [0.31, -0.18],
                                            [0, 0],
                                            [0.3, -0.13],
                                            [0.07, -0.02],
                                            [0.03, -0.01],
                                            [0.2, -0.05],
                                            [0.09, -0.02],
                                            [0, 0],
                                            [0.19, -0.03],
                                            [0.11, -0.01],
                                            [0, 0],
                                            [0.22, -0.01],
                                            [0.12, 0],
                                            [0.2, 0.01],
                                            [0, 0],
                                            [0.11, 0.01],
                                            [0.19, 0.03],
                                            [0, 0],
                                            [0.08, 0.02],
                                            [0.21, 0.06],
                                            [0.02, 0.01],
                                            [0.05, 0.02],
                                            [0.4, 0.15],
                                            [0, 0],
                                            [0.12, 0.07],
                                            [0.07, 0.04],
                                            [0, 0],
                                            [0.14, 0.09],
                                            [0.07, 0.06],
                                            [0, 0],
                                            [0.16, 0.13],
                                            [0.08, 0.07],
                                            [0.13, 0.13],
                                            [0.07, 0.08],
                                            [0.11, 0.13],
                                            [0, 0],
                                            [0.05, 0.07],
                                            [0.12, 0.17],
                                            [0.01, 0.02],
                                            [0.04, 0.06],
                                            [0.16, 0.29],
                                            [0, 0],
                                            [0.11, 0.25],
                                            [0.02, 0.06],
                                            [0, 0],
                                            [0.06, 0.2],
                                            [0, 0],
                                            [0.02, 0.07],
                                            [0.05, 0.23],
                                            [0, 0],
                                            [0.01, 0.04],
                                            [0.03, 0.27],
                                            [0, 0.07],
                                            [0, 0],
                                            [0, 0.19],
                                            [-0.01, 0.12],
                                            [-0.02, 0.14],
                                            [-0.07, 0.48],
                                            [-0.02, 0.05],
                                            [0, 0],
                                            [-0.09, 0.26],
                                            [-0.04, 0.08],
                                            [-0.12, 0.24],
                                            [0, 0],
                                            [-0.03, 0.05],
                                            [-0.2, 0.32],
                                            [-0.02, 0.03],
                                            [-0.19, 0.24],
                                            [-0.06, 0.06],
                                            [0, 0],
                                            [-0.18, 0.17],
                                            [-0.1, 0.08],
                                            [-0.19, 0.14],
                                            [0, 0],
                                            [-0.07, 0.04],
                                            [-0.35, 0.2],
                                            [0, 0],
                                            [-0.24, 0.1],
                                            [0, 0],
                                            [-0.05, 0.02],
                                            [-0.27, 0.08],
                                            [-0.03, 0.01],
                                            [0, 0],
                                            [-0.25, 0.05],
                                            [0, 0],
                                            [-0.03, 0],
                                            [-0.25, 0.03],
                                            [-0.06, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [110.74, 330.76],
                                            [110.71, 330.76],
                                            [109.94, 330.73],
                                            [109.83, 330.72],
                                            [109.8, 330.71],
                                            [109.14, 330.62],
                                            [109.09, 330.62],
                                            [108.91, 330.58],
                                            [108.21, 330.42],
                                            [108.01, 330.36],
                                            [107.97, 330.35],
                                            [107.42, 330.16],
                                            [107.4, 330.15],
                                            [107.15, 330.06],
                                            [106.58, 329.8],
                                            [106.3, 329.66],
                                            [105.73, 329.33],
                                            [105.48, 329.16],
                                            [105.41, 329.11],
                                            [105.04, 328.86],
                                            [104.76, 328.63],
                                            [104.36, 328.29],
                                            [104.31, 328.24],
                                            [104.15, 328.1],
                                            [103.59, 327.5],
                                            [103.51, 327.42],
                                            [103.5, 327.4],
                                            [103.06, 326.84],
                                            [102.92, 326.63],
                                            [102.91, 326.62],
                                            [102.58, 326.09],
                                            [102.55, 326.04],
                                            [102.45, 325.86],
                                            [102.06, 325.08],
                                            [101.48, 323.74],
                                            [0.78, 92.27],
                                            [0.46, 91.41],
                                            [0.4, 91.22],
                                            [0.38, 91.14],
                                            [0.22, 90.55],
                                            [0.17, 90.29],
                                            [0.16, 90.22],
                                            [0.07, 89.67],
                                            [0.04, 89.33],
                                            [0.01, 88.79],
                                            [0, 88.45],
                                            [0.02, 87.91],
                                            [0.02, 87.85],
                                            [0.04, 87.57],
                                            [0.11, 87.04],
                                            [0.13, 86.96],
                                            [0.17, 86.71],
                                            [0.28, 86.24],
                                            [0.29, 86.2],
                                            [0.69, 84.95],
                                            [0.75, 84.82],
                                            [0.77, 84.78],
                                            [1.1, 84.08],
                                            [1.2, 83.89],
                                            [1.24, 83.82],
                                            [1.6, 83.24],
                                            [1.77, 82.99],
                                            [1.79, 82.97],
                                            [2.18, 82.46],
                                            [2.42, 82.19],
                                            [2.85, 81.74],
                                            [2.87, 81.72],
                                            [3.12, 81.49],
                                            [3.61, 81.08],
                                            [3.68, 81.02],
                                            [3.9, 80.86],
                                            [4.48, 80.47],
                                            [4.55, 80.43],
                                            [4.75, 80.31],
                                            [5.67, 79.84],
                                            [187.31, 0.78],
                                            [188.28, 0.42],
                                            [188.5, 0.36],
                                            [188.59, 0.34],
                                            [189.25, 0.17],
                                            [189.54, 0.13],
                                            [189.62, 0.11],
                                            [190.25, 0.03],
                                            [190.58, 0.01],
                                            [190.62, 0.01],
                                            [191.24, 0],
                                            [191.61, 0.01],
                                            [192.23, 0.07],
                                            [192.25, 0.07],
                                            [192.58, 0.12],
                                            [193.22, 0.25],
                                            [193.3, 0.27],
                                            [193.53, 0.32],
                                            [194.23, 0.55],
                                            [194.29, 0.56],
                                            [194.45, 0.62],
                                            [195.65, 1.19],
                                            [195.71, 1.21],
                                            [196.08, 1.43],
                                            [196.28, 1.56],
                                            [196.35, 1.61],
                                            [196.8, 1.93],
                                            [197.02, 2.1],
                                            [197.05, 2.13],
                                            [197.47, 2.49],
                                            [197.71, 2.72],
                                            [198.09, 3.12],
                                            [198.31, 3.37],
                                            [198.66, 3.82],
                                            [198.7, 3.88],
                                            [198.85, 4.08],
                                            [199.18, 4.6],
                                            [199.22, 4.67],
                                            [199.33, 4.85],
                                            [199.73, 5.67],
                                            [301.01, 238.48],
                                            [301.32, 239.3],
                                            [301.38, 239.48],
                                            [301.4, 239.54],
                                            [301.56, 240.15],
                                            [301.57, 240.19],
                                            [301.62, 240.41],
                                            [301.73, 241.11],
                                            [301.73, 241.14],
                                            [301.75, 241.25],
                                            [301.8, 242.06],
                                            [301.8, 242.28],
                                            [301.8, 242.36],
                                            [301.77, 242.88],
                                            [301.74, 243.24],
                                            [301.69, 243.67],
                                            [301.36, 245.06],
                                            [301.31, 245.22],
                                            [301.29, 245.28],
                                            [300.99, 246.05],
                                            [300.88, 246.3],
                                            [300.49, 247.04],
                                            [300.46, 247.09],
                                            [300.38, 247.22],
                                            [299.77, 248.1],
                                            [299.71, 248.17],
                                            [299.08, 248.87],
                                            [298.91, 249.04],
                                            [298.85, 249.1],
                                            [298.29, 249.59],
                                            [298, 249.81],
                                            [297.38, 250.23],
                                            [297.31, 250.28],
                                            [297.1, 250.41],
                                            [296.12, 250.91],
                                            [114.48, 329.98],
                                            [113.67, 330.28],
                                            [113.65, 330.29],
                                            [113.5, 330.34],
                                            [112.71, 330.55],
                                            [112.6, 330.57],
                                            [112.56, 330.58],
                                            [111.83, 330.69],
                                            [111.8, 330.7],
                                            [111.7, 330.71],
                                            [110.91, 330.76],
                                            [110.73, 330.76],
                                            [110.74, 330.76]
                                        ]
                                    }
                                ],
                                "t": 240
                            }
                        ]
                    }
                },
                {
                    "ty": "sh",
                    "d": 1,
                    "ks": {
                        "a": 1,
                        "k": [
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0.14, -0.01],
                                            [0, 0],
                                            [0.08, -0.01],
                                            [0.16, -0.02],
                                            [0, 0],
                                            [0.06, -0.01],
                                            [0.16, -0.04],
                                            [0.04, -0.01],
                                            [0.04, -0.01],
                                            [0.24, -0.1],
                                            [0, 0],
                                            [0.25, -0.14],
                                            [0.04, -0.02],
                                            [0.04, -0.02],
                                            [0.15, -0.11],
                                            [0.05, -0.04],
                                            [0, 0],
                                            [0.13, -0.12],
                                            [0.06, -0.06],
                                            [0, 0],
                                            [0.1, -0.12],
                                            [0.06, -0.07],
                                            [0.1, -0.15],
                                            [0, 0],
                                            [0.04, -0.06],
                                            [0.1, -0.18],
                                            [0, 0],
                                            [0.02, -0.04],
                                            [0.09, -0.21],
                                            [0.02, -0.03],
                                            [0, -0.01],
                                            [0.09, -0.37],
                                            [0, 0],
                                            [0.02, -0.11],
                                            [0.01, -0.05],
                                            [0, 0],
                                            [0.02, -0.14],
                                            [0, -0.07],
                                            [0, 0],
                                            [0, -0.12],
                                            [0, -0.09],
                                            [-0.01, -0.14],
                                            [-0.01, -0.09],
                                            [-0.03, -0.17],
                                            [0, 0],
                                            [-0.01, -0.06],
                                            [-0.04, -0.15],
                                            [-0.01, -0.04],
                                            [-0.01, -0.04],
                                            [-0.09, -0.21],
                                            [0, 0],
                                            [-0.12, -0.23],
                                            [-0.02, -0.04],
                                            [0, 0],
                                            [-0.09, -0.14],
                                            [0, 0],
                                            [-0.04, -0.05],
                                            [-0.12, -0.14],
                                            [-0.02, -0.02],
                                            [0, 0],
                                            [-0.17, -0.16],
                                            [-0.04, -0.03],
                                            [0, 0],
                                            [-0.1, -0.08],
                                            [-0.08, -0.06],
                                            [-0.1, -0.07],
                                            [0, 0],
                                            [-0.06, -0.04],
                                            [-0.18, -0.09],
                                            [-0.08, -0.04],
                                            [-0.15, -0.06],
                                            [-0.07, -0.03],
                                            [-0.15, -0.04],
                                            [0, 0],
                                            [-0.05, -0.01],
                                            [-0.19, -0.04],
                                            [-0.04, -0.01],
                                            [0, 0],
                                            [-0.17, -0.02],
                                            [-0.02, 0],
                                            [0, 0],
                                            [-0.23, 0],
                                            [-0.05, 0],
                                            [-0.2, 0.02],
                                            [0, 0],
                                            [-0.2, 0.04],
                                            [0, 0],
                                            [-0.22, 0.07],
                                            [-0.04, 0.01],
                                            [0, 0],
                                            [-0.19, 0.08],
                                            [0, 0],
                                            [-0.28, 0.16],
                                            [-0.04, 0.03],
                                            [0, 0],
                                            [-0.15, 0.11],
                                            [-0.08, 0.06],
                                            [-0.15, 0.14],
                                            [0, 0],
                                            [-0.04, 0.04],
                                            [-0.15, 0.19],
                                            [-0.02, 0.02],
                                            [-0.16, 0.25],
                                            [-0.01, 0.02],
                                            [-0.02, 0.03],
                                            [-0.09, 0.19],
                                            [-0.03, 0.07],
                                            [-0.07, 0.21],
                                            [0, 0],
                                            [-0.01, 0.04],
                                            [-0.06, 0.38],
                                            [-0.01, 0.12],
                                            [-0.01, 0.1],
                                            [0, 0.15],
                                            [0, 0],
                                            [0, 0.05],
                                            [0.02, 0.21],
                                            [0, 0],
                                            [0, 0.03],
                                            [0.04, 0.19],
                                            [0.01, 0.05],
                                            [0, 0],
                                            [0.05, 0.16],
                                            [0, 0],
                                            [0.01, 0.04],
                                            [0.08, 0.19],
                                            [0, 0],
                                            [0.13, 0.23],
                                            [0.02, 0.03],
                                            [0.02, 0.03],
                                            [0.08, 0.12],
                                            [0.04, 0.05],
                                            [0, 0],
                                            [0.08, 0.1],
                                            [0.06, 0.07],
                                            [0.1, 0.1],
                                            [0.06, 0.06],
                                            [0.13, 0.11],
                                            [0, 0],
                                            [0.05, 0.04],
                                            [0.12, 0.08],
                                            [0, 0],
                                            [0.04, 0.03],
                                            [0.1, 0.05],
                                            [0, 0],
                                            [0.31, 0.12],
                                            [0.02, 0.01],
                                            [0.04, 0.01],
                                            [0.17, 0.04],
                                            [0.05, 0.01],
                                            [0, 0],
                                            [0.15, 0.02],
                                            [0.09, 0.01],
                                            [0, 0],
                                            [0.16, 0.01],
                                            [0.1, 0],
                                            [0.04, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [-0.12, 0],
                                            [0, 0],
                                            [-0.08, 0.01],
                                            [-0.17, 0.02],
                                            [0, 0],
                                            [-0.06, 0.01],
                                            [-0.18, 0.04],
                                            [-0.04, 0.01],
                                            [-0.04, 0.01],
                                            [-0.28, 0.09],
                                            [0, 0],
                                            [-0.24, 0.1],
                                            [-0.04, 0.02],
                                            [-0.04, 0.02],
                                            [-0.16, 0.1],
                                            [-0.05, 0.04],
                                            [0, 0],
                                            [-0.12, 0.09],
                                            [-0.07, 0.06],
                                            [0, 0],
                                            [-0.13, 0.13],
                                            [-0.06, 0.07],
                                            [-0.1, 0.13],
                                            [0, 0],
                                            [-0.05, 0.06],
                                            [-0.09, 0.14],
                                            [0, 0],
                                            [-0.02, 0.04],
                                            [-0.09, 0.16],
                                            [-0.01, 0.03],
                                            [-0.01, 0.01],
                                            [-0.12, 0.31],
                                            [0, 0],
                                            [-0.03, 0.13],
                                            [-0.01, 0.05],
                                            [0, 0],
                                            [-0.02, 0.13],
                                            [-0.01, 0.07],
                                            [0, 0],
                                            [-0.01, 0.16],
                                            [0, 0.09],
                                            [0, 0.14],
                                            [0.01, 0.09],
                                            [0.02, 0.12],
                                            [0, 0],
                                            [0.01, 0.06],
                                            [0.04, 0.16],
                                            [0.01, 0.04],
                                            [0.01, 0.04],
                                            [0.08, 0.25],
                                            [0, 0],
                                            [0.08, 0.19],
                                            [0.02, 0.04],
                                            [0, 0],
                                            [0.08, 0.14],
                                            [0, 0],
                                            [0.04, 0.05],
                                            [0.11, 0.15],
                                            [0.02, 0.03],
                                            [0, 0],
                                            [0.13, 0.15],
                                            [0.04, 0.03],
                                            [0, 0],
                                            [0.11, 0.1],
                                            [0.08, 0.06],
                                            [0.09, 0.07],
                                            [0, 0],
                                            [0.06, 0.04],
                                            [0.13, 0.08],
                                            [0.07, 0.04],
                                            [0.16, 0.08],
                                            [0.06, 0.03],
                                            [0.16, 0.06],
                                            [0, 0],
                                            [0.05, 0.02],
                                            [0.18, 0.05],
                                            [0.04, 0.01],
                                            [0, 0],
                                            [0.18, 0.03],
                                            [0.03, 0],
                                            [0, 0],
                                            [0.18, 0.02],
                                            [0.06, 0],
                                            [0.23, 0],
                                            [0, 0],
                                            [0.19, -0.02],
                                            [0, 0],
                                            [0.2, -0.04],
                                            [0.04, -0.01],
                                            [0, 0],
                                            [0.25, -0.08],
                                            [0, 0],
                                            [0.24, -0.11],
                                            [0.04, -0.03],
                                            [0, 0],
                                            [0.19, -0.12],
                                            [0.08, -0.06],
                                            [0.15, -0.12],
                                            [0, 0],
                                            [0.04, -0.04],
                                            [0.18, -0.19],
                                            [0.02, -0.03],
                                            [0.16, -0.21],
                                            [0.01, -0.02],
                                            [0.02, -0.03],
                                            [0.12, -0.2],
                                            [0.03, -0.07],
                                            [0.09, -0.2],
                                            [0, 0],
                                            [0.01, -0.03],
                                            [0.11, -0.36],
                                            [0.02, -0.12],
                                            [0.01, -0.1],
                                            [0.01, -0.13],
                                            [0, 0],
                                            [0, -0.05],
                                            [0, -0.23],
                                            [0, 0],
                                            [0, -0.03],
                                            [-0.02, -0.19],
                                            [-0.01, -0.05],
                                            [0, 0],
                                            [-0.04, -0.16],
                                            [0, 0],
                                            [-0.01, -0.04],
                                            [-0.08, -0.25],
                                            [0, 0],
                                            [-0.09, -0.21],
                                            [-0.02, -0.03],
                                            [-0.02, -0.03],
                                            [-0.1, -0.16],
                                            [-0.03, -0.05],
                                            [0, 0],
                                            [-0.1, -0.14],
                                            [-0.06, -0.07],
                                            [-0.1, -0.11],
                                            [-0.06, -0.06],
                                            [-0.1, -0.09],
                                            [0, 0],
                                            [-0.05, -0.04],
                                            [-0.11, -0.09],
                                            [0, 0],
                                            [-0.04, -0.03],
                                            [-0.09, -0.06],
                                            [0, 0],
                                            [-0.34, -0.19],
                                            [-0.02, -0.01],
                                            [-0.04, -0.01],
                                            [-0.22, -0.08],
                                            [-0.05, -0.01],
                                            [0, 0],
                                            [-0.2, -0.05],
                                            [-0.09, -0.01],
                                            [0, 0],
                                            [-0.17, -0.02],
                                            [-0.1, -0.01],
                                            [-0.04, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [191.1, 1.89],
                                            [190.72, 1.9],
                                            [190.67, 1.9],
                                            [190.42, 1.92],
                                            [189.92, 1.98],
                                            [189.81, 2],
                                            [189.62, 2.03],
                                            [189.09, 2.16],
                                            [188.96, 2.19],
                                            [188.84, 2.23],
                                            [188.07, 2.51],
                                            [6.43, 81.58],
                                            [5.69, 81.95],
                                            [5.59, 82.01],
                                            [5.47, 82.09],
                                            [5.01, 82.39],
                                            [4.87, 82.5],
                                            [4.78, 82.57],
                                            [4.39, 82.89],
                                            [4.2, 83.08],
                                            [4.18, 83.1],
                                            [3.83, 83.46],
                                            [3.64, 83.68],
                                            [3.33, 84.08],
                                            [3.31, 84.11],
                                            [3.18, 84.3],
                                            [2.89, 84.76],
                                            [2.84, 84.85],
                                            [2.77, 84.97],
                                            [2.51, 85.53],
                                            [2.46, 85.62],
                                            [2.45, 85.67],
                                            [2.13, 86.67],
                                            [2.11, 86.71],
                                            [2.03, 87.07],
                                            [2, 87.23],
                                            [1.99, 87.34],
                                            [1.93, 87.76],
                                            [1.91, 87.97],
                                            [1.91, 88.03],
                                            [1.89, 88.46],
                                            [1.9, 88.73],
                                            [1.92, 89.16],
                                            [1.95, 89.44],
                                            [2.02, 89.88],
                                            [2.04, 89.96],
                                            [2.07, 90.14],
                                            [2.2, 90.61],
                                            [2.23, 90.73],
                                            [2.26, 90.83],
                                            [2.52, 91.52],
                                            [103.8, 324.33],
                                            [104.11, 324.96],
                                            [104.18, 325.08],
                                            [104.21, 325.14],
                                            [104.48, 325.56],
                                            [104.49, 325.58],
                                            [104.6, 325.74],
                                            [104.95, 326.18],
                                            [105, 326.25],
                                            [105.02, 326.27],
                                            [105.46, 326.74],
                                            [105.57, 326.84],
                                            [105.64, 326.9],
                                            [105.95, 327.17],
                                            [106.18, 327.35],
                                            [106.47, 327.55],
                                            [106.55, 327.61],
                                            [106.73, 327.73],
                                            [107.19, 327.99],
                                            [107.41, 328.1],
                                            [107.87, 328.31],
                                            [108.07, 328.38],
                                            [108.52, 328.54],
                                            [108.57, 328.55],
                                            [108.72, 328.6],
                                            [109.28, 328.73],
                                            [109.4, 328.75],
                                            [109.46, 328.76],
                                            [109.99, 328.83],
                                            [110.06, 328.84],
                                            [110.1, 328.85],
                                            [110.71, 328.87],
                                            [110.88, 328.87],
                                            [111.51, 328.83],
                                            [111.61, 328.82],
                                            [112.2, 328.72],
                                            [112.31, 328.7],
                                            [112.95, 328.53],
                                            [113.06, 328.5],
                                            [113.08, 328.49],
                                            [113.73, 328.24],
                                            [295.37, 249.18],
                                            [296.16, 248.78],
                                            [296.29, 248.69],
                                            [296.38, 248.63],
                                            [296.88, 248.3],
                                            [297.11, 248.12],
                                            [297.55, 247.73],
                                            [297.62, 247.66],
                                            [297.74, 247.55],
                                            [298.24, 246.98],
                                            [298.3, 246.92],
                                            [298.77, 246.23],
                                            [298.8, 246.17],
                                            [298.86, 246.08],
                                            [299.17, 245.49],
                                            [299.26, 245.29],
                                            [299.5, 244.68],
                                            [299.52, 244.6],
                                            [299.56, 244.5],
                                            [299.82, 243.39],
                                            [299.86, 243.04],
                                            [299.89, 242.75],
                                            [299.9, 242.34],
                                            [299.9, 242.25],
                                            [299.91, 242.11],
                                            [299.87, 241.46],
                                            [299.87, 241.44],
                                            [299.85, 241.35],
                                            [299.76, 240.79],
                                            [299.73, 240.62],
                                            [299.72, 240.58],
                                            [299.59, 240.1],
                                            [299.57, 240.03],
                                            [299.53, 239.9],
                                            [299.28, 239.24],
                                            [198, 6.43],
                                            [197.68, 5.77],
                                            [197.62, 5.68],
                                            [197.56, 5.58],
                                            [197.3, 5.16],
                                            [197.19, 5.02],
                                            [197.14, 4.95],
                                            [196.86, 4.59],
                                            [196.69, 4.39],
                                            [196.38, 4.07],
                                            [196.19, 3.89],
                                            [195.86, 3.6],
                                            [195.82, 3.57],
                                            [195.66, 3.44],
                                            [195.3, 3.19],
                                            [195.21, 3.12],
                                            [195.08, 3.04],
                                            [194.8, 2.88],
                                            [194.74, 2.85],
                                            [193.77, 2.39],
                                            [193.71, 2.37],
                                            [193.6, 2.33],
                                            [193.04, 2.15],
                                            [192.89, 2.12],
                                            [192.79, 2.09],
                                            [192.28, 1.99],
                                            [192.02, 1.96],
                                            [192, 1.95],
                                            [191.51, 1.91],
                                            [191.21, 1.9],
                                            [191.1, 1.9],
                                            [191.1, 1.89]
                                        ]
                                    }
                                ],
                                "t": 0
                            },
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0.14, -0.01],
                                            [0, 0],
                                            [0.08, -0.01],
                                            [0.16, -0.02],
                                            [0, 0],
                                            [0.06, -0.01],
                                            [0.16, -0.04],
                                            [0.04, -0.01],
                                            [0.04, -0.01],
                                            [0.24, -0.1],
                                            [0, 0],
                                            [0.25, -0.14],
                                            [0.04, -0.02],
                                            [0.04, -0.02],
                                            [0.15, -0.11],
                                            [0.05, -0.04],
                                            [0, 0],
                                            [0.13, -0.12],
                                            [0.06, -0.06],
                                            [0, 0],
                                            [0.1, -0.12],
                                            [0.06, -0.07],
                                            [0.1, -0.15],
                                            [0, 0],
                                            [0.04, -0.06],
                                            [0.1, -0.18],
                                            [0, 0],
                                            [0.02, -0.04],
                                            [0.09, -0.21],
                                            [0.02, -0.03],
                                            [0, -0.01],
                                            [0.09, -0.37],
                                            [0, 0],
                                            [0.02, -0.11],
                                            [0.01, -0.05],
                                            [0, 0],
                                            [0.02, -0.14],
                                            [0, -0.07],
                                            [0, 0],
                                            [0, -0.12],
                                            [0, -0.09],
                                            [-0.01, -0.14],
                                            [-0.01, -0.09],
                                            [-0.03, -0.17],
                                            [0, 0],
                                            [-0.01, -0.06],
                                            [-0.04, -0.15],
                                            [-0.01, -0.04],
                                            [-0.01, -0.04],
                                            [-0.09, -0.21],
                                            [0, 0],
                                            [-0.12, -0.23],
                                            [-0.02, -0.04],
                                            [0, 0],
                                            [-0.09, -0.14],
                                            [0, 0],
                                            [-0.04, -0.05],
                                            [-0.12, -0.14],
                                            [-0.02, -0.02],
                                            [0, 0],
                                            [-0.17, -0.16],
                                            [-0.04, -0.03],
                                            [0, 0],
                                            [-0.1, -0.08],
                                            [-0.08, -0.06],
                                            [-0.1, -0.07],
                                            [0, 0],
                                            [-0.06, -0.04],
                                            [-0.18, -0.09],
                                            [-0.08, -0.04],
                                            [-0.15, -0.06],
                                            [-0.07, -0.03],
                                            [-0.15, -0.04],
                                            [0, 0],
                                            [-0.05, -0.01],
                                            [-0.19, -0.04],
                                            [-0.04, -0.01],
                                            [0, 0],
                                            [-0.17, -0.02],
                                            [-0.02, 0],
                                            [0, 0],
                                            [-0.23, 0],
                                            [-0.05, 0],
                                            [-0.2, 0.02],
                                            [0, 0],
                                            [-0.2, 0.04],
                                            [0, 0],
                                            [-0.22, 0.07],
                                            [-0.04, 0.01],
                                            [0, 0],
                                            [-0.19, 0.08],
                                            [0, 0],
                                            [-0.28, 0.16],
                                            [-0.04, 0.03],
                                            [0, 0],
                                            [-0.15, 0.11],
                                            [-0.08, 0.06],
                                            [-0.15, 0.14],
                                            [0, 0],
                                            [-0.04, 0.04],
                                            [-0.15, 0.19],
                                            [-0.02, 0.02],
                                            [-0.16, 0.25],
                                            [-0.01, 0.02],
                                            [-0.02, 0.03],
                                            [-0.09, 0.19],
                                            [-0.03, 0.07],
                                            [-0.07, 0.21],
                                            [0, 0],
                                            [-0.01, 0.04],
                                            [-0.06, 0.38],
                                            [-0.01, 0.12],
                                            [-0.01, 0.1],
                                            [0, 0.15],
                                            [0, 0],
                                            [0, 0.05],
                                            [0.02, 0.21],
                                            [0, 0],
                                            [0, 0.03],
                                            [0.04, 0.19],
                                            [0.01, 0.05],
                                            [0, 0],
                                            [0.05, 0.16],
                                            [0, 0],
                                            [0.01, 0.04],
                                            [0.08, 0.19],
                                            [0, 0],
                                            [0.13, 0.23],
                                            [0.02, 0.03],
                                            [0.02, 0.03],
                                            [0.08, 0.12],
                                            [0.04, 0.05],
                                            [0, 0],
                                            [0.08, 0.1],
                                            [0.06, 0.07],
                                            [0.1, 0.1],
                                            [0.06, 0.06],
                                            [0.13, 0.11],
                                            [0, 0],
                                            [0.05, 0.04],
                                            [0.12, 0.08],
                                            [0, 0],
                                            [0.04, 0.03],
                                            [0.1, 0.05],
                                            [0, 0],
                                            [0.31, 0.12],
                                            [0.02, 0.01],
                                            [0.04, 0.01],
                                            [0.17, 0.04],
                                            [0.05, 0.01],
                                            [0, 0],
                                            [0.15, 0.02],
                                            [0.09, 0.01],
                                            [0, 0],
                                            [0.16, 0.01],
                                            [0.1, 0],
                                            [0.04, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [-0.12, 0],
                                            [0, 0],
                                            [-0.08, 0.01],
                                            [-0.17, 0.02],
                                            [0, 0],
                                            [-0.06, 0.01],
                                            [-0.18, 0.04],
                                            [-0.04, 0.01],
                                            [-0.04, 0.01],
                                            [-0.28, 0.09],
                                            [0, 0],
                                            [-0.24, 0.1],
                                            [-0.04, 0.02],
                                            [-0.04, 0.02],
                                            [-0.16, 0.1],
                                            [-0.05, 0.04],
                                            [0, 0],
                                            [-0.12, 0.09],
                                            [-0.07, 0.06],
                                            [0, 0],
                                            [-0.13, 0.13],
                                            [-0.06, 0.07],
                                            [-0.1, 0.13],
                                            [0, 0],
                                            [-0.05, 0.06],
                                            [-0.09, 0.14],
                                            [0, 0],
                                            [-0.02, 0.04],
                                            [-0.09, 0.16],
                                            [-0.01, 0.03],
                                            [-0.01, 0.01],
                                            [-0.12, 0.31],
                                            [0, 0],
                                            [-0.03, 0.13],
                                            [-0.01, 0.05],
                                            [0, 0],
                                            [-0.02, 0.13],
                                            [-0.01, 0.07],
                                            [0, 0],
                                            [-0.01, 0.16],
                                            [0, 0.09],
                                            [0, 0.14],
                                            [0.01, 0.09],
                                            [0.02, 0.12],
                                            [0, 0],
                                            [0.01, 0.06],
                                            [0.04, 0.16],
                                            [0.01, 0.04],
                                            [0.01, 0.04],
                                            [0.08, 0.25],
                                            [0, 0],
                                            [0.08, 0.19],
                                            [0.02, 0.04],
                                            [0, 0],
                                            [0.08, 0.14],
                                            [0, 0],
                                            [0.04, 0.05],
                                            [0.11, 0.15],
                                            [0.02, 0.03],
                                            [0, 0],
                                            [0.13, 0.15],
                                            [0.04, 0.03],
                                            [0, 0],
                                            [0.11, 0.1],
                                            [0.08, 0.06],
                                            [0.09, 0.07],
                                            [0, 0],
                                            [0.06, 0.04],
                                            [0.13, 0.08],
                                            [0.07, 0.04],
                                            [0.16, 0.08],
                                            [0.06, 0.03],
                                            [0.16, 0.06],
                                            [0, 0],
                                            [0.05, 0.02],
                                            [0.18, 0.05],
                                            [0.04, 0.01],
                                            [0, 0],
                                            [0.18, 0.03],
                                            [0.03, 0],
                                            [0, 0],
                                            [0.18, 0.02],
                                            [0.06, 0],
                                            [0.23, 0],
                                            [0, 0],
                                            [0.19, -0.02],
                                            [0, 0],
                                            [0.2, -0.04],
                                            [0.04, -0.01],
                                            [0, 0],
                                            [0.25, -0.08],
                                            [0, 0],
                                            [0.24, -0.11],
                                            [0.04, -0.03],
                                            [0, 0],
                                            [0.19, -0.12],
                                            [0.08, -0.06],
                                            [0.15, -0.12],
                                            [0, 0],
                                            [0.04, -0.04],
                                            [0.18, -0.19],
                                            [0.02, -0.03],
                                            [0.16, -0.21],
                                            [0.01, -0.02],
                                            [0.02, -0.03],
                                            [0.12, -0.2],
                                            [0.03, -0.07],
                                            [0.09, -0.2],
                                            [0, 0],
                                            [0.01, -0.03],
                                            [0.11, -0.36],
                                            [0.02, -0.12],
                                            [0.01, -0.1],
                                            [0.01, -0.13],
                                            [0, 0],
                                            [0, -0.05],
                                            [0, -0.23],
                                            [0, 0],
                                            [0, -0.03],
                                            [-0.02, -0.19],
                                            [-0.01, -0.05],
                                            [0, 0],
                                            [-0.04, -0.16],
                                            [0, 0],
                                            [-0.01, -0.04],
                                            [-0.08, -0.25],
                                            [0, 0],
                                            [-0.09, -0.21],
                                            [-0.02, -0.03],
                                            [-0.02, -0.03],
                                            [-0.1, -0.16],
                                            [-0.03, -0.05],
                                            [0, 0],
                                            [-0.1, -0.14],
                                            [-0.06, -0.07],
                                            [-0.1, -0.11],
                                            [-0.06, -0.06],
                                            [-0.1, -0.09],
                                            [0, 0],
                                            [-0.05, -0.04],
                                            [-0.11, -0.09],
                                            [0, 0],
                                            [-0.04, -0.03],
                                            [-0.09, -0.06],
                                            [0, 0],
                                            [-0.34, -0.19],
                                            [-0.02, -0.01],
                                            [-0.04, -0.01],
                                            [-0.22, -0.08],
                                            [-0.05, -0.01],
                                            [0, 0],
                                            [-0.2, -0.05],
                                            [-0.09, -0.01],
                                            [0, 0],
                                            [-0.17, -0.02],
                                            [-0.1, -0.01],
                                            [-0.04, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [191.1, 1.89],
                                            [190.72, 1.9],
                                            [190.67, 1.9],
                                            [190.42, 1.92],
                                            [189.92, 1.98],
                                            [189.81, 2],
                                            [189.62, 2.03],
                                            [189.09, 2.16],
                                            [188.96, 2.19],
                                            [188.84, 2.23],
                                            [188.07, 2.51],
                                            [6.43, 81.58],
                                            [5.69, 81.95],
                                            [5.59, 82.01],
                                            [5.47, 82.09],
                                            [5.01, 82.39],
                                            [4.87, 82.5],
                                            [4.78, 82.57],
                                            [4.39, 82.89],
                                            [4.2, 83.08],
                                            [4.18, 83.1],
                                            [3.83, 83.46],
                                            [3.64, 83.68],
                                            [3.33, 84.08],
                                            [3.31, 84.11],
                                            [3.18, 84.3],
                                            [2.89, 84.76],
                                            [2.84, 84.85],
                                            [2.77, 84.97],
                                            [2.51, 85.53],
                                            [2.46, 85.62],
                                            [2.45, 85.67],
                                            [2.13, 86.67],
                                            [2.11, 86.71],
                                            [2.03, 87.07],
                                            [2, 87.23],
                                            [1.99, 87.34],
                                            [1.93, 87.76],
                                            [1.91, 87.97],
                                            [1.91, 88.03],
                                            [1.89, 88.46],
                                            [1.9, 88.73],
                                            [1.92, 89.16],
                                            [1.95, 89.44],
                                            [2.02, 89.88],
                                            [2.04, 89.96],
                                            [2.07, 90.14],
                                            [2.2, 90.61],
                                            [2.23, 90.73],
                                            [2.26, 90.83],
                                            [2.52, 91.52],
                                            [103.8, 324.33],
                                            [104.11, 324.96],
                                            [104.18, 325.08],
                                            [104.21, 325.14],
                                            [104.48, 325.56],
                                            [104.49, 325.58],
                                            [104.6, 325.74],
                                            [104.95, 326.18],
                                            [105, 326.25],
                                            [105.02, 326.27],
                                            [105.46, 326.74],
                                            [105.57, 326.84],
                                            [105.64, 326.9],
                                            [105.95, 327.17],
                                            [106.18, 327.35],
                                            [106.47, 327.55],
                                            [106.55, 327.61],
                                            [106.73, 327.73],
                                            [107.19, 327.99],
                                            [107.41, 328.1],
                                            [107.87, 328.31],
                                            [108.07, 328.38],
                                            [108.52, 328.54],
                                            [108.57, 328.55],
                                            [108.72, 328.6],
                                            [109.28, 328.73],
                                            [109.4, 328.75],
                                            [109.46, 328.76],
                                            [109.99, 328.83],
                                            [110.06, 328.84],
                                            [110.1, 328.85],
                                            [110.71, 328.87],
                                            [110.88, 328.87],
                                            [111.51, 328.83],
                                            [111.61, 328.82],
                                            [112.2, 328.72],
                                            [112.31, 328.7],
                                            [112.95, 328.53],
                                            [113.06, 328.5],
                                            [113.08, 328.49],
                                            [113.73, 328.24],
                                            [295.37, 249.18],
                                            [296.16, 248.78],
                                            [296.29, 248.69],
                                            [296.38, 248.63],
                                            [296.88, 248.3],
                                            [297.11, 248.12],
                                            [297.55, 247.73],
                                            [297.62, 247.66],
                                            [297.74, 247.55],
                                            [298.24, 246.98],
                                            [298.3, 246.92],
                                            [298.77, 246.23],
                                            [298.8, 246.17],
                                            [298.86, 246.08],
                                            [299.17, 245.49],
                                            [299.26, 245.29],
                                            [299.5, 244.68],
                                            [299.52, 244.6],
                                            [299.56, 244.5],
                                            [299.82, 243.39],
                                            [299.86, 243.04],
                                            [299.89, 242.75],
                                            [299.9, 242.34],
                                            [299.9, 242.25],
                                            [299.91, 242.11],
                                            [299.87, 241.46],
                                            [299.87, 241.44],
                                            [299.85, 241.35],
                                            [299.76, 240.79],
                                            [299.73, 240.62],
                                            [299.72, 240.58],
                                            [299.59, 240.1],
                                            [299.57, 240.03],
                                            [299.53, 239.9],
                                            [299.28, 239.24],
                                            [198, 6.43],
                                            [197.68, 5.77],
                                            [197.62, 5.68],
                                            [197.56, 5.58],
                                            [197.3, 5.16],
                                            [197.19, 5.02],
                                            [197.14, 4.95],
                                            [196.86, 4.59],
                                            [196.69, 4.39],
                                            [196.38, 4.07],
                                            [196.19, 3.89],
                                            [195.86, 3.6],
                                            [195.82, 3.57],
                                            [195.66, 3.44],
                                            [195.3, 3.19],
                                            [195.21, 3.12],
                                            [195.08, 3.04],
                                            [194.8, 2.88],
                                            [194.74, 2.85],
                                            [193.77, 2.39],
                                            [193.71, 2.37],
                                            [193.6, 2.33],
                                            [193.04, 2.15],
                                            [192.89, 2.12],
                                            [192.79, 2.09],
                                            [192.28, 1.99],
                                            [192.02, 1.96],
                                            [192, 1.95],
                                            [191.51, 1.91],
                                            [191.21, 1.9],
                                            [191.1, 1.9],
                                            [191.1, 1.89]
                                        ]
                                    }
                                ],
                                "t": 60
                            },
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0.14, -0.01],
                                            [0, 0],
                                            [0.08, -0.01],
                                            [0.16, -0.02],
                                            [0, 0],
                                            [0.06, -0.01],
                                            [0.16, -0.04],
                                            [0.04, -0.01],
                                            [0.04, -0.01],
                                            [0.24, -0.1],
                                            [0, 0],
                                            [0.25, -0.14],
                                            [0.04, -0.02],
                                            [0.04, -0.02],
                                            [0.15, -0.11],
                                            [0.05, -0.04],
                                            [0, 0],
                                            [0.13, -0.12],
                                            [0.06, -0.06],
                                            [0, 0],
                                            [0.1, -0.12],
                                            [0.06, -0.07],
                                            [0.1, -0.15],
                                            [0, 0],
                                            [0.04, -0.06],
                                            [0.1, -0.18],
                                            [0, 0],
                                            [0.02, -0.04],
                                            [0.09, -0.21],
                                            [0.02, -0.03],
                                            [0, -0.01],
                                            [0.09, -0.37],
                                            [0, 0],
                                            [0.02, -0.11],
                                            [0.01, -0.05],
                                            [0, 0],
                                            [0.02, -0.14],
                                            [0, -0.07],
                                            [0, 0],
                                            [0, -0.12],
                                            [0, -0.09],
                                            [-0.01, -0.14],
                                            [-0.01, -0.09],
                                            [-0.03, -0.17],
                                            [0, 0],
                                            [-0.01, -0.06],
                                            [-0.04, -0.15],
                                            [-0.01, -0.04],
                                            [-0.01, -0.04],
                                            [-0.09, -0.21],
                                            [0, 0],
                                            [-0.12, -0.23],
                                            [-0.02, -0.04],
                                            [0, 0],
                                            [-0.09, -0.14],
                                            [0, 0],
                                            [-0.04, -0.05],
                                            [-0.12, -0.14],
                                            [-0.02, -0.02],
                                            [0, 0],
                                            [-0.17, -0.16],
                                            [-0.04, -0.03],
                                            [0, 0],
                                            [-0.1, -0.08],
                                            [-0.08, -0.06],
                                            [-0.1, -0.07],
                                            [0, 0],
                                            [-0.06, -0.04],
                                            [-0.18, -0.09],
                                            [-0.08, -0.04],
                                            [-0.15, -0.06],
                                            [-0.07, -0.03],
                                            [-0.15, -0.04],
                                            [0, 0],
                                            [-0.05, -0.01],
                                            [-0.19, -0.04],
                                            [-0.04, -0.01],
                                            [0, 0],
                                            [-0.17, -0.02],
                                            [-0.02, 0],
                                            [0, 0],
                                            [-0.23, 0],
                                            [-0.05, 0],
                                            [-0.2, 0.02],
                                            [0, 0],
                                            [-0.2, 0.04],
                                            [0, 0],
                                            [-0.22, 0.07],
                                            [-0.04, 0.01],
                                            [0, 0],
                                            [-0.19, 0.08],
                                            [0, 0],
                                            [-0.28, 0.16],
                                            [-0.04, 0.03],
                                            [0, 0],
                                            [-0.15, 0.11],
                                            [-0.08, 0.06],
                                            [-0.15, 0.14],
                                            [0, 0],
                                            [-0.04, 0.04],
                                            [-0.15, 0.19],
                                            [-0.02, 0.02],
                                            [-0.16, 0.25],
                                            [-0.01, 0.02],
                                            [-0.02, 0.03],
                                            [-0.09, 0.19],
                                            [-0.03, 0.07],
                                            [-0.07, 0.21],
                                            [0, 0],
                                            [-0.01, 0.04],
                                            [-0.06, 0.38],
                                            [-0.01, 0.12],
                                            [-0.01, 0.1],
                                            [0, 0.15],
                                            [0, 0],
                                            [0, 0.05],
                                            [0.02, 0.21],
                                            [0, 0],
                                            [0, 0.03],
                                            [0.04, 0.19],
                                            [0.01, 0.05],
                                            [0, 0],
                                            [0.05, 0.16],
                                            [0, 0],
                                            [0.01, 0.04],
                                            [0.08, 0.19],
                                            [0, 0],
                                            [0.13, 0.23],
                                            [0.02, 0.03],
                                            [0.02, 0.03],
                                            [0.08, 0.12],
                                            [0.04, 0.05],
                                            [0, 0],
                                            [0.08, 0.1],
                                            [0.06, 0.07],
                                            [0.1, 0.1],
                                            [0.06, 0.06],
                                            [0.13, 0.11],
                                            [0, 0],
                                            [0.05, 0.04],
                                            [0.12, 0.08],
                                            [0, 0],
                                            [0.04, 0.03],
                                            [0.1, 0.05],
                                            [0, 0],
                                            [0.31, 0.12],
                                            [0.02, 0.01],
                                            [0.04, 0.01],
                                            [0.17, 0.04],
                                            [0.05, 0.01],
                                            [0, 0],
                                            [0.15, 0.02],
                                            [0.09, 0.01],
                                            [0, 0],
                                            [0.16, 0.01],
                                            [0.1, 0],
                                            [0.04, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [-0.12, 0],
                                            [0, 0],
                                            [-0.08, 0.01],
                                            [-0.17, 0.02],
                                            [0, 0],
                                            [-0.06, 0.01],
                                            [-0.18, 0.04],
                                            [-0.04, 0.01],
                                            [-0.04, 0.01],
                                            [-0.28, 0.09],
                                            [0, 0],
                                            [-0.24, 0.1],
                                            [-0.04, 0.02],
                                            [-0.04, 0.02],
                                            [-0.16, 0.1],
                                            [-0.05, 0.04],
                                            [0, 0],
                                            [-0.12, 0.09],
                                            [-0.07, 0.06],
                                            [0, 0],
                                            [-0.13, 0.13],
                                            [-0.06, 0.07],
                                            [-0.1, 0.13],
                                            [0, 0],
                                            [-0.05, 0.06],
                                            [-0.09, 0.14],
                                            [0, 0],
                                            [-0.02, 0.04],
                                            [-0.09, 0.16],
                                            [-0.01, 0.03],
                                            [-0.01, 0.01],
                                            [-0.12, 0.31],
                                            [0, 0],
                                            [-0.03, 0.13],
                                            [-0.01, 0.05],
                                            [0, 0],
                                            [-0.02, 0.13],
                                            [-0.01, 0.07],
                                            [0, 0],
                                            [-0.01, 0.16],
                                            [0, 0.09],
                                            [0, 0.14],
                                            [0.01, 0.09],
                                            [0.02, 0.12],
                                            [0, 0],
                                            [0.01, 0.06],
                                            [0.04, 0.16],
                                            [0.01, 0.04],
                                            [0.01, 0.04],
                                            [0.08, 0.25],
                                            [0, 0],
                                            [0.08, 0.19],
                                            [0.02, 0.04],
                                            [0, 0],
                                            [0.08, 0.14],
                                            [0, 0],
                                            [0.04, 0.05],
                                            [0.11, 0.15],
                                            [0.02, 0.03],
                                            [0, 0],
                                            [0.13, 0.15],
                                            [0.04, 0.03],
                                            [0, 0],
                                            [0.11, 0.1],
                                            [0.08, 0.06],
                                            [0.09, 0.07],
                                            [0, 0],
                                            [0.06, 0.04],
                                            [0.13, 0.08],
                                            [0.07, 0.04],
                                            [0.16, 0.08],
                                            [0.06, 0.03],
                                            [0.16, 0.06],
                                            [0, 0],
                                            [0.05, 0.02],
                                            [0.18, 0.05],
                                            [0.04, 0.01],
                                            [0, 0],
                                            [0.18, 0.03],
                                            [0.03, 0],
                                            [0, 0],
                                            [0.18, 0.02],
                                            [0.06, 0],
                                            [0.23, 0],
                                            [0, 0],
                                            [0.19, -0.02],
                                            [0, 0],
                                            [0.2, -0.04],
                                            [0.04, -0.01],
                                            [0, 0],
                                            [0.25, -0.08],
                                            [0, 0],
                                            [0.24, -0.11],
                                            [0.04, -0.03],
                                            [0, 0],
                                            [0.19, -0.12],
                                            [0.08, -0.06],
                                            [0.15, -0.12],
                                            [0, 0],
                                            [0.04, -0.04],
                                            [0.18, -0.19],
                                            [0.02, -0.03],
                                            [0.16, -0.21],
                                            [0.01, -0.02],
                                            [0.02, -0.03],
                                            [0.12, -0.2],
                                            [0.03, -0.07],
                                            [0.09, -0.2],
                                            [0, 0],
                                            [0.01, -0.03],
                                            [0.11, -0.36],
                                            [0.02, -0.12],
                                            [0.01, -0.1],
                                            [0.01, -0.13],
                                            [0, 0],
                                            [0, -0.05],
                                            [0, -0.23],
                                            [0, 0],
                                            [0, -0.03],
                                            [-0.02, -0.19],
                                            [-0.01, -0.05],
                                            [0, 0],
                                            [-0.04, -0.16],
                                            [0, 0],
                                            [-0.01, -0.04],
                                            [-0.08, -0.25],
                                            [0, 0],
                                            [-0.09, -0.21],
                                            [-0.02, -0.03],
                                            [-0.02, -0.03],
                                            [-0.1, -0.16],
                                            [-0.03, -0.05],
                                            [0, 0],
                                            [-0.1, -0.14],
                                            [-0.06, -0.07],
                                            [-0.1, -0.11],
                                            [-0.06, -0.06],
                                            [-0.1, -0.09],
                                            [0, 0],
                                            [-0.05, -0.04],
                                            [-0.11, -0.09],
                                            [0, 0],
                                            [-0.04, -0.03],
                                            [-0.09, -0.06],
                                            [0, 0],
                                            [-0.34, -0.19],
                                            [-0.02, -0.01],
                                            [-0.04, -0.01],
                                            [-0.22, -0.08],
                                            [-0.05, -0.01],
                                            [0, 0],
                                            [-0.2, -0.05],
                                            [-0.09, -0.01],
                                            [0, 0],
                                            [-0.17, -0.02],
                                            [-0.1, -0.01],
                                            [-0.04, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [191.1, 1.89],
                                            [190.72, 1.9],
                                            [190.67, 1.9],
                                            [190.42, 1.92],
                                            [189.92, 1.98],
                                            [189.81, 2],
                                            [189.62, 2.03],
                                            [189.09, 2.16],
                                            [188.96, 2.19],
                                            [188.84, 2.23],
                                            [188.07, 2.51],
                                            [6.43, 81.58],
                                            [5.69, 81.95],
                                            [5.59, 82.01],
                                            [5.47, 82.09],
                                            [5.01, 82.39],
                                            [4.87, 82.5],
                                            [4.78, 82.57],
                                            [4.39, 82.89],
                                            [4.2, 83.08],
                                            [4.18, 83.1],
                                            [3.83, 83.46],
                                            [3.64, 83.68],
                                            [3.33, 84.08],
                                            [3.31, 84.11],
                                            [3.18, 84.3],
                                            [2.89, 84.76],
                                            [2.84, 84.85],
                                            [2.77, 84.97],
                                            [2.51, 85.53],
                                            [2.46, 85.62],
                                            [2.45, 85.67],
                                            [2.13, 86.67],
                                            [2.11, 86.71],
                                            [2.03, 87.07],
                                            [2, 87.23],
                                            [1.99, 87.34],
                                            [1.93, 87.76],
                                            [1.91, 87.97],
                                            [1.91, 88.03],
                                            [1.89, 88.46],
                                            [1.9, 88.73],
                                            [1.92, 89.16],
                                            [1.95, 89.44],
                                            [2.02, 89.88],
                                            [2.04, 89.96],
                                            [2.07, 90.14],
                                            [2.2, 90.61],
                                            [2.23, 90.73],
                                            [2.26, 90.83],
                                            [2.52, 91.52],
                                            [103.8, 324.33],
                                            [104.11, 324.96],
                                            [104.18, 325.08],
                                            [104.21, 325.14],
                                            [104.48, 325.56],
                                            [104.49, 325.58],
                                            [104.6, 325.74],
                                            [104.95, 326.18],
                                            [105, 326.25],
                                            [105.02, 326.27],
                                            [105.46, 326.74],
                                            [105.57, 326.84],
                                            [105.64, 326.9],
                                            [105.95, 327.17],
                                            [106.18, 327.35],
                                            [106.47, 327.55],
                                            [106.55, 327.61],
                                            [106.73, 327.73],
                                            [107.19, 327.99],
                                            [107.41, 328.1],
                                            [107.87, 328.31],
                                            [108.07, 328.38],
                                            [108.52, 328.54],
                                            [108.57, 328.55],
                                            [108.72, 328.6],
                                            [109.28, 328.73],
                                            [109.4, 328.75],
                                            [109.46, 328.76],
                                            [109.99, 328.83],
                                            [110.06, 328.84],
                                            [110.1, 328.85],
                                            [110.71, 328.87],
                                            [110.88, 328.87],
                                            [111.51, 328.83],
                                            [111.61, 328.82],
                                            [112.2, 328.72],
                                            [112.31, 328.7],
                                            [112.95, 328.53],
                                            [113.06, 328.5],
                                            [113.08, 328.49],
                                            [113.73, 328.24],
                                            [295.37, 249.18],
                                            [296.16, 248.78],
                                            [296.29, 248.69],
                                            [296.38, 248.63],
                                            [296.88, 248.3],
                                            [297.11, 248.12],
                                            [297.55, 247.73],
                                            [297.62, 247.66],
                                            [297.74, 247.55],
                                            [298.24, 246.98],
                                            [298.3, 246.92],
                                            [298.77, 246.23],
                                            [298.8, 246.17],
                                            [298.86, 246.08],
                                            [299.17, 245.49],
                                            [299.26, 245.29],
                                            [299.5, 244.68],
                                            [299.52, 244.6],
                                            [299.56, 244.5],
                                            [299.82, 243.39],
                                            [299.86, 243.04],
                                            [299.89, 242.75],
                                            [299.9, 242.34],
                                            [299.9, 242.25],
                                            [299.91, 242.11],
                                            [299.87, 241.46],
                                            [299.87, 241.44],
                                            [299.85, 241.35],
                                            [299.76, 240.79],
                                            [299.73, 240.62],
                                            [299.72, 240.58],
                                            [299.59, 240.1],
                                            [299.57, 240.03],
                                            [299.53, 239.9],
                                            [299.28, 239.24],
                                            [198, 6.43],
                                            [197.68, 5.77],
                                            [197.62, 5.68],
                                            [197.56, 5.58],
                                            [197.3, 5.16],
                                            [197.19, 5.02],
                                            [197.14, 4.95],
                                            [196.86, 4.59],
                                            [196.69, 4.39],
                                            [196.38, 4.07],
                                            [196.19, 3.89],
                                            [195.86, 3.6],
                                            [195.82, 3.57],
                                            [195.66, 3.44],
                                            [195.3, 3.19],
                                            [195.21, 3.12],
                                            [195.08, 3.04],
                                            [194.8, 2.88],
                                            [194.74, 2.85],
                                            [193.77, 2.39],
                                            [193.71, 2.37],
                                            [193.6, 2.33],
                                            [193.04, 2.15],
                                            [192.89, 2.12],
                                            [192.79, 2.09],
                                            [192.28, 1.99],
                                            [192.02, 1.96],
                                            [192, 1.95],
                                            [191.51, 1.91],
                                            [191.21, 1.9],
                                            [191.1, 1.9],
                                            [191.1, 1.89]
                                        ]
                                    }
                                ],
                                "t": 120
                            },
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0.14, -0.01],
                                            [0, 0],
                                            [0.08, -0.01],
                                            [0.16, -0.02],
                                            [0, 0],
                                            [0.06, -0.01],
                                            [0.16, -0.04],
                                            [0.04, -0.01],
                                            [0.04, -0.01],
                                            [0.24, -0.1],
                                            [0, 0],
                                            [0.25, -0.14],
                                            [0.04, -0.02],
                                            [0.04, -0.02],
                                            [0.15, -0.11],
                                            [0.05, -0.04],
                                            [0, 0],
                                            [0.13, -0.12],
                                            [0.06, -0.06],
                                            [0, 0],
                                            [0.1, -0.12],
                                            [0.06, -0.07],
                                            [0.1, -0.15],
                                            [0, 0],
                                            [0.04, -0.06],
                                            [0.1, -0.18],
                                            [0, 0],
                                            [0.02, -0.04],
                                            [0.09, -0.21],
                                            [0.02, -0.03],
                                            [0, -0.01],
                                            [0.09, -0.37],
                                            [0, 0],
                                            [0.02, -0.11],
                                            [0.01, -0.05],
                                            [0, 0],
                                            [0.02, -0.14],
                                            [0, -0.07],
                                            [0, 0],
                                            [0, -0.12],
                                            [0, -0.09],
                                            [-0.01, -0.14],
                                            [-0.01, -0.09],
                                            [-0.03, -0.17],
                                            [0, 0],
                                            [-0.01, -0.06],
                                            [-0.04, -0.15],
                                            [-0.01, -0.04],
                                            [-0.01, -0.04],
                                            [-0.09, -0.21],
                                            [0, 0],
                                            [-0.12, -0.23],
                                            [-0.02, -0.04],
                                            [0, 0],
                                            [-0.09, -0.14],
                                            [0, 0],
                                            [-0.04, -0.05],
                                            [-0.12, -0.14],
                                            [-0.02, -0.02],
                                            [0, 0],
                                            [-0.17, -0.16],
                                            [-0.04, -0.03],
                                            [0, 0],
                                            [-0.1, -0.08],
                                            [-0.08, -0.06],
                                            [-0.1, -0.07],
                                            [0, 0],
                                            [-0.06, -0.04],
                                            [-0.18, -0.09],
                                            [-0.08, -0.04],
                                            [-0.15, -0.06],
                                            [-0.07, -0.03],
                                            [-0.15, -0.04],
                                            [0, 0],
                                            [-0.05, -0.01],
                                            [-0.19, -0.04],
                                            [-0.04, -0.01],
                                            [0, 0],
                                            [-0.17, -0.02],
                                            [-0.02, 0],
                                            [0, 0],
                                            [-0.23, 0],
                                            [-0.05, 0],
                                            [-0.2, 0.02],
                                            [0, 0],
                                            [-0.2, 0.04],
                                            [0, 0],
                                            [-0.22, 0.07],
                                            [-0.04, 0.01],
                                            [0, 0],
                                            [-0.19, 0.08],
                                            [0, 0],
                                            [-0.28, 0.16],
                                            [-0.04, 0.03],
                                            [0, 0],
                                            [-0.15, 0.11],
                                            [-0.08, 0.06],
                                            [-0.15, 0.14],
                                            [0, 0],
                                            [-0.04, 0.04],
                                            [-0.15, 0.19],
                                            [-0.02, 0.02],
                                            [-0.16, 0.25],
                                            [-0.01, 0.02],
                                            [-0.02, 0.03],
                                            [-0.09, 0.19],
                                            [-0.03, 0.07],
                                            [-0.07, 0.21],
                                            [0, 0],
                                            [-0.01, 0.04],
                                            [-0.06, 0.38],
                                            [-0.01, 0.12],
                                            [-0.01, 0.1],
                                            [0, 0.15],
                                            [0, 0],
                                            [0, 0.05],
                                            [0.02, 0.21],
                                            [0, 0],
                                            [0, 0.03],
                                            [0.04, 0.19],
                                            [0.01, 0.05],
                                            [0, 0],
                                            [0.05, 0.16],
                                            [0, 0],
                                            [0.01, 0.04],
                                            [0.08, 0.19],
                                            [0, 0],
                                            [0.13, 0.23],
                                            [0.02, 0.03],
                                            [0.02, 0.03],
                                            [0.08, 0.12],
                                            [0.04, 0.05],
                                            [0, 0],
                                            [0.08, 0.1],
                                            [0.06, 0.07],
                                            [0.1, 0.1],
                                            [0.06, 0.06],
                                            [0.13, 0.11],
                                            [0, 0],
                                            [0.05, 0.04],
                                            [0.12, 0.08],
                                            [0, 0],
                                            [0.04, 0.03],
                                            [0.1, 0.05],
                                            [0, 0],
                                            [0.31, 0.12],
                                            [0.02, 0.01],
                                            [0.04, 0.01],
                                            [0.17, 0.04],
                                            [0.05, 0.01],
                                            [0, 0],
                                            [0.15, 0.02],
                                            [0.09, 0.01],
                                            [0, 0],
                                            [0.16, 0.01],
                                            [0.1, 0],
                                            [0.04, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [-0.12, 0],
                                            [0, 0],
                                            [-0.08, 0.01],
                                            [-0.17, 0.02],
                                            [0, 0],
                                            [-0.06, 0.01],
                                            [-0.18, 0.04],
                                            [-0.04, 0.01],
                                            [-0.04, 0.01],
                                            [-0.28, 0.09],
                                            [0, 0],
                                            [-0.24, 0.1],
                                            [-0.04, 0.02],
                                            [-0.04, 0.02],
                                            [-0.16, 0.1],
                                            [-0.05, 0.04],
                                            [0, 0],
                                            [-0.12, 0.09],
                                            [-0.07, 0.06],
                                            [0, 0],
                                            [-0.13, 0.13],
                                            [-0.06, 0.07],
                                            [-0.1, 0.13],
                                            [0, 0],
                                            [-0.05, 0.06],
                                            [-0.09, 0.14],
                                            [0, 0],
                                            [-0.02, 0.04],
                                            [-0.09, 0.16],
                                            [-0.01, 0.03],
                                            [-0.01, 0.01],
                                            [-0.12, 0.31],
                                            [0, 0],
                                            [-0.03, 0.13],
                                            [-0.01, 0.05],
                                            [0, 0],
                                            [-0.02, 0.13],
                                            [-0.01, 0.07],
                                            [0, 0],
                                            [-0.01, 0.16],
                                            [0, 0.09],
                                            [0, 0.14],
                                            [0.01, 0.09],
                                            [0.02, 0.12],
                                            [0, 0],
                                            [0.01, 0.06],
                                            [0.04, 0.16],
                                            [0.01, 0.04],
                                            [0.01, 0.04],
                                            [0.08, 0.25],
                                            [0, 0],
                                            [0.08, 0.19],
                                            [0.02, 0.04],
                                            [0, 0],
                                            [0.08, 0.14],
                                            [0, 0],
                                            [0.04, 0.05],
                                            [0.11, 0.15],
                                            [0.02, 0.03],
                                            [0, 0],
                                            [0.13, 0.15],
                                            [0.04, 0.03],
                                            [0, 0],
                                            [0.11, 0.1],
                                            [0.08, 0.06],
                                            [0.09, 0.07],
                                            [0, 0],
                                            [0.06, 0.04],
                                            [0.13, 0.08],
                                            [0.07, 0.04],
                                            [0.16, 0.08],
                                            [0.06, 0.03],
                                            [0.16, 0.06],
                                            [0, 0],
                                            [0.05, 0.02],
                                            [0.18, 0.05],
                                            [0.04, 0.01],
                                            [0, 0],
                                            [0.18, 0.03],
                                            [0.03, 0],
                                            [0, 0],
                                            [0.18, 0.02],
                                            [0.06, 0],
                                            [0.23, 0],
                                            [0, 0],
                                            [0.19, -0.02],
                                            [0, 0],
                                            [0.2, -0.04],
                                            [0.04, -0.01],
                                            [0, 0],
                                            [0.25, -0.08],
                                            [0, 0],
                                            [0.24, -0.11],
                                            [0.04, -0.03],
                                            [0, 0],
                                            [0.19, -0.12],
                                            [0.08, -0.06],
                                            [0.15, -0.12],
                                            [0, 0],
                                            [0.04, -0.04],
                                            [0.18, -0.19],
                                            [0.02, -0.03],
                                            [0.16, -0.21],
                                            [0.01, -0.02],
                                            [0.02, -0.03],
                                            [0.12, -0.2],
                                            [0.03, -0.07],
                                            [0.09, -0.2],
                                            [0, 0],
                                            [0.01, -0.03],
                                            [0.11, -0.36],
                                            [0.02, -0.12],
                                            [0.01, -0.1],
                                            [0.01, -0.13],
                                            [0, 0],
                                            [0, -0.05],
                                            [0, -0.23],
                                            [0, 0],
                                            [0, -0.03],
                                            [-0.02, -0.19],
                                            [-0.01, -0.05],
                                            [0, 0],
                                            [-0.04, -0.16],
                                            [0, 0],
                                            [-0.01, -0.04],
                                            [-0.08, -0.25],
                                            [0, 0],
                                            [-0.09, -0.21],
                                            [-0.02, -0.03],
                                            [-0.02, -0.03],
                                            [-0.1, -0.16],
                                            [-0.03, -0.05],
                                            [0, 0],
                                            [-0.1, -0.14],
                                            [-0.06, -0.07],
                                            [-0.1, -0.11],
                                            [-0.06, -0.06],
                                            [-0.1, -0.09],
                                            [0, 0],
                                            [-0.05, -0.04],
                                            [-0.11, -0.09],
                                            [0, 0],
                                            [-0.04, -0.03],
                                            [-0.09, -0.06],
                                            [0, 0],
                                            [-0.34, -0.19],
                                            [-0.02, -0.01],
                                            [-0.04, -0.01],
                                            [-0.22, -0.08],
                                            [-0.05, -0.01],
                                            [0, 0],
                                            [-0.2, -0.05],
                                            [-0.09, -0.01],
                                            [0, 0],
                                            [-0.17, -0.02],
                                            [-0.1, -0.01],
                                            [-0.04, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [191.1, 1.89],
                                            [190.72, 1.9],
                                            [190.67, 1.9],
                                            [190.42, 1.92],
                                            [189.92, 1.98],
                                            [189.81, 2],
                                            [189.62, 2.03],
                                            [189.09, 2.16],
                                            [188.96, 2.19],
                                            [188.84, 2.23],
                                            [188.07, 2.51],
                                            [6.43, 81.58],
                                            [5.69, 81.95],
                                            [5.59, 82.01],
                                            [5.47, 82.09],
                                            [5.01, 82.39],
                                            [4.87, 82.5],
                                            [4.78, 82.57],
                                            [4.39, 82.89],
                                            [4.2, 83.08],
                                            [4.18, 83.1],
                                            [3.83, 83.46],
                                            [3.64, 83.68],
                                            [3.33, 84.08],
                                            [3.31, 84.11],
                                            [3.18, 84.3],
                                            [2.89, 84.76],
                                            [2.84, 84.85],
                                            [2.77, 84.97],
                                            [2.51, 85.53],
                                            [2.46, 85.62],
                                            [2.45, 85.67],
                                            [2.13, 86.67],
                                            [2.11, 86.71],
                                            [2.03, 87.07],
                                            [2, 87.23],
                                            [1.99, 87.34],
                                            [1.93, 87.76],
                                            [1.91, 87.97],
                                            [1.91, 88.03],
                                            [1.89, 88.46],
                                            [1.9, 88.73],
                                            [1.92, 89.16],
                                            [1.95, 89.44],
                                            [2.02, 89.88],
                                            [2.04, 89.96],
                                            [2.07, 90.14],
                                            [2.2, 90.61],
                                            [2.23, 90.73],
                                            [2.26, 90.83],
                                            [2.52, 91.52],
                                            [103.8, 324.33],
                                            [104.11, 324.96],
                                            [104.18, 325.08],
                                            [104.21, 325.14],
                                            [104.48, 325.56],
                                            [104.49, 325.58],
                                            [104.6, 325.74],
                                            [104.95, 326.18],
                                            [105, 326.25],
                                            [105.02, 326.27],
                                            [105.46, 326.74],
                                            [105.57, 326.84],
                                            [105.64, 326.9],
                                            [105.95, 327.17],
                                            [106.18, 327.35],
                                            [106.47, 327.55],
                                            [106.55, 327.61],
                                            [106.73, 327.73],
                                            [107.19, 327.99],
                                            [107.41, 328.1],
                                            [107.87, 328.31],
                                            [108.07, 328.38],
                                            [108.52, 328.54],
                                            [108.57, 328.55],
                                            [108.72, 328.6],
                                            [109.28, 328.73],
                                            [109.4, 328.75],
                                            [109.46, 328.76],
                                            [109.99, 328.83],
                                            [110.06, 328.84],
                                            [110.1, 328.85],
                                            [110.71, 328.87],
                                            [110.88, 328.87],
                                            [111.51, 328.83],
                                            [111.61, 328.82],
                                            [112.2, 328.72],
                                            [112.31, 328.7],
                                            [112.95, 328.53],
                                            [113.06, 328.5],
                                            [113.08, 328.49],
                                            [113.73, 328.24],
                                            [295.37, 249.18],
                                            [296.16, 248.78],
                                            [296.29, 248.69],
                                            [296.38, 248.63],
                                            [296.88, 248.3],
                                            [297.11, 248.12],
                                            [297.55, 247.73],
                                            [297.62, 247.66],
                                            [297.74, 247.55],
                                            [298.24, 246.98],
                                            [298.3, 246.92],
                                            [298.77, 246.23],
                                            [298.8, 246.17],
                                            [298.86, 246.08],
                                            [299.17, 245.49],
                                            [299.26, 245.29],
                                            [299.5, 244.68],
                                            [299.52, 244.6],
                                            [299.56, 244.5],
                                            [299.82, 243.39],
                                            [299.86, 243.04],
                                            [299.89, 242.75],
                                            [299.9, 242.34],
                                            [299.9, 242.25],
                                            [299.91, 242.11],
                                            [299.87, 241.46],
                                            [299.87, 241.44],
                                            [299.85, 241.35],
                                            [299.76, 240.79],
                                            [299.73, 240.62],
                                            [299.72, 240.58],
                                            [299.59, 240.1],
                                            [299.57, 240.03],
                                            [299.53, 239.9],
                                            [299.28, 239.24],
                                            [198, 6.43],
                                            [197.68, 5.77],
                                            [197.62, 5.68],
                                            [197.56, 5.58],
                                            [197.3, 5.16],
                                            [197.19, 5.02],
                                            [197.14, 4.95],
                                            [196.86, 4.59],
                                            [196.69, 4.39],
                                            [196.38, 4.07],
                                            [196.19, 3.89],
                                            [195.86, 3.6],
                                            [195.82, 3.57],
                                            [195.66, 3.44],
                                            [195.3, 3.19],
                                            [195.21, 3.12],
                                            [195.08, 3.04],
                                            [194.8, 2.88],
                                            [194.74, 2.85],
                                            [193.77, 2.39],
                                            [193.71, 2.37],
                                            [193.6, 2.33],
                                            [193.04, 2.15],
                                            [192.89, 2.12],
                                            [192.79, 2.09],
                                            [192.28, 1.99],
                                            [192.02, 1.96],
                                            [192, 1.95],
                                            [191.51, 1.91],
                                            [191.21, 1.9],
                                            [191.1, 1.9],
                                            [191.1, 1.89]
                                        ]
                                    }
                                ],
                                "t": 180
                            },
                            {
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0.14, -0.01],
                                            [0, 0],
                                            [0.08, -0.01],
                                            [0.16, -0.02],
                                            [0, 0],
                                            [0.06, -0.01],
                                            [0.16, -0.04],
                                            [0.04, -0.01],
                                            [0.04, -0.01],
                                            [0.24, -0.1],
                                            [0, 0],
                                            [0.25, -0.14],
                                            [0.04, -0.02],
                                            [0.04, -0.02],
                                            [0.15, -0.11],
                                            [0.05, -0.04],
                                            [0, 0],
                                            [0.13, -0.12],
                                            [0.06, -0.06],
                                            [0, 0],
                                            [0.1, -0.12],
                                            [0.06, -0.07],
                                            [0.1, -0.15],
                                            [0, 0],
                                            [0.04, -0.06],
                                            [0.1, -0.18],
                                            [0, 0],
                                            [0.02, -0.04],
                                            [0.09, -0.21],
                                            [0.02, -0.03],
                                            [0, -0.01],
                                            [0.09, -0.37],
                                            [0, 0],
                                            [0.02, -0.11],
                                            [0.01, -0.05],
                                            [0, 0],
                                            [0.02, -0.14],
                                            [0, -0.07],
                                            [0, 0],
                                            [0, -0.12],
                                            [0, -0.09],
                                            [-0.01, -0.14],
                                            [-0.01, -0.09],
                                            [-0.03, -0.17],
                                            [0, 0],
                                            [-0.01, -0.06],
                                            [-0.04, -0.15],
                                            [-0.01, -0.04],
                                            [-0.01, -0.04],
                                            [-0.09, -0.21],
                                            [0, 0],
                                            [-0.12, -0.23],
                                            [-0.02, -0.04],
                                            [0, 0],
                                            [-0.09, -0.14],
                                            [0, 0],
                                            [-0.04, -0.05],
                                            [-0.12, -0.14],
                                            [-0.02, -0.02],
                                            [0, 0],
                                            [-0.17, -0.16],
                                            [-0.04, -0.03],
                                            [0, 0],
                                            [-0.1, -0.08],
                                            [-0.08, -0.06],
                                            [-0.1, -0.07],
                                            [0, 0],
                                            [-0.06, -0.04],
                                            [-0.18, -0.09],
                                            [-0.08, -0.04],
                                            [-0.15, -0.06],
                                            [-0.07, -0.03],
                                            [-0.15, -0.04],
                                            [0, 0],
                                            [-0.05, -0.01],
                                            [-0.19, -0.04],
                                            [-0.04, -0.01],
                                            [0, 0],
                                            [-0.17, -0.02],
                                            [-0.02, 0],
                                            [0, 0],
                                            [-0.23, 0],
                                            [-0.05, 0],
                                            [-0.2, 0.02],
                                            [0, 0],
                                            [-0.2, 0.04],
                                            [0, 0],
                                            [-0.22, 0.07],
                                            [-0.04, 0.01],
                                            [0, 0],
                                            [-0.19, 0.08],
                                            [0, 0],
                                            [-0.28, 0.16],
                                            [-0.04, 0.03],
                                            [0, 0],
                                            [-0.15, 0.11],
                                            [-0.08, 0.06],
                                            [-0.15, 0.14],
                                            [0, 0],
                                            [-0.04, 0.04],
                                            [-0.15, 0.19],
                                            [-0.02, 0.02],
                                            [-0.16, 0.25],
                                            [-0.01, 0.02],
                                            [-0.02, 0.03],
                                            [-0.09, 0.19],
                                            [-0.03, 0.07],
                                            [-0.07, 0.21],
                                            [0, 0],
                                            [-0.01, 0.04],
                                            [-0.06, 0.38],
                                            [-0.01, 0.12],
                                            [-0.01, 0.1],
                                            [0, 0.15],
                                            [0, 0],
                                            [0, 0.05],
                                            [0.02, 0.21],
                                            [0, 0],
                                            [0, 0.03],
                                            [0.04, 0.19],
                                            [0.01, 0.05],
                                            [0, 0],
                                            [0.05, 0.16],
                                            [0, 0],
                                            [0.01, 0.04],
                                            [0.08, 0.19],
                                            [0, 0],
                                            [0.13, 0.23],
                                            [0.02, 0.03],
                                            [0.02, 0.03],
                                            [0.08, 0.12],
                                            [0.04, 0.05],
                                            [0, 0],
                                            [0.08, 0.1],
                                            [0.06, 0.07],
                                            [0.1, 0.1],
                                            [0.06, 0.06],
                                            [0.13, 0.11],
                                            [0, 0],
                                            [0.05, 0.04],
                                            [0.12, 0.08],
                                            [0, 0],
                                            [0.04, 0.03],
                                            [0.1, 0.05],
                                            [0, 0],
                                            [0.31, 0.12],
                                            [0.02, 0.01],
                                            [0.04, 0.01],
                                            [0.17, 0.04],
                                            [0.05, 0.01],
                                            [0, 0],
                                            [0.15, 0.02],
                                            [0.09, 0.01],
                                            [0, 0],
                                            [0.16, 0.01],
                                            [0.1, 0],
                                            [0.04, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [-0.12, 0],
                                            [0, 0],
                                            [-0.08, 0.01],
                                            [-0.17, 0.02],
                                            [0, 0],
                                            [-0.06, 0.01],
                                            [-0.18, 0.04],
                                            [-0.04, 0.01],
                                            [-0.04, 0.01],
                                            [-0.28, 0.09],
                                            [0, 0],
                                            [-0.24, 0.1],
                                            [-0.04, 0.02],
                                            [-0.04, 0.02],
                                            [-0.16, 0.1],
                                            [-0.05, 0.04],
                                            [0, 0],
                                            [-0.12, 0.09],
                                            [-0.07, 0.06],
                                            [0, 0],
                                            [-0.13, 0.13],
                                            [-0.06, 0.07],
                                            [-0.1, 0.13],
                                            [0, 0],
                                            [-0.05, 0.06],
                                            [-0.09, 0.14],
                                            [0, 0],
                                            [-0.02, 0.04],
                                            [-0.09, 0.16],
                                            [-0.01, 0.03],
                                            [-0.01, 0.01],
                                            [-0.12, 0.31],
                                            [0, 0],
                                            [-0.03, 0.13],
                                            [-0.01, 0.05],
                                            [0, 0],
                                            [-0.02, 0.13],
                                            [-0.01, 0.07],
                                            [0, 0],
                                            [-0.01, 0.16],
                                            [0, 0.09],
                                            [0, 0.14],
                                            [0.01, 0.09],
                                            [0.02, 0.12],
                                            [0, 0],
                                            [0.01, 0.06],
                                            [0.04, 0.16],
                                            [0.01, 0.04],
                                            [0.01, 0.04],
                                            [0.08, 0.25],
                                            [0, 0],
                                            [0.08, 0.19],
                                            [0.02, 0.04],
                                            [0, 0],
                                            [0.08, 0.14],
                                            [0, 0],
                                            [0.04, 0.05],
                                            [0.11, 0.15],
                                            [0.02, 0.03],
                                            [0, 0],
                                            [0.13, 0.15],
                                            [0.04, 0.03],
                                            [0, 0],
                                            [0.11, 0.1],
                                            [0.08, 0.06],
                                            [0.09, 0.07],
                                            [0, 0],
                                            [0.06, 0.04],
                                            [0.13, 0.08],
                                            [0.07, 0.04],
                                            [0.16, 0.08],
                                            [0.06, 0.03],
                                            [0.16, 0.06],
                                            [0, 0],
                                            [0.05, 0.02],
                                            [0.18, 0.05],
                                            [0.04, 0.01],
                                            [0, 0],
                                            [0.18, 0.03],
                                            [0.03, 0],
                                            [0, 0],
                                            [0.18, 0.02],
                                            [0.06, 0],
                                            [0.23, 0],
                                            [0, 0],
                                            [0.19, -0.02],
                                            [0, 0],
                                            [0.2, -0.04],
                                            [0.04, -0.01],
                                            [0, 0],
                                            [0.25, -0.08],
                                            [0, 0],
                                            [0.24, -0.11],
                                            [0.04, -0.03],
                                            [0, 0],
                                            [0.19, -0.12],
                                            [0.08, -0.06],
                                            [0.15, -0.12],
                                            [0, 0],
                                            [0.04, -0.04],
                                            [0.18, -0.19],
                                            [0.02, -0.03],
                                            [0.16, -0.21],
                                            [0.01, -0.02],
                                            [0.02, -0.03],
                                            [0.12, -0.2],
                                            [0.03, -0.07],
                                            [0.09, -0.2],
                                            [0, 0],
                                            [0.01, -0.03],
                                            [0.11, -0.36],
                                            [0.02, -0.12],
                                            [0.01, -0.1],
                                            [0.01, -0.13],
                                            [0, 0],
                                            [0, -0.05],
                                            [0, -0.23],
                                            [0, 0],
                                            [0, -0.03],
                                            [-0.02, -0.19],
                                            [-0.01, -0.05],
                                            [0, 0],
                                            [-0.04, -0.16],
                                            [0, 0],
                                            [-0.01, -0.04],
                                            [-0.08, -0.25],
                                            [0, 0],
                                            [-0.09, -0.21],
                                            [-0.02, -0.03],
                                            [-0.02, -0.03],
                                            [-0.1, -0.16],
                                            [-0.03, -0.05],
                                            [0, 0],
                                            [-0.1, -0.14],
                                            [-0.06, -0.07],
                                            [-0.1, -0.11],
                                            [-0.06, -0.06],
                                            [-0.1, -0.09],
                                            [0, 0],
                                            [-0.05, -0.04],
                                            [-0.11, -0.09],
                                            [0, 0],
                                            [-0.04, -0.03],
                                            [-0.09, -0.06],
                                            [0, 0],
                                            [-0.34, -0.19],
                                            [-0.02, -0.01],
                                            [-0.04, -0.01],
                                            [-0.22, -0.08],
                                            [-0.05, -0.01],
                                            [0, 0],
                                            [-0.2, -0.05],
                                            [-0.09, -0.01],
                                            [0, 0],
                                            [-0.17, -0.02],
                                            [-0.1, -0.01],
                                            [-0.04, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [191.1, 1.89],
                                            [190.72, 1.9],
                                            [190.67, 1.9],
                                            [190.42, 1.92],
                                            [189.92, 1.98],
                                            [189.81, 2],
                                            [189.62, 2.03],
                                            [189.09, 2.16],
                                            [188.96, 2.19],
                                            [188.84, 2.23],
                                            [188.07, 2.51],
                                            [6.43, 81.58],
                                            [5.69, 81.95],
                                            [5.59, 82.01],
                                            [5.47, 82.09],
                                            [5.01, 82.39],
                                            [4.87, 82.5],
                                            [4.78, 82.57],
                                            [4.39, 82.89],
                                            [4.2, 83.08],
                                            [4.18, 83.1],
                                            [3.83, 83.46],
                                            [3.64, 83.68],
                                            [3.33, 84.08],
                                            [3.31, 84.11],
                                            [3.18, 84.3],
                                            [2.89, 84.76],
                                            [2.84, 84.85],
                                            [2.77, 84.97],
                                            [2.51, 85.53],
                                            [2.46, 85.62],
                                            [2.45, 85.67],
                                            [2.13, 86.67],
                                            [2.11, 86.71],
                                            [2.03, 87.07],
                                            [2, 87.23],
                                            [1.99, 87.34],
                                            [1.93, 87.76],
                                            [1.91, 87.97],
                                            [1.91, 88.03],
                                            [1.89, 88.46],
                                            [1.9, 88.73],
                                            [1.92, 89.16],
                                            [1.95, 89.44],
                                            [2.02, 89.88],
                                            [2.04, 89.96],
                                            [2.07, 90.14],
                                            [2.2, 90.61],
                                            [2.23, 90.73],
                                            [2.26, 90.83],
                                            [2.52, 91.52],
                                            [103.8, 324.33],
                                            [104.11, 324.96],
                                            [104.18, 325.08],
                                            [104.21, 325.14],
                                            [104.48, 325.56],
                                            [104.49, 325.58],
                                            [104.6, 325.74],
                                            [104.95, 326.18],
                                            [105, 326.25],
                                            [105.02, 326.27],
                                            [105.46, 326.74],
                                            [105.57, 326.84],
                                            [105.64, 326.9],
                                            [105.95, 327.17],
                                            [106.18, 327.35],
                                            [106.47, 327.55],
                                            [106.55, 327.61],
                                            [106.73, 327.73],
                                            [107.19, 327.99],
                                            [107.41, 328.1],
                                            [107.87, 328.31],
                                            [108.07, 328.38],
                                            [108.52, 328.54],
                                            [108.57, 328.55],
                                            [108.72, 328.6],
                                            [109.28, 328.73],
                                            [109.4, 328.75],
                                            [109.46, 328.76],
                                            [109.99, 328.83],
                                            [110.06, 328.84],
                                            [110.1, 328.85],
                                            [110.71, 328.87],
                                            [110.88, 328.87],
                                            [111.51, 328.83],
                                            [111.61, 328.82],
                                            [112.2, 328.72],
                                            [112.31, 328.7],
                                            [112.95, 328.53],
                                            [113.06, 328.5],
                                            [113.08, 328.49],
                                            [113.73, 328.24],
                                            [295.37, 249.18],
                                            [296.16, 248.78],
                                            [296.29, 248.69],
                                            [296.38, 248.63],
                                            [296.88, 248.3],
                                            [297.11, 248.12],
                                            [297.55, 247.73],
                                            [297.62, 247.66],
                                            [297.74, 247.55],
                                            [298.24, 246.98],
                                            [298.3, 246.92],
                                            [298.77, 246.23],
                                            [298.8, 246.17],
                                            [298.86, 246.08],
                                            [299.17, 245.49],
                                            [299.26, 245.29],
                                            [299.5, 244.68],
                                            [299.52, 244.6],
                                            [299.56, 244.5],
                                            [299.82, 243.39],
                                            [299.86, 243.04],
                                            [299.89, 242.75],
                                            [299.9, 242.34],
                                            [299.9, 242.25],
                                            [299.91, 242.11],
                                            [299.87, 241.46],
                                            [299.87, 241.44],
                                            [299.85, 241.35],
                                            [299.76, 240.79],
                                            [299.73, 240.62],
                                            [299.72, 240.58],
                                            [299.59, 240.1],
                                            [299.57, 240.03],
                                            [299.53, 239.9],
                                            [299.28, 239.24],
                                            [198, 6.43],
                                            [197.68, 5.77],
                                            [197.62, 5.68],
                                            [197.56, 5.58],
                                            [197.3, 5.16],
                                            [197.19, 5.02],
                                            [197.14, 4.95],
                                            [196.86, 4.59],
                                            [196.69, 4.39],
                                            [196.38, 4.07],
                                            [196.19, 3.89],
                                            [195.86, 3.6],
                                            [195.82, 3.57],
                                            [195.66, 3.44],
                                            [195.3, 3.19],
                                            [195.21, 3.12],
                                            [195.08, 3.04],
                                            [194.8, 2.88],
                                            [194.74, 2.85],
                                            [193.77, 2.39],
                                            [193.71, 2.37],
                                            [193.6, 2.33],
                                            [193.04, 2.15],
                                            [192.89, 2.12],
                                            [192.79, 2.09],
                                            [192.28, 1.99],
                                            [192.02, 1.96],
                                            [192, 1.95],
                                            [191.51, 1.91],
                                            [191.21, 1.9],
                                            [191.1, 1.9],
                                            [191.1, 1.89]
                                        ]
                                    }
                                ],
                                "t": 240
                            }
                        ]
                    }
                },
                {
                    "ty": "fl",
                    "c": {
                        "a": 1,
                        "k": [
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0.4588, 0.4588, 0.4588], "t": 0 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0.4588, 0.4588, 0.4588], "t": 60 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0.4588, 0.4588, 0.4588], "t": 120 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0.4588, 0.4588, 0.4588], "t": 180 },
                            { "s": [0.4588, 0.4588, 0.4588], "t": 240 }
                        ]
                    },
                    "r": 1,
                    "o": {
                        "a": 1,
                        "k": [
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 0 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 60 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 120 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 180 },
                            { "s": [100], "t": 240 }
                        ]
                    }
                }
            ],
            "ind": 27
        },
        {
            "ty": 4,
            "sr": 1,
            "st": 0,
            "op": 241,
            "ip": 0,
            "hasMask": false,
            "ao": 0,
            "ks": {
                "a": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [79.72, 5.11], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [79.72, 5.11], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [79.72, 5.11], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [79.72, 5.11], "t": 180 },
                        { "s": [79.72, 5.11], "t": 240 }
                    ]
                },
                "s": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [99.99, 100.01], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [99.99, 100.01], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [99.99, 100.01], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [99.99, 100.01], "t": 180 },
                        { "s": [99.99, 100.01], "t": 240 }
                    ]
                },
                "p": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [539.21, 523.07], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [532.02, 519.13], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [539.21, 523.07], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [532.02, 519.13], "t": 180 },
                        { "s": [539.21, 523.07], "t": 240 }
                    ]
                },
                "r": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [26.46], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [31.06], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [26.46], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [31.06], "t": 180 },
                        { "s": [26.46], "t": 240 }
                    ]
                },
                "o": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 180 },
                        { "s": [100], "t": 240 }
                    ]
                }
            },
            "shapes": [
                {
                    "ty": "sh",
                    "d": 1,
                    "ks": {
                        "a": 1,
                        "k": [
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, -2.82],
                                            [0, 0],
                                            [2.82, 0],
                                            [0, 0],
                                            [0, 2.82],
                                            [0, 0],
                                            [-2.82, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [2.82, 0],
                                            [0, 0],
                                            [0, 2.82],
                                            [0, 0],
                                            [-2.82, 0],
                                            [0, 0],
                                            [0, -2.82],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [5.11, 0],
                                            [154.33, 0],
                                            [159.44, 5.11],
                                            [159.44, 5.11],
                                            [154.33, 10.22],
                                            [5.11, 10.22],
                                            [0, 5.11],
                                            [0, 5.11],
                                            [5.11, 0]
                                        ]
                                    }
                                ],
                                "t": 0
                            },
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, -2.82],
                                            [0, 0],
                                            [2.82, 0],
                                            [0, 0],
                                            [0, 2.82],
                                            [0, 0],
                                            [-2.82, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [2.82, 0],
                                            [0, 0],
                                            [0, 2.82],
                                            [0, 0],
                                            [-2.82, 0],
                                            [0, 0],
                                            [0, -2.82],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [5.11, 0],
                                            [154.33, 0],
                                            [159.44, 5.11],
                                            [159.44, 5.11],
                                            [154.33, 10.22],
                                            [5.11, 10.22],
                                            [0, 5.11],
                                            [0, 5.11],
                                            [5.11, 0]
                                        ]
                                    }
                                ],
                                "t": 60
                            },
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, -2.82],
                                            [0, 0],
                                            [2.82, 0],
                                            [0, 0],
                                            [0, 2.82],
                                            [0, 0],
                                            [-2.82, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [2.82, 0],
                                            [0, 0],
                                            [0, 2.82],
                                            [0, 0],
                                            [-2.82, 0],
                                            [0, 0],
                                            [0, -2.82],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [5.11, 0],
                                            [154.33, 0],
                                            [159.44, 5.11],
                                            [159.44, 5.11],
                                            [154.33, 10.22],
                                            [5.11, 10.22],
                                            [0, 5.11],
                                            [0, 5.11],
                                            [5.11, 0]
                                        ]
                                    }
                                ],
                                "t": 120
                            },
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, -2.82],
                                            [0, 0],
                                            [2.82, 0],
                                            [0, 0],
                                            [0, 2.82],
                                            [0, 0],
                                            [-2.82, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [2.82, 0],
                                            [0, 0],
                                            [0, 2.82],
                                            [0, 0],
                                            [-2.82, 0],
                                            [0, 0],
                                            [0, -2.82],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [5.11, 0],
                                            [154.33, 0],
                                            [159.44, 5.11],
                                            [159.44, 5.11],
                                            [154.33, 10.22],
                                            [5.11, 10.22],
                                            [0, 5.11],
                                            [0, 5.11],
                                            [5.11, 0]
                                        ]
                                    }
                                ],
                                "t": 180
                            },
                            {
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, -2.82],
                                            [0, 0],
                                            [2.82, 0],
                                            [0, 0],
                                            [0, 2.82],
                                            [0, 0],
                                            [-2.82, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [2.82, 0],
                                            [0, 0],
                                            [0, 2.82],
                                            [0, 0],
                                            [-2.82, 0],
                                            [0, 0],
                                            [0, -2.82],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [5.11, 0],
                                            [154.33, 0],
                                            [159.44, 5.11],
                                            [159.44, 5.11],
                                            [154.33, 10.22],
                                            [5.11, 10.22],
                                            [0, 5.11],
                                            [0, 5.11],
                                            [5.11, 0]
                                        ]
                                    }
                                ],
                                "t": 240
                            }
                        ]
                    }
                },
                {
                    "ty": "fl",
                    "c": {
                        "a": 1,
                        "k": [
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0.0863, 0.6431, 0.498], "t": 0 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0.0863, 0.6431, 0.498], "t": 60 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0.0863, 0.6431, 0.498], "t": 120 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0.0863, 0.6431, 0.498], "t": 180 },
                            { "s": [0.0863, 0.6431, 0.498], "t": 240 }
                        ]
                    },
                    "r": 1,
                    "o": {
                        "a": 1,
                        "k": [
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 0 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 60 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 120 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 180 },
                            { "s": [100], "t": 240 }
                        ]
                    }
                }
            ],
            "ind": 28
        },
        {
            "ty": 4,
            "sr": 1,
            "st": 0,
            "op": 241,
            "ip": 0,
            "hasMask": false,
            "ao": 0,
            "ks": {
                "a": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [79.72, 5.11], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [79.72, 5.11], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [79.72, 5.11], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [79.72, 5.11], "t": 180 },
                        { "s": [79.72, 5.11], "t": 240 }
                    ]
                },
                "s": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [99.99, 100.01], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [99.99, 100.01], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [99.99, 100.01], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [99.99, 100.01], "t": 180 },
                        { "s": [99.99, 100.01], "t": 240 }
                    ]
                },
                "p": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [549.69, 502], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [544.15, 498.97], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [549.69, 502], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [544.15, 498.97], "t": 180 },
                        { "s": [549.69, 502], "t": 240 }
                    ]
                },
                "r": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [26.46], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [31.06], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [26.46], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [31.06], "t": 180 },
                        { "s": [26.46], "t": 240 }
                    ]
                },
                "o": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 180 },
                        { "s": [100], "t": 240 }
                    ]
                }
            },
            "shapes": [
                {
                    "ty": "sh",
                    "d": 1,
                    "ks": {
                        "a": 1,
                        "k": [
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, -2.82],
                                            [0, 0],
                                            [2.82, 0],
                                            [0, 0],
                                            [0, 2.82],
                                            [0, 0],
                                            [-2.82, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [2.82, 0],
                                            [0, 0],
                                            [0, 2.82],
                                            [0, 0],
                                            [-2.82, 0],
                                            [0, 0],
                                            [0, -2.82],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [5.11, 0],
                                            [154.33, 0],
                                            [159.44, 5.11],
                                            [159.44, 5.11],
                                            [154.33, 10.22],
                                            [5.11, 10.22],
                                            [0, 5.11],
                                            [0, 5.11],
                                            [5.11, 0]
                                        ]
                                    }
                                ],
                                "t": 0
                            },
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, -2.82],
                                            [0, 0],
                                            [2.82, 0],
                                            [0, 0],
                                            [0, 2.82],
                                            [0, 0],
                                            [-2.82, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [2.82, 0],
                                            [0, 0],
                                            [0, 2.82],
                                            [0, 0],
                                            [-2.82, 0],
                                            [0, 0],
                                            [0, -2.82],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [5.11, 0],
                                            [154.33, 0],
                                            [159.44, 5.11],
                                            [159.44, 5.11],
                                            [154.33, 10.22],
                                            [5.11, 10.22],
                                            [0, 5.11],
                                            [0, 5.11],
                                            [5.11, 0]
                                        ]
                                    }
                                ],
                                "t": 60
                            },
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, -2.82],
                                            [0, 0],
                                            [2.82, 0],
                                            [0, 0],
                                            [0, 2.82],
                                            [0, 0],
                                            [-2.82, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [2.82, 0],
                                            [0, 0],
                                            [0, 2.82],
                                            [0, 0],
                                            [-2.82, 0],
                                            [0, 0],
                                            [0, -2.82],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [5.11, 0],
                                            [154.33, 0],
                                            [159.44, 5.11],
                                            [159.44, 5.11],
                                            [154.33, 10.22],
                                            [5.11, 10.22],
                                            [0, 5.11],
                                            [0, 5.11],
                                            [5.11, 0]
                                        ]
                                    }
                                ],
                                "t": 120
                            },
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, -2.82],
                                            [0, 0],
                                            [2.82, 0],
                                            [0, 0],
                                            [0, 2.82],
                                            [0, 0],
                                            [-2.82, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [2.82, 0],
                                            [0, 0],
                                            [0, 2.82],
                                            [0, 0],
                                            [-2.82, 0],
                                            [0, 0],
                                            [0, -2.82],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [5.11, 0],
                                            [154.33, 0],
                                            [159.44, 5.11],
                                            [159.44, 5.11],
                                            [154.33, 10.22],
                                            [5.11, 10.22],
                                            [0, 5.11],
                                            [0, 5.11],
                                            [5.11, 0]
                                        ]
                                    }
                                ],
                                "t": 180
                            },
                            {
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, -2.82],
                                            [0, 0],
                                            [2.82, 0],
                                            [0, 0],
                                            [0, 2.82],
                                            [0, 0],
                                            [-2.82, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [2.82, 0],
                                            [0, 0],
                                            [0, 2.82],
                                            [0, 0],
                                            [-2.82, 0],
                                            [0, 0],
                                            [0, -2.82],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [5.11, 0],
                                            [154.33, 0],
                                            [159.44, 5.11],
                                            [159.44, 5.11],
                                            [154.33, 10.22],
                                            [5.11, 10.22],
                                            [0, 5.11],
                                            [0, 5.11],
                                            [5.11, 0]
                                        ]
                                    }
                                ],
                                "t": 240
                            }
                        ]
                    }
                },
                {
                    "ty": "fl",
                    "c": {
                        "a": 1,
                        "k": [
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0.702, 0.8078, 0.9647], "t": 0 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0.702, 0.8078, 0.9647], "t": 60 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0.702, 0.8078, 0.9647], "t": 120 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0.702, 0.8078, 0.9647], "t": 180 },
                            { "s": [0.702, 0.8078, 0.9647], "t": 240 }
                        ]
                    },
                    "r": 1,
                    "o": {
                        "a": 1,
                        "k": [
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 0 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 60 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 120 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 180 },
                            { "s": [100], "t": 240 }
                        ]
                    }
                }
            ],
            "ind": 29
        },
        {
            "ty": 4,
            "sr": 1,
            "st": 0,
            "op": 241,
            "ip": 0,
            "hasMask": false,
            "ao": 0,
            "ks": {
                "a": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [79.72, 5.11], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [79.72, 5.11], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [79.72, 5.11], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [79.72, 5.11], "t": 180 },
                        { "s": [79.72, 5.11], "t": 240 }
                    ]
                },
                "s": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [99.99, 100.01], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [99.99, 100.01], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [99.99, 100.01], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [99.99, 100.01], "t": 180 },
                        { "s": [99.99, 100.01], "t": 240 }
                    ]
                },
                "p": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [560.17, 480.93], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [556.29, 478.8], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [560.17, 480.93], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [556.29, 478.8], "t": 180 },
                        { "s": [560.17, 480.93], "t": 240 }
                    ]
                },
                "r": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [26.46], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [31.06], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [26.46], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [31.06], "t": 180 },
                        { "s": [26.46], "t": 240 }
                    ]
                },
                "o": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 180 },
                        { "s": [100], "t": 240 }
                    ]
                }
            },
            "shapes": [
                {
                    "ty": "sh",
                    "d": 1,
                    "ks": {
                        "a": 1,
                        "k": [
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, -2.82],
                                            [0, 0],
                                            [2.82, 0],
                                            [0, 0],
                                            [0, 2.82],
                                            [0, 0],
                                            [-2.82, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [2.82, 0],
                                            [0, 0],
                                            [0, 2.82],
                                            [0, 0],
                                            [-2.82, 0],
                                            [0, 0],
                                            [0, -2.82],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [5.11, 0],
                                            [154.33, 0],
                                            [159.44, 5.11],
                                            [159.44, 5.11],
                                            [154.33, 10.22],
                                            [5.11, 10.22],
                                            [0, 5.11],
                                            [0, 5.11],
                                            [5.11, 0]
                                        ]
                                    }
                                ],
                                "t": 0
                            },
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, -2.82],
                                            [0, 0],
                                            [2.82, 0],
                                            [0, 0],
                                            [0, 2.82],
                                            [0, 0],
                                            [-2.82, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [2.82, 0],
                                            [0, 0],
                                            [0, 2.82],
                                            [0, 0],
                                            [-2.82, 0],
                                            [0, 0],
                                            [0, -2.82],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [5.11, 0],
                                            [154.33, 0],
                                            [159.44, 5.11],
                                            [159.44, 5.11],
                                            [154.33, 10.22],
                                            [5.11, 10.22],
                                            [0, 5.11],
                                            [0, 5.11],
                                            [5.11, 0]
                                        ]
                                    }
                                ],
                                "t": 60
                            },
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, -2.82],
                                            [0, 0],
                                            [2.82, 0],
                                            [0, 0],
                                            [0, 2.82],
                                            [0, 0],
                                            [-2.82, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [2.82, 0],
                                            [0, 0],
                                            [0, 2.82],
                                            [0, 0],
                                            [-2.82, 0],
                                            [0, 0],
                                            [0, -2.82],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [5.11, 0],
                                            [154.33, 0],
                                            [159.44, 5.11],
                                            [159.44, 5.11],
                                            [154.33, 10.22],
                                            [5.11, 10.22],
                                            [0, 5.11],
                                            [0, 5.11],
                                            [5.11, 0]
                                        ]
                                    }
                                ],
                                "t": 120
                            },
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, -2.82],
                                            [0, 0],
                                            [2.82, 0],
                                            [0, 0],
                                            [0, 2.82],
                                            [0, 0],
                                            [-2.82, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [2.82, 0],
                                            [0, 0],
                                            [0, 2.82],
                                            [0, 0],
                                            [-2.82, 0],
                                            [0, 0],
                                            [0, -2.82],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [5.11, 0],
                                            [154.33, 0],
                                            [159.44, 5.11],
                                            [159.44, 5.11],
                                            [154.33, 10.22],
                                            [5.11, 10.22],
                                            [0, 5.11],
                                            [0, 5.11],
                                            [5.11, 0]
                                        ]
                                    }
                                ],
                                "t": 180
                            },
                            {
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, -2.82],
                                            [0, 0],
                                            [2.82, 0],
                                            [0, 0],
                                            [0, 2.82],
                                            [0, 0],
                                            [-2.82, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [2.82, 0],
                                            [0, 0],
                                            [0, 2.82],
                                            [0, 0],
                                            [-2.82, 0],
                                            [0, 0],
                                            [0, -2.82],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [5.11, 0],
                                            [154.33, 0],
                                            [159.44, 5.11],
                                            [159.44, 5.11],
                                            [154.33, 10.22],
                                            [5.11, 10.22],
                                            [0, 5.11],
                                            [0, 5.11],
                                            [5.11, 0]
                                        ]
                                    }
                                ],
                                "t": 240
                            }
                        ]
                    }
                },
                {
                    "ty": "fl",
                    "c": {
                        "a": 1,
                        "k": [
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0.0863, 0.6431, 0.498], "t": 0 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0.0863, 0.6431, 0.498], "t": 60 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0.0863, 0.6431, 0.498], "t": 120 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0.0863, 0.6431, 0.498], "t": 180 },
                            { "s": [0.0863, 0.6431, 0.498], "t": 240 }
                        ]
                    },
                    "r": 1,
                    "o": {
                        "a": 1,
                        "k": [
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 0 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 60 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 120 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 180 },
                            { "s": [100], "t": 240 }
                        ]
                    }
                }
            ],
            "ind": 30
        },
        {
            "ty": 4,
            "sr": 1,
            "st": 0,
            "op": 241,
            "ip": 0,
            "hasMask": false,
            "ao": 0,
            "ks": {
                "a": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [79.72, 5.11], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [79.72, 5.11], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [79.72, 5.11], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [79.72, 5.11], "t": 180 },
                        { "s": [79.72, 5.11], "t": 240 }
                    ]
                },
                "s": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [99.99, 100.01], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [99.99, 100.01], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [99.99, 100.01], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [99.99, 100.01], "t": 180 },
                        { "s": [99.99, 100.01], "t": 240 }
                    ]
                },
                "p": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [570.65, 459.87], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [568.42, 458.64], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [570.65, 459.87], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [568.42, 458.64], "t": 180 },
                        { "s": [570.65, 459.87], "t": 240 }
                    ]
                },
                "r": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [26.46], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [31.06], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [26.46], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [31.06], "t": 180 },
                        { "s": [26.46], "t": 240 }
                    ]
                },
                "o": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 180 },
                        { "s": [100], "t": 240 }
                    ]
                }
            },
            "shapes": [
                {
                    "ty": "sh",
                    "d": 1,
                    "ks": {
                        "a": 1,
                        "k": [
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, -2.82],
                                            [0, 0],
                                            [2.82, 0],
                                            [0, 0],
                                            [0, 2.82],
                                            [0, 0],
                                            [-2.82, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [2.82, 0],
                                            [0, 0],
                                            [0, 2.82],
                                            [0, 0],
                                            [-2.82, 0],
                                            [0, 0],
                                            [0, -2.82],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [5.11, 0],
                                            [154.33, 0],
                                            [159.44, 5.11],
                                            [159.44, 5.11],
                                            [154.33, 10.22],
                                            [5.11, 10.22],
                                            [0, 5.11],
                                            [0, 5.11],
                                            [5.11, 0]
                                        ]
                                    }
                                ],
                                "t": 0
                            },
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, -2.82],
                                            [0, 0],
                                            [2.82, 0],
                                            [0, 0],
                                            [0, 2.82],
                                            [0, 0],
                                            [-2.82, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [2.82, 0],
                                            [0, 0],
                                            [0, 2.82],
                                            [0, 0],
                                            [-2.82, 0],
                                            [0, 0],
                                            [0, -2.82],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [5.11, 0],
                                            [154.33, 0],
                                            [159.44, 5.11],
                                            [159.44, 5.11],
                                            [154.33, 10.22],
                                            [5.11, 10.22],
                                            [0, 5.11],
                                            [0, 5.11],
                                            [5.11, 0]
                                        ]
                                    }
                                ],
                                "t": 60
                            },
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, -2.82],
                                            [0, 0],
                                            [2.82, 0],
                                            [0, 0],
                                            [0, 2.82],
                                            [0, 0],
                                            [-2.82, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [2.82, 0],
                                            [0, 0],
                                            [0, 2.82],
                                            [0, 0],
                                            [-2.82, 0],
                                            [0, 0],
                                            [0, -2.82],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [5.11, 0],
                                            [154.33, 0],
                                            [159.44, 5.11],
                                            [159.44, 5.11],
                                            [154.33, 10.22],
                                            [5.11, 10.22],
                                            [0, 5.11],
                                            [0, 5.11],
                                            [5.11, 0]
                                        ]
                                    }
                                ],
                                "t": 120
                            },
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, -2.82],
                                            [0, 0],
                                            [2.82, 0],
                                            [0, 0],
                                            [0, 2.82],
                                            [0, 0],
                                            [-2.82, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [2.82, 0],
                                            [0, 0],
                                            [0, 2.82],
                                            [0, 0],
                                            [-2.82, 0],
                                            [0, 0],
                                            [0, -2.82],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [5.11, 0],
                                            [154.33, 0],
                                            [159.44, 5.11],
                                            [159.44, 5.11],
                                            [154.33, 10.22],
                                            [5.11, 10.22],
                                            [0, 5.11],
                                            [0, 5.11],
                                            [5.11, 0]
                                        ]
                                    }
                                ],
                                "t": 180
                            },
                            {
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, -2.82],
                                            [0, 0],
                                            [2.82, 0],
                                            [0, 0],
                                            [0, 2.82],
                                            [0, 0],
                                            [-2.82, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [2.82, 0],
                                            [0, 0],
                                            [0, 2.82],
                                            [0, 0],
                                            [-2.82, 0],
                                            [0, 0],
                                            [0, -2.82],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [5.11, 0],
                                            [154.33, 0],
                                            [159.44, 5.11],
                                            [159.44, 5.11],
                                            [154.33, 10.22],
                                            [5.11, 10.22],
                                            [0, 5.11],
                                            [0, 5.11],
                                            [5.11, 0]
                                        ]
                                    }
                                ],
                                "t": 240
                            }
                        ]
                    }
                },
                {
                    "ty": "fl",
                    "c": {
                        "a": 1,
                        "k": [
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0.0863, 0.6431, 0.498], "t": 0 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0.0863, 0.6431, 0.498], "t": 60 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0.0863, 0.6431, 0.498], "t": 120 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0.0863, 0.6431, 0.498], "t": 180 },
                            { "s": [0.0863, 0.6431, 0.498], "t": 240 }
                        ]
                    },
                    "r": 1,
                    "o": {
                        "a": 1,
                        "k": [
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 0 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 60 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 120 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 180 },
                            { "s": [100], "t": 240 }
                        ]
                    }
                }
            ],
            "ind": 31
        },
        {
            "ty": 4,
            "sr": 1,
            "st": 0,
            "op": 241,
            "ip": 0,
            "hasMask": false,
            "ao": 0,
            "ks": {
                "a": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [79.72, 5.11], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [79.72, 5.11], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [79.72, 5.11], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [79.72, 5.11], "t": 180 },
                        { "s": [79.72, 5.11], "t": 240 }
                    ]
                },
                "s": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [99.99, 100.01], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [99.99, 100.01], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [99.99, 100.01], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [99.99, 100.01], "t": 180 },
                        { "s": [99.99, 100.01], "t": 240 }
                    ]
                },
                "p": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [581.13, 438.8], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [580.56, 438.48], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [581.13, 438.8], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [580.56, 438.48], "t": 180 },
                        { "s": [581.13, 438.8], "t": 240 }
                    ]
                },
                "r": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [26.46], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [31.06], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [26.46], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [31.06], "t": 180 },
                        { "s": [26.46], "t": 240 }
                    ]
                },
                "o": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 180 },
                        { "s": [100], "t": 240 }
                    ]
                }
            },
            "shapes": [
                {
                    "ty": "sh",
                    "d": 1,
                    "ks": {
                        "a": 1,
                        "k": [
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, -2.82],
                                            [0, 0],
                                            [2.82, 0],
                                            [0, 0],
                                            [0, 2.82],
                                            [0, 0],
                                            [-2.82, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [2.82, 0],
                                            [0, 0],
                                            [0, 2.82],
                                            [0, 0],
                                            [-2.82, 0],
                                            [0, 0],
                                            [0, -2.82],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [5.11, 0],
                                            [154.33, 0],
                                            [159.44, 5.11],
                                            [159.44, 5.11],
                                            [154.33, 10.22],
                                            [5.11, 10.22],
                                            [0, 5.11],
                                            [0, 5.11],
                                            [5.11, 0]
                                        ]
                                    }
                                ],
                                "t": 0
                            },
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, -2.82],
                                            [0, 0],
                                            [2.82, 0],
                                            [0, 0],
                                            [0, 2.82],
                                            [0, 0],
                                            [-2.82, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [2.82, 0],
                                            [0, 0],
                                            [0, 2.82],
                                            [0, 0],
                                            [-2.82, 0],
                                            [0, 0],
                                            [0, -2.82],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [5.11, 0],
                                            [154.33, 0],
                                            [159.44, 5.11],
                                            [159.44, 5.11],
                                            [154.33, 10.22],
                                            [5.11, 10.22],
                                            [0, 5.11],
                                            [0, 5.11],
                                            [5.11, 0]
                                        ]
                                    }
                                ],
                                "t": 60
                            },
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, -2.82],
                                            [0, 0],
                                            [2.82, 0],
                                            [0, 0],
                                            [0, 2.82],
                                            [0, 0],
                                            [-2.82, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [2.82, 0],
                                            [0, 0],
                                            [0, 2.82],
                                            [0, 0],
                                            [-2.82, 0],
                                            [0, 0],
                                            [0, -2.82],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [5.11, 0],
                                            [154.33, 0],
                                            [159.44, 5.11],
                                            [159.44, 5.11],
                                            [154.33, 10.22],
                                            [5.11, 10.22],
                                            [0, 5.11],
                                            [0, 5.11],
                                            [5.11, 0]
                                        ]
                                    }
                                ],
                                "t": 120
                            },
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, -2.82],
                                            [0, 0],
                                            [2.82, 0],
                                            [0, 0],
                                            [0, 2.82],
                                            [0, 0],
                                            [-2.82, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [2.82, 0],
                                            [0, 0],
                                            [0, 2.82],
                                            [0, 0],
                                            [-2.82, 0],
                                            [0, 0],
                                            [0, -2.82],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [5.11, 0],
                                            [154.33, 0],
                                            [159.44, 5.11],
                                            [159.44, 5.11],
                                            [154.33, 10.22],
                                            [5.11, 10.22],
                                            [0, 5.11],
                                            [0, 5.11],
                                            [5.11, 0]
                                        ]
                                    }
                                ],
                                "t": 180
                            },
                            {
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, -2.82],
                                            [0, 0],
                                            [2.82, 0],
                                            [0, 0],
                                            [0, 2.82],
                                            [0, 0],
                                            [-2.82, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [2.82, 0],
                                            [0, 0],
                                            [0, 2.82],
                                            [0, 0],
                                            [-2.82, 0],
                                            [0, 0],
                                            [0, -2.82],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [5.11, 0],
                                            [154.33, 0],
                                            [159.44, 5.11],
                                            [159.44, 5.11],
                                            [154.33, 10.22],
                                            [5.11, 10.22],
                                            [0, 5.11],
                                            [0, 5.11],
                                            [5.11, 0]
                                        ]
                                    }
                                ],
                                "t": 240
                            }
                        ]
                    }
                },
                {
                    "ty": "fl",
                    "c": {
                        "a": 1,
                        "k": [
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0.0863, 0.6431, 0.498], "t": 0 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0.0863, 0.6431, 0.498], "t": 60 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0.0863, 0.6431, 0.498], "t": 120 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0.0863, 0.6431, 0.498], "t": 180 },
                            { "s": [0.0863, 0.6431, 0.498], "t": 240 }
                        ]
                    },
                    "r": 1,
                    "o": {
                        "a": 1,
                        "k": [
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 0 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 60 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 120 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 180 },
                            { "s": [100], "t": 240 }
                        ]
                    }
                }
            ],
            "ind": 32
        },
        {
            "ty": 4,
            "sr": 1,
            "st": 0,
            "op": 241,
            "ip": 0,
            "hasMask": false,
            "ao": 0,
            "ks": {
                "a": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [79.72, 5.11], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [79.72, 5.11], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [79.72, 5.11], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [79.72, 5.11], "t": 180 },
                        { "s": [79.72, 5.11], "t": 240 }
                    ]
                },
                "s": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [99.99, 100.01], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [99.99, 100.01], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [99.99, 100.01], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [99.99, 100.01], "t": 180 },
                        { "s": [99.99, 100.01], "t": 240 }
                    ]
                },
                "p": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [591.62, 417.73], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [592.69, 418.32], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [591.62, 417.73], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [592.69, 418.32], "t": 180 },
                        { "s": [591.62, 417.73], "t": 240 }
                    ]
                },
                "r": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [26.46], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [31.06], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [26.46], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [31.06], "t": 180 },
                        { "s": [26.46], "t": 240 }
                    ]
                },
                "o": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 180 },
                        { "s": [100], "t": 240 }
                    ]
                }
            },
            "shapes": [
                {
                    "ty": "sh",
                    "d": 1,
                    "ks": {
                        "a": 1,
                        "k": [
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, -2.82],
                                            [0, 0],
                                            [2.82, 0],
                                            [0, 0],
                                            [0, 2.82],
                                            [0, 0],
                                            [-2.82, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [2.82, 0],
                                            [0, 0],
                                            [0, 2.82],
                                            [0, 0],
                                            [-2.82, 0],
                                            [0, 0],
                                            [0, -2.82],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [5.11, 0],
                                            [154.33, 0],
                                            [159.44, 5.11],
                                            [159.44, 5.11],
                                            [154.33, 10.22],
                                            [5.11, 10.22],
                                            [0, 5.11],
                                            [0, 5.11],
                                            [5.11, 0]
                                        ]
                                    }
                                ],
                                "t": 0
                            },
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, -2.82],
                                            [0, 0],
                                            [2.82, 0],
                                            [0, 0],
                                            [0, 2.82],
                                            [0, 0],
                                            [-2.82, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [2.82, 0],
                                            [0, 0],
                                            [0, 2.82],
                                            [0, 0],
                                            [-2.82, 0],
                                            [0, 0],
                                            [0, -2.82],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [5.11, 0],
                                            [154.33, 0],
                                            [159.44, 5.11],
                                            [159.44, 5.11],
                                            [154.33, 10.22],
                                            [5.11, 10.22],
                                            [0, 5.11],
                                            [0, 5.11],
                                            [5.11, 0]
                                        ]
                                    }
                                ],
                                "t": 60
                            },
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, -2.82],
                                            [0, 0],
                                            [2.82, 0],
                                            [0, 0],
                                            [0, 2.82],
                                            [0, 0],
                                            [-2.82, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [2.82, 0],
                                            [0, 0],
                                            [0, 2.82],
                                            [0, 0],
                                            [-2.82, 0],
                                            [0, 0],
                                            [0, -2.82],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [5.11, 0],
                                            [154.33, 0],
                                            [159.44, 5.11],
                                            [159.44, 5.11],
                                            [154.33, 10.22],
                                            [5.11, 10.22],
                                            [0, 5.11],
                                            [0, 5.11],
                                            [5.11, 0]
                                        ]
                                    }
                                ],
                                "t": 120
                            },
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, -2.82],
                                            [0, 0],
                                            [2.82, 0],
                                            [0, 0],
                                            [0, 2.82],
                                            [0, 0],
                                            [-2.82, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [2.82, 0],
                                            [0, 0],
                                            [0, 2.82],
                                            [0, 0],
                                            [-2.82, 0],
                                            [0, 0],
                                            [0, -2.82],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [5.11, 0],
                                            [154.33, 0],
                                            [159.44, 5.11],
                                            [159.44, 5.11],
                                            [154.33, 10.22],
                                            [5.11, 10.22],
                                            [0, 5.11],
                                            [0, 5.11],
                                            [5.11, 0]
                                        ]
                                    }
                                ],
                                "t": 180
                            },
                            {
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, -2.82],
                                            [0, 0],
                                            [2.82, 0],
                                            [0, 0],
                                            [0, 2.82],
                                            [0, 0],
                                            [-2.82, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [2.82, 0],
                                            [0, 0],
                                            [0, 2.82],
                                            [0, 0],
                                            [-2.82, 0],
                                            [0, 0],
                                            [0, -2.82],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [5.11, 0],
                                            [154.33, 0],
                                            [159.44, 5.11],
                                            [159.44, 5.11],
                                            [154.33, 10.22],
                                            [5.11, 10.22],
                                            [0, 5.11],
                                            [0, 5.11],
                                            [5.11, 0]
                                        ]
                                    }
                                ],
                                "t": 240
                            }
                        ]
                    }
                },
                {
                    "ty": "fl",
                    "c": {
                        "a": 1,
                        "k": [
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0.0863, 0.6431, 0.498], "t": 0 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0.0863, 0.6431, 0.498], "t": 60 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0.0863, 0.6431, 0.498], "t": 120 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0.0863, 0.6431, 0.498], "t": 180 },
                            { "s": [0.0863, 0.6431, 0.498], "t": 240 }
                        ]
                    },
                    "r": 1,
                    "o": {
                        "a": 1,
                        "k": [
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 0 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 60 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 120 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 180 },
                            { "s": [100], "t": 240 }
                        ]
                    }
                }
            ],
            "ind": 33
        },
        {
            "ty": 4,
            "sr": 1,
            "st": 0,
            "op": 241,
            "ip": 0,
            "hasMask": false,
            "ao": 0,
            "ks": {
                "a": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [79.72, 5.11], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [79.72, 5.11], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [79.72, 5.11], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [79.72, 5.11], "t": 180 },
                        { "s": [79.72, 5.11], "t": 240 }
                    ]
                },
                "s": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [99.99, 100.01], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [99.99, 100.01], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [99.99, 100.01], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [99.99, 100.01], "t": 180 },
                        { "s": [99.99, 100.01], "t": 240 }
                    ]
                },
                "p": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [602.1, 396.66], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [604.83, 398.16], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [602.1, 396.66], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [604.83, 398.16], "t": 180 },
                        { "s": [602.1, 396.66], "t": 240 }
                    ]
                },
                "r": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [26.46], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [31.06], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [26.46], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [31.06], "t": 180 },
                        { "s": [26.46], "t": 240 }
                    ]
                },
                "o": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 180 },
                        { "s": [100], "t": 240 }
                    ]
                }
            },
            "shapes": [
                {
                    "ty": "sh",
                    "d": 1,
                    "ks": {
                        "a": 1,
                        "k": [
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, -2.82],
                                            [0, 0],
                                            [2.82, 0],
                                            [0, 0],
                                            [0, 2.82],
                                            [0, 0],
                                            [-2.82, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [2.82, 0],
                                            [0, 0],
                                            [0, 2.82],
                                            [0, 0],
                                            [-2.82, 0],
                                            [0, 0],
                                            [0, -2.82],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [5.11, 0],
                                            [154.33, 0],
                                            [159.44, 5.11],
                                            [159.44, 5.11],
                                            [154.33, 10.22],
                                            [5.11, 10.22],
                                            [0, 5.11],
                                            [0, 5.11],
                                            [5.11, 0]
                                        ]
                                    }
                                ],
                                "t": 0
                            },
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, -2.82],
                                            [0, 0],
                                            [2.82, 0],
                                            [0, 0],
                                            [0, 2.82],
                                            [0, 0],
                                            [-2.82, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [2.82, 0],
                                            [0, 0],
                                            [0, 2.82],
                                            [0, 0],
                                            [-2.82, 0],
                                            [0, 0],
                                            [0, -2.82],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [5.11, 0],
                                            [154.33, 0],
                                            [159.44, 5.11],
                                            [159.44, 5.11],
                                            [154.33, 10.22],
                                            [5.11, 10.22],
                                            [0, 5.11],
                                            [0, 5.11],
                                            [5.11, 0]
                                        ]
                                    }
                                ],
                                "t": 60
                            },
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, -2.82],
                                            [0, 0],
                                            [2.82, 0],
                                            [0, 0],
                                            [0, 2.82],
                                            [0, 0],
                                            [-2.82, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [2.82, 0],
                                            [0, 0],
                                            [0, 2.82],
                                            [0, 0],
                                            [-2.82, 0],
                                            [0, 0],
                                            [0, -2.82],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [5.11, 0],
                                            [154.33, 0],
                                            [159.44, 5.11],
                                            [159.44, 5.11],
                                            [154.33, 10.22],
                                            [5.11, 10.22],
                                            [0, 5.11],
                                            [0, 5.11],
                                            [5.11, 0]
                                        ]
                                    }
                                ],
                                "t": 120
                            },
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, -2.82],
                                            [0, 0],
                                            [2.82, 0],
                                            [0, 0],
                                            [0, 2.82],
                                            [0, 0],
                                            [-2.82, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [2.82, 0],
                                            [0, 0],
                                            [0, 2.82],
                                            [0, 0],
                                            [-2.82, 0],
                                            [0, 0],
                                            [0, -2.82],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [5.11, 0],
                                            [154.33, 0],
                                            [159.44, 5.11],
                                            [159.44, 5.11],
                                            [154.33, 10.22],
                                            [5.11, 10.22],
                                            [0, 5.11],
                                            [0, 5.11],
                                            [5.11, 0]
                                        ]
                                    }
                                ],
                                "t": 180
                            },
                            {
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, -2.82],
                                            [0, 0],
                                            [2.82, 0],
                                            [0, 0],
                                            [0, 2.82],
                                            [0, 0],
                                            [-2.82, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [2.82, 0],
                                            [0, 0],
                                            [0, 2.82],
                                            [0, 0],
                                            [-2.82, 0],
                                            [0, 0],
                                            [0, -2.82],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [5.11, 0],
                                            [154.33, 0],
                                            [159.44, 5.11],
                                            [159.44, 5.11],
                                            [154.33, 10.22],
                                            [5.11, 10.22],
                                            [0, 5.11],
                                            [0, 5.11],
                                            [5.11, 0]
                                        ]
                                    }
                                ],
                                "t": 240
                            }
                        ]
                    }
                },
                {
                    "ty": "fl",
                    "c": {
                        "a": 1,
                        "k": [
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0.0863, 0.6431, 0.498], "t": 0 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0.0863, 0.6431, 0.498], "t": 60 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0.0863, 0.6431, 0.498], "t": 120 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0.0863, 0.6431, 0.498], "t": 180 },
                            { "s": [0.0863, 0.6431, 0.498], "t": 240 }
                        ]
                    },
                    "r": 1,
                    "o": {
                        "a": 1,
                        "k": [
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 0 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 60 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 120 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 180 },
                            { "s": [100], "t": 240 }
                        ]
                    }
                }
            ],
            "ind": 34
        },
        {
            "ty": 4,
            "sr": 1,
            "st": 0,
            "op": 241,
            "ip": 0,
            "hasMask": false,
            "ao": 0,
            "ks": {
                "a": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [79.72, 5.11], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [79.72, 5.11], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [79.72, 5.11], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [79.72, 5.11], "t": 180 },
                        { "s": [79.72, 5.11], "t": 240 }
                    ]
                },
                "s": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [99.99, 100.01], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [99.99, 100.01], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [99.99, 100.01], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [99.99, 100.01], "t": 180 },
                        { "s": [99.99, 100.01], "t": 240 }
                    ]
                },
                "p": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [612.58, 375.6], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [616.96, 378], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [612.58, 375.6], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [616.96, 378], "t": 180 },
                        { "s": [612.58, 375.6], "t": 240 }
                    ]
                },
                "r": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [26.46], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [31.06], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [26.46], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [31.06], "t": 180 },
                        { "s": [26.46], "t": 240 }
                    ]
                },
                "o": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 180 },
                        { "s": [100], "t": 240 }
                    ]
                }
            },
            "shapes": [
                {
                    "ty": "sh",
                    "d": 1,
                    "ks": {
                        "a": 1,
                        "k": [
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, -2.82],
                                            [0, 0],
                                            [2.82, 0],
                                            [0, 0],
                                            [0, 2.82],
                                            [0, 0],
                                            [-2.82, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [2.82, 0],
                                            [0, 0],
                                            [0, 2.82],
                                            [0, 0],
                                            [-2.82, 0],
                                            [0, 0],
                                            [0, -2.82],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [5.11, 0],
                                            [154.33, 0],
                                            [159.44, 5.11],
                                            [159.44, 5.11],
                                            [154.33, 10.22],
                                            [5.11, 10.22],
                                            [0, 5.11],
                                            [0, 5.11],
                                            [5.11, 0]
                                        ]
                                    }
                                ],
                                "t": 0
                            },
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, -2.82],
                                            [0, 0],
                                            [2.82, 0],
                                            [0, 0],
                                            [0, 2.82],
                                            [0, 0],
                                            [-2.82, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [2.82, 0],
                                            [0, 0],
                                            [0, 2.82],
                                            [0, 0],
                                            [-2.82, 0],
                                            [0, 0],
                                            [0, -2.82],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [5.11, 0],
                                            [154.33, 0],
                                            [159.44, 5.11],
                                            [159.44, 5.11],
                                            [154.33, 10.22],
                                            [5.11, 10.22],
                                            [0, 5.11],
                                            [0, 5.11],
                                            [5.11, 0]
                                        ]
                                    }
                                ],
                                "t": 60
                            },
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, -2.82],
                                            [0, 0],
                                            [2.82, 0],
                                            [0, 0],
                                            [0, 2.82],
                                            [0, 0],
                                            [-2.82, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [2.82, 0],
                                            [0, 0],
                                            [0, 2.82],
                                            [0, 0],
                                            [-2.82, 0],
                                            [0, 0],
                                            [0, -2.82],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [5.11, 0],
                                            [154.33, 0],
                                            [159.44, 5.11],
                                            [159.44, 5.11],
                                            [154.33, 10.22],
                                            [5.11, 10.22],
                                            [0, 5.11],
                                            [0, 5.11],
                                            [5.11, 0]
                                        ]
                                    }
                                ],
                                "t": 120
                            },
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, -2.82],
                                            [0, 0],
                                            [2.82, 0],
                                            [0, 0],
                                            [0, 2.82],
                                            [0, 0],
                                            [-2.82, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [2.82, 0],
                                            [0, 0],
                                            [0, 2.82],
                                            [0, 0],
                                            [-2.82, 0],
                                            [0, 0],
                                            [0, -2.82],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [5.11, 0],
                                            [154.33, 0],
                                            [159.44, 5.11],
                                            [159.44, 5.11],
                                            [154.33, 10.22],
                                            [5.11, 10.22],
                                            [0, 5.11],
                                            [0, 5.11],
                                            [5.11, 0]
                                        ]
                                    }
                                ],
                                "t": 180
                            },
                            {
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, -2.82],
                                            [0, 0],
                                            [2.82, 0],
                                            [0, 0],
                                            [0, 2.82],
                                            [0, 0],
                                            [-2.82, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [2.82, 0],
                                            [0, 0],
                                            [0, 2.82],
                                            [0, 0],
                                            [-2.82, 0],
                                            [0, 0],
                                            [0, -2.82],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [5.11, 0],
                                            [154.33, 0],
                                            [159.44, 5.11],
                                            [159.44, 5.11],
                                            [154.33, 10.22],
                                            [5.11, 10.22],
                                            [0, 5.11],
                                            [0, 5.11],
                                            [5.11, 0]
                                        ]
                                    }
                                ],
                                "t": 240
                            }
                        ]
                    }
                },
                {
                    "ty": "fl",
                    "c": {
                        "a": 1,
                        "k": [
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0.0863, 0.6431, 0.498], "t": 0 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0.0863, 0.6431, 0.498], "t": 60 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0.0863, 0.6431, 0.498], "t": 120 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0.0863, 0.6431, 0.498], "t": 180 },
                            { "s": [0.0863, 0.6431, 0.498], "t": 240 }
                        ]
                    },
                    "r": 1,
                    "o": {
                        "a": 1,
                        "k": [
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 0 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 60 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 120 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 180 },
                            { "s": [100], "t": 240 }
                        ]
                    }
                }
            ],
            "ind": 35
        },
        {
            "ty": 4,
            "sr": 1,
            "st": 0,
            "op": 241,
            "ip": 0,
            "hasMask": false,
            "ao": 0,
            "ks": {
                "a": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [52.48, 5.11], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [52.48, 5.11], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [52.48, 5.11], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [52.48, 5.11], "t": 180 },
                        { "s": [52.48, 5.11], "t": 240 }
                    ]
                },
                "s": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [99.99, 100.01], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [99.99, 100.01], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [99.99, 100.01], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [99.99, 100.01], "t": 180 },
                        { "s": [99.99, 100.01], "t": 240 }
                    ]
                },
                "p": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [625.82, 348.99], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [632.29, 352.54], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [625.82, 348.99], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [632.29, 352.54], "t": 180 },
                        { "s": [625.82, 348.99], "t": 240 }
                    ]
                },
                "r": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [26.46], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [31.06], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [26.46], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [31.06], "t": 180 },
                        { "s": [26.46], "t": 240 }
                    ]
                },
                "o": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 180 },
                        { "s": [100], "t": 240 }
                    ]
                }
            },
            "shapes": [
                {
                    "ty": "sh",
                    "d": 1,
                    "ks": {
                        "a": 1,
                        "k": [
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, -2.82],
                                            [0, 0],
                                            [2.82, 0],
                                            [0, 0],
                                            [0, 2.82],
                                            [0, 0],
                                            [-2.82, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [2.82, 0],
                                            [0, 0],
                                            [0, 2.82],
                                            [0, 0],
                                            [-2.82, 0],
                                            [0, 0],
                                            [0, -2.82],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [5.11, 0],
                                            [99.84, 0],
                                            [104.95, 5.11],
                                            [104.95, 5.11],
                                            [99.84, 10.22],
                                            [5.11, 10.22],
                                            [0, 5.11],
                                            [0, 5.11],
                                            [5.11, 0]
                                        ]
                                    }
                                ],
                                "t": 0
                            },
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, -2.82],
                                            [0, 0],
                                            [2.82, 0],
                                            [0, 0],
                                            [0, 2.82],
                                            [0, 0],
                                            [-2.82, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [2.82, 0],
                                            [0, 0],
                                            [0, 2.82],
                                            [0, 0],
                                            [-2.82, 0],
                                            [0, 0],
                                            [0, -2.82],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [5.11, 0],
                                            [99.84, 0],
                                            [104.95, 5.11],
                                            [104.95, 5.11],
                                            [99.84, 10.22],
                                            [5.11, 10.22],
                                            [0, 5.11],
                                            [0, 5.11],
                                            [5.11, 0]
                                        ]
                                    }
                                ],
                                "t": 60
                            },
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, -2.82],
                                            [0, 0],
                                            [2.82, 0],
                                            [0, 0],
                                            [0, 2.82],
                                            [0, 0],
                                            [-2.82, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [2.82, 0],
                                            [0, 0],
                                            [0, 2.82],
                                            [0, 0],
                                            [-2.82, 0],
                                            [0, 0],
                                            [0, -2.82],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [5.11, 0],
                                            [99.84, 0],
                                            [104.95, 5.11],
                                            [104.95, 5.11],
                                            [99.84, 10.22],
                                            [5.11, 10.22],
                                            [0, 5.11],
                                            [0, 5.11],
                                            [5.11, 0]
                                        ]
                                    }
                                ],
                                "t": 120
                            },
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, -2.82],
                                            [0, 0],
                                            [2.82, 0],
                                            [0, 0],
                                            [0, 2.82],
                                            [0, 0],
                                            [-2.82, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [2.82, 0],
                                            [0, 0],
                                            [0, 2.82],
                                            [0, 0],
                                            [-2.82, 0],
                                            [0, 0],
                                            [0, -2.82],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [5.11, 0],
                                            [99.84, 0],
                                            [104.95, 5.11],
                                            [104.95, 5.11],
                                            [99.84, 10.22],
                                            [5.11, 10.22],
                                            [0, 5.11],
                                            [0, 5.11],
                                            [5.11, 0]
                                        ]
                                    }
                                ],
                                "t": 180
                            },
                            {
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, -2.82],
                                            [0, 0],
                                            [2.82, 0],
                                            [0, 0],
                                            [0, 2.82],
                                            [0, 0],
                                            [-2.82, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [2.82, 0],
                                            [0, 0],
                                            [0, 2.82],
                                            [0, 0],
                                            [-2.82, 0],
                                            [0, 0],
                                            [0, -2.82],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [5.11, 0],
                                            [99.84, 0],
                                            [104.95, 5.11],
                                            [104.95, 5.11],
                                            [99.84, 10.22],
                                            [5.11, 10.22],
                                            [0, 5.11],
                                            [0, 5.11],
                                            [5.11, 0]
                                        ]
                                    }
                                ],
                                "t": 240
                            }
                        ]
                    }
                },
                {
                    "ty": "fl",
                    "c": {
                        "a": 1,
                        "k": [
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0.702, 0.8078, 0.9647], "t": 0 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0.702, 0.8078, 0.9647], "t": 60 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0.702, 0.8078, 0.9647], "t": 120 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0.702, 0.8078, 0.9647], "t": 180 },
                            { "s": [0.702, 0.8078, 0.9647], "t": 240 }
                        ]
                    },
                    "r": 1,
                    "o": {
                        "a": 1,
                        "k": [
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 0 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 60 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 120 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 180 },
                            { "s": [100], "t": 240 }
                        ]
                    }
                }
            ],
            "ind": 36
        },
        {
            "ty": 4,
            "sr": 1,
            "st": 0,
            "op": 241,
            "ip": 0,
            "hasMask": false,
            "ao": 0,
            "ks": {
                "a": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [104.48, 135.36], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [104.48, 135.36], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [104.48, 135.36], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [104.48, 135.36], "t": 180 },
                        { "s": [104.48, 135.36], "t": 240 }
                    ]
                },
                "s": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [99.99, 100.01], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [99.99, 100.01], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [99.99, 100.01], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [99.99, 100.01], "t": 180 },
                        { "s": [99.99, 100.01], "t": 240 }
                    ]
                },
                "p": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [584.75, 431.46], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [584.75, 431.45], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [584.75, 431.46], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [584.75, 431.45], "t": 180 },
                        { "s": [584.75, 431.46], "t": 240 }
                    ]
                },
                "r": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [26.47], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [31.06], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [26.47], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [31.06], "t": 180 },
                        { "s": [26.47], "t": 240 }
                    ]
                },
                "o": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 180 },
                        { "s": [100], "t": 240 }
                    ]
                }
            },
            "shapes": [
                {
                    "ty": "sh",
                    "d": 1,
                    "ks": {
                        "a": 1,
                        "k": [
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, -3.82],
                                            [0, 0],
                                            [3.81, 0],
                                            [0, 0],
                                            [0, 3.82],
                                            [0, 0],
                                            [-3.81, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [3.81, 0],
                                            [0, 0],
                                            [0, 3.82],
                                            [0, 0],
                                            [-3.81, 0],
                                            [0, 0],
                                            [0, -3.82],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [6.91, 0],
                                            [202.05, 0],
                                            [208.96, 6.91],
                                            [208.96, 263.82],
                                            [202.05, 270.72],
                                            [6.91, 270.72],
                                            [0, 263.82],
                                            [0, 6.91],
                                            [6.91, 0]
                                        ]
                                    }
                                ],
                                "t": 0
                            },
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, -3.82],
                                            [0, 0],
                                            [3.81, 0],
                                            [0, 0],
                                            [0, 3.82],
                                            [0, 0],
                                            [-3.81, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [3.81, 0],
                                            [0, 0],
                                            [0, 3.82],
                                            [0, 0],
                                            [-3.81, 0],
                                            [0, 0],
                                            [0, -3.82],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [6.91, 0],
                                            [202.05, 0],
                                            [208.96, 6.91],
                                            [208.96, 263.82],
                                            [202.05, 270.72],
                                            [6.91, 270.72],
                                            [0, 263.82],
                                            [0, 6.91],
                                            [6.91, 0]
                                        ]
                                    }
                                ],
                                "t": 60
                            },
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, -3.82],
                                            [0, 0],
                                            [3.81, 0],
                                            [0, 0],
                                            [0, 3.82],
                                            [0, 0],
                                            [-3.81, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [3.81, 0],
                                            [0, 0],
                                            [0, 3.82],
                                            [0, 0],
                                            [-3.81, 0],
                                            [0, 0],
                                            [0, -3.82],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [6.91, 0],
                                            [202.05, 0],
                                            [208.96, 6.91],
                                            [208.96, 263.82],
                                            [202.05, 270.72],
                                            [6.91, 270.72],
                                            [0, 263.82],
                                            [0, 6.91],
                                            [6.91, 0]
                                        ]
                                    }
                                ],
                                "t": 120
                            },
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, -3.82],
                                            [0, 0],
                                            [3.81, 0],
                                            [0, 0],
                                            [0, 3.82],
                                            [0, 0],
                                            [-3.81, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [3.81, 0],
                                            [0, 0],
                                            [0, 3.82],
                                            [0, 0],
                                            [-3.81, 0],
                                            [0, 0],
                                            [0, -3.82],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [6.91, 0],
                                            [202.05, 0],
                                            [208.96, 6.91],
                                            [208.96, 263.82],
                                            [202.05, 270.72],
                                            [6.91, 270.72],
                                            [0, 263.82],
                                            [0, 6.91],
                                            [6.91, 0]
                                        ]
                                    }
                                ],
                                "t": 180
                            },
                            {
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, -3.82],
                                            [0, 0],
                                            [3.81, 0],
                                            [0, 0],
                                            [0, 3.82],
                                            [0, 0],
                                            [-3.81, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [3.81, 0],
                                            [0, 0],
                                            [0, 3.82],
                                            [0, 0],
                                            [-3.81, 0],
                                            [0, 0],
                                            [0, -3.82],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [6.91, 0],
                                            [202.05, 0],
                                            [208.96, 6.91],
                                            [208.96, 263.82],
                                            [202.05, 270.72],
                                            [6.91, 270.72],
                                            [0, 263.82],
                                            [0, 6.91],
                                            [6.91, 0]
                                        ]
                                    }
                                ],
                                "t": 240
                            }
                        ]
                    }
                },
                {
                    "ty": "fl",
                    "c": {
                        "a": 1,
                        "k": [
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0.5412, 0.8353, 0.7608], "t": 0 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0.5412, 0.8353, 0.7608], "t": 60 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0.5412, 0.8353, 0.7608], "t": 120 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0.5412, 0.8353, 0.7608], "t": 180 },
                            { "s": [0.5412, 0.8353, 0.7608], "t": 240 }
                        ]
                    },
                    "r": 1,
                    "o": {
                        "a": 1,
                        "k": [
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 0 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 60 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 120 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 180 },
                            { "s": [100], "t": 240 }
                        ]
                    }
                }
            ],
            "ind": 37
        },
        {
            "ty": 4,
            "sr": 1,
            "st": 0,
            "op": 241,
            "ip": 0,
            "hasMask": false,
            "ao": 0,
            "ks": {
                "a": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [119.08, 146.37], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [119.08, 146.37], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [119.08, 146.37], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [119.08, 146.37], "t": 180 },
                        { "s": [119.08, 146.37], "t": 240 }
                    ]
                },
                "s": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100, 100], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100, 100], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100, 100], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100, 100], "t": 180 },
                        { "s": [100, 100], "t": 240 }
                    ]
                },
                "p": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [583.36, 434.24], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [583.14, 434.12], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [583.36, 434.24], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [583.14, 434.12], "t": 180 },
                        { "s": [583.36, 434.24], "t": 240 }
                    ]
                },
                "r": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [10.73], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [15.32], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [10.73], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [15.32], "t": 180 },
                        { "s": [10.73], "t": 240 }
                    ]
                },
                "o": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 180 },
                        { "s": [100], "t": 240 }
                    ]
                }
            },
            "shapes": [
                {
                    "ty": "sh",
                    "d": 1,
                    "ks": {
                        "a": 1,
                        "k": [
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0.29, 0.03],
                                            [0, 0],
                                            [1.31, 1.64],
                                            [-0.23, 2.08],
                                            [0, 0],
                                            [-1.64, 1.31],
                                            [-2.08, -0.23],
                                            [0, 0],
                                            [-1.31, -1.64],
                                            [0.23, -2.08],
                                            [0, 0],
                                            [1.64, -1.31],
                                            [1.77, 0]
                                        ],
                                        "o": [
                                            [-0.29, 0],
                                            [0, 0],
                                            [-2.08, -0.23],
                                            [-1.31, -1.64],
                                            [0, 0],
                                            [0.23, -2.08],
                                            [1.64, -1.31],
                                            [0, 0],
                                            [2.08, 0.23],
                                            [1.31, 1.64],
                                            [0, 0],
                                            [-0.23, 2.08],
                                            [-1.41, 1.13],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [201.78, 292.73],
                                            [200.9, 292.68],
                                            [6.98, 270.99],
                                            [1.72, 268.08],
                                            [0.05, 262.31],
                                            [28.59, 6.98],
                                            [31.5, 1.73],
                                            [37.27, 0.05],
                                            [231.19, 21.74],
                                            [236.44, 24.65],
                                            [238.12, 30.42],
                                            [209.57, 285.75],
                                            [206.67, 291.01],
                                            [201.78, 292.73]
                                        ]
                                    }
                                ],
                                "t": 0
                            },
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0.29, 0.03],
                                            [0, 0],
                                            [1.31, 1.64],
                                            [-0.23, 2.08],
                                            [0, 0],
                                            [-1.64, 1.31],
                                            [-2.08, -0.23],
                                            [0, 0],
                                            [-1.31, -1.64],
                                            [0.23, -2.08],
                                            [0, 0],
                                            [1.64, -1.31],
                                            [1.77, 0]
                                        ],
                                        "o": [
                                            [-0.29, 0],
                                            [0, 0],
                                            [-2.08, -0.23],
                                            [-1.31, -1.64],
                                            [0, 0],
                                            [0.23, -2.08],
                                            [1.64, -1.31],
                                            [0, 0],
                                            [2.08, 0.23],
                                            [1.31, 1.64],
                                            [0, 0],
                                            [-0.23, 2.08],
                                            [-1.41, 1.13],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [201.78, 292.73],
                                            [200.9, 292.68],
                                            [6.98, 270.99],
                                            [1.72, 268.08],
                                            [0.05, 262.31],
                                            [28.59, 6.98],
                                            [31.5, 1.73],
                                            [37.27, 0.05],
                                            [231.19, 21.74],
                                            [236.44, 24.65],
                                            [238.12, 30.42],
                                            [209.57, 285.75],
                                            [206.67, 291.01],
                                            [201.78, 292.73]
                                        ]
                                    }
                                ],
                                "t": 60
                            },
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0.29, 0.03],
                                            [0, 0],
                                            [1.31, 1.64],
                                            [-0.23, 2.08],
                                            [0, 0],
                                            [-1.64, 1.31],
                                            [-2.08, -0.23],
                                            [0, 0],
                                            [-1.31, -1.64],
                                            [0.23, -2.08],
                                            [0, 0],
                                            [1.64, -1.31],
                                            [1.77, 0]
                                        ],
                                        "o": [
                                            [-0.29, 0],
                                            [0, 0],
                                            [-2.08, -0.23],
                                            [-1.31, -1.64],
                                            [0, 0],
                                            [0.23, -2.08],
                                            [1.64, -1.31],
                                            [0, 0],
                                            [2.08, 0.23],
                                            [1.31, 1.64],
                                            [0, 0],
                                            [-0.23, 2.08],
                                            [-1.41, 1.13],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [201.78, 292.73],
                                            [200.9, 292.68],
                                            [6.98, 270.99],
                                            [1.72, 268.08],
                                            [0.05, 262.31],
                                            [28.59, 6.98],
                                            [31.5, 1.73],
                                            [37.27, 0.05],
                                            [231.19, 21.74],
                                            [236.44, 24.65],
                                            [238.12, 30.42],
                                            [209.57, 285.75],
                                            [206.67, 291.01],
                                            [201.78, 292.73]
                                        ]
                                    }
                                ],
                                "t": 120
                            },
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0.29, 0.03],
                                            [0, 0],
                                            [1.31, 1.64],
                                            [-0.23, 2.08],
                                            [0, 0],
                                            [-1.64, 1.31],
                                            [-2.08, -0.23],
                                            [0, 0],
                                            [-1.31, -1.64],
                                            [0.23, -2.08],
                                            [0, 0],
                                            [1.64, -1.31],
                                            [1.77, 0]
                                        ],
                                        "o": [
                                            [-0.29, 0],
                                            [0, 0],
                                            [-2.08, -0.23],
                                            [-1.31, -1.64],
                                            [0, 0],
                                            [0.23, -2.08],
                                            [1.64, -1.31],
                                            [0, 0],
                                            [2.08, 0.23],
                                            [1.31, 1.64],
                                            [0, 0],
                                            [-0.23, 2.08],
                                            [-1.41, 1.13],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [201.78, 292.73],
                                            [200.9, 292.68],
                                            [6.98, 270.99],
                                            [1.72, 268.08],
                                            [0.05, 262.31],
                                            [28.59, 6.98],
                                            [31.5, 1.73],
                                            [37.27, 0.05],
                                            [231.19, 21.74],
                                            [236.44, 24.65],
                                            [238.12, 30.42],
                                            [209.57, 285.75],
                                            [206.67, 291.01],
                                            [201.78, 292.73]
                                        ]
                                    }
                                ],
                                "t": 180
                            },
                            {
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0.29, 0.03],
                                            [0, 0],
                                            [1.31, 1.64],
                                            [-0.23, 2.08],
                                            [0, 0],
                                            [-1.64, 1.31],
                                            [-2.08, -0.23],
                                            [0, 0],
                                            [-1.31, -1.64],
                                            [0.23, -2.08],
                                            [0, 0],
                                            [1.64, -1.31],
                                            [1.77, 0]
                                        ],
                                        "o": [
                                            [-0.29, 0],
                                            [0, 0],
                                            [-2.08, -0.23],
                                            [-1.31, -1.64],
                                            [0, 0],
                                            [0.23, -2.08],
                                            [1.64, -1.31],
                                            [0, 0],
                                            [2.08, 0.23],
                                            [1.31, 1.64],
                                            [0, 0],
                                            [-0.23, 2.08],
                                            [-1.41, 1.13],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [201.78, 292.73],
                                            [200.9, 292.68],
                                            [6.98, 270.99],
                                            [1.72, 268.08],
                                            [0.05, 262.31],
                                            [28.59, 6.98],
                                            [31.5, 1.73],
                                            [37.27, 0.05],
                                            [231.19, 21.74],
                                            [236.44, 24.65],
                                            [238.12, 30.42],
                                            [209.57, 285.75],
                                            [206.67, 291.01],
                                            [201.78, 292.73]
                                        ]
                                    }
                                ],
                                "t": 240
                            }
                        ]
                    }
                },
                {
                    "ty": "sh",
                    "d": 1,
                    "ks": {
                        "a": 1,
                        "k": [
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [1.07, -0.86],
                                            [0.18, -1.58],
                                            [0, 0],
                                            [-1, -1.25],
                                            [-1.57, -0.18],
                                            [0, 0],
                                            [-1.25, 1],
                                            [-0.18, 1.58],
                                            [0, 0],
                                            [1, 1.25],
                                            [1.57, 0.18],
                                            [0, 0],
                                            [0.22, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [-1.34, 0],
                                            [-1.25, 1],
                                            [0, 0],
                                            [-0.18, 1.58],
                                            [1, 1.25],
                                            [0, 0],
                                            [1.57, 0.18],
                                            [1.25, -1],
                                            [0, 0],
                                            [0.18, -1.58],
                                            [-1, -1.25],
                                            [0, 0],
                                            [-0.22, -0.02],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [36.39, 1.89],
                                            [32.68, 3.2],
                                            [30.47, 7.19],
                                            [1.93, 262.52],
                                            [3.2, 266.9],
                                            [7.19, 269.11],
                                            [201.11, 290.8],
                                            [205.49, 289.53],
                                            [207.69, 285.54],
                                            [236.24, 30.21],
                                            [234.97, 25.83],
                                            [230.98, 23.62],
                                            [37.06, 1.93],
                                            [36.4, 1.89],
                                            [36.39, 1.89]
                                        ]
                                    }
                                ],
                                "t": 0
                            },
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [1.07, -0.86],
                                            [0.18, -1.58],
                                            [0, 0],
                                            [-1, -1.25],
                                            [-1.57, -0.18],
                                            [0, 0],
                                            [-1.25, 1],
                                            [-0.18, 1.58],
                                            [0, 0],
                                            [1, 1.25],
                                            [1.57, 0.18],
                                            [0, 0],
                                            [0.22, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [-1.34, 0],
                                            [-1.25, 1],
                                            [0, 0],
                                            [-0.18, 1.58],
                                            [1, 1.25],
                                            [0, 0],
                                            [1.57, 0.18],
                                            [1.25, -1],
                                            [0, 0],
                                            [0.18, -1.58],
                                            [-1, -1.25],
                                            [0, 0],
                                            [-0.22, -0.02],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [36.39, 1.89],
                                            [32.68, 3.2],
                                            [30.47, 7.19],
                                            [1.93, 262.52],
                                            [3.2, 266.9],
                                            [7.19, 269.11],
                                            [201.11, 290.8],
                                            [205.49, 289.53],
                                            [207.69, 285.54],
                                            [236.24, 30.21],
                                            [234.97, 25.83],
                                            [230.98, 23.62],
                                            [37.06, 1.93],
                                            [36.4, 1.89],
                                            [36.39, 1.89]
                                        ]
                                    }
                                ],
                                "t": 60
                            },
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [1.07, -0.86],
                                            [0.18, -1.58],
                                            [0, 0],
                                            [-1, -1.25],
                                            [-1.57, -0.18],
                                            [0, 0],
                                            [-1.25, 1],
                                            [-0.18, 1.58],
                                            [0, 0],
                                            [1, 1.25],
                                            [1.57, 0.18],
                                            [0, 0],
                                            [0.22, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [-1.34, 0],
                                            [-1.25, 1],
                                            [0, 0],
                                            [-0.18, 1.58],
                                            [1, 1.25],
                                            [0, 0],
                                            [1.57, 0.18],
                                            [1.25, -1],
                                            [0, 0],
                                            [0.18, -1.58],
                                            [-1, -1.25],
                                            [0, 0],
                                            [-0.22, -0.02],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [36.39, 1.89],
                                            [32.68, 3.2],
                                            [30.47, 7.19],
                                            [1.93, 262.52],
                                            [3.2, 266.9],
                                            [7.19, 269.11],
                                            [201.11, 290.8],
                                            [205.49, 289.53],
                                            [207.69, 285.54],
                                            [236.24, 30.21],
                                            [234.97, 25.83],
                                            [230.98, 23.62],
                                            [37.06, 1.93],
                                            [36.4, 1.89],
                                            [36.39, 1.89]
                                        ]
                                    }
                                ],
                                "t": 120
                            },
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [1.07, -0.86],
                                            [0.18, -1.58],
                                            [0, 0],
                                            [-1, -1.25],
                                            [-1.57, -0.18],
                                            [0, 0],
                                            [-1.25, 1],
                                            [-0.18, 1.58],
                                            [0, 0],
                                            [1, 1.25],
                                            [1.57, 0.18],
                                            [0, 0],
                                            [0.22, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [-1.34, 0],
                                            [-1.25, 1],
                                            [0, 0],
                                            [-0.18, 1.58],
                                            [1, 1.25],
                                            [0, 0],
                                            [1.57, 0.18],
                                            [1.25, -1],
                                            [0, 0],
                                            [0.18, -1.58],
                                            [-1, -1.25],
                                            [0, 0],
                                            [-0.22, -0.02],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [36.39, 1.89],
                                            [32.68, 3.2],
                                            [30.47, 7.19],
                                            [1.93, 262.52],
                                            [3.2, 266.9],
                                            [7.19, 269.11],
                                            [201.11, 290.8],
                                            [205.49, 289.53],
                                            [207.69, 285.54],
                                            [236.24, 30.21],
                                            [234.97, 25.83],
                                            [230.98, 23.62],
                                            [37.06, 1.93],
                                            [36.4, 1.89],
                                            [36.39, 1.89]
                                        ]
                                    }
                                ],
                                "t": 180
                            },
                            {
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [1.07, -0.86],
                                            [0.18, -1.58],
                                            [0, 0],
                                            [-1, -1.25],
                                            [-1.57, -0.18],
                                            [0, 0],
                                            [-1.25, 1],
                                            [-0.18, 1.58],
                                            [0, 0],
                                            [1, 1.25],
                                            [1.57, 0.18],
                                            [0, 0],
                                            [0.22, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [-1.34, 0],
                                            [-1.25, 1],
                                            [0, 0],
                                            [-0.18, 1.58],
                                            [1, 1.25],
                                            [0, 0],
                                            [1.57, 0.18],
                                            [1.25, -1],
                                            [0, 0],
                                            [0.18, -1.58],
                                            [-1, -1.25],
                                            [0, 0],
                                            [-0.22, -0.02],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [36.39, 1.89],
                                            [32.68, 3.2],
                                            [30.47, 7.19],
                                            [1.93, 262.52],
                                            [3.2, 266.9],
                                            [7.19, 269.11],
                                            [201.11, 290.8],
                                            [205.49, 289.53],
                                            [207.69, 285.54],
                                            [236.24, 30.21],
                                            [234.97, 25.83],
                                            [230.98, 23.62],
                                            [37.06, 1.93],
                                            [36.4, 1.89],
                                            [36.39, 1.89]
                                        ]
                                    }
                                ],
                                "t": 240
                            }
                        ]
                    }
                },
                {
                    "ty": "fl",
                    "c": {
                        "a": 1,
                        "k": [
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0.4588, 0.4588, 0.4588], "t": 0 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0.4588, 0.4588, 0.4588], "t": 60 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0.4588, 0.4588, 0.4588], "t": 120 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0.4588, 0.4588, 0.4588], "t": 180 },
                            { "s": [0.4588, 0.4588, 0.4588], "t": 240 }
                        ]
                    },
                    "r": 1,
                    "o": {
                        "a": 1,
                        "k": [
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 0 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 60 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 120 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 180 },
                            { "s": [100], "t": 240 }
                        ]
                    }
                }
            ],
            "ind": 38
        },
        {
            "ty": 4,
            "sr": 1,
            "st": 0,
            "op": 241,
            "ip": 0,
            "hasMask": false,
            "ao": 0,
            "ks": {
                "a": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [214.06, 212.67], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [214.06, 212.67], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [214.06, 212.67], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [214.06, 212.67], "t": 180 },
                        { "s": [214.06, 212.67], "t": 240 }
                    ]
                },
                "s": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100, 100], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100, 100], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100, 100], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100, 100], "t": 180 },
                        { "s": [100, 100], "t": 240 }
                    ]
                },
                "p": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [474.6, 367.57], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [474.6, 367.57], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [474.6, 367.57], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [474.6, 367.57], "t": 180 },
                        { "s": [474.6, 367.57], "t": 240 }
                    ]
                },
                "r": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0], "t": 180 },
                        { "s": [0], "t": 240 }
                    ]
                },
                "o": {
                    "a": 1,
                    "k": [
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 0 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 60 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 120 },
                        { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 180 },
                        { "s": [100], "t": 240 }
                    ]
                }
            },
            "shapes": [
                {
                    "ty": "sh",
                    "d": 1,
                    "ks": {
                        "a": 1,
                        "k": [
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [-77.13, 49.28],
                                            [-66.92, -85.45],
                                            [33.79, -73.91],
                                            [90.23, 91.33],
                                            [-1.64, 24.13],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [1.66, -24.43],
                                            [88.28, -56.4],
                                            [40.78, 52.07],
                                            [-57.46, 125.68],
                                            [-56, -56.69],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [1.02, 201.7],
                                            [86.78, 25.51],
                                            [375.73, 97.48],
                                            [413.71, 310.51],
                                            [49.37, 370.97],
                                            [1.02, 201.69],
                                            [1.02, 201.7]
                                        ]
                                    }
                                ],
                                "t": 0
                            },
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [-77.13, 49.28],
                                            [-66.92, -85.45],
                                            [33.79, -73.91],
                                            [90.23, 91.33],
                                            [-1.64, 24.13],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [1.66, -24.43],
                                            [88.28, -56.4],
                                            [40.78, 52.07],
                                            [-57.46, 125.68],
                                            [-56, -56.69],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [1.02, 201.7],
                                            [86.78, 25.51],
                                            [375.73, 97.48],
                                            [413.71, 310.51],
                                            [49.37, 370.97],
                                            [1.02, 201.69],
                                            [1.02, 201.7]
                                        ]
                                    }
                                ],
                                "t": 60
                            },
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [-77.13, 49.28],
                                            [-66.92, -85.45],
                                            [33.79, -73.91],
                                            [90.23, 91.33],
                                            [-1.64, 24.13],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [1.66, -24.43],
                                            [88.28, -56.4],
                                            [40.78, 52.07],
                                            [-57.46, 125.68],
                                            [-56, -56.69],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [1.02, 201.7],
                                            [86.78, 25.51],
                                            [375.73, 97.48],
                                            [413.71, 310.51],
                                            [49.37, 370.97],
                                            [1.02, 201.69],
                                            [1.02, 201.7]
                                        ]
                                    }
                                ],
                                "t": 120
                            },
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 0.58, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [-77.13, 49.28],
                                            [-66.92, -85.45],
                                            [33.79, -73.91],
                                            [90.23, 91.33],
                                            [-1.64, 24.13],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [1.66, -24.43],
                                            [88.28, -56.4],
                                            [40.78, 52.07],
                                            [-57.46, 125.68],
                                            [-56, -56.69],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [1.02, 201.7],
                                            [86.78, 25.51],
                                            [375.73, 97.48],
                                            [413.71, 310.51],
                                            [49.37, 370.97],
                                            [1.02, 201.69],
                                            [1.02, 201.7]
                                        ]
                                    }
                                ],
                                "t": 180
                            },
                            {
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [-77.13, 49.28],
                                            [-66.92, -85.45],
                                            [33.79, -73.91],
                                            [90.23, 91.33],
                                            [-1.64, 24.13],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [1.66, -24.43],
                                            [88.28, -56.4],
                                            [40.78, 52.07],
                                            [-57.46, 125.68],
                                            [-56, -56.69],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [1.02, 201.7],
                                            [86.78, 25.51],
                                            [375.73, 97.48],
                                            [413.71, 310.51],
                                            [49.37, 370.97],
                                            [1.02, 201.69],
                                            [1.02, 201.7]
                                        ]
                                    }
                                ],
                                "t": 240
                            }
                        ]
                    }
                },
                {
                    "ty": "fl",
                    "c": {
                        "a": 1,
                        "k": [
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0.949, 0.949, 0.949], "t": 0 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0.949, 0.949, 0.949], "t": 60 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0.949, 0.949, 0.949], "t": 120 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [0.949, 0.949, 0.949], "t": 180 },
                            { "s": [0.949, 0.949, 0.949], "t": 240 }
                        ]
                    },
                    "r": 1,
                    "o": {
                        "a": 1,
                        "k": [
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 0 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 60 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 120 },
                            { "o": { "x": 0, "y": 0 }, "i": { "x": 0.58, "y": 1 }, "s": [100], "t": 180 },
                            { "s": [100], "t": 240 }
                        ]
                    }
                }
            ],
            "ind": 39
        }
    ],
    "v": "5.7.0",
    "fr": 30,
    "op": 240,
    "ip": 0,
    "assets": []
}
